// @ts-nocheck
import { GraphQLResolveInfo, SelectionSetNode, FieldNode, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import type { GetMeshOptions } from '@graphql-mesh/runtime';
import type { YamlConfig } from '@graphql-mesh/types';
import { PubSub } from '@graphql-mesh/utils';
import { DefaultLogger } from '@graphql-mesh/utils';
import MeshCache from "@graphql-mesh/cache-localforage";
import fetchFn from "@graphcommerce/graphql-mesh/customFetch";

import { MeshResolvedSource } from '@graphql-mesh/runtime';
import { MeshTransform, MeshPlugin } from '@graphql-mesh/types';
import GraphqlHandler from "@graphql-mesh/graphql"
import UseHttpDetailsExtensions from "@graphql-mesh/plugin-http-details-extensions";
import FilterSchemaTransform from "@graphql-mesh/transform-filter-schema";
import PruneTransform from "@graphql-mesh/transform-prune";
import { parse } from 'graphql';
import StitchingMerger from "@graphql-mesh/merger-stitching";
import { createMeshHTTPHandler, MeshHTTPHandler } from '@graphql-mesh/http';
import { getMesh, ExecuteMeshFn, SubscribeMeshFn, MeshContext as BaseMeshContext, MeshInstance } from '@graphql-mesh/runtime';
import { MeshStore, FsStoreStorageAdapter } from '@graphql-mesh/store';
import { path as pathModule } from '@graphql-mesh/cross-helpers';
import { ImportFn } from '@graphql-mesh/types';
import type { HygraphTypes } from './sources/hygraph/types';
import type { M2Types } from './sources/m2/types';
import * as importedModule$0 from "./sources/m2/introspectionSchema";
import * as importedModule$1 from "./sources/hygraph/introspectionSchema";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };



/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  RichTextAST: { input: any; output: any; }
};

export type Query = {
  amMostviewedBundlePacks?: Maybe<AmMostviewedBundlePacks>;
  amMostviewedGroups?: Maybe<AmMostviewedRelatedRules>;
  amMostviewedGroupsByPosition?: Maybe<AmMostviewedRelatedRules>;
  amOrderList?: Maybe<Array<Maybe<SortingOrder>>>;
  /** List of linked accounts */
  amSocialLoginAccountData?: Maybe<Array<Maybe<AmLinkedSocialAccounts>>>;
  /** Button configuration */
  amSocialLoginButtonConfig?: Maybe<Array<Maybe<AmSocialLoginButton>>>;
  amfeaturedWidget?: Maybe<Array<Maybe<ProductData>>>;
  /** Get a list of available store views and their config information. */
  availableStores?: Maybe<Array<Maybe<StoreConfig>>>;
  /** Get role by id */
  bssCompanyAccountGetRole?: Maybe<SubRole>;
  /** Get sub-user by id */
  bssCompanyAccountGetSubUser?: Maybe<SubUser>;
  /** Get role by id */
  bssCompanyAccountGetSubUsersByRole?: Maybe<Array<Maybe<SubUser>>>;
  /** Get current auth subuser */
  bssSubUser?: Maybe<SubUser>;
  /** Returns information about the sub-user shopping cart */
  bssSubUserCart: Cart;
  /** Return information about the specified shopping cart. */
  cart?: Maybe<Cart>;
  /** Return a list of categories that match the specified filter. */
  categories?: Maybe<CategoryResult>;
  /**
   * Search for categories that match the criteria specified in the `search` and `filter` attributes.
   * @deprecated Use `categories` instead.
   */
  category?: Maybe<CategoryTree>;
  /**
   * Return an array of categories based on the specified filters.
   * @deprecated Use `categories` instead.
   */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  /** Return Terms and Conditions configuration information. */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** Return information about CMS blocks. */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** Return details about a CMS page. */
  cmsPage?: Maybe<CmsPage>;
  /** Return products that have been added to the specified compare list. */
  compareList?: Maybe<CompareList>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  /** Return information about the store's currency. */
  currency?: Maybe<Currency>;
  /** Return the attribute type, given an attribute code and entity type. */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** Return detailed information about a customer account. */
  customer?: Maybe<Customer>;
  /** Return information about the customer's shopping cart. */
  customerCart: Cart;
  /** Return a list of downloadable products the customer has purchased. */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>;
  /** @deprecated Use the `customer` query instead. */
  customerOrders?: Maybe<CustomerOrders>;
  /** Return a list of customer payment tokens stored in the vault. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  defaultSorting?: Maybe<Array<Maybe<SortingOrder>>>;
  fourOverCartItemAvailableQuantities?: Maybe<Array<Maybe<FourOverItemQuantity>>>;
  fourOverProductArtworkPreflight?: Maybe<ArtworkPreflightResponse>;
  fourOverProductArtworkRequirements?: Maybe<Array<Maybe<ArtworkRequirement>>>;
  /** Get FAQ Module Settings. */
  getAmFaqSettings?: Maybe<AmFaqSettings>;
  getAmFiles?: Maybe<Array<Maybe<AmFile>>>;
  /** Get Product Attachment Module Settings. */
  getAmProductAttachmentSettings?: Maybe<AmProductAttachmentSettings>;
  /** Retrieve the secure PayPal URL for a Payments Pro Hosted Solution transaction. */
  getHostedProUrl?: Maybe<HostedProUrl>;
  /** Retrieve payment credentials for a transaction. Use this query for Payflow Link and Payments Advanced payment methods. */
  getPayflowLinkToken?: Maybe<PayflowLinkToken>;
  /** Check whether the specified email has already been used to create a customer account. */
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  /** Searches for Best Sellers information matches the filter. */
  mpSmtpBestsellers?: Maybe<SmtpBestsellersOutput>;
  /** The pickup locations query searches for locations that match the search request requirements. */
  pickupLocations?: Maybe<PickupLocations>;
  /** Return the active ratings attributes and the values each rating can have. */
  productReviewRatingsMetadata: ProductReviewRatingsMetadata;
  /** Search for products that match the criteria specified in the `search` and `filter` attributes. */
  products?: Maybe<Products>;
  /** Return the full details for a specified product, category, or CMS page. */
  route?: Maybe<RoutableInterface>;
  /** Search all FAQ categories by keyword with filter and sortOrder. */
  searchAmFaqCategories?: Maybe<AmFaqCategoriesSearch>;
  /** Search all FAQ questions with filter and sortOrder. */
  searchAmFaqQuestions?: Maybe<AmFaqQuestionsSearch>;
  /** Return details about the store's configuration. */
  storeConfig?: Maybe<StoreConfig>;
  /**
   * Return the relative URL for a specified product, category or CMS page.
   * @deprecated Use the `route` query instead.
   */
  urlResolver?: Maybe<EntityUrl>;
  /**
   * Return the contents of a customer's wish list.
   * @deprecated Moved under `Customer.wishlist`.
   */
  wishlist?: Maybe<WishlistOutput>;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve multiple pages */
  pages: Array<Page>;
  /** Retrieve a single page */
  page?: Maybe<Page>;
  /** Retrieve multiple pages using the Relay connection interface */
  pagesConnection: PageConnection;
  /** Retrieve multiple rowHeroBanners */
  rowHeroBanners: Array<RowHeroBanner>;
  /** Retrieve a single rowHeroBanner */
  rowHeroBanner?: Maybe<RowHeroBanner>;
  /** Retrieve multiple rowHeroBanners using the Relay connection interface */
  rowHeroBannersConnection: RowHeroBannerConnection;
  /** Retrieve multiple pageLinks */
  pageLinks: Array<PageLink>;
  /** Retrieve a single pageLink */
  pageLink?: Maybe<PageLink>;
  /** Retrieve multiple pageLinks using the Relay connection interface */
  pageLinksConnection: PageLinkConnection;
  /** Retrieve multiple footers */
  footers: Array<Footer>;
  /** Retrieve a single footer */
  footer?: Maybe<Footer>;
  /** Retrieve multiple footers using the Relay connection interface */
  footersConnection: FooterConnection;
  /** Retrieve multiple rowServiceOptionsMultiple */
  rowServiceOptionsMultiple: Array<RowServiceOptions>;
  /** Retrieve a single rowServiceOptions */
  rowServiceOptions?: Maybe<RowServiceOptions>;
  /** Retrieve multiple rowServiceOptionsMultiple using the Relay connection interface */
  rowServiceOptionsMultipleConnection: RowServiceOptionsConnection;
  /** Retrieve multiple rowBlogContents */
  rowBlogContents: Array<RowBlogContent>;
  /** Retrieve a single rowBlogContent */
  rowBlogContent?: Maybe<RowBlogContent>;
  /** Retrieve multiple rowBlogContents using the Relay connection interface */
  rowBlogContentsConnection: RowBlogContentConnection;
  /** Retrieve multiple uspsMultiple */
  uspsMultiple: Array<Usps>;
  /** Retrieve a single usps */
  usps?: Maybe<Usps>;
  /** Retrieve multiple uspsMultiple using the Relay connection interface */
  uspsMultipleConnection: UspsConnection;
  /** Retrieve multiple rowProductMultiple */
  rowProductMultiple: Array<RowProduct>;
  /** Retrieve a single rowProduct */
  rowProduct?: Maybe<RowProduct>;
  /** Retrieve multiple rowProductMultiple using the Relay connection interface */
  rowProductMultipleConnection: RowProductConnection;
  /** Retrieve multiple rowLinksMultiple */
  rowLinksMultiple: Array<RowLinks>;
  /** Retrieve a single rowLinks */
  rowLinks?: Maybe<RowLinks>;
  /** Retrieve multiple rowLinksMultiple using the Relay connection interface */
  rowLinksMultipleConnection: RowLinksConnection;
  /** Retrieve multiple productSideInfos */
  productSideInfos: Array<ProductSideInfo>;
  /** Retrieve a single productSideInfo */
  productSideInfo?: Maybe<ProductSideInfo>;
  /** Retrieve multiple productSideInfos using the Relay connection interface */
  productSideInfosConnection: ProductSideInfoConnection;
  /** Retrieve multiple rowBrandsBanners */
  rowBrandsBanners: Array<RowBrandsBanner>;
  /** Retrieve a single rowBrandsBanner */
  rowBrandsBanner?: Maybe<RowBrandsBanner>;
  /** Retrieve multiple rowBrandsBanners using the Relay connection interface */
  rowBrandsBannersConnection: RowBrandsBannerConnection;
  /** Retrieve multiple rowOrderProcesses */
  rowOrderProcesses: Array<RowOrderProcess>;
  /** Retrieve a single rowOrderProcess */
  rowOrderProcess?: Maybe<RowOrderProcess>;
  /** Retrieve multiple rowOrderProcesses using the Relay connection interface */
  rowOrderProcessesConnection: RowOrderProcessConnection;
  /** Retrieve multiple rowProductHighlights */
  rowProductHighlights: Array<RowProductHighlight>;
  /** Retrieve a single rowProductHighlight */
  rowProductHighlight?: Maybe<RowProductHighlight>;
  /** Retrieve multiple rowProductHighlights using the Relay connection interface */
  rowProductHighlightsConnection: RowProductHighlightConnection;
  /** Retrieve multiple pageFooters */
  pageFooters: Array<PageFooter>;
  /** Retrieve a single pageFooter */
  pageFooter?: Maybe<PageFooter>;
  /** Retrieve multiple pageFooters using the Relay connection interface */
  pageFootersConnection: PageFooterConnection;
  /** Retrieve multiple productThingsToKnows */
  productThingsToKnows: Array<ProductThingsToKnow>;
  /** Retrieve a single productThingsToKnow */
  productThingsToKnow?: Maybe<ProductThingsToKnow>;
  /** Retrieve multiple productThingsToKnows using the Relay connection interface */
  productThingsToKnowsConnection: ProductThingsToKnowConnection;
  /** Retrieve multiple rowServicePageContents */
  rowServicePageContents: Array<RowServicePageContent>;
  /** Retrieve a single rowServicePageContent */
  rowServicePageContent?: Maybe<RowServicePageContent>;
  /** Retrieve multiple rowServicePageContents using the Relay connection interface */
  rowServicePageContentsConnection: RowServicePageContentConnection;
  /** Retrieve multiple rowReviewHighlights */
  rowReviewHighlights: Array<RowReviewHighlight>;
  /** Retrieve a single rowReviewHighlight */
  rowReviewHighlight?: Maybe<RowReviewHighlight>;
  /** Retrieve multiple rowReviewHighlights using the Relay connection interface */
  rowReviewHighlightsConnection: RowReviewHighlightConnection;
  /** Retrieve multiple rowFeaturedCategories */
  rowFeaturedCategories: Array<RowFeaturedCategory>;
  /** Retrieve a single rowFeaturedCategory */
  rowFeaturedCategory?: Maybe<RowFeaturedCategory>;
  /** Retrieve multiple rowFeaturedCategories using the Relay connection interface */
  rowFeaturedCategoriesConnection: RowFeaturedCategoryConnection;
  /** Retrieve multiple rowParagraphs */
  rowParagraphs: Array<RowParagraph>;
  /** Retrieve a single rowParagraph */
  rowParagraph?: Maybe<RowParagraph>;
  /** Retrieve multiple rowParagraphs using the Relay connection interface */
  rowParagraphsConnection: RowParagraphConnection;
  currentCartId?: Maybe<CurrentCartId>;
  currentCompareUid?: Maybe<CurrentCompareUid>;
  customerToken?: Maybe<CustomerToken>;
  guestWishlist?: Maybe<GuestWishlist>;
};


export type QueryamMostviewedBundlePacksArgs = {
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryamMostviewedGroupsArgs = {
  uid: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
};


export type QueryamMostviewedGroupsByPositionArgs = {
  position?: InputMaybe<Scalars['String']['input']>;
};


export type QueryamfeaturedWidgetArgs = {
  sortBy: Scalars['String']['input'];
  amsortingSortOrder: Scalars['String']['input'];
  productsCount: Scalars['Int']['input'];
  conditions: Scalars['String']['input'];
  showPager?: InputMaybe<Scalars['Boolean']['input']>;
  productsPerPage?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryavailableStoresArgs = {
  useCurrentGroup?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerybssCompanyAccountGetRoleArgs = {
  role_id: Scalars['Int']['input'];
};


export type QuerybssCompanyAccountGetSubUserArgs = {
  sub_id: Scalars['Int']['input'];
};


export type QuerybssCompanyAccountGetSubUsersByRoleArgs = {
  role_id: Scalars['Int']['input'];
};


export type QuerycartArgs = {
  cart_id: Scalars['String']['input'];
};


export type QuerycategoriesArgs = {
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycategoryListArgs = {
  filters?: InputMaybe<CategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerycmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerycmsPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};


export type QuerycompareListArgs = {
  uid: Scalars['ID']['input'];
};


export type QuerycountryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerycustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};


export type QuerydefaultSortingArgs = {
  pageType: PageTypeEnum;
};


export type QueryfourOverCartItemAvailableQuantitiesArgs = {
  cart_id: Scalars['String']['input'];
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryfourOverProductArtworkPreflightArgs = {
  files?: InputMaybe<Array<InputMaybe<FourOverFile>>>;
};


export type QueryfourOverProductArtworkRequirementsArgs = {
  productUuid?: InputMaybe<Scalars['String']['input']>;
  optionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enteredOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerygetAmFilesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QuerygetHostedProUrlArgs = {
  input: HostedProUrlInput;
};


export type QuerygetPayflowLinkTokenArgs = {
  input: PayflowLinkTokenInput;
};


export type QueryisEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


export type QuerympSmtpBestsellersArgs = {
  app_id: Scalars['String']['input'];
  secret_key: Scalars['String']['input'];
  filters?: InputMaybe<MpFilters>;
};


export type QuerypickupLocationsArgs = {
  area?: InputMaybe<AreaInput>;
  filters?: InputMaybe<PickupLocationFilterInput>;
  sort?: InputMaybe<PickupLocationSortInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  productsInfo?: InputMaybe<Array<InputMaybe<ProductInfoInput>>>;
};


export type QueryproductsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


export type QueryrouteArgs = {
  url: Scalars['String']['input'];
};


export type QuerysearchAmFaqCategoriesArgs = {
  filter?: InputMaybe<AmFaqCategoryFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AmFaqCategorySortInput>;
};


export type QuerysearchAmFaqQuestionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AmFaqQuestionFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AmFaqQuestionSortInput>;
};


export type QueryurlResolverArgs = {
  url: Scalars['String']['input'];
};


export type QueryentitiesArgs = {
  where: Array<EntityWhereInput>;
};


export type QuerypagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QuerypageArgs = {
  where: PageWhereUniqueInput;
  stage?: Stage;
};


export type QuerypagesConnectionArgs = {
  where?: InputMaybe<PageWhereInput>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowHeroBannersArgs = {
  where?: InputMaybe<RowHeroBannerWhereInput>;
  orderBy?: InputMaybe<RowHeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowHeroBannerArgs = {
  where: RowHeroBannerWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowHeroBannersConnectionArgs = {
  where?: InputMaybe<RowHeroBannerWhereInput>;
  orderBy?: InputMaybe<RowHeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QuerypageLinksArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QuerypageLinkArgs = {
  where: PageLinkWhereUniqueInput;
  stage?: Stage;
};


export type QuerypageLinksConnectionArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryfootersArgs = {
  where?: InputMaybe<FooterWhereInput>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryfooterArgs = {
  where: FooterWhereUniqueInput;
  stage?: Stage;
};


export type QueryfootersConnectionArgs = {
  where?: InputMaybe<FooterWhereInput>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowServiceOptionsMultipleArgs = {
  where?: InputMaybe<RowServiceOptionsWhereInput>;
  orderBy?: InputMaybe<RowServiceOptionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowServiceOptionsArgs = {
  where: RowServiceOptionsWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowServiceOptionsMultipleConnectionArgs = {
  where?: InputMaybe<RowServiceOptionsWhereInput>;
  orderBy?: InputMaybe<RowServiceOptionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowBlogContentsArgs = {
  where?: InputMaybe<RowBlogContentWhereInput>;
  orderBy?: InputMaybe<RowBlogContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowBlogContentArgs = {
  where: RowBlogContentWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowBlogContentsConnectionArgs = {
  where?: InputMaybe<RowBlogContentWhereInput>;
  orderBy?: InputMaybe<RowBlogContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryuspsMultipleArgs = {
  where?: InputMaybe<UspsWhereInput>;
  orderBy?: InputMaybe<UspsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryuspsArgs = {
  where: UspsWhereUniqueInput;
  stage?: Stage;
};


export type QueryuspsMultipleConnectionArgs = {
  where?: InputMaybe<UspsWhereInput>;
  orderBy?: InputMaybe<UspsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowProductMultipleArgs = {
  where?: InputMaybe<RowProductWhereInput>;
  orderBy?: InputMaybe<RowProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowProductArgs = {
  where: RowProductWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowProductMultipleConnectionArgs = {
  where?: InputMaybe<RowProductWhereInput>;
  orderBy?: InputMaybe<RowProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowLinksMultipleArgs = {
  where?: InputMaybe<RowLinksWhereInput>;
  orderBy?: InputMaybe<RowLinksOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowLinksArgs = {
  where: RowLinksWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowLinksMultipleConnectionArgs = {
  where?: InputMaybe<RowLinksWhereInput>;
  orderBy?: InputMaybe<RowLinksOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryproductSideInfosArgs = {
  where?: InputMaybe<ProductSideInfoWhereInput>;
  orderBy?: InputMaybe<ProductSideInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryproductSideInfoArgs = {
  where: ProductSideInfoWhereUniqueInput;
  stage?: Stage;
};


export type QueryproductSideInfosConnectionArgs = {
  where?: InputMaybe<ProductSideInfoWhereInput>;
  orderBy?: InputMaybe<ProductSideInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowBrandsBannersArgs = {
  where?: InputMaybe<RowBrandsBannerWhereInput>;
  orderBy?: InputMaybe<RowBrandsBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowBrandsBannerArgs = {
  where: RowBrandsBannerWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowBrandsBannersConnectionArgs = {
  where?: InputMaybe<RowBrandsBannerWhereInput>;
  orderBy?: InputMaybe<RowBrandsBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowOrderProcessesArgs = {
  where?: InputMaybe<RowOrderProcessWhereInput>;
  orderBy?: InputMaybe<RowOrderProcessOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowOrderProcessArgs = {
  where: RowOrderProcessWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowOrderProcessesConnectionArgs = {
  where?: InputMaybe<RowOrderProcessWhereInput>;
  orderBy?: InputMaybe<RowOrderProcessOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowProductHighlightsArgs = {
  where?: InputMaybe<RowProductHighlightWhereInput>;
  orderBy?: InputMaybe<RowProductHighlightOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowProductHighlightArgs = {
  where: RowProductHighlightWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowProductHighlightsConnectionArgs = {
  where?: InputMaybe<RowProductHighlightWhereInput>;
  orderBy?: InputMaybe<RowProductHighlightOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QuerypageFootersArgs = {
  where?: InputMaybe<PageFooterWhereInput>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QuerypageFooterArgs = {
  where: PageFooterWhereUniqueInput;
  stage?: Stage;
};


export type QuerypageFootersConnectionArgs = {
  where?: InputMaybe<PageFooterWhereInput>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryproductThingsToKnowsArgs = {
  where?: InputMaybe<ProductThingsToKnowWhereInput>;
  orderBy?: InputMaybe<ProductThingsToKnowOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryproductThingsToKnowArgs = {
  where: ProductThingsToKnowWhereUniqueInput;
  stage?: Stage;
};


export type QueryproductThingsToKnowsConnectionArgs = {
  where?: InputMaybe<ProductThingsToKnowWhereInput>;
  orderBy?: InputMaybe<ProductThingsToKnowOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowServicePageContentsArgs = {
  where?: InputMaybe<RowServicePageContentWhereInput>;
  orderBy?: InputMaybe<RowServicePageContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowServicePageContentArgs = {
  where: RowServicePageContentWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowServicePageContentsConnectionArgs = {
  where?: InputMaybe<RowServicePageContentWhereInput>;
  orderBy?: InputMaybe<RowServicePageContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowReviewHighlightsArgs = {
  where?: InputMaybe<RowReviewHighlightWhereInput>;
  orderBy?: InputMaybe<RowReviewHighlightOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowReviewHighlightArgs = {
  where: RowReviewHighlightWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowReviewHighlightsConnectionArgs = {
  where?: InputMaybe<RowReviewHighlightWhereInput>;
  orderBy?: InputMaybe<RowReviewHighlightOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowFeaturedCategoriesArgs = {
  where?: InputMaybe<RowFeaturedCategoryWhereInput>;
  orderBy?: InputMaybe<RowFeaturedCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowFeaturedCategoryArgs = {
  where: RowFeaturedCategoryWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowFeaturedCategoriesConnectionArgs = {
  where?: InputMaybe<RowFeaturedCategoryWhereInput>;
  orderBy?: InputMaybe<RowFeaturedCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowParagraphsArgs = {
  where?: InputMaybe<RowParagraphWhereInput>;
  orderBy?: InputMaybe<RowParagraphOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};


export type QueryrowParagraphArgs = {
  where: RowParagraphWhereUniqueInput;
  stage?: Stage;
};


export type QueryrowParagraphsConnectionArgs = {
  where?: InputMaybe<RowParagraphWhereInput>;
  orderBy?: InputMaybe<RowParagraphOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
};

export type Mutation = {
  /** Add one or more bundle products to the specified cart. We recommend using `addProductsToCart` instead. */
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  /** Add one or more configurable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  addCustomerNoteToCart: Cart;
  /** Add one or more downloadable products to the specified cart. We recommend using `addProductsToCart` instead. */
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>;
  /** Add any type of product to the cart. */
  addProductsToCart?: Maybe<AddProductsToCartOutput>;
  /** Add products to the specified compare list. */
  addProductsToCompareList?: Maybe<CompareList>;
  /** Add one or more products to the specified wish list. This mutation supports all product types. */
  addProductsToWishlist?: Maybe<AddProductsToWishlistOutput>;
  /** Add one or more simple products to the specified cart. We recommend using `addProductsToCart` instead. */
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  /** Add one or more virtual products to the specified cart. We recommend using `addProductsToCart` instead. */
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  /** Add items in the specified wishlist to the customer's cart. */
  addWishlistItemsToCart?: Maybe<AddWishlistItemsToCartOutput>;
  /** Link account */
  amSocialLoginLinkAccount?: Maybe<AmUnlinkData>;
  /** Unlink account */
  amSocialLoginUnlinkAccount?: Maybe<AmUnlinkData>;
  /** Apply a pre-defined coupon code to the specified cart. */
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  approveProof?: Maybe<GenericProofOutput>;
  /** Assign the specified compare list to the logged in customer. */
  assignCompareListToCustomer?: Maybe<AssignCompareListToCustomerOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart. */
  assignCustomerToGuestCart: Cart;
  attachArtwork?: Maybe<AttachArtworkOutput>;
  attachProjectData?: Maybe<AttachProjectDataOutput>;
  /** Change password for sub user */
  bssCompanyAccountChangeSubPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Create sub-user */
  bssCompanyAccountCreateSubUser?: Maybe<Scalars['Boolean']['output']>;
  /** Delete role */
  bssCompanyAccountDeleteRole?: Maybe<Scalars['Boolean']['output']>;
  /** Delete sub-user by id */
  bssCompanyAccountDeleteSubUser?: Maybe<Scalars['Boolean']['output']>;
  /** Edit sub-user */
  bssCompanyAccountEditSubUser?: Maybe<Scalars['Boolean']['output']>;
  /** Request send email reset password for sub user */
  bssCompanyAccountRequestResetSubPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Reset sub-user password */
  bssCompanyAccountResetSubPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Create/update role */
  bssCompanyAccountSaveRole?: Maybe<SubRole>;
  /** Generate the sub-user token */
  bssGenerateSubUserToken?: Maybe<SubUserToken>;
  /** Revoke the sub-user token */
  bssRevokeSubUserToken?: Maybe<RevokeSubUserTokenOutput>;
  /** Update company to company account or not */
  bssUpdateToCompanyAccount?: Maybe<Customer>;
  /** Change the password for the logged-in customer. */
  changeCustomerPassword?: Maybe<Customer>;
  /** Creates Client Token for Braintree Javascript SDK initialization. */
  createBraintreeClientToken: Scalars['String']['output'];
  /** Create a new compare list. The compare list is saved for logged in customers. */
  createCompareList?: Maybe<CompareList>;
  /** Use `createCustomerV2` instead. */
  createCustomer?: Maybe<CustomerOutput>;
  /** Create a billing or shipping address for a customer or guest. */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Create a customer account. */
  createCustomerV2?: Maybe<CustomerOutput>;
  /** Create an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']['output']>;
  createFourOverProductArtworkFiles?: Maybe<ArtworkPreflightResponse>;
  /** Initiate a transaction and receive a token. Use this mutation for Payflow Pro and Payments Pro payment methods */
  createPayflowProToken?: Maybe<CreatePayflowProTokenOutput>;
  /** Initiate an Express Checkout transaction and receive a token. Use this mutation for Express Checkout and Payments Standard payment methods. */
  createPaypalExpressToken?: Maybe<PaypalExpressTokenOutput>;
  /** Create a product review for the specified product. */
  createProductReview: CreateProductReviewOutput;
  declineProof?: Maybe<GenericProofOutput>;
  /** Delete the specified compare list. */
  deleteCompareList?: Maybe<DeleteCompareListOutput>;
  /** Delete customer account */
  deleteCustomer?: Maybe<Scalars['Boolean']['output']>;
  /** Delete the billing or shipping address of a customer. */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a customer's payment token. */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  detachArtwork?: Maybe<DetachArtworkOutput>;
  /** Generate a token for specified customer. */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Request a customer token so that an administrator can perform remote shopping assistance. */
  generateCustomerTokenAsAdmin?: Maybe<GenerateCustomerTokenAsAdminOutput>;
  /** Request a customer token by secret. */
  generateCustomerTokenBySecret?: Maybe<GenerateCustomerTokenBySecretOutput>;
  generateSignedCommandUrl?: Maybe<SignedCommandUrlOutput>;
  /** Handle a payment response and save the payment in Quote. Use this mutation for Payflow Pro and Payments Pro payment methods. */
  handlePayflowProResponse?: Maybe<PayflowProResponseOutput>;
  /** Transfer the contents of a guest cart into the cart of a logged-in customer. */
  mergeCarts: Cart;
  /** Place new FAQ Question. */
  placeAmFaqQuestion?: Maybe<AmFaqCommonOutput>;
  /** Convert the quote into an order. */
  placeOrder?: Maybe<PlaceOrderOutput>;
  prepareCheckout?: Maybe<Cart>;
  /** Rate FAQ Question. */
  rateAmFaqQuestion?: Maybe<AmFaqCommonOutput>;
  /** Remove a previously-applied coupon from the cart. The cart must contain at least one item in order to remove the coupon. */
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  /** Delete the entire quantity of a specified item from the cart. If you remove all items from the cart, the cart continues to exist. */
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  /** Remove products from the specified compare list. */
  removeProductsFromCompareList?: Maybe<CompareList>;
  /** Remove one or more products from the specified wish list. */
  removeProductsFromWishlist?: Maybe<RemoveProductsFromWishlistOutput>;
  /** Switch customer to company account yes/no */
  reorderItem?: Maybe<ReorderItemOutput>;
  /** Add all products from a customer's previous order to the cart. */
  reorderItems?: Maybe<ReorderItemsOutput>;
  /** Request an email with a reset password token for the registered customer identified by the specified email. */
  requestPasswordResetEmail?: Maybe<Scalars['Boolean']['output']>;
  resetCheckout?: Maybe<Cart>;
  /** Reset a customer's password using the reset password token that the customer received in an email after requesting it using `requestPasswordResetEmail`. */
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Revoke the customer token. */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  /** Send a message on behalf of a customer to the specified email addresses. */
  sendEmailToFriend?: Maybe<SendEmailToFriendOutput>;
  /** Set the billing address on a specific cart. */
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  /** Assign the email address of a guest to the cart. */
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  /**
   * Set the cart payment method and convert the cart into an order.
   * @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request.
   */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  /** Apply a payment method to the cart. */
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  /** Set one or more shipping addresses on a specific cart. */
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  /** Set one or more delivery methods on a cart. */
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  /** Subscribe the specified email to the store's newsletter. */
  subscribeEmailToNewsletter?: Maybe<SubscribeEmailToNewsletterOutput>;
  update4OverItemQuantity?: Maybe<Update4OverItemQuantityOutput>;
  /** Modify items in the cart. */
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** Use `updateCustomerV2` instead. */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update the billing or shipping address of a customer or guest. */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  /** Change the email address for the logged-in customer. */
  updateCustomerEmail?: Maybe<CustomerOutput>;
  /** Switch customer to company account yes/no */
  updateCustomerIsCompanyAccount?: Maybe<CustomerOutput>;
  /** Update the customer's personal information. */
  updateCustomerV2?: Maybe<CustomerOutput>;
  /** Update one or more products in the specified wish list. */
  updateProductsInWishlist?: Maybe<UpdateProductsInWishlistOutput>;
};


export type MutationaddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};


export type MutationaddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};


export type MutationaddCustomerNoteToCartArgs = {
  input: SetCustomerNoteToCartInput;
};


export type MutationaddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>;
};


export type MutationaddProductsToCartArgs = {
  cartId: Scalars['String']['input'];
  cartItems: Array<CartItemInput>;
};


export type MutationaddProductsToCompareListArgs = {
  input?: InputMaybe<AddProductsToCompareListInput>;
};


export type MutationaddProductsToWishlistArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItems: Array<WishlistItemInput>;
};


export type MutationaddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};


export type MutationaddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};


export type MutationaddWishlistItemsToCartArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationamSocialLoginLinkAccountArgs = {
  type: Scalars['String']['input'];
};


export type MutationamSocialLoginUnlinkAccountArgs = {
  type: Scalars['String']['input'];
};


export type MutationapplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};


export type MutationapproveProofArgs = {
  proofId: Scalars['ID']['input'];
  comments: Scalars['String']['input'];
};


export type MutationassignCompareListToCustomerArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationassignCustomerToGuestCartArgs = {
  cart_id: Scalars['String']['input'];
};


export type MutationattachArtworkArgs = {
  fileUrl: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  cartItemUid: Scalars['ID']['input'];
  proofingOption?: InputMaybe<PROOFING_OPTION>;
  comments?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['String']['input']>;
};


export type MutationattachProjectDataArgs = {
  cartUid: Scalars['ID']['input'];
  cartItemUid: Scalars['ID']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationbssCompanyAccountChangeSubPasswordArgs = {
  user?: InputMaybe<SubUserChangePass>;
};


export type MutationbssCompanyAccountCreateSubUserArgs = {
  user?: InputMaybe<SubUsers>;
};


export type MutationbssCompanyAccountDeleteRoleArgs = {
  role_id: Scalars['Int']['input'];
};


export type MutationbssCompanyAccountDeleteSubUserArgs = {
  sub_id: Scalars['Int']['input'];
};


export type MutationbssCompanyAccountEditSubUserArgs = {
  user?: InputMaybe<SubUserForEdit>;
};


export type MutationbssCompanyAccountRequestResetSubPasswordArgs = {
  user?: InputMaybe<SubUserRequestResetPass>;
};


export type MutationbssCompanyAccountResetSubPasswordArgs = {
  user?: InputMaybe<SubUserResetPass>;
};


export type MutationbssCompanyAccountSaveRoleArgs = {
  input?: InputMaybe<SubRoleInput>;
};


export type MutationbssGenerateSubUserTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationbssUpdateToCompanyAccountArgs = {
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  is_company_account?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationchangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationcreateCompareListArgs = {
  input?: InputMaybe<CreateCompareListInput>;
};


export type MutationcreateCustomerArgs = {
  input: CustomerInput;
};


export type MutationcreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


export type MutationcreateCustomerV2Args = {
  input: CustomerCreateInput;
};


export type MutationcreateEmptyCartArgs = {
  input?: InputMaybe<createEmptyCartInput>;
};


export type MutationcreateFourOverProductArtworkFilesArgs = {
  files?: InputMaybe<Array<InputMaybe<FourOverFile>>>;
};


export type MutationcreatePayflowProTokenArgs = {
  input: PayflowProTokenInput;
};


export type MutationcreatePaypalExpressTokenArgs = {
  input: PaypalExpressTokenInput;
};


export type MutationcreateProductReviewArgs = {
  input: CreateProductReviewInput;
};


export type MutationdeclineProofArgs = {
  proofId: Scalars['ID']['input'];
  comments: Scalars['String']['input'];
};


export type MutationdeleteCompareListArgs = {
  uid: Scalars['ID']['input'];
};


export type MutationdeleteCustomerAddressArgs = {
  id: Scalars['Int']['input'];
};


export type MutationdeletePaymentTokenArgs = {
  public_hash: Scalars['String']['input'];
};


export type MutationdetachArtworkArgs = {
  artworkId: Scalars['ID']['input'];
};


export type MutationgenerateCustomerTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationgenerateCustomerTokenAsAdminArgs = {
  input: GenerateCustomerTokenAsAdminInput;
};


export type MutationgenerateCustomerTokenBySecretArgs = {
  input: GenerateCustomerTokenBySecretInput;
};


export type MutationgenerateSignedCommandUrlArgs = {
  objectKey: Scalars['String']['input'];
  bucket?: InputMaybe<Scalars['String']['input']>;
};


export type MutationhandlePayflowProResponseArgs = {
  input: PayflowProResponseInput;
};


export type MutationmergeCartsArgs = {
  source_cart_id: Scalars['String']['input'];
  destination_cart_id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationplaceAmFaqQuestionArgs = {
  input?: InputMaybe<PlaceAmFaqQuestionInput>;
};


export type MutationplaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};


export type MutationprepareCheckoutArgs = {
  cart_id: Scalars['ID']['input'];
};


export type MutationrateAmFaqQuestionArgs = {
  input?: InputMaybe<RateAmFaqQuestionInput>;
};


export type MutationremoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};


export type MutationremoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};


export type MutationremoveProductsFromCompareListArgs = {
  input?: InputMaybe<RemoveProductsFromCompareListInput>;
};


export type MutationremoveProductsFromWishlistArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItemsIds: Array<Scalars['ID']['input']>;
};


export type MutationreorderItemArgs = {
  input: ReorderItemInput;
};


export type MutationreorderItemsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationrequestPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationresetCheckoutArgs = {
  cart_id: Scalars['ID']['input'];
};


export type MutationresetPasswordArgs = {
  email: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationsendEmailToFriendArgs = {
  input?: InputMaybe<SendEmailToFriendInput>;
};


export type MutationsetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};


export type MutationsetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};


export type MutationsetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};


export type MutationsetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};


export type MutationsetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};


export type MutationsetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};


export type MutationsubscribeEmailToNewsletterArgs = {
  email: Scalars['String']['input'];
  customFields?: InputMaybe<NewsletterCustomFieldsInput>;
};


export type Mutationupdate4OverItemQuantityArgs = {
  input?: InputMaybe<Update4OverItemQuantityInput>;
};


export type MutationupdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};


export type MutationupdateCustomerArgs = {
  input: CustomerInput;
};


export type MutationupdateCustomerAddressArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<CustomerAddressInput>;
};


export type MutationupdateCustomerEmailArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationupdateCustomerIsCompanyAccountArgs = {
  isCompanyAccount: Scalars['Boolean']['input'];
};


export type MutationupdateCustomerV2Args = {
  input: CustomerUpdateInput;
};


export type MutationupdateProductsInWishlistArgs = {
  wishlistId: Scalars['ID']['input'];
  wishlistItems: Array<WishlistItemUpdateInput>;
};

/** Defines the comparison operators that can be used in a filter. */
export type FilterTypeInput = {
  /** Equals. */
  eq?: InputMaybe<Scalars['String']['input']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** From. Must be used with the `to` field. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Greater than. */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to. */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** In. The value can contain a set of comma-separated values. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Less than. */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to. */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** More than or equal to. */
  moreq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to. */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Not in. The value can contain a set of comma-separated values. */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not null. */
  notnull?: InputMaybe<Scalars['String']['input']>;
  /** Is null. */
  null?: InputMaybe<Scalars['String']['input']>;
  /** To. Must be used with the `from` field. */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific category ID, specify a value such as `5`. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Use this attribute to filter on an array of values. For example, to filter on category IDs 4, 5, and 6, specify a value of `["4", "5", "6"]`. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** Use this attribute to specify the lowest possible value in the range. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Use this attribute to specify the highest possible value in the range. */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** Use this attribute to exactly match the specified string. For example, to filter on a specific SKU, specify a value such as `24-MB01`. */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** Provides navigation for the query response. */
export type SearchResultPageInfo = {
  /** The specific page to return. */
  current_page?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of items to return per page of results. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages in the response. */
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Indicates whether to return results in ascending or descending order. */
export type SortEnum =
  | 'ASC'
  | 'DESC';

export type ComplexTextValue = {
  /** Text that can contain HTML tags. */
  html: Scalars['String']['output'];
};

/** Defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  /** A three-letter currency code, such as USD or EUR. */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** The list of available currency codes. */
export type CurrencyEnum =
  | 'AFN'
  | 'ALL'
  | 'AZN'
  | 'DZD'
  | 'AOA'
  | 'ARS'
  | 'AMD'
  | 'AWG'
  | 'AUD'
  | 'BSD'
  | 'BHD'
  | 'BDT'
  | 'BBD'
  | 'BYN'
  | 'BZD'
  | 'BMD'
  | 'BTN'
  | 'BOB'
  | 'BAM'
  | 'BWP'
  | 'BRL'
  | 'GBP'
  | 'BND'
  | 'BGN'
  | 'BUK'
  | 'BIF'
  | 'KHR'
  | 'CAD'
  | 'CVE'
  | 'CZK'
  | 'KYD'
  | 'GQE'
  | 'CLP'
  | 'CNY'
  | 'COP'
  | 'KMF'
  | 'CDF'
  | 'CRC'
  | 'HRK'
  | 'CUP'
  | 'DKK'
  | 'DJF'
  | 'DOP'
  | 'XCD'
  | 'EGP'
  | 'SVC'
  | 'ERN'
  | 'EEK'
  | 'ETB'
  | 'EUR'
  | 'FKP'
  | 'FJD'
  | 'GMD'
  | 'GEK'
  | 'GEL'
  | 'GHS'
  | 'GIP'
  | 'GTQ'
  | 'GNF'
  | 'GYD'
  | 'HTG'
  | 'HNL'
  | 'HKD'
  | 'HUF'
  | 'ISK'
  | 'INR'
  | 'IDR'
  | 'IRR'
  | 'IQD'
  | 'ILS'
  | 'JMD'
  | 'JPY'
  | 'JOD'
  | 'KZT'
  | 'KES'
  | 'KWD'
  | 'KGS'
  | 'LAK'
  | 'LVL'
  | 'LBP'
  | 'LSL'
  | 'LRD'
  | 'LYD'
  | 'LTL'
  | 'MOP'
  | 'MKD'
  | 'MGA'
  | 'MWK'
  | 'MYR'
  | 'MVR'
  | 'LSM'
  | 'MRO'
  | 'MUR'
  | 'MXN'
  | 'MDL'
  | 'MNT'
  | 'MAD'
  | 'MZN'
  | 'MMK'
  | 'NAD'
  | 'NPR'
  | 'ANG'
  | 'YTL'
  | 'NZD'
  | 'NIC'
  | 'NGN'
  | 'KPW'
  | 'NOK'
  | 'OMR'
  | 'PKR'
  | 'PAB'
  | 'PGK'
  | 'PYG'
  | 'PEN'
  | 'PHP'
  | 'PLN'
  | 'QAR'
  | 'RHD'
  | 'RON'
  | 'RUB'
  | 'RWF'
  | 'SHP'
  | 'STD'
  | 'SAR'
  | 'RSD'
  | 'SCR'
  | 'SLL'
  | 'SGD'
  | 'SKK'
  | 'SBD'
  | 'SOS'
  | 'ZAR'
  | 'KRW'
  | 'LKR'
  | 'SDG'
  | 'SRD'
  | 'SZL'
  | 'SEK'
  | 'CHF'
  | 'SYP'
  | 'TWD'
  | 'TJS'
  | 'TZS'
  | 'THB'
  | 'TOP'
  | 'TTD'
  | 'TND'
  | 'TMM'
  | 'USD'
  | 'UGX'
  | 'UAH'
  | 'AED'
  | 'UYU'
  | 'UZS'
  | 'VUV'
  | 'VEB'
  | 'VEF'
  | 'VND'
  | 'CHE'
  | 'CHW'
  | 'XOF'
  | 'WST'
  | 'YER'
  | 'ZMK'
  | 'ZWD'
  | 'TRY'
  | 'AZM'
  | 'ROL'
  | 'TRL'
  | 'XPF';

/** Defines a customer-entered option. */
export type EnteredOptionInput = {
  /** The unique ID for a `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  uid: Scalars['ID']['input'];
  /** Text the customer entered. */
  value: Scalars['String']['input'];
};

export type BatchMutationStatus =
  | 'SUCCESS'
  | 'FAILURE'
  | 'MIXED_RESULTS';

export type ErrorInterface = {
  /** The returned error message. */
  message: Scalars['String']['output'];
};

/** Contains an error message when an invalid UID was specified. */
export type NoSuchEntityUidError = ErrorInterface & {
  /** The returned error message. */
  message: Scalars['String']['output'];
  /** The specified invalid unique ID of an object. */
  uid: Scalars['ID']['output'];
};

/** Contains an error message when an internal error occurred. */
export type InternalError = ErrorInterface & {
  /** The returned error message. */
  message: Scalars['String']['output'];
};

/** The type contains information about a store config. */
export type StoreConfig = {
  /** Contains scripts that must be included in the HTML before the closing `<body>` tag. */
  absolute_footer?: Maybe<Scalars['String']['output']>;
  /** Indicates whether guest users can write product reviews. Possible values: 1 (Yes) and 0 (No). */
  allow_guests_to_write_product_reviews?: Maybe<Scalars['String']['output']>;
  /** The value of the Allow Gift Messages for Order Items option */
  allow_items?: Maybe<Scalars['String']['output']>;
  /** The value of the Allow Gift Messages on Order Level option */
  allow_order?: Maybe<Scalars['String']['output']>;
  /** Login Buttons Position. */
  amsociallogin_general_button_position?: Maybe<Scalars['String']['output']>;
  /** Login Buttons Shape. */
  amsociallogin_general_button_shape?: Maybe<Scalars['Int']['output']>;
  /** Redirect Url after Login. */
  amsociallogin_general_custom_url?: Maybe<Scalars['String']['output']>;
  /** Enable Social Login. */
  amsociallogin_general_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Add Social Login to. */
  amsociallogin_general_login_position?: Maybe<Scalars['String']['output']>;
  /** Enable Ajax Popup. */
  amsociallogin_general_popup_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Redirect after Login. */
  amsociallogin_general_redirect_type?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether to enable autocomplete on login and forgot password forms. */
  autocomplete_on_storefront?: Maybe<Scalars['Boolean']['output']>;
  /** The base currency code. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** A fully-qualified URL that is used to create relative links to the `base_url`. */
  base_link_url?: Maybe<Scalars['String']['output']>;
  /** The fully-qualified URL that specifies the location of media files. */
  base_media_url?: Maybe<Scalars['String']['output']>;
  /** The fully-qualified URL that specifies the location of static view files. */
  base_static_url?: Maybe<Scalars['String']['output']>;
  /** The store’s fully-qualified base URL. */
  base_url?: Maybe<Scalars['String']['output']>;
  /** Braintree cc vault status. */
  braintree_cc_vault_active?: Maybe<Scalars['String']['output']>;
  /** The default sort order of the search results list. */
  catalog_default_sort_by?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices In Product Lists' field in the Admin. It indicates how FPT information is displayed on category pages. */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** The suffix applied to category pages, such as `.htm` or `.html`. */
  category_url_suffix?: Maybe<Scalars['String']['output']>;
  /** Indicates whether only specific countries can use this payment method. */
  check_money_order_enable_for_specific_countries?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the Check/Money Order payment method is enabled. */
  check_money_order_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the party to whom the check must be payable. */
  check_money_order_make_check_payable_to?: Maybe<Scalars['String']['output']>;
  /** The maximum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_max_order_total?: Maybe<Scalars['String']['output']>;
  /** The minimum order amount required to qualify for the Check/Money Order payment method. */
  check_money_order_min_order_total?: Maybe<Scalars['String']['output']>;
  /** The status of new orders placed using the Check/Money Order payment method. */
  check_money_order_new_order_status?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of specific countries allowed to use the Check/Money Order payment method. */
  check_money_order_payment_from_specific_countries?: Maybe<Scalars['String']['output']>;
  /** The full street address or PO Box where the checks are mailed. */
  check_money_order_send_check_to?: Maybe<Scalars['String']['output']>;
  /** A number indicating the position of the Check/Money Order payment method in the list of available payment methods during checkout. */
  check_money_order_sort_order?: Maybe<Scalars['Int']['output']>;
  /** The title of the Check/Money Order payment method displayed on the storefront. */
  check_money_order_title?: Maybe<Scalars['String']['output']>;
  /** The name of the CMS page that identifies the home page for the store. */
  cms_home_page?: Maybe<Scalars['String']['output']>;
  /** A specific CMS page that displays when cookies are not enabled for the browser. */
  cms_no_cookies?: Maybe<Scalars['String']['output']>;
  /** A specific CMS page that displays when a 404 'Page Not Found' error occurs. */
  cms_no_route?: Maybe<Scalars['String']['output']>;
  /**
   * A code assigned to the store to identify it.
   * @deprecated Use `store_code` instead.
   */
  code?: Maybe<Scalars['String']['output']>;
  /** To be company account notification Email Template */
  company_account_ca_approval?: Maybe<Scalars['String']['output']>;
  /** Revoke company account notification email template */
  company_account_ca_remove?: Maybe<Scalars['String']['output']>;
  /** Email Sender */
  company_account_email_sender?: Maybe<Scalars['String']['output']>;
  /** Module enable/disable */
  company_account_enable?: Maybe<Scalars['String']['output']>;
  /** To be company account notification copy to emails */
  company_account_send_approval_copy_to?: Maybe<Scalars['String']['output']>;
  /** Revoke company account notification copy to emails */
  company_account_send_remove_copy_to?: Maybe<Scalars['String']['output']>;
  /** Remove sub-user from company account notification email template */
  company_account_subuser_remove?: Maybe<Scalars['String']['output']>;
  /** Reset password sub-user email template */
  company_account_subuser_reset_password?: Maybe<Scalars['String']['output']>;
  /** Welcome to be sub-user of company account notification email template. */
  company_account_subuser_welcome?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the `parent` or child (`itself`) thumbnail should be used in the cart for configurable products. */
  configurable_thumbnail_source?: Maybe<Scalars['String']['output']>;
  /** The copyright statement that appears at the bottom of each page. */
  copyright?: Maybe<Scalars['String']['output']>;
  /** The description that provides a summary of your site for search engine listings. It should not be more than 160 characters in length. */
  default_description?: Maybe<Scalars['String']['output']>;
  /** The default display currency code. */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** A series of keywords that describe your store, each separated by a comma. */
  default_keywords?: Maybe<Scalars['String']['output']>;
  /** The title that appears at the title bar of each page when viewed in a browser. */
  default_title?: Maybe<Scalars['String']['output']>;
  /** Controls the display of the demo store notice at the top of the page. Options: 0 (No) or 1 (Yes). */
  demonotice?: Maybe<Scalars['Int']['output']>;
  /** The landing page that is associated with the base URL. */
  front?: Maybe<Scalars['String']['output']>;
  /** The default number of products per page in Grid View. */
  grid_per_page?: Maybe<Scalars['Int']['output']>;
  /** A list of numbers that define how many products can be displayed in Grid View. */
  grid_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Scripts that must be included in the HTML before the closing `<head>` tag. */
  head_includes?: Maybe<Scalars['String']['output']>;
  /** The small graphic image (favicon) that appears in the address bar and tab of the browser. */
  head_shortcut_icon?: Maybe<Scalars['String']['output']>;
  /** The path to the logo that appears in the header. */
  header_logo_src?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the store.
   * @deprecated Use `store_code` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the store view has been designated as the default within the store group. */
  is_default_store?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the store group has been designated as the default within the website. */
  is_default_store_group?: Maybe<Scalars['Boolean']['output']>;
  /** The format of the search results list. */
  list_mode?: Maybe<Scalars['String']['output']>;
  /** The default number of products per page in List View. */
  list_per_page?: Maybe<Scalars['Int']['output']>;
  /** A list of numbers that define how many products can be displayed in List View. */
  list_per_page_values?: Maybe<Scalars['String']['output']>;
  /** The store locale. */
  locale?: Maybe<Scalars['String']['output']>;
  /** The Alt text that is associated with the logo. */
  logo_alt?: Maybe<Scalars['String']['output']>;
  /** The height of the logo image, in pixels. */
  logo_height?: Maybe<Scalars['Int']['output']>;
  /** The width of the logo image, in pixels. */
  logo_width?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether wishlists are enabled (1) or disabled (0). */
  magento_wishlist_general_is_enabled?: Maybe<Scalars['String']['output']>;
  /** The minimum number of characters required for a valid password. */
  minimum_password_length?: Maybe<Scalars['String']['output']>;
  /** The default page that displays when a 404 'Page not Found' error occurs. */
  no_route?: Maybe<Scalars['String']['output']>;
  /** Payflow Pro vault status. */
  payment_payflowpro_cc_vault_active?: Maybe<Scalars['String']['output']>;
  pitch_print_api_key?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices On Product View Page' field in the Admin. It indicates how FPT information is displayed on product pages. */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Indicates whether product reviews are enabled. Possible values: 1 (Yes) and 0 (No). */
  product_reviews_enabled?: Maybe<Scalars['String']['output']>;
  /** The suffix applied to product pages, such as `.htm` or `.html`. */
  product_url_suffix?: Maybe<Scalars['String']['output']>;
  /** The number of different character classes (lowercase, uppercase, digits, special characters) required in a password. */
  required_character_classes_number?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the root category.
   * @deprecated Use `root_category_uid` instead.
   */
  root_category_id?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for a `CategoryInterface` object. */
  root_category_uid?: Maybe<Scalars['ID']['output']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field in the Admin. It indicates how FPT information is displayed on cart, checkout, and order pages. */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** A secure fully-qualified URL that is used to create relative links to the `base_url`. */
  secure_base_link_url?: Maybe<Scalars['String']['output']>;
  /** The secure fully-qualified URL that specifies the location of media files. */
  secure_base_media_url?: Maybe<Scalars['String']['output']>;
  /** The secure fully-qualified URL that specifies the location of static view files. */
  secure_base_static_url?: Maybe<Scalars['String']['output']>;
  /** The store’s fully-qualified secure base URL. */
  secure_base_url?: Maybe<Scalars['String']['output']>;
  /** Email to a Friend configuration. */
  send_friend?: Maybe<SendFriendConfiguration>;
  /** Indicates whether a breadcrumb trail appears on all CMS pages in the catalog. 0 (No) or 1 (Yes). */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']['output']>;
  /** The unique ID of the store view. In the Admin, this is called the Store View Code. When making a GraphQL call, assign this value to the `Store` header to provide the scope. */
  store_code?: Maybe<Scalars['ID']['output']>;
  /** The unique ID assigned to the store group. In the Admin, this is called the Store Name. */
  store_group_code?: Maybe<Scalars['ID']['output']>;
  /** The label assigned to the store group. */
  store_group_name?: Maybe<Scalars['String']['output']>;
  /** The label assigned to the store view. */
  store_name?: Maybe<Scalars['String']['output']>;
  /** The store view sort order. */
  store_sort_order?: Maybe<Scalars['Int']['output']>;
  /** The time zone of the store. */
  timezone?: Maybe<Scalars['String']['output']>;
  /** A prefix that appears before the title to create a two- or three-part title. */
  title_prefix?: Maybe<Scalars['String']['output']>;
  /** The character that separates the category name and subcategory in the browser title bar. */
  title_separator?: Maybe<Scalars['String']['output']>;
  /** A suffix that appears after the title to create a two- or three-part title. */
  title_suffix?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the store code should be used in the URL. */
  use_store_in_url?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for the website. */
  website_code?: Maybe<Scalars['ID']['output']>;
  /**
   * The ID number assigned to the website store.
   * @deprecated The field should not be used on the storefront.
   */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The label assigned to the website. */
  website_name?: Maybe<Scalars['String']['output']>;
  /** The unit of weight. */
  weight_unit?: Maybe<Scalars['String']['output']>;
  /** Text that appears in the header of the page and includes the name of the logged in customer. */
  welcome?: Maybe<Scalars['String']['output']>;
  /** Indicates whether only specific countries can use this payment method. */
  zero_subtotal_enable_for_specific_countries?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the Zero Subtotal payment method is enabled. */
  zero_subtotal_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The status of new orders placed using the Zero Subtotal payment method. */
  zero_subtotal_new_order_status?: Maybe<Scalars['String']['output']>;
  /** When the new order status is 'Processing', this can be set to `authorize_capture` to automatically invoice all items that have a zero balance. */
  zero_subtotal_payment_action?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of specific countries allowed to use the Zero Subtotal payment method. */
  zero_subtotal_payment_from_specific_countries?: Maybe<Scalars['String']['output']>;
  /** A number indicating the position of the Zero Subtotal payment method in the list of available payment methods during checkout. */
  zero_subtotal_sort_order?: Maybe<Scalars['Int']['output']>;
  /** The title of the Zero Subtotal payment method displayed on the storefront. */
  zero_subtotal_title?: Maybe<Scalars['String']['output']>;
};

/** Contains details about a CMS page. */
export type CmsPage = RoutableInterface & {
  /** The content of the CMS page in raw HTML. */
  content?: Maybe<Scalars['String']['output']>;
  /** The heading that displays at the top of the CMS page. */
  content_heading?: Maybe<Scalars['String']['output']>;
  /** The ID of a CMS page. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** A brief description of the page for search results listings. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A brief description of the page for search results listings. */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** A page title that is indexed by search engines and appears in search results listings. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The design layout of the page, indicating the number of columns and navigation features used on the page. */
  page_layout?: Maybe<Scalars['String']['output']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** The name that appears in the breadcrumb trail navigation and in the browser title bar and tab. */
  title?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The URL key of the CMS page, which is often based on the `content_heading`. */
  url_key?: Maybe<Scalars['String']['output']>;
};

/** Contains an array CMS block items. */
export type CmsBlocks = {
  /** An array of CMS blocks. */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** Contains details about a specific CMS block. */
export type CmsBlock = {
  /** The content of the CMS block in raw HTML. */
  content?: Maybe<Scalars['String']['output']>;
  /** The CMS block identifier. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** The title assigned to the CMS block. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Defines an array of custom attributes. */
export type CustomAttributeMetadata = {
  /** An array of attributes. */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

/** Contains details about the attribute, including the code and type. */
export type Attribute = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute. */
  attribute_type?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute. */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute. */
  input_type?: Maybe<Scalars['String']['output']>;
  /** Details about the storefront properties configured for the attribute. */
  storefront_properties?: Maybe<StorefrontProperties>;
};

/** Indicates where an attribute can be displayed. */
export type StorefrontProperties = {
  /** The relative position of the attribute in the layered navigation block. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the attribute is filterable with results, without results, or not at all. */
  use_in_layered_navigation?: Maybe<UseInLayeredNavigationOptions>;
  /** Indicates whether the attribute is displayed in product listings. */
  use_in_product_listing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the attribute can be used in layered navigation on search results pages. */
  use_in_search_results_layered_navigation?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the attribute is displayed on product pages. */
  visible_on_catalog_pages?: Maybe<Scalars['Boolean']['output']>;
};

/** Defines whether the attribute is filterable in layered navigation. */
export type UseInLayeredNavigationOptions =
  | 'NO'
  | 'FILTERABLE_WITH_RESULTS'
  | 'FILTERABLE_NO_RESULT';

/** Defines an attribute option. */
export type AttributeOption = {
  /** The label assigned to the attribute option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The attribute option value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Defines the attribute characteristics to search for the `attribute_code` and `entity_type` to search. */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']['input']>;
  /** The type of entity that defines the attribute. */
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** Deprecated. It should not be used on the storefront. Contains information about a website. */
export type Website = {
  /**
   * A code assigned to the website to identify it.
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * The default group ID of the website.
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the website.
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /**
   * Indicates whether this is the default website.
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute to use for sorting websites.
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** Defines details about an individual checkout agreement. */
export type CheckoutAgreement = {
  /** The ID for a checkout agreement. */
  agreement_id: Scalars['Int']['output'];
  /** The checkbox text for the checkout agreement. */
  checkbox_text: Scalars['String']['output'];
  /** Required. The text of the agreement. */
  content: Scalars['String']['output'];
  /** The height of the text box where the Terms and Conditions statement appears during checkout. */
  content_height?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the `content` text is in HTML format. */
  is_html: Scalars['Boolean']['output'];
  /** Indicates whether agreements are accepted automatically or manually. */
  mode: CheckoutAgreementMode;
  /** The name given to the condition. */
  name: Scalars['String']['output'];
};

/** Indicates how agreements are accepted. */
export type CheckoutAgreementMode =
  /** Conditions are automatically accepted upon checkout. */
  | 'AUTO'
  /** Shoppers must manually accept the conditions to place an order. */
  | 'MANUAL';

/** Deprecated. Use `ProductPrice` instead. Defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Use `ProductPrice` instead.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Use `ProductPrice` instead.
   */
  amount?: Maybe<Money>;
};

/** Deprecated. Taxes will be included or excluded in the price. Defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated `PriceAdjustment` is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** `PriceAdjustment.code` is deprecated. */
export type PriceAdjustmentCodesEnum =
  | 'TAX'
  | 'WEEE'
  | 'WEEE_TAX';

/** `PriceAdjustmentDescriptionEnum` is deprecated. States whether a price adjustment is included or excluded. */
export type PriceAdjustmentDescriptionEnum =
  | 'INCLUDED'
  | 'EXCLUDED';

/** Defines the price type. */
export type PriceTypeEnum =
  | 'FIXED'
  | 'PERCENT'
  | 'DYNAMIC'
  | 'FINAL';

/** Defines the customizable date type. */
export type CustomizableDateTypeEnum =
  | 'DATE'
  | 'DATE_TIME'
  | 'TIME';

/** Deprecated. Use `PriceRange` instead. Contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `to` value.
   * @deprecated Use `PriceRange.maximum_price` instead.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the `from` value.
   * @deprecated Use `PriceRange.minimum_price` instead.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use `regular_price` from `PriceRange.minimum_price` or `PriceRange.maximum_price` instead.
   */
  regularPrice?: Maybe<Price>;
};

/** Contains the price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** Represents a product price. */
export type ProductPrice = {
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after applying discounts. */
  final_price: Money;
  /** An array of the multiple Fixed Product Taxes that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** Contains the discount applied to a product price. */
export type ProductDiscount = {
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']['output']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']['output']>;
};

/** An implementation of `ProductLinksInterface`. */
export type ProductLinks = ProductLinksInterface & {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']['output']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']['output']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']['output']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']['output']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']['output']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']['output']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Contains fields that are common to all types of products. */
export type ProductInterface = {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  last_price_break?: Maybe<PriceBreak>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Contains fields that are common to all types of products. */
export type ProductInterfacereviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};

/** Contains information about a text area that is defined as part of a customizable option. */
export type CustomizableAreaOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a text area. */
  value?: Maybe<CustomizableAreaValue>;
};

/** Defines the price and sku of a product whose page contains a customized text area. */
export type CustomizableAreaValue = {
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableAreaValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains the hierarchy of categories. */
export type CategoryTree = CategoryInterface & RoutableInterface & {
  /** List of Files Attached to a Category */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** A tree of child categories. */
  children?: Maybe<Array<Maybe<CategoryTree>>>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  /** the extra description of the category. */
  extra_description?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  h1_content?: Maybe<Scalars['String']['output']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image_alt?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']['output']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  synced_to_yotpo_collection?: Maybe<Scalars['Int']['output']>;
  /** Category thumnnail. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnail_alt?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
};


/** Contains the hierarchy of categories. */
export type CategoryTreeproductsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains a collection of `CategoryTree` objects and pagination information. */
export type CategoryResult = {
  /** A list of categories that match the filter criteria. */
  items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** An object that includes the `page_info` and `currentPage` values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of categories that match the criteria. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains information about a date picker that is defined as part of a customizable option. */
export type CustomizableDateOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a date field in a customizable option. */
  value?: Maybe<CustomizableDateValue>;
};

/** Defines the price and sku of a product whose page contains a customized date picker. */
export type CustomizableDateValue = {
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** DATE, DATE_TIME or TIME */
  type?: Maybe<CustomizableDateTypeEnum>;
  /** The unique ID for a `CustomizableDateValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a drop down menu that is defined as part of a customizable option. */
export type CustomizableDropDownOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines the set of options for a drop down menu. */
  value?: Maybe<Array<Maybe<CustomizableDropDownValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized drop down menu. */
export type CustomizableDropDownValue = {
  fourover_data?: Maybe<OptionFourOverData>;
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  quantity?: Maybe<Scalars['String']['output']>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableDropDownValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a multiselect that is defined as part of a customizable option. */
export type CustomizableMultipleOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines the set of options for a multiselect. */
  value?: Maybe<Array<Maybe<CustomizableMultipleValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized multiselect. */
export type CustomizableMultipleValue = {
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableMultipleValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a text field that is defined as part of a customizable option. */
export type CustomizableFieldOption = CustomizableOptionInterface & {
  color_list?: Maybe<Array<Maybe<Color>>>;
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  simples?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a text field. */
  value?: Maybe<CustomizableFieldValue>;
};

/** Defines the price and sku of a product whose page contains a customized text field. */
export type CustomizableFieldValue = {
  /** The maximum number of characters that can be entered for this customizable option. */
  max_characters?: Maybe<Scalars['Int']['output']>;
  /** The price of the custom value. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableFieldValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a file picker that is defined as part of a customizable option. */
export type CustomizableFileOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** The Stock Keeping Unit of the base product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An object that defines a file value. */
  value?: Maybe<CustomizableFileValue>;
};

/** Defines the price and sku of a product whose page contains a customized file picker. */
export type CustomizableFileValue = {
  /** The file extension to accept. */
  file_extension?: Maybe<Scalars['String']['output']>;
  /** The maximum width of an image. */
  image_size_x?: Maybe<Scalars['Int']['output']>;
  /** The maximum height of an image. */
  image_size_y?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableFileValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Contains product image information, including the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
  /** Contains a `ProductMediaGalleryEntriesVideoContent` object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  /** List of Files Attached to a Category */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** An array of breadcrumb items. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Contains a category CMS block. */
  cms_block?: Maybe<CmsBlock>;
  /**
   * The timestamp indicating when the category was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  /** the extra description of the category. */
  extra_description?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  h1_content?: Maybe<Scalars['String']['output']>;
  /**
   * An ID that uniquely identifies the category.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image_alt?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** The depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The full category path. */
  path?: Maybe<Scalars['String']['output']>;
  /** The category path within the store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  product_count?: Maybe<Scalars['Int']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  synced_to_yotpo_collection?: Maybe<Scalars['Int']['output']>;
  /** Category thumnnail. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnail_alt?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CategoryInterface` object. */
  uid: Scalars['ID']['output'];
  /**
   * The timestamp indicating when the category was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The URL key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
};


/** Contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceproductsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Contains details about an individual category that comprises a breadcrumb. */
export type Breadcrumb = {
  /**
   * The ID of the category.
   * @deprecated Use `category_uid` instead.
   */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** The category level. */
  category_level?: Maybe<Scalars['Int']['output']>;
  /** The display name of the category. */
  category_name?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Breadcrumb` object. */
  category_uid: Scalars['ID']['output'];
  /** The URL key of the category. */
  category_url_key?: Maybe<Scalars['String']['output']>;
  /** The URL path of the category. */
  category_url_path?: Maybe<Scalars['String']['output']>;
};

/** Contains information about a set of radio buttons that are defined as part of a customizable option. */
export type CustomizableRadioOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines a set of radio buttons. */
  value?: Maybe<Array<Maybe<CustomizableRadioValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of radio buttons. */
export type CustomizableRadioValue = {
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the radio button is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableRadioValue` object. */
  uid: Scalars['ID']['output'];
};

/** Contains information about a set of checkbox values that are defined as part of a customizable option. */
export type CustomizableCheckboxOption = CustomizableOptionInterface & {
  /**
   * Option ID.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableOptionInterface` object. */
  uid: Scalars['ID']['output'];
  /** An array that defines a set of checkbox values. */
  value?: Maybe<Array<Maybe<CustomizableCheckboxValue>>>;
};

/** Defines the price and sku of a product whose page contains a customized set of checkbox values. */
export type CustomizableCheckboxValue = {
  /** The ID assigned to the value. */
  option_type_id?: Maybe<Scalars['Int']['output']>;
  /** The price assigned to this option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** The Stock Keeping Unit for this option. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The order in which the checkbox value is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `CustomizableCheckboxValue` object. */
  uid: Scalars['ID']['output'];
};

/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = ProductInterface & RoutableInterface & CustomizableProductInterface & {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  last_price_break?: Maybe<PriceBreak>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Defines a virtual product, which is a non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProductreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProduct = ProductInterface & RoutableInterface & PhysicalProductInterface & CustomizableProductInterface & {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  last_price_break?: Maybe<PriceBreak>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Defines a simple product, which is tangible and is usually sold in single units or in fixed quantities. */
export type SimpleProductreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains the results of a `products` query. */
export type Products = {
  /** A bucket that contains the attribute code and label for each filterable option. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use `aggregations` instead.
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** An array of search suggestions for case when search query have no results. */
  suggestions?: Maybe<Array<Maybe<SearchSuggestion>>>;
  /** The number of products that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']['output']>;
};


/** Contains the results of a `products` query. */
export type ProductsaggregationsArgs = {
  filter?: InputMaybe<AggregationsFilterInput>;
};

/** An input object that specifies the filters used in product aggregations. */
export type AggregationsFilterInput = {
  /** Filter category aggregations in layered navigation. */
  category?: InputMaybe<AggregationsCategoryFilterInput>;
};

/** Filter category aggregations in layered navigation. */
export type AggregationsCategoryFilterInput = {
  /** Indicates whether to include only direct subcategories or all children categories at all levels. */
  includeDirectChildrenOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains details about the products assigned to a category. */
export type CategoryProducts = {
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products in the category that are marked as visible. By default, in complex products, parent products are visible, but their child products are not. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Deprecated: use `category_uid` to filter product by category ID. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by the unique ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  created_at?: InputMaybe<FilterTypeInput>;
  /** Attribute label: Description */
  description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter product by news_from_date. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** Filter product by news_to_date. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Short Description */
  short_description?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterEqualTypeInput>;
};

/** Defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by the unique category ID for a `CategoryInterface` object. */
  category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Deprecated: use 'category_uid' to filter uniquely identifiers of categories. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_category_uid?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the unique parent category ID for a `CategoryInterface` object. */
  parent_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the part of the URL that identifies the category. */
  url_key?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the URL path for the category. */
  url_path?: InputMaybe<FilterEqualTypeInput>;
};

/** ProductFilterInput is deprecated, use @ProductAttributeFilterInput instead. ProductFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductFilterInput = {
  /** The category ID the product belongs to. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<FilterTypeInput>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<FilterTypeInput>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<FilterTypeInput>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<FilterTypeInput>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<FilterTypeInput>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<FilterTypeInput>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<FilterTypeInput>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<FilterTypeInput>;
  /** The numeric maximal price of the product. Do not include the currency code. */
  max_price?: InputMaybe<FilterTypeInput>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<FilterTypeInput>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<FilterTypeInput>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<FilterTypeInput>;
  /** The numeric minimal price of the product. Do not include the currency code. */
  min_price?: InputMaybe<FilterTypeInput>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<FilterTypeInput>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<FilterTypeInput>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<FilterTypeInput>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<FilterTypeInput>;
  /** The keyword required to perform a logical OR comparison. */
  or?: InputMaybe<ProductFilterInput>;
  /** The price of an item. */
  price?: InputMaybe<FilterTypeInput>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<FilterTypeInput>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<FilterTypeInput>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<FilterTypeInput>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<FilterTypeInput>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<FilterTypeInput>;
  /** The discounted price of the product. Do not include the currency code. */
  special_price?: InputMaybe<FilterTypeInput>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<FilterTypeInput>;
  /** The file name of a swatch image. */
  swatch_image?: InputMaybe<FilterTypeInput>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<FilterTypeInput>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<FilterTypeInput>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<FilterTypeInput>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<FilterTypeInput>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<FilterTypeInput>;
  url_path?: InputMaybe<FilterTypeInput>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<FilterTypeInput>;
};

/** Contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']['output']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']['output']>;
};

/** Contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']['output']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']['output']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']['output']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']['output']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']['output']>;
};

/** ProductSortInput specifies the attribute to use for sorting. */
export type ProductSortInput = {
  /** Is product bestsellers. */
  bestsellers?: InputMaybe<SortEnum>;
  /** The product's country of origin. */
  country_of_manufacture?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was created. */
  created_at?: InputMaybe<SortEnum>;
  /** The name of a custom layout. */
  custom_layout?: InputMaybe<SortEnum>;
  /** XML code that is applied as a layout update to the product page. */
  custom_layout_update?: InputMaybe<SortEnum>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: InputMaybe<SortEnum>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: InputMaybe<SortEnum>;
  /** Indicates whether additional attributes have been created for the product. */
  has_options?: InputMaybe<SortEnum>;
  /** The relative path to the main image on the product page. */
  image?: InputMaybe<SortEnum>;
  /** The label assigned to a product image. */
  image_label?: InputMaybe<SortEnum>;
  /** A number representing the product's manufacturer. */
  manufacturer?: InputMaybe<SortEnum>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: InputMaybe<SortEnum>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: InputMaybe<SortEnum>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: InputMaybe<SortEnum>;
  /** The product most_viewed. */
  most_viewed?: InputMaybe<SortEnum>;
  /** The product name. Customers use this name to identify the product. */
  name?: InputMaybe<SortEnum>;
  /** Is product new. */
  new?: InputMaybe<SortEnum>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  news_from_date?: InputMaybe<SortEnum>;
  /** The end date for new product listings. */
  news_to_date?: InputMaybe<SortEnum>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: InputMaybe<SortEnum>;
  /** The price of the item. */
  price?: InputMaybe<SortEnum>;
  /** The product price_asc. */
  price_asc?: InputMaybe<SortEnum>;
  /** The product price_desc. */
  price_desc?: InputMaybe<SortEnum>;
  /** The product rating_summary. */
  rating_summary?: InputMaybe<SortEnum>;
  /** Indicates whether the product has required options. */
  required_options?: InputMaybe<SortEnum>;
  /** Revenue. */
  revenue?: InputMaybe<SortEnum>;
  /** The product reviews_count. */
  reviews_count?: InputMaybe<SortEnum>;
  /** The product saving. */
  saving?: InputMaybe<SortEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: InputMaybe<SortEnum>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: InputMaybe<SortEnum>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: InputMaybe<SortEnum>;
  /** The label assigned to a product's small image. */
  small_image_label?: InputMaybe<SortEnum>;
  /** The beginning date that a product has a special price. */
  special_from_date?: InputMaybe<SortEnum>;
  /** The discounted price of the product. */
  special_price?: InputMaybe<SortEnum>;
  /** The end date that a product has a special price. */
  special_to_date?: InputMaybe<SortEnum>;
  /** Indicates the criteria to sort swatches. */
  swatch_image?: InputMaybe<SortEnum>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: InputMaybe<SortEnum>;
  /** The label assigned to a product's thumbnail image. */
  thumbnail_label?: InputMaybe<SortEnum>;
  /** The price when tier pricing is in effect and the items purchased threshold has been reached. */
  tier_price?: InputMaybe<SortEnum>;
  /** The timestamp indicating when the product was updated. */
  updated_at?: InputMaybe<SortEnum>;
  /** The part of the URL that identifies the product */
  url_key?: InputMaybe<SortEnum>;
  url_path?: InputMaybe<SortEnum>;
  /** The weight of the item, in units defined by the store. */
  weight?: InputMaybe<SortEnum>;
  /** Is product wished. */
  wished?: InputMaybe<SortEnum>;
};

/** ProductAttributeSortInput specifies the attribute to use for sorting. */
export type ProductAttributeSortInput = {
  /** Is product bestsellers. */
  bestsellers?: InputMaybe<SortEnum>;
  /** The product most_viewed. */
  most_viewed?: InputMaybe<SortEnum>;
  /** Attribute label: Product Name */
  name?: InputMaybe<SortEnum>;
  /** Is product new. */
  new?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price */
  price?: InputMaybe<SortEnum>;
  /** The product price_asc. */
  price_asc?: InputMaybe<SortEnum>;
  /** The product price_desc. */
  price_desc?: InputMaybe<SortEnum>;
  production_time?: InputMaybe<SortEnum>;
  /** The product rating_summary. */
  rating_summary?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
  /** Revenue. */
  revenue?: InputMaybe<SortEnum>;
  /** The product reviews_count. */
  reviews_count?: InputMaybe<SortEnum>;
  /** The product saving. */
  saving?: InputMaybe<SortEnum>;
  /** Is product wished. */
  wished?: InputMaybe<SortEnum>;
};

/** Defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  /** Details about the content of the media gallery item. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Indicates whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']['output']>;
  /**
   * The identifier assigned to the object.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The alt text displayed on the storefront when the user points to the image. */
  label?: Maybe<Scalars['String']['output']>;
  /** Either `image` or `video`. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique ID for a `MediaGalleryEntry` object. */
  uid: Scalars['ID']['output'];
  /** Details about the content of a video item. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains information for rendering layered navigation. */
export type LayerFilter = {
  /**
   * An array of filter items.
   * @deprecated Use `Aggregation.options` instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * The count of filter items in filter group.
   * @deprecated Use `Aggregation.count` instead.
   */
  filter_items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The name of a layered navigation filter.
   * @deprecated Use `Aggregation.label` instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The request variable name for a filter query.
   * @deprecated Use `Aggregation.attribute_code` instead.
   */
  request_var?: Maybe<Scalars['String']['output']>;
};

export type LayerFilterItemInterface = {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type LayerFilterItem = LayerFilterItemInterface & {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

/** Contains information for each filterable option (such as price, category `UID`, and custom attributes). */
export type Aggregation = {
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']['output']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
  /** The relative position of the attribute in a layered navigation block. */
  position?: Maybe<Scalars['Int']['output']>;
};

/** A string that contains search suggestion */
export type SearchSuggestion = {
  /** The search suggestion of existing product. */
  search: Scalars['String']['output'];
};

/** Defines aggregation option fields. */
export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

/** An implementation of `AggregationOptionInterface`. */
export type AggregationOption = AggregationOptionInterface & {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The display label for an aggregation option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

/** Defines a possible sort field. */
export type SortField = {
  /** The label of the sort field. */
  label?: Maybe<Scalars['String']['output']>;
  /** The attribute code of the sort field. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  /** The default sort field value. */
  default?: Maybe<Scalars['String']['output']>;
  /** An array of possible sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

/** Contains a simple product wish list item. */
export type SimpleWishlistItem = WishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Contains a virtual product wish list item. */
export type VirtualWishlistItem = WishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** This enumeration defines the entity type. */
export type UrlRewriteEntityTypeEnum =
  | 'CMS_PAGE'
  | 'PRODUCT'
  | 'CATEGORY';

/** Defines an object used to iterate through items for product comparisons. */
export type ComparableItem = {
  /** An array of product attributes that can be used to compare products. */
  attributes: Array<Maybe<ProductAttribute>>;
  /** Details about a product in a compare list. */
  product: ProductInterface;
  /** The unique ID of an item in a compare list. */
  uid: Scalars['ID']['output'];
};

/** Contains a product attribute code and value. */
export type ProductAttribute = {
  /** The unique identifier for a product attribute code. */
  code: Scalars['String']['output'];
  /** The display value of the attribute. */
  value: Scalars['String']['output'];
};

/** Contains an attribute code that is used for product comparisons. */
export type ComparableAttribute = {
  /** An attribute code that is enabled for product comparisons. */
  code: Scalars['String']['output'];
  /** The label of the attribute code. */
  label: Scalars['String']['output'];
};

/** Contains iterable information such as the array of items, the count, and attributes that represent the compare list. */
export type CompareList = {
  /** An array of attributes that can be used for comparing products. */
  attributes?: Maybe<Array<Maybe<ComparableAttribute>>>;
  /** The number of items in the compare list. */
  item_count: Scalars['Int']['output'];
  /** An array of products to compare. */
  items?: Maybe<Array<Maybe<ComparableItem>>>;
  /** The unique ID assigned to the compare list. */
  uid: Scalars['ID']['output'];
};

/** Defines the customer name, addresses, and other details. */
export type Customer = {
  /** An array containing the customer's shipping and billing addresses. */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance: Scalars['Boolean']['output'];
  bss_is_company_account?: Maybe<Scalars['Boolean']['output']>;
  /** Return a list of categories that match the specified filter. */
  company_categories?: Maybe<CategoryResult>;
  company_industry?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Timestamp indicating when the account was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The customer's date of birth. */
  date_of_birth?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the billing address. */
  default_billing?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the shipping address. */
  default_shipping?: Maybe<Scalars['String']['output']>;
  /**
   * The customer's date of birth.
   * @deprecated Use `date_of_birth` instead.
   */
  dob?: Maybe<Scalars['String']['output']>;
  /** The customer's email address. Required. */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer's first name. */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios. */
  group_id?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID assigned to the customer.
   * @deprecated `id` is not needed as part of `Customer`, because on the server side, it can be identified based on the customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's family name. */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's middle name. */
  middlename?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<CustomerOrders>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Contains the customer's product reviews. */
  reviews: ProductReviews;
  /** Get information of salesrep */
  salesrep?: Maybe<SalesRepUser>;
  /** List roles were created by company account */
  sub_roles?: Maybe<Array<Maybe<SubRole>>>;
  /** List sub-user of company account */
  sub_users?: Maybe<Array<Maybe<SubUser>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  taxvat?: Maybe<Scalars['String']['output']>;
  /**
   * Return a customer's wish lists.
   * @deprecated Use `Customer.wishlists` or `Customer.wishlist_v2` instead.
   */
  wishlist: Wishlist;
  /** Retrieve the wish list identified by the unique ID for a `Wishlist` object. */
  wishlist_v2?: Maybe<Wishlist>;
  /** An array of wishlists. In Magento Open Source, customers are limited to one wish list. The number of wish lists is configurable for Adobe Commerce. */
  wishlists: Array<Maybe<Wishlist>>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerordersArgs = {
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CustomerOrderSortInput>;
  scope?: InputMaybe<ScopeTypeEnum>;
};


/** Defines the customer name, addresses, and other details. */
export type CustomerreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};


/** Defines the customer name, addresses, and other details. */
export type Customerwishlist_v2Args = {
  id: Scalars['ID']['input'];
};


/** Defines the customer name, addresses, and other details. */
export type CustomerwishlistsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains an array of product IDs to use for creating a compare list. */
export type CreateCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Contains products to add to an existing compare list. */
export type AddProductsToCompareListInput = {
  /** An array of product IDs to add to the compare list. */
  products: Array<InputMaybe<Scalars['ID']['input']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']['input'];
};

/** Defines which products to remove from a compare list. */
export type RemoveProductsFromCompareListInput = {
  /** An array of product IDs to remove from the compare list. */
  products: Array<InputMaybe<Scalars['ID']['input']>>;
  /** The unique identifier of the compare list to modify. */
  uid: Scalars['ID']['input'];
};

/** Contains the results of the request to delete a compare list. */
export type DeleteCompareListOutput = {
  /** Indicates whether the compare list was successfully deleted. */
  result: Scalars['Boolean']['output'];
};

/** Contains the results of the request to assign a compare list. */
export type AssignCompareListToCustomerOutput = {
  /** The contents of the customer's compare list. */
  compare_list?: Maybe<CompareList>;
  /** Indicates whether the compare list was successfully assigned to the customer. */
  result: Scalars['Boolean']['output'];
};

/** Assigns a specific `cart_id` to the empty cart. */
export type createEmptyCartInput = {
  /** The ID to assign to the cart. */
  cart_id?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the simple and group products to add to the cart. */
export type AddSimpleProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of simple and group items to add. */
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

/** Defines a single product to add to the cart. */
export type SimpleProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Defines the virtual products to add to the cart. */
export type AddVirtualProductsToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of virtual products to add. */
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

/** Defines a single product to add to the cart. */
export type VirtualProductCartItemInput = {
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** An object containing the `sku`, `quantity`, and other relevant information about the product. */
  data: CartItemInput;
};

/** Defines an item to be added to the cart. */
export type CartItemInput = {
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For a child product, the SKU of its parent product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  /** The amount or number of an item to add. */
  quantity: Scalars['Float']['input'];
  /** The selected options for the base product, such as color or size, using the unique ID for an object such as `CustomizableRadioOption`, `CustomizableDropDownOption`, or `ConfigurableProductOptionsValues`. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The SKU of the product. */
  sku: Scalars['String']['input'];
};

/** Defines a customizable option. */
export type CustomizableOptionInput = {
  /** The customizable option ID of the product. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The string value of the option. */
  value_string: Scalars['String']['input'];
};

/** Specifies the coupon code to apply to the cart. */
export type ApplyCouponToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** A valid coupon code. */
  coupon_code: Scalars['String']['input'];
};

/** Modifies the specified items in the cart. */
export type UpdateCartItemsInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of items to be updated. */
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

/** A single item to be updated. */
export type CartItemUpdateInput = {
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']['input']>;
  /** The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>;
  /** An array that defines customizable options for the product. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** Gift message details for the cart item */
  gift_message?: InputMaybe<GiftMessageInput>;
  /** The new quantity of the item. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

/** Specifies which items to remove from the cart. */
export type RemoveItemFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** Deprecated. Use `cart_item_uid` instead. */
  cart_item_id?: InputMaybe<Scalars['Int']['input']>;
  /** Required field. The unique ID for a `CartItemInterface` object. */
  cart_item_uid?: InputMaybe<Scalars['ID']['input']>;
};

/** Specifies an array of addresses to use for shipping. */
export type SetShippingAddressesOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of shipping addresses. */
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

/** Defines a single shipping address. */
export type ShippingAddressInput = {
  /** Defines a shipping address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for shipping. */
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** Text provided by the shopper. */
  customer_notes?: InputMaybe<Scalars['String']['input']>;
  /** The code of Pickup Location which will be used for In-Store Pickup. */
  pickup_location_code?: InputMaybe<Scalars['String']['input']>;
};

/** Sets the billing address. */
export type SetBillingAddressOnCartInput = {
  /** The billing address. */
  billing_address: BillingAddressInput;
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Defines the billing address. */
export type BillingAddressInput = {
  /** Defines a billing address. */
  address?: InputMaybe<CartAddressInput>;
  /** An ID from the customer's address book that uniquely identifies the address to be used for billing. */
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether to set the billing address to be the same as the existing shipping address on the cart. */
  same_as_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether to set the shipping address to be the same as this billing address. */
  use_for_shipping?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies an array of addresses to use for shipping. */
export type CartAddressInput = {
  /** Indicates whether the address requires appointment. */
  appointment_required?: InputMaybe<Scalars['Boolean']['input']>;
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['input'];
  /** The company specified for the billing or shipping address. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The country code and label for the billing or shipping address. */
  country_code: Scalars['String']['input'];
  /** Days / Hours Delivery can be made. */
  days_hours_delivery?: InputMaybe<Array<InputMaybe<DeliveryDateRangeInput>>>;
  /** Indicates whether the address delivers to door. */
  delivery_to_door?: InputMaybe<Scalars['Boolean']['input']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['input'];
  /** Indicates whether the address is freight shipping address. */
  is_freight_address?: InputMaybe<Scalars['Boolean']['input']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['input'];
  /** Indicates whether the address has Limited access Delivery */
  limited_access_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address has loading dock. */
  loading_dock?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** A string that defines the state or province of the billing or shipping address. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** An integer that defines the state or province of the billing or shipping address. */
  region_id?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the address is residential. */
  residential_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether to save the address in the customer's address book. The default value is true. */
  save_in_address_book?: InputMaybe<Scalars['Boolean']['input']>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<InputMaybe<Scalars['String']['input']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The VAT company number for billing or shipping address. */
  vat_id?: InputMaybe<Scalars['String']['input']>;
};

/** Applies one or shipping methods to the cart. */
export type SetShippingMethodsOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** An array of shipping methods. */
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

/** Defines the shipping carrier and method. */
export type ShippingMethodInput = {
  /** A string that identifies a commercial carrier or an offline delivery method. */
  carrier_code: Scalars['String']['input'];
  /** A string that indicates which service a commercial carrier will use to ship items. For offline delivery methods, this value is similar to the label displayed on the checkout page. */
  method_code: Scalars['String']['input'];
};

/** Applies a payment method to the quote. */
export type SetPaymentMethodAndPlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Specifies the quote to be converted to an order. */
export type PlaceOrderInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  sub_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Applies a payment method to the cart. */
export type SetPaymentMethodOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** The payment method data to apply to the cart. */
  payment_method: PaymentMethodInput;
};

/** Defines the payment method. */
export type PaymentMethodInput = {
  braintree?: InputMaybe<BraintreeInput>;
  braintree_cc_vault?: InputMaybe<BraintreeCcVaultInput>;
  /** The internal name for the payment method. */
  code: Scalars['String']['input'];
  /** Required input for PayPal Hosted pro payments. */
  hosted_pro?: InputMaybe<HostedProInput>;
  /** Required input for Payflow Express Checkout payments. */
  payflow_express?: InputMaybe<PayflowExpressInput>;
  /** Required input for PayPal Payflow Link and Payments Advanced payments. */
  payflow_link?: InputMaybe<PayflowLinkInput>;
  /** Required input for PayPal Payflow Pro and Payment Pro payments. */
  payflowpro?: InputMaybe<PayflowProInput>;
  /** Required input for PayPal Payflow Pro vault payments. */
  payflowpro_cc_vault?: InputMaybe<VaultTokenInput>;
  /** Required input for Express Checkout and Payments Standard payments. */
  paypal_express?: InputMaybe<PaypalExpressInput>;
  /** The purchase order number. Optional for most payment methods. */
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the guest email and cart. */
export type SetGuestEmailOnCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** The email address of the guest. */
  email: Scalars['String']['input'];
};

/** Contains details about the final price of items in the cart, including discount and tax information. */
export type CartPrices = {
  /** An array containing the names and amounts of taxes applied to each item in the cart. */
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** @deprecated Use discounts instead. */
  discount?: Maybe<CartDiscount>;
  /** An array containing cart rule discounts, store credit and gift cards applied to the cart. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The total, including discounts, taxes, shipping, and other fees. */
  grand_total?: Maybe<Money>;
  /** An array containing all setup fees applied to the cart. */
  setup_fees?: Maybe<Array<Maybe<SetupFee>>>;
  /** Setup fees total. */
  setup_fees_total?: Maybe<Money>;
  /** The subtotal without any applied taxes. */
  subtotal_excluding_tax?: Maybe<Money>;
  /** The subtotal excluding taxes and including setup_fees */
  subtotal_excluding_tax_and_setup?: Maybe<Money>;
  /** The subtotal including any applied taxes. */
  subtotal_including_tax?: Maybe<Money>;
  /** The subtotal including taxes and setup_fees */
  subtotal_including_tax_and_setup?: Maybe<Money>;
  /** The subtotal with any discounts applied, but not taxes. */
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
};

/** Contains tax information about an item in the cart. */
export type CartTaxItem = {
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The description of the tax. */
  label: Scalars['String']['output'];
};

/** Contains information about discounts applied to the cart. */
export type CartDiscount = {
  /** The amount of the discount applied to the item. */
  amount: Money;
  /** The description of the discount. */
  label: Array<Maybe<Scalars['String']['output']>>;
};

/** Contains details about the cart after setting the payment method. */
export type SetPaymentMethodOnCartOutput = {
  /** The cart after setting the payment method. */
  cart: Cart;
};

/** Contains details about the cart after setting the billing address. */
export type SetBillingAddressOnCartOutput = {
  /** The cart after setting the billing address. */
  cart: Cart;
};

/** Contains details about the cart after setting the shipping addresses. */
export type SetShippingAddressesOnCartOutput = {
  /** The cart after setting the shipping addresses. */
  cart: Cart;
};

/** Contains details about the cart after setting the shipping methods. */
export type SetShippingMethodsOnCartOutput = {
  /** The cart after setting the shipping methods. */
  cart: Cart;
};

/** Contains details about the cart after applying a coupon. */
export type ApplyCouponToCartOutput = {
  /** The cart after applying a coupon. */
  cart: Cart;
};

/** Contains the results of the request to place an order. */
export type PlaceOrderOutput = {
  /** The ID of the order. */
  order: Order;
  orders?: Maybe<Array<Maybe<Order>>>;
};

/** Contains the contents and other details about a guest or customer cart. */
export type Cart = {
  /** @deprecated Use `applied_coupons` instead. */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code. */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** An array of available payment methods. */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  /** The billing address assigned to the cart. */
  billing_address?: Maybe<BillingCartAddress>;
  /** Customer Note */
  customer_note?: Maybe<Scalars['String']['output']>;
  /** The email address of the guest or customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** The entered gift message for the cart */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for a `Cart` object. */
  id: Scalars['ID']['output'];
  /** Indicates whether the cart contains only virtual products. */
  is_virtual: Scalars['Boolean']['output'];
  /** An array of products that have been added to the cart. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  itemsBySource?: Maybe<Array<Maybe<CartItemsBySource>>>;
  prepared: Scalars['Boolean']['output'];
  /** Pricing details for the quote. */
  prices?: Maybe<CartPrices>;
  /** Indicates which payment method was applied to the cart. */
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  /** An array of shipping addresses assigned to the cart. */
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  /** The total number of items in the cart. */
  total_quantity: Scalars['Float']['output'];
};

export type CartAddressInterface = {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The unique id of the customer address. */
  uid: Scalars['String']['output'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']['output']>;
};

/** Contains shipping addresses and methods. */
export type ShippingCartAddress = CartAddressInterface & {
  /** Indicates whether the address requires appointment. */
  appointment_required?: Maybe<Scalars['Boolean']['output']>;
  /** An array that lists the shipping methods that can be applied to the cart. */
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated Use `cart_items_v2` instead. */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  /** An array that lists the items in the cart. */
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** Text provided by the shopper. */
  customer_notes?: Maybe<Scalars['String']['output']>;
  /** Days / Hours Delivery can be made. */
  days_hours_delivery?: Maybe<Array<Maybe<DeliveryDateRange>>>;
  /** Indicates whether the address delivers to door. */
  delivery_to_door?: Maybe<Scalars['Boolean']['output']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output'];
  /** Indicates whether the address is freight shipping address. */
  is_freight_address?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This information should not be exposed on the frontend. */
  items_weight?: Maybe<Scalars['Float']['output']>;
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output'];
  /** Indicates whether the address has Limited access Delivery */
  limited_access_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address has loading dock. */
  loading_dock?: Maybe<Scalars['Boolean']['output']>;
  pickup_location_code?: Maybe<Scalars['String']['output']>;
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** Indicates whether the address is residential. */
  residential_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** An object that describes the selected shipping method. */
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The unique id of the customer address. */
  uid: Scalars['String']['output'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']['output']>;
};

/** Contains details about the billing address. */
export type BillingCartAddress = CartAddressInterface & {
  /** The city specified for the billing or shipping address. */
  city: Scalars['String']['output'];
  /** The company specified for the billing or shipping address. */
  company?: Maybe<Scalars['String']['output']>;
  /** An object containing the country label and code. */
  country: CartAddressCountry;
  /** @deprecated The field is used only in shipping address. */
  customer_notes?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer or guest. */
  firstname: Scalars['String']['output'];
  /** The last name of the customer or guest. */
  lastname: Scalars['String']['output'];
  /** The ZIP or postal code of the billing or shipping address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An object containing the region label and code. */
  region?: Maybe<CartAddressRegion>;
  /** An array containing the street for the billing or shipping address. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** The telephone number for the billing or shipping address. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The unique id of the customer address. */
  uid: Scalars['String']['output'];
  /** The VAT company number for billing or shipping address. */
  vat_id?: Maybe<Scalars['String']['output']>;
};

/** Deprecated: The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
export type CartItemQuantity = {
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  cart_item_id: Scalars['Int']['output'];
  /** @deprecated The `ShippingCartAddress.cart_items` field now returns `CartItemInterface`. */
  quantity: Scalars['Float']['output'];
};

/** Contains details about the region in a billing or shipping address. */
export type CartAddressRegion = {
  /** The state or province code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The display label for the region. */
  label?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']['output']>;
};

/** Contains details the country in a billing or shipping address. */
export type CartAddressCountry = {
  /** The country code. */
  code: Scalars['String']['output'];
  /** The display label for the country. */
  label: Scalars['String']['output'];
};

/** Contains details about the selected shipping method and carrier. */
export type SelectedShippingMethod = {
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String']['output'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String']['output'];
  /** A shipping method code associated with a carrier. */
  method_code: Scalars['String']['output'];
  /** The label for the method code. */
  method_title: Scalars['String']['output'];
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

/** Contains details about the possible shipping methods and carriers. */
export type AvailableShippingMethod = {
  /** The cost of shipping using this shipping method. */
  amount: Money;
  /** Indicates whether this shipping method can be applied to the cart. */
  available: Scalars['Boolean']['output'];
  /** @deprecated The field should not be used on the storefront. */
  base_amount?: Maybe<Money>;
  /** A string that identifies a commercial carrier or an offline shipping method. */
  carrier_code: Scalars['String']['output'];
  /** The label for the carrier code. */
  carrier_title: Scalars['String']['output'];
  /** Describes an error condition. */
  error_message?: Maybe<Scalars['String']['output']>;
  /** A shipping method code associated with a carrier. The value could be null if no method is available. */
  method_code?: Maybe<Scalars['String']['output']>;
  /** The label for the shipping method code. The value could be null if no method is available. */
  method_title?: Maybe<Scalars['String']['output']>;
  /** The cost of shipping using this shipping method, excluding tax. */
  price_excl_tax: Money;
  /** The cost of shipping using this shipping method, including tax. */
  price_incl_tax: Money;
};

/** Describes a payment method that the shopper can use to pay for the order. */
export type AvailablePaymentMethod = {
  /** The payment method code. */
  code: Scalars['String']['output'];
  /** If the payment method is an online integration */
  is_deferred: Scalars['Boolean']['output'];
  /** The payment method title. */
  title: Scalars['String']['output'];
};

/** Describes the payment method the shopper selected. */
export type SelectedPaymentMethod = {
  /** The payment method code. */
  code: Scalars['String']['output'];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  /** The payment method title. */
  title: Scalars['String']['output'];
};

/** Contains the applied coupon code. */
export type AppliedCoupon = {
  /** The coupon code the shopper applied to the card. */
  code: Scalars['String']['output'];
};

/** Specifies the cart from which to remove a coupon. */
export type RemoveCouponFromCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
};

/** Contains details about the cart after removing a coupon. */
export type RemoveCouponFromCartOutput = {
  /** The cart after removing a coupon. */
  cart?: Maybe<Cart>;
};

/** Contains details about the cart after adding simple or group products. */
export type AddSimpleProductsToCartOutput = {
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains details about the cart after adding virtual products. */
export type AddVirtualProductsToCartOutput = {
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains details about the cart after updating items. */
export type UpdateCartItemsOutput = {
  /** The cart after updating products. */
  cart: Cart;
};

/** Contains details about the cart after removing an item. */
export type RemoveItemFromCartOutput = {
  /** The cart after removing an item. */
  cart: Cart;
};

/** Contains details about the cart after setting the email of a guest. */
export type SetGuestEmailOnCartOutput = {
  /** The cart after setting the guest email. */
  cart: Cart;
};

export type SimpleCartItem = CartItemInterface & {
  /** An array containing the artwork attached to the quote item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  projectId?: Maybe<Scalars['String']['output']>;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  reorder?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
};

export type VirtualCartItem = CartItemInterface & {
  /** An array containing the artwork attached to the quote item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** An array containing customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  projectId?: Maybe<Scalars['String']['output']>;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  reorder?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
};

export type CartItemInterface = {
  /** An array containing the artwork attached to the quote item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  projectId?: Maybe<Scalars['String']['output']>;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  reorder?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
};

export type CartItemError = {
  /** An error code that describes the error encountered */
  code: CartItemErrorType;
  /** A localized error message */
  message: Scalars['String']['output'];
};

export type CartItemErrorType =
  | 'UNDEFINED'
  | 'ITEM_QTY'
  | 'ITEM_INCREMENTS';

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export type Discount = {
  /** The amount of the discount. */
  amount: Money;
  /** A description of the discount. */
  label: Scalars['String']['output'];
};

/** Contains details about the price of the item, including taxes and discounts. */
export type CartItemPrices = {
  /** An array of discounts to be applied to the cart item. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** An array of FPTs applied to the cart item. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price: Money;
  /** The price of the item before any discounts were applied. The price that might include tax, depending on the configured display settings for cart. */
  price_including_tax: Money;
  /** The value of the price multiplied by the quantity of the item. */
  row_total: Money;
  /** The value of `row_total` plus the tax applied to the item. */
  row_total_including_tax: Money;
  /** Setup Fee */
  setup_fee: Money;
  /** The total of all discounts applied to the item. */
  total_item_discount?: Maybe<Money>;
};

/** Identifies a customized product that has been placed in a cart. */
export type SelectedCustomizableOption = {
  /** The unique ID for a specific `CustomizableOptionInterface` object, such as a `CustomizableFieldOption`, `CustomizableFileOption`, or `CustomizableAreaOption` object. */
  customizable_option_uid: Scalars['ID']['output'];
  /** @deprecated Use `SelectedCustomizableOption.customizable_option_uid` instead. */
  id: Scalars['Int']['output'];
  /** Indicates whether the customizable option is required. */
  is_required: Scalars['Boolean']['output'];
  /** The display name of the selected customizable option. */
  label: Scalars['String']['output'];
  /** A value indicating the order to display this option. */
  sort_order: Scalars['Int']['output'];
  /** The type of `CustomizableOptionInterface` object. */
  type: Scalars['String']['output'];
  /** An array of selectable values. */
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

/** Identifies the value of the selected customized option. */
export type SelectedCustomizableOptionValue = {
  /** The unique ID for a value object that corresponds to the object represented by the `customizable_option_uid` attribute. */
  customizable_option_value_uid: Scalars['ID']['output'];
  /** @deprecated Use `SelectedCustomizableOptionValue.customizable_option_value_uid` instead. */
  id: Scalars['Int']['output'];
  /** The display name of the selected value. */
  label: Scalars['String']['output'];
  /** The price of the selected customizable value. */
  price: CartItemSelectedOptionValuePrice;
  /** The text identifying the selected value. */
  value: Scalars['String']['output'];
};

/** Contains details about the price of a selected customizable value. */
export type CartItemSelectedOptionValuePrice = {
  /** Indicates whether the price type is fixed, percent, or dynamic. */
  type: PriceTypeEnum;
  /** A string that describes the unit of the value. */
  units: Scalars['String']['output'];
  /** A price value. */
  value: Scalars['Float']['output'];
};

/** Contains the order ID. */
export type Order = {
  display_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `order_number` instead. */
  order_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for an `Order` object. */
  order_number: Scalars['String']['output'];
};

/** An error encountered while adding an item to the the cart. */
export type CartUserInputError = {
  /** A cart-specific error code. */
  code: CartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

/** Contains details about the cart after adding products to it. */
export type AddProductsToCartOutput = {
  /** The cart after products have been added. */
  cart: Cart;
  /** Contains errors encountered while adding an item to the cart. */
  user_errors: Array<Maybe<CartUserInputError>>;
};

export type CartUserInputErrorType =
  | 'PRODUCT_NOT_FOUND'
  | 'NOT_SALABLE'
  | 'INSUFFICIENT_STOCK'
  | 'UNDEFINED';

/** Contains details about a billing or shipping address. */
export type CustomerAddressInput = {
  /** Indicates whether the address requires appointment. */
  appointment_required?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's city or town. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The two-letter code representing the customer's country. */
  country_code?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>;
  /** Days / Hours Delivery can be made. */
  days_hours_delivery?: InputMaybe<Array<InputMaybe<DeliveryDateRangeInput>>>;
  /** Indicates whether the address is the default billing address. */
  default_billing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address is the default shipping address. */
  default_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address delivers to door. */
  delivery_to_door?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's fax number. */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the person associated with the billing/shipping address. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the address is freight shipping address. */
  is_freight_address?: InputMaybe<Scalars['Boolean']['input']>;
  /** The family name of the person associated with the billing/shipping address. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the address has Limited access Delivery */
  limited_access_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address has loading dock. */
  loading_dock?: InputMaybe<Scalars['Boolean']['input']>;
  /** The middle name of the person associated with the billing/shipping address. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's ZIP or postal code. */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** An object containing the region name, region code, and region ID. */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** Indicates whether the address is residential. */
  residential_delivery?: InputMaybe<Scalars['Boolean']['input']>;
  /** An array of strings that define the street number and name. */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's telephone number. */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  vat_id?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegionInput = {
  /** The state or province name. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The address region code. */
  region_code?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID for a pre-defined region. */
  region_id?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies the attribute code and value of a customer attribute. */
export type CustomerAddressAttributeInput = {
  /** The name assigned to the attribute. */
  attribute_code: Scalars['String']['input'];
  /** The value assigned to the attribute. */
  value: Scalars['String']['input'];
};

/** Contains a customer authorization token. */
export type CustomerToken = {
  /** The customer authorization token. */
  token?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** An input object that assigns or updates customer attributes. */
export type CustomerInput = {
  company_industry?: InputMaybe<Scalars['String']['input']>;
  company_name?: InputMaybe<Scalars['String']['input']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. Required when creating a customer. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>;
};

/** An input object for creating a customer. */
export type CustomerCreateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. */
  email: Scalars['String']['input'];
  /** The customer's first name. */
  firstname: Scalars['String']['input'];
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's family name. */
  lastname: Scalars['String']['input'];
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>;
};

/** An input object for updating a customer. */
export type CustomerUpdateInput = {
  /** Indicates whether the customer has enabled remote shopping assistance. */
  allow_remote_shopping_assistance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's date of birth. */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: Use `date_of_birth` instead. */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name. */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's gender (Male - 1, Female - 2). */
  gender?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates whether the customer is subscribed to the company's newsletter. */
  is_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's family name. */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name. */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** A value such as Sr., Jr., or III. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers). */
  taxvat?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details about a newly-created or updated customer. */
export type CustomerOutput = {
  /** Customer details after creating or updating a customer. */
  customer: Customer;
};

/** Contains the result of a request to revoke a customer token. */
export type RevokeCustomerTokenOutput = {
  /** The result of a request to revoke a customer token. */
  result: Scalars['Boolean']['output'];
};

/** Contains detailed information about a customer's billing or shipping address. */
export type CustomerAddress = {
  /** Indicates whether the address requires appointment. */
  appointment_required?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's city or town. */
  city?: Maybe<Scalars['String']['output']>;
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country.
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Custom attributes should not be put into a container. */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /**
   * The customer ID
   * @deprecated `customer_id` is not needed as part of `CustomerAddress`. The `id` is a unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** Days / Hours Delivery can be made. */
  days_hours_delivery?: Maybe<Array<Maybe<DeliveryDateRange>>>;
  /** Indicates whether the address is the customer's default billing address. */
  default_billing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address is the customer's default shipping address. */
  default_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address delivers to door. */
  delivery_to_door?: Maybe<Scalars['Boolean']['output']>;
  /** Contains any extension attributes for the address. */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The customer's fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The ID of a `CustomerAddress` object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the address is freight shipping address. */
  is_freight_address?: Maybe<Scalars['Boolean']['output']>;
  /** The family name of the person associated with the shipping/billing address. */
  lastname?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the address has Limited access Delivery. */
  limited_access_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address has loading dock. */
  loading_dock?: Maybe<Scalars['Boolean']['output']>;
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region name, region code, and region ID. */
  region?: Maybe<CustomerAddressRegion>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the address is residential. */
  residential_delivery?: Maybe<Scalars['Boolean']['output']>;
  /** An array of strings that define the street number and name. */
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The customer's telephone number. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']['output']>;
};

/** Defines the customer's state or province. */
export type CustomerAddressRegion = {
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>;
  /** The address region code. */
  region_code?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a pre-defined region. */
  region_id?: Maybe<Scalars['Int']['output']>;
};

/** Specifies the attribute code and value of a customer address attribute. */
export type CustomerAddressAttribute = {
  /** The name assigned to the customer address attribute. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** The valuue assigned to the customer address attribute. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Contains the result of the `isEmailAvailable` query. */
export type IsEmailAvailableOutput = {
  /** Indicates whether the specified email address can be used to create a customer. */
  is_email_available?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the customer with specified email is a sub-user.  */
  is_sub_user?: Maybe<Scalars['Boolean']['output']>;
};

/** The list of country codes. */
export type CountryCodeEnum =
  /** Afghanistan */
  | 'AF'
  /** Åland Islands */
  | 'AX'
  /** Albania */
  | 'AL'
  /** Algeria */
  | 'DZ'
  /** American Samoa */
  | 'AS'
  /** Andorra */
  | 'AD'
  /** Angola */
  | 'AO'
  /** Anguilla */
  | 'AI'
  /** Antarctica */
  | 'AQ'
  /** Antigua & Barbuda */
  | 'AG'
  /** Argentina */
  | 'AR'
  /** Armenia */
  | 'AM'
  /** Aruba */
  | 'AW'
  /** Australia */
  | 'AU'
  /** Austria */
  | 'AT'
  /** Azerbaijan */
  | 'AZ'
  /** Bahamas */
  | 'BS'
  /** Bahrain */
  | 'BH'
  /** Bangladesh */
  | 'BD'
  /** Barbados */
  | 'BB'
  /** Belarus */
  | 'BY'
  /** Belgium */
  | 'BE'
  /** Belize */
  | 'BZ'
  /** Benin */
  | 'BJ'
  /** Bermuda */
  | 'BM'
  /** Bhutan */
  | 'BT'
  /** Bolivia */
  | 'BO'
  /** Bosnia & Herzegovina */
  | 'BA'
  /** Botswana */
  | 'BW'
  /** Bouvet Island */
  | 'BV'
  /** Brazil */
  | 'BR'
  /** British Indian Ocean Territory */
  | 'IO'
  /** British Virgin Islands */
  | 'VG'
  /** Brunei */
  | 'BN'
  /** Bulgaria */
  | 'BG'
  /** Burkina Faso */
  | 'BF'
  /** Burundi */
  | 'BI'
  /** Cambodia */
  | 'KH'
  /** Cameroon */
  | 'CM'
  /** Canada */
  | 'CA'
  /** Cape Verde */
  | 'CV'
  /** Cayman Islands */
  | 'KY'
  /** Central African Republic */
  | 'CF'
  /** Chad */
  | 'TD'
  /** Chile */
  | 'CL'
  /** China */
  | 'CN'
  /** Christmas Island */
  | 'CX'
  /** Cocos (Keeling) Islands */
  | 'CC'
  /** Colombia */
  | 'CO'
  /** Comoros */
  | 'KM'
  /** Congo-Brazzaville */
  | 'CG'
  /** Congo-Kinshasa */
  | 'CD'
  /** Cook Islands */
  | 'CK'
  /** Costa Rica */
  | 'CR'
  /** Côte d’Ivoire */
  | 'CI'
  /** Croatia */
  | 'HR'
  /** Cuba */
  | 'CU'
  /** Cyprus */
  | 'CY'
  /** Czech Republic */
  | 'CZ'
  /** Denmark */
  | 'DK'
  /** Djibouti */
  | 'DJ'
  /** Dominica */
  | 'DM'
  /** Dominican Republic */
  | 'DO'
  /** Ecuador */
  | 'EC'
  /** Egypt */
  | 'EG'
  /** El Salvador */
  | 'SV'
  /** Equatorial Guinea */
  | 'GQ'
  /** Eritrea */
  | 'ER'
  /** Estonia */
  | 'EE'
  /** Ethiopia */
  | 'ET'
  /** Falkland Islands */
  | 'FK'
  /** Faroe Islands */
  | 'FO'
  /** Fiji */
  | 'FJ'
  /** Finland */
  | 'FI'
  /** France */
  | 'FR'
  /** French Guiana */
  | 'GF'
  /** French Polynesia */
  | 'PF'
  /** French Southern Territories */
  | 'TF'
  /** Gabon */
  | 'GA'
  /** Gambia */
  | 'GM'
  /** Georgia */
  | 'GE'
  /** Germany */
  | 'DE'
  /** Ghana */
  | 'GH'
  /** Gibraltar */
  | 'GI'
  /** Greece */
  | 'GR'
  /** Greenland */
  | 'GL'
  /** Grenada */
  | 'GD'
  /** Guadeloupe */
  | 'GP'
  /** Guam */
  | 'GU'
  /** Guatemala */
  | 'GT'
  /** Guernsey */
  | 'GG'
  /** Guinea */
  | 'GN'
  /** Guinea-Bissau */
  | 'GW'
  /** Guyana */
  | 'GY'
  /** Haiti */
  | 'HT'
  /** Heard &amp; McDonald Islands */
  | 'HM'
  /** Honduras */
  | 'HN'
  /** Hong Kong SAR China */
  | 'HK'
  /** Hungary */
  | 'HU'
  /** Iceland */
  | 'IS'
  /** India */
  | 'IN'
  /** Indonesia */
  | 'ID'
  /** Iran */
  | 'IR'
  /** Iraq */
  | 'IQ'
  /** Ireland */
  | 'IE'
  /** Isle of Man */
  | 'IM'
  /** Israel */
  | 'IL'
  /** Italy */
  | 'IT'
  /** Jamaica */
  | 'JM'
  /** Japan */
  | 'JP'
  /** Jersey */
  | 'JE'
  /** Jordan */
  | 'JO'
  /** Kazakhstan */
  | 'KZ'
  /** Kenya */
  | 'KE'
  /** Kiribati */
  | 'KI'
  /** Kuwait */
  | 'KW'
  /** Kyrgyzstan */
  | 'KG'
  /** Laos */
  | 'LA'
  /** Latvia */
  | 'LV'
  /** Lebanon */
  | 'LB'
  /** Lesotho */
  | 'LS'
  /** Liberia */
  | 'LR'
  /** Libya */
  | 'LY'
  /** Liechtenstein */
  | 'LI'
  /** Lithuania */
  | 'LT'
  /** Luxembourg */
  | 'LU'
  /** Macau SAR China */
  | 'MO'
  /** Macedonia */
  | 'MK'
  /** Madagascar */
  | 'MG'
  /** Malawi */
  | 'MW'
  /** Malaysia */
  | 'MY'
  /** Maldives */
  | 'MV'
  /** Mali */
  | 'ML'
  /** Malta */
  | 'MT'
  /** Marshall Islands */
  | 'MH'
  /** Martinique */
  | 'MQ'
  /** Mauritania */
  | 'MR'
  /** Mauritius */
  | 'MU'
  /** Mayotte */
  | 'YT'
  /** Mexico */
  | 'MX'
  /** Micronesia */
  | 'FM'
  /** Moldova */
  | 'MD'
  /** Monaco */
  | 'MC'
  /** Mongolia */
  | 'MN'
  /** Montenegro */
  | 'ME'
  /** Montserrat */
  | 'MS'
  /** Morocco */
  | 'MA'
  /** Mozambique */
  | 'MZ'
  /** Myanmar (Burma) */
  | 'MM'
  /** Namibia */
  | 'NA'
  /** Nauru */
  | 'NR'
  /** Nepal */
  | 'NP'
  /** Netherlands */
  | 'NL'
  /** Netherlands Antilles */
  | 'AN'
  /** New Caledonia */
  | 'NC'
  /** New Zealand */
  | 'NZ'
  /** Nicaragua */
  | 'NI'
  /** Niger */
  | 'NE'
  /** Nigeria */
  | 'NG'
  /** Niue */
  | 'NU'
  /** Norfolk Island */
  | 'NF'
  /** Northern Mariana Islands */
  | 'MP'
  /** North Korea */
  | 'KP'
  /** Norway */
  | 'NO'
  /** Oman */
  | 'OM'
  /** Pakistan */
  | 'PK'
  /** Palau */
  | 'PW'
  /** Palestinian Territories */
  | 'PS'
  /** Panama */
  | 'PA'
  /** Papua New Guinea */
  | 'PG'
  /** Paraguay */
  | 'PY'
  /** Peru */
  | 'PE'
  /** Philippines */
  | 'PH'
  /** Pitcairn Islands */
  | 'PN'
  /** Poland */
  | 'PL'
  /** Portugal */
  | 'PT'
  /** Qatar */
  | 'QA'
  /** Réunion */
  | 'RE'
  /** Romania */
  | 'RO'
  /** Russia */
  | 'RU'
  /** Rwanda */
  | 'RW'
  /** Samoa */
  | 'WS'
  /** San Marino */
  | 'SM'
  /** São Tomé & Príncipe */
  | 'ST'
  /** Saudi Arabia */
  | 'SA'
  /** Senegal */
  | 'SN'
  /** Serbia */
  | 'RS'
  /** Seychelles */
  | 'SC'
  /** Sierra Leone */
  | 'SL'
  /** Singapore */
  | 'SG'
  /** Slovakia */
  | 'SK'
  /** Slovenia */
  | 'SI'
  /** Solomon Islands */
  | 'SB'
  /** Somalia */
  | 'SO'
  /** South Africa */
  | 'ZA'
  /** South Georgia & South Sandwich Islands */
  | 'GS'
  /** South Korea */
  | 'KR'
  /** Spain */
  | 'ES'
  /** Sri Lanka */
  | 'LK'
  /** St. Barthélemy */
  | 'BL'
  /** St. Helena */
  | 'SH'
  /** St. Kitts & Nevis */
  | 'KN'
  /** St. Lucia */
  | 'LC'
  /** St. Martin */
  | 'MF'
  /** St. Pierre & Miquelon */
  | 'PM'
  /** St. Vincent & Grenadines */
  | 'VC'
  /** Sudan */
  | 'SD'
  /** Suriname */
  | 'SR'
  /** Svalbard & Jan Mayen */
  | 'SJ'
  /** Swaziland */
  | 'SZ'
  /** Sweden */
  | 'SE'
  /** Switzerland */
  | 'CH'
  /** Syria */
  | 'SY'
  /** Taiwan */
  | 'TW'
  /** Tajikistan */
  | 'TJ'
  /** Tanzania */
  | 'TZ'
  /** Thailand */
  | 'TH'
  /** Timor-Leste */
  | 'TL'
  /** Togo */
  | 'TG'
  /** Tokelau */
  | 'TK'
  /** Tonga */
  | 'TO'
  /** Trinidad & Tobago */
  | 'TT'
  /** Tunisia */
  | 'TN'
  /** Turkey */
  | 'TR'
  /** Turkmenistan */
  | 'TM'
  /** Turks & Caicos Islands */
  | 'TC'
  /** Tuvalu */
  | 'TV'
  /** Uganda */
  | 'UG'
  /** Ukraine */
  | 'UA'
  /** United Arab Emirates */
  | 'AE'
  /** United Kingdom */
  | 'GB'
  /** United States */
  | 'US'
  /** Uruguay */
  | 'UY'
  /** U.S. Outlying Islands */
  | 'UM'
  /** U.S. Virgin Islands */
  | 'VI'
  /** Uzbekistan */
  | 'UZ'
  /** Vanuatu */
  | 'VU'
  /** Vatican City */
  | 'VA'
  /** Venezuela */
  | 'VE'
  /** Vietnam */
  | 'VN'
  /** Wallis & Futuna */
  | 'WF'
  /** Western Sahara */
  | 'EH'
  /** Yemen */
  | 'YE'
  /** Zambia */
  | 'ZM'
  /** Zimbabwe */
  | 'ZW';

export type Currency = {
  /** An array of three-letter currency codes accepted by the store, such as USD and EUR. */
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The base currency set for the store, such as USD. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** The symbol for the specified base currency, such as $. */
  base_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']['output']>;
  /** The currency that is displayed by default, such as USD. */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** The currency symbol that is displayed by default, such as $. */
  default_display_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** An array of exchange rates for currencies defined in the store. */
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** Lists the exchange rate. */
export type ExchangeRate = {
  /** Specifies the store’s default currency to exchange to. */
  currency_to?: Maybe<Scalars['String']['output']>;
  /** The exchange rate for the store’s default currency. */
  rate?: Maybe<Scalars['Float']['output']>;
};

export type Country = {
  /** An array of regions within a particular country. */
  available_regions?: Maybe<Array<Maybe<Region>>>;
  /** The name of the country in English. */
  full_name_english?: Maybe<Scalars['String']['output']>;
  /** The name of the country in the current locale. */
  full_name_locale?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Country` object. */
  id?: Maybe<Scalars['String']['output']>;
  /** The three-letter abbreviation of the country, such as USA. */
  three_letter_abbreviation?: Maybe<Scalars['String']['output']>;
  /** The two-letter abbreviation of the country, such as US. */
  two_letter_abbreviation?: Maybe<Scalars['String']['output']>;
};

export type Region = {
  /** The two-letter code for the region, such as TX for Texas. */
  code?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Region` object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of the region, such as Texas. */
  name?: Maybe<Scalars['String']['output']>;
};

export type AddDownloadableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of downloadable products to add. */
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>;
};

/** Defines a single downloadable product. */
export type DownloadableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the downloadable product. */
  data: CartItemInput;
  /** An array of objects containing the link_id of the downloadable product link. */
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>;
};

/** Contains the link ID for the downloadable product. */
export type DownloadableProductLinksInput = {
  /** The unique ID of the downloadable product link. */
  link_id: Scalars['Int']['input'];
};

/** Contains details about the cart after adding downloadable products. */
export type AddDownloadableProductsToCartOutput = {
  /** The cart after adding products. */
  cart: Cart;
};

export type DownloadableCartItem = CartItemInterface & {
  /** An array containing the artwork attached to the quote item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** An array containing information about the links for the downloadable product added to the cart. */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  projectId?: Maybe<Scalars['String']['output']>;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  reorder?: Maybe<Scalars['Boolean']['output']>;
  /** An array containing information about samples of the selected downloadable product. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
};

/** Defines a product that the shopper downloads. */
export type DownloadableProduct = ProductInterface & RoutableInterface & CustomizableProductInterface & {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** An array containing information about the links for this downloadable product. */
  downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** An array containing information about samples of this downloadable product. */
  downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  last_price_break?: Maybe<PriceBreak>;
  /** A value of 1 indicates that each link in the array must be purchased separately. */
  links_purchased_separately?: Maybe<Scalars['Int']['output']>;
  /** The heading above the list of downloadable products. */
  links_title?: Maybe<Scalars['String']['output']>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Defines a product that the shopper downloads. */
export type DownloadableProductreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

export type DownloadableFileTypeEnum =
  | 'FILE'
  | 'URL';

/** Defines characteristics of a downloadable product. */
export type DownloadableProductLinks = {
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This information should not be exposed on frontend. */
  is_shareable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend. */
  number_of_downloads?: Maybe<Scalars['Int']['output']>;
  /** The price of the downloadable product. */
  price?: Maybe<Scalars['Float']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `DownloadableProductLinks` object. */
  uid: Scalars['ID']['output'];
};

/** Defines characteristics of a downloadable product. */
export type DownloadableProductSamples = {
  /** @deprecated This information should not be exposed on frontend. */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** The full URL to the downloadable sample. */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the sample. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Defines downloadable product options for `OrderItemInterface`. */
export type DownloadableOrderItem = OrderItemInterface & {
  /** An array containing the artwork attached to the order item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are ordered from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Indicates whether product exists.  */
  product_exists?: Maybe<Scalars['Boolean']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['String']['output']>;
  /** An array containing the proofs attached to the order item. */
  proofs?: Maybe<Array<Maybe<ProofInterface>>>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines downloadable product options for `InvoiceItemInterface`. */
export type DownloadableInvoiceItem = InvoiceItemInterface & {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are invoiced from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Defines downloadable product options for `CreditMemoItemInterface`. */
export type DownloadableCreditMemoItem = CreditMemoItemInterface & {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** A list of downloadable links that are refunded from the downloadable product. */
  downloadable_links?: Maybe<Array<Maybe<DownloadableItemsLinks>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Defines characteristics of the links for downloadable product. */
export type DownloadableItemsLinks = {
  /** A number indicating the sort order. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `DownloadableItemsLinks` object. */
  uid: Scalars['ID']['output'];
};

/** A downloadable product wish list item. */
export type DownloadableWishlistItem = WishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** An array containing information about the selected links. */
  links_v2?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
  /** An array containing information about the selected samples. */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

/** Contains a list of downloadable products. */
export type CustomerDownloadableProducts = {
  /** An array of purchased downloadable items. */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>;
};

/** Contains details about a single downloadable product. */
export type CustomerDownloadableProduct = {
  /** The date and time the purchase was made. */
  date?: Maybe<Scalars['String']['output']>;
  /** The fully qualified URL to the download file. */
  download_url?: Maybe<Scalars['String']['output']>;
  /** The unique ID assigned to the item. */
  order_increment_id?: Maybe<Scalars['String']['output']>;
  /** The remaining number of times the customer can download the product. */
  remaining_downloads?: Maybe<Scalars['String']['output']>;
  /** Indicates when the product becomes available for download. Options are `Pending` and `Invoiced`. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Deprecated. Use `TierPrice` instead. Defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  /**
   * The ID of the customer group.
   * @deprecated Not relevant for the storefront.
   */
  customer_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage discount of the item.
   * @deprecated Use `TierPrice.discount` instead.
   */
  percentage_value?: Maybe<Scalars['Float']['output']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated Use `TierPrice.quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /**
   * The price of the fixed price item.
   * @deprecated Use `TierPrice.final_price` instead.
   */
  value?: Maybe<Scalars['Float']['output']>;
  /**
   * The ID assigned to the website.
   * @deprecated Not relevant for the storefront.
   */
  website_id?: Maybe<Scalars['Float']['output']>;
};

/** Defines a price based on the quantity purchased. */
export type TierPrice = {
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  /** The price of the product at this tier. */
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type ConfigurableCartItem = CartItemInterface & {
  /** An array containing the artwork attached to the quote item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** An array containing the configuranle options the shopper selected. */
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  projectId?: Maybe<Scalars['String']['output']>;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  reorder?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
};

export type BundleCartItem = CartItemInterface & {
  /** An array containing the artwork attached to the quote item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** An array containing the bundle options the shopper selected. */
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  /** An array containing the customizable options the shopper selected. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** An array of errors encountered while loading the cart item */
  errors?: Maybe<Array<Maybe<CartItemError>>>;
  /** The entered gift message for the cart item */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use `uid` instead. */
  id: Scalars['String']['output'];
  /** Contains details about the price of the item, including taxes and discounts. */
  prices?: Maybe<CartItemPrices>;
  /** Details about an item in the cart. */
  product: ProductInterface;
  projectId?: Maybe<Scalars['String']['output']>;
  /** The quantity of this item in the cart. */
  quantity: Scalars['Float']['output'];
  reorder?: Maybe<Scalars['Boolean']['output']>;
  /** The unique ID for a `CartItemInterface` object. */
  uid: Scalars['ID']['output'];
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessage = {
  /** Sender name */
  from: Scalars['String']['output'];
  /** Gift message text */
  message: Scalars['String']['output'];
  /** Recipient name */
  to: Scalars['String']['output'];
};

/** Contains the text of a gift message, its sender, and recipient */
export type GiftMessageInput = {
  /** Sender name */
  from: Scalars['String']['input'];
  /** Gift message text */
  message: Scalars['String']['input'];
  /** Recipient name */
  to: Scalars['String']['input'];
};

export type SalesItemInterface = {
  /** The entered gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
};

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  customer_email?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  estimated_ship_date?: Maybe<Scalars['String']['output']>;
  /** The entered gift message for the order */
  gift_message?: Maybe<GiftMessage>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID']['output'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']['output']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** The order number. */
  number: Scalars['String']['output'];
  /** The date the order was placed. */
  order_date: Scalars['String']['output'];
  /** @deprecated Use the `number` field instead. */
  order_number: Scalars['String']['output'];
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']['output']>;
  /** The current status of the order. */
  status: Scalars['String']['output'];
  /** Sub-user's information at the place order time */
  sub_user?: Maybe<SubUser>;
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** An array containing the artwork attached to the order item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Indicates whether product exists.  */
  product_exists?: Maybe<Scalars['Boolean']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['String']['output']>;
  /** An array containing the proofs attached to the order item. */
  proofs?: Maybe<Array<Maybe<ProofInterface>>>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines the bundle products to add to the cart. */
export type AddBundleProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of bundle products to add. */
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

/** Defines a single bundle product. */
export type BundleProductCartItemInput = {
  /** A mandatory array of options for the bundle product, including each chosen option and specified quantity. */
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the bundle product. */
  data: CartItemInput;
};

/** Defines the input for a bundle option. */
export type BundleOptionInput = {
  /** The ID of the option. */
  id: Scalars['Int']['input'];
  /** The number of the selected item to add to the cart. */
  quantity: Scalars['Float']['input'];
  /** An array with the chosen value of the option. */
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Contains details about the cart after adding bundle products. */
export type AddBundleProductsToCartOutput = {
  /** The cart after adding products. */
  cart: Cart;
};

/** Contains details about a selected bundle option. */
export type SelectedBundleOption = {
  /** @deprecated Use `uid` instead */
  id: Scalars['Int']['output'];
  /** The display name of the selected bundle product option. */
  label: Scalars['String']['output'];
  /** The type of selected bundle product option. */
  type: Scalars['String']['output'];
  /** The unique ID for a `SelectedBundleOption` object */
  uid: Scalars['ID']['output'];
  /** An array of selected bundle option values. */
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

/** Contains details about a value for a selected bundle option. */
export type SelectedBundleOptionValue = {
  /** Use `uid` instead */
  id: Scalars['Int']['output'];
  /** The display name of the value for the selected bundle product option. */
  label: Scalars['String']['output'];
  /** The price of the value for the selected bundle product option. */
  price: Scalars['Float']['output'];
  /** The quantity of the value for the selected bundle product option. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `SelectedBundleOptionValue` object */
  uid: Scalars['ID']['output'];
};

/** Defines an individual item within a bundle product. */
export type BundleItem = {
  /**
   * An ID assigned to each type of item in a bundle product.
   * @deprecated Use `uid` instead
   */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** A number indicating the sequence order of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']['output']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `BundleItem` object. */
  uid?: Maybe<Scalars['ID']['output']>;
};

/** Defines the characteristics that comprise a specific bundle item and its options. */
export type BundleItemOption = {
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The ID assigned to the bundled item option.
   * @deprecated Use `uid` instead
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']['output']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /** The quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** The unique ID for a `BundleItemOption` object. */
  uid: Scalars['ID']['output'];
};

/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = ProductInterface & RoutableInterface & PhysicalProductInterface & CustomizableProductInterface & {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the bundle product has a dynamic price. */
  dynamic_price?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamic SKU. */
  dynamic_sku?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamic_weight?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** An array containing information about individual bundle items. */
  items?: Maybe<Array<Maybe<BundleItem>>>;
  last_price_break?: Maybe<PriceBreak>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** One of PRICE_RANGE or AS_LOW_AS. */
  price_view?: Maybe<PriceViewEnum>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether to ship bundle items together or individually. */
  ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProductreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export type PriceViewEnum =
  | 'PRICE_RANGE'
  | 'AS_LOW_AS';

/** Defines whether bundle items must be shipped together. */
export type ShipBundleItemsEnum =
  | 'TOGETHER'
  | 'SEPARATELY';

/** Defines bundle product options for `OrderItemInterface`. */
export type BundleOrderItem = OrderItemInterface & {
  /** An array containing the artwork attached to the order item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** A list of bundle options that are assigned to the bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Indicates whether product exists.  */
  product_exists?: Maybe<Scalars['Boolean']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['String']['output']>;
  /** An array containing the proofs attached to the order item. */
  proofs?: Maybe<Array<Maybe<ProofInterface>>>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Defines bundle product options for `InvoiceItemInterface`. */
export type BundleInvoiceItem = InvoiceItemInterface & {
  /** A list of bundle options that are assigned to an invoiced bundle product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Defines bundle product options for `ShipmentItemInterface`. */
export type BundleShipmentItem = ShipmentItemInterface & {
  /** A list of bundle options that are assigned to a shipped product. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Defines bundle product options for `CreditMemoItemInterface`. */
export type BundleCreditMemoItem = CreditMemoItemInterface & {
  /** A list of bundle options that are assigned to a bundle product that is part of a credit memo. */
  bundle_options?: Maybe<Array<Maybe<ItemSelectedBundleOption>>>;
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** A list of options of the selected bundle product. */
export type ItemSelectedBundleOption = {
  /**
   * The unique ID for a `ItemSelectedBundleOption` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']['output'];
  /** The label of the option. */
  label: Scalars['String']['output'];
  /** The unique ID for a `ItemSelectedBundleOption` object. */
  uid: Scalars['ID']['output'];
  /** A list of products that represent the values of the parent option. */
  values?: Maybe<Array<Maybe<ItemSelectedBundleOptionValue>>>;
};

/** A list of values for the selected bundle product. */
export type ItemSelectedBundleOptionValue = {
  /**
   * The unique ID for a `ItemSelectedBundleOptionValue` object.
   * @deprecated Use `uid` instead.
   */
  id: Scalars['ID']['output'];
  /** The price of the child bundle product. */
  price: Money;
  /** The name of the child bundle product. */
  product_name: Scalars['String']['output'];
  /** The SKU of the child bundle product. */
  product_sku: Scalars['String']['output'];
  /** The number of this bundle product that were ordered. */
  quantity: Scalars['Float']['output'];
  /** The unique ID for a `ItemSelectedBundleOptionValue` object. */
  uid: Scalars['ID']['output'];
};

/** Defines bundle product options for `WishlistItemInterface`. */
export type BundleWishlistItem = WishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** An array containing information about the selected bundle items. */
  bundle_options?: Maybe<Array<Maybe<SelectedBundleOption>>>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProduct = ProductInterface & RoutableInterface & PhysicalProductInterface & {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** An array containing grouped product items. */
  items?: Maybe<Array<Maybe<GroupedProductItem>>>;
  last_price_break?: Maybe<PriceBreak>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Defines a grouped product, which consists of simple standalone products that are presented as a group. */
export type GroupedProductreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains information about an individual grouped product item. */
export type GroupedProductItem = {
  /** The relative position of this item compared to the other group items. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Details about this product option. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this grouped product item. */
  qty?: Maybe<Scalars['Float']['output']>;
};

/** A grouped product wish list item. */
export type GroupedProductWishlistItem = WishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProduct = ProductInterface & RoutableInterface & PhysicalProductInterface & CustomizableProductInterface & {
  /** Add to cart url. */
  add_to_cart_url?: Maybe<Scalars['String']['output']>;
  /** Add to wishlist information. */
  add_to_wishlist?: Maybe<Scalars['String']['output']>;
  /** List of FAQ Questions Assigned to a Product. */
  amfaq_questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** List of Files Attached to a Product. */
  amfiles?: Maybe<Array<Maybe<AmFile>>>;
  /**
   * The attribute set assigned to the product.
   * @deprecated The field should not be used on the storefront.
   */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  /** The relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  color?: Maybe<Scalars['Int']['output']>;
  /** An array of options for the configurable product. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
  /** An array of media gallery items and other details about selected configurable product options as well as details about remaining selectable options. */
  configurable_product_options_selection?: Maybe<ConfigurableProductOptionsSelection>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was created.
   * @deprecated The field should not be used on the storefront.
   */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  design_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the `custom_attributes` field instead. */
  fourover_options_modifier?: Maybe<Array<Maybe<FourOverCustomOptionModifier>>>;
  free_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the product.
   * @deprecated Use the `uid` field instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  last_price_break?: Maybe<PriceBreak>;
  /**
   * A number representing the product's manufacturer.
   * @deprecated Use the `custom_attributes` field instead.
   */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  max_tier_price?: Maybe<Scalars['Float']['output']>;
  /** An array of media gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use `media_gallery` instead.
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  min_tier_max_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_min_unit_price?: Maybe<Scalars['Float']['output']>;
  min_tier_price?: Maybe<Scalars['Float']['output']>;
  moq?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  pallet_depth?: Maybe<Scalars['String']['output']>;
  pallet_height?: Maybe<Scalars['String']['output']>;
  pallet_weight?: Maybe<Scalars['String']['output']>;
  pallet_width?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates the price of an item.
   * @deprecated Use `price_range` for product price information.
   */
  price?: Maybe<ProductPrices>;
  price_breaks?: Maybe<Array<Maybe<PriceBreak>>>;
  /** The range of prices for the product */
  price_range: PriceRange;
  /** An array of `TierPrice` objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array of `ProductLinks` objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  /** @deprecated Use the `custom_attributes` field instead. */
  product_qbo_id?: Maybe<Scalars['String']['output']>;
  /** Product url. */
  product_url?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['Float']['output']>;
  /** The average of all the ratings given to the product. */
  rating_summary: Scalars['Float']['output'];
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** An array of products to be displayed in a Related Products block. */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  requires_artwork?: Maybe<Scalars['Boolean']['output']>;
  /** The total count of all the reviews given to the product. */
  review_count: Scalars['Int']['output'];
  /** The list of products reviews. */
  reviews: ProductReviews;
  setup_price?: Maybe<Scalars['Float']['output']>;
  setup_price_discount?: Maybe<Scalars['Float']['output']>;
  setup_price_quantity_threshold?: Maybe<Scalars['Float']['output']>;
  setup_price_type?: Maybe<Scalars['Float']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  source?: Maybe<Source>;
  /**
   * The beginning date that a product has a special price.
   * @deprecated The field should not be used on the storefront.
   */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date for a product with a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image. */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use `price_tiers` for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use `__typename` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface` object. */
  uid: Scalars['ID']['output'];
  units_per_pallet?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp indicating when the product was updated.
   * @deprecated The field should not be used on the storefront.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  /** An array of simple product variants. */
  variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  yotpo_average_rating?: Maybe<Scalars['Float']['output']>;
  yotpo_review_count?: Maybe<Scalars['Int']['output']>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductconfigurable_product_options_selectionArgs = {
  configurableOptionValueUids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Defines basic features of a configurable product and its simple product variants. */
export type ConfigurableProductreviewsArgs = {
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains all the simple product variants of a configurable product. */
export type ConfigurableVariant = {
  /** An array of configurable attribute options. */
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  /** An array of linked simple products. */
  product?: Maybe<SimpleProduct>;
};

/** Contains details about a configurable product attribute option. */
export type ConfigurableAttributeOption = {
  /** The ID assigned to the attribute. */
  code?: Maybe<Scalars['String']['output']>;
  /** A string that describes the configurable attribute option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ConfigurableAttributeOption` object. */
  uid: Scalars['ID']['output'];
  /** A unique index number assigned to the configurable product option. */
  value_index?: Maybe<Scalars['Int']['output']>;
};

/** Defines configurable attributes for the specified product. */
export type ConfigurableProductOptions = {
  /** A string that identifies the attribute. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id?: Maybe<Scalars['String']['output']>;
  /**
   * The ID assigned to the attribute.
   * @deprecated Use `attribute_uid` instead.
   */
  attribute_id_v2?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for an `Attribute` object. */
  attribute_uid: Scalars['ID']['output'];
  /**
   * The configurable option ID number assigned by the system.
   * @deprecated Use `uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** A displayed string that describes the configurable product option. */
  label?: Maybe<Scalars['String']['output']>;
  /** A number that indicates the order in which the attribute is displayed. */
  position?: Maybe<Scalars['Int']['output']>;
  /**
   * This is the same as a product's `id` field.
   * @deprecated `product_id` is not needed and can be obtained from its parent.
   */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The unique ID for a `ConfigurableProductOptions` object. */
  uid: Scalars['ID']['output'];
  /** Indicates whether the option is the default. */
  use_default?: Maybe<Scalars['Boolean']['output']>;
  /** An array that defines the `value_index` codes assigned to the configurable product. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** Contains the index number assigned to a configurable product option. */
export type ConfigurableProductOptionsValues = {
  /** The label of the product on the default store. */
  default_label?: Maybe<Scalars['String']['output']>;
  /** The label of the product. */
  label?: Maybe<Scalars['String']['output']>;
  /** The label of the product on the current store. */
  store_label?: Maybe<Scalars['String']['output']>;
  /** Swatch data for a configurable product option. */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  uid?: Maybe<Scalars['ID']['output']>;
  /** Indicates whether to use the default_label. */
  use_default_value?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A unique index number assigned to the configurable product option.
   * @deprecated Use `uid` instead.
   */
  value_index?: Maybe<Scalars['Int']['output']>;
};

/** Defines the configurable products to add to the cart. */
export type AddConfigurableProductsToCartInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of configurable products to add. */
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

/** Contains details about the cart after adding configurable products. */
export type AddConfigurableProductsToCartOutput = {
  /** The cart after adding products. */
  cart: Cart;
};

export type ConfigurableProductCartItemInput = {
  /** The ID and value of the option. */
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  /** The quantity and SKU of the configurable product. */
  data: CartItemInput;
  /** The SKU of the parent configurable product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use `CartItemInput.sku` instead. */
  variant_sku?: InputMaybe<Scalars['String']['input']>;
};

/** Contains details about a selected configurable option. */
export type SelectedConfigurableOption = {
  /** The unique ID for a `ConfigurableProductOptions` object. */
  configurable_product_option_uid: Scalars['ID']['output'];
  /** The unique ID for a `ConfigurableProductOptionsValues` object. */
  configurable_product_option_value_uid: Scalars['ID']['output'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_uid` instead. */
  id: Scalars['Int']['output'];
  /** The display text for the option. */
  option_label: Scalars['String']['output'];
  /** @deprecated Use `SelectedConfigurableOption.configurable_product_option_value_uid` instead. */
  value_id: Scalars['Int']['output'];
  /** The display name of the selected configurable option. */
  value_label: Scalars['String']['output'];
};

/** A configurable product wish list item. */
export type ConfigurableWishlistItem = WishlistItemInterface & {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /**
   * The SKU of the simple product corresponding to a set of selected configurable options.
   * @deprecated Use `ConfigurableWishlistItem.configured_variant.sku` instead.
   */
  child_sku: Scalars['String']['output'];
  /** An array of selected configurable options. */
  configurable_options?: Maybe<Array<Maybe<SelectedConfigurableOption>>>;
  /** Product details of the selected variant. The value is null if some options are not configured. */
  configured_variant?: Maybe<ProductInterface>;
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Contains metadata corresponding to the selected configurable options. */
export type ConfigurableProductOptionsSelection = {
  /** An array of all possible configurable options. */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOption>>>;
  /** Product images and videos corresponding to the specified configurable options selection. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /** The configurable options available for further selection based on the current selection. */
  options_available_for_selection?: Maybe<Array<Maybe<ConfigurableOptionAvailableForSelection>>>;
  /** A variant represented by the specified configurable options selection. The value is expected to be null until selections are made for each configurable option. */
  variant?: Maybe<SimpleProduct>;
};

/** Describes configurable options that have been selected and can be selected as a result of the previous selections. */
export type ConfigurableOptionAvailableForSelection = {
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String']['output'];
  /** An array of selectable option value IDs. */
  option_value_uids: Array<Maybe<Scalars['ID']['output']>>;
};

/** Contains details about configurable product options. */
export type ConfigurableProductOption = {
  /** An attribute code that uniquely identifies a configurable option. */
  attribute_code: Scalars['String']['output'];
  /** The display name of the option. */
  label: Scalars['String']['output'];
  /** The unique ID of the configurable option. */
  uid: Scalars['ID']['output'];
  /** An array of values that are applicable for this option. */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionValue>>>;
};

/** Defines a value for a configurable product option. */
export type ConfigurableProductOptionValue = {
  /** Indicates whether the product is available with this selected option. */
  is_available: Scalars['Boolean']['output'];
  /** Indicates whether the value is the default. */
  is_use_default: Scalars['Boolean']['output'];
  /** The display name of the value. */
  label: Scalars['String']['output'];
  /** The URL assigned to the thumbnail of the swatch image. */
  swatch?: Maybe<SwatchDataInterface>;
  /** The unique ID of the value. */
  uid: Scalars['ID']['output'];
};

/** AreaInput defines the parameters which will be used for filter by specified location. */
export type AreaInput = {
  /** The radius for the search in KM. */
  radius: Scalars['Int']['input'];
  /** The country code where search must be performed. Required parameter together with region, city or postcode. */
  search_term: Scalars['String']['input'];
};

/** PickupLocationFilterInput defines the list of attributes and filters for the search. */
export type PickupLocationFilterInput = {
  /** Filter by city. */
  city?: InputMaybe<FilterTypeInput>;
  /** Filter by country. */
  country_id?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location name. */
  name?: InputMaybe<FilterTypeInput>;
  /** Filter by pickup location code. */
  pickup_location_code?: InputMaybe<FilterTypeInput>;
  /** Filter by postcode. */
  postcode?: InputMaybe<FilterTypeInput>;
  /** Filter by region. */
  region?: InputMaybe<FilterTypeInput>;
  /** Filter by region id. */
  region_id?: InputMaybe<FilterTypeInput>;
  /** Filter by street. */
  street?: InputMaybe<FilterTypeInput>;
};

/** PickupLocationSortInput specifies attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type PickupLocationSortInput = {
  /** City where pickup location is placed. */
  city?: InputMaybe<SortEnum>;
  /** Name of the contact person. */
  contact_name?: InputMaybe<SortEnum>;
  /** Id of the country in two letters. */
  country_id?: InputMaybe<SortEnum>;
  /** Description of the pickup location. */
  description?: InputMaybe<SortEnum>;
  /** Distance to the address, requested by distance filter. Applicable only with distance filter. If distance sort order is present, all other sort orders will be ignored. */
  distance?: InputMaybe<SortEnum>;
  /** Contact email of the pickup location. */
  email?: InputMaybe<SortEnum>;
  /** Contact fax of the pickup location. */
  fax?: InputMaybe<SortEnum>;
  /** Geographic latitude where pickup location is placed. */
  latitude?: InputMaybe<SortEnum>;
  /** Geographic longitude where pickup location is placed. */
  longitude?: InputMaybe<SortEnum>;
  /** The pickup location name. Customer use this to identify the pickup location. */
  name?: InputMaybe<SortEnum>;
  /** Contact phone number of the pickup location. */
  phone?: InputMaybe<SortEnum>;
  /** A code assigned to pickup location to identify the source. */
  pickup_location_code?: InputMaybe<SortEnum>;
  /** Postcode where pickup location is placed. */
  postcode?: InputMaybe<SortEnum>;
  /** Name of the region. */
  region?: InputMaybe<SortEnum>;
  /** Id of the region. */
  region_id?: InputMaybe<SortEnum>;
  /** Street where pickup location is placed. */
  street?: InputMaybe<SortEnum>;
};

/** Top level object returned in a pickup locations search. */
export type PickupLocations = {
  /** An array of pickup locations that match the specific search request. */
  items?: Maybe<Array<Maybe<PickupLocation>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Defines Pickup Location information. */
export type PickupLocation = {
  city?: Maybe<Scalars['String']['output']>;
  contact_name?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pickup_location_code?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

/** Product Information used for Pickup Locations search. */
export type ProductInfoInput = {
  /** Product SKU. */
  sku: Scalars['String']['input'];
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export type ProductStockStatus =
  | 'IN_STOCK'
  | 'OUT_OF_STOCK';

/** Identifies which customer requires remote shopping assistance. */
export type GenerateCustomerTokenAsAdminInput = {
  /** The email address of the customer requesting remote shopping assistance. */
  customer_email: Scalars['String']['input'];
};

/** Contains the generated customer token. */
export type GenerateCustomerTokenAsAdminOutput = {
  /** The generated customer token. */
  customer_token: Scalars['String']['output'];
};

/** Contains the result of the `subscribeEmailToNewsletter` operation. */
export type SubscribeEmailToNewsletterOutput = {
  /** The status of the subscription request. */
  status?: Maybe<SubscriptionStatusesEnum>;
};

/** Indicates the status of the request. */
export type SubscriptionStatusesEnum =
  | 'NOT_ACTIVE'
  | 'SUBSCRIBED'
  | 'UNSUBSCRIBED'
  | 'UNCONFIRMED';

/** Defines the attributes required to receive a payment token for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']['input'];
  /** The payment method code. */
  code: Scalars['String']['input'];
  /** Indicates whether the buyer selected the quick checkout button. The default value is false. */
  express_button?: InputMaybe<Scalars['Boolean']['input']>;
  /** A set of relative URLs that PayPal uses in response to various actions during the authorization process. */
  urls: PaypalExpressUrlsInput;
  /** Indicates whether the buyer clicked the PayPal credit button. The default value is false. */
  use_paypal_credit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Deprecated. Use `PaypalExpressTokenOutput` instead. */
export type PaypalExpressToken = {
  /**
   * A set of URLs that allow the buyer to authorize payment and adjust checkout details.
   * @deprecated Use `PaypalExpressTokenOutput.paypal_urls` instead.
   */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /**
   * The token returned by PayPal.
   * @deprecated Use `PaypalExpressTokenOutput.token` instead.
   */
  token?: Maybe<Scalars['String']['output']>;
};

/** Contains the token returned by PayPal and a set of URLs that allow the buyer to authorize payment and adjust checkout details. Applies to Express Checkout and Payments Standard payment methods. */
export type PaypalExpressTokenOutput = {
  /** A set of URLs that allow the buyer to authorize payment and adjust checkout details. */
  paypal_urls?: Maybe<PaypalExpressUrlList>;
  /** The token returned by PayPal. */
  token?: Maybe<Scalars['String']['output']>;
};

/** Contains information used to generate PayPal iframe for transaction. Applies to Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkToken = {
  /** The mode for the Payflow transaction. */
  mode?: Maybe<PayflowLinkMode>;
  /** The PayPal URL used for requesting a Payflow form. */
  paypal_url?: Maybe<Scalars['String']['output']>;
  /** The secure token generated by PayPal. */
  secure_token?: Maybe<Scalars['String']['output']>;
  /** The secure token ID generated by PayPal. */
  secure_token_id?: Maybe<Scalars['String']['output']>;
};

/** Contains the secure URL used for the Payments Pro Hosted Solution payment method. */
export type HostedProUrl = {
  /** The secure URL generated by PayPal. */
  secure_form_url?: Maybe<Scalars['String']['output']>;
};

/** Contains the required input to request the secure URL for Payments Pro Hosted Solution payment. */
export type HostedProUrlInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input'];
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payments Pro Hosted Solution payment method. */
export type HostedProInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. For example, if the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. For example, if the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
};

/** Contains required input for Express Checkout and Payments Standard payments. */
export type PaypalExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']['input'];
  /** The token returned by the `createPaypalExpressToken` mutation. */
  token: Scalars['String']['input'];
};

/** Contains required input for Payflow Express Checkout payments. */
export type PayflowExpressInput = {
  /** The unique ID of the PayPal user. */
  payer_id: Scalars['String']['input'];
  /** The token returned by the createPaypalExpressToken mutation. */
  token: Scalars['String']['input'];
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Express Checkout and Payments Standard payment methods. */
export type PaypalExpressUrlsInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the page that PayPal redirects to when the payment has been put on hold for additional review. This condition mostly applies to ACH transactions, and is not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success_pending.html, the relative URL is paypal/action/success_pending.html. */
  pending_url?: InputMaybe<Scalars['String']['input']>;
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. Not applicable to most PayPal solutions. If the full URL to this page is https://www.example.com/paypal/action/success.html, the relative URL is paypal/action/success.html. */
  success_url?: InputMaybe<Scalars['String']['input']>;
};

/** Contains a set of URLs that allow the buyer to authorize payment and adjust checkout details for Express Checkout and Payments Standard transactions. */
export type PaypalExpressUrlList = {
  /** The PayPal URL that allows the buyer to edit their checkout details. */
  edit?: Maybe<Scalars['String']['output']>;
  /** The URL to the PayPal login page. */
  start?: Maybe<Scalars['String']['output']>;
};

/** A set of relative URLs that PayPal uses in response to various actions during the authorization process. Adobe Commerce prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']['input'];
  /** The relative URL of the order confirmation page that PayPal redirects to when the payment is successful and additional confirmation is not needed. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
};

/** Contains information required to fetch payment token information for the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkTokenInput = {
  /** The unique ID that identifies the customer's cart. */
  cart_id: Scalars['String']['input'];
};

/** Indicates the mode for payment. Applies to the Payflow Link and Payments Advanced payment methods. */
export type PayflowLinkMode =
  | 'TEST'
  | 'LIVE';

/** Contains input required to fetch payment token information for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProTokenInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input'];
  /** A set of relative URLs that PayPal uses for callback. */
  urls: PayflowProUrlInput;
};

/** Contains input for the Payflow Pro and Payments Pro payment methods. */
export type PayflowProInput = {
  /** Required input for credit card related information. */
  cc_details: CreditCardDetailsInput;
  /** Indicates whether details about the shopper's credit/debit card should be tokenized for later usage. Required only if Vault is enabled for the PayPal Payflow Pro payment integration. */
  is_active_payment_token_enabler?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Required fields for Payflow Pro and Payments Pro credit card payments. */
export type CreditCardDetailsInput = {
  /** The credit card expiration month. */
  cc_exp_month: Scalars['Int']['input'];
  /** The credit card expiration year. */
  cc_exp_year: Scalars['Int']['input'];
  /** The last 4 digits of the credit card. */
  cc_last_4: Scalars['Int']['input'];
  /** The credit card type. */
  cc_type: Scalars['String']['input'];
};

/** Contains a set of relative URLs that PayPal uses in response to various actions during the authorization process. Magento prepends the base URL to this value to create a full URL. For example, if the full URL is https://www.example.com/path/to/page.html, the relative URL is path/to/page.html. Use this input for the Payflow Pro and Payment Pro payment methods. */
export type PayflowProUrlInput = {
  /** The relative URL of the page that PayPal redirects to when the buyer cancels the transaction in order to choose a different payment method. If the full URL to this page is https://www.example.com/paypal/action/cancel.html, the relative URL is paypal/action/cancel.html. */
  cancel_url: Scalars['String']['input'];
  /** The relative URL of the transaction error page that PayPal redirects to upon payment error. If the full URL to this page is https://www.example.com/paypal/action/error.html, the relative URL is paypal/action/error.html. */
  error_url: Scalars['String']['input'];
  /** The relative URL of the final confirmation page that PayPal redirects to upon payment success. If the full URL to this page is https://www.example.com/paypal/action/return.html, the relative URL is paypal/action/return.html. */
  return_url: Scalars['String']['input'];
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProToken = {
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String']['output'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']['output'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int']['output'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String']['output'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String']['output'];
};

/** Contains the secure information used to authorize transaction. Applies to Payflow Pro and Payments Pro payment methods. */
export type CreatePayflowProTokenOutput = {
  /** The RESPMSG returned by PayPal. If the `result` is `0`, then `response_message` is `Approved`. */
  response_message: Scalars['String']['output'];
  /** A non-zero value if any errors occurred. */
  result: Scalars['Int']['output'];
  /** The RESULT returned by PayPal. A value of `0` indicates the transaction was approved. */
  result_code: Scalars['Int']['output'];
  /** A secure token generated by PayPal. */
  secure_token: Scalars['String']['output'];
  /** A secure token ID generated by PayPal. */
  secure_token_id: Scalars['String']['output'];
};

/** Input required to complete payment. Applies to Payflow Pro and Payments Pro payment methods. */
export type PayflowProResponseInput = {
  /** The unique ID that identifies the shopper's cart. */
  cart_id: Scalars['String']['input'];
  /** The payload returned from PayPal. */
  paypal_payload: Scalars['String']['input'];
};

export type PayflowProResponseOutput = {
  /** The cart with the updated selected payment method. */
  cart: Cart;
};

/** Contains required input for payment methods with Vault support. */
export type VaultTokenInput = {
  /** The public hash of the payment token. */
  public_hash: Scalars['String']['input'];
};

/** Contains an array of product reviews. */
export type ProductReviews = {
  /** An array of product reviews. */
  items: Array<Maybe<ProductReview>>;
  /** Metadata for pagination rendering. */
  page_info: SearchResultPageInfo;
};

/** Contains details of a product review. */
export type ProductReview = {
  /** The average of all ratings for this product. */
  average_rating: Scalars['Float']['output'];
  /** The date the review was created. */
  created_at: Scalars['String']['output'];
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']['output'];
  /** The reviewed product. */
  product: ProductInterface;
  /** An array of ratings by rating category, such as quality, price, and value. */
  ratings_breakdown: Array<Maybe<ProductReviewRating>>;
  /** The summary (title) of the review. */
  summary: Scalars['String']['output'];
  /** The review text. */
  text: Scalars['String']['output'];
};

/** Contains data about a single aspect of a product review. */
export type ProductReviewRating = {
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']['output'];
  /** The rating value given by customer. By default, possible values range from 1 to 5. */
  value: Scalars['String']['output'];
};

/** Contains an array of metadata about each aspect of a product review. */
export type ProductReviewRatingsMetadata = {
  /** An array of product reviews sorted by position. */
  items: Array<Maybe<ProductReviewRatingMetadata>>;
};

/** Contains details about a single aspect of a product review. */
export type ProductReviewRatingMetadata = {
  /** An encoded rating ID. */
  id: Scalars['String']['output'];
  /** The label assigned to an aspect of a product that is being rated, such as quality or price. */
  name: Scalars['String']['output'];
  /** List of product review ratings sorted by position. */
  values: Array<Maybe<ProductReviewRatingValueMetadata>>;
};

/** Contains details about a single value in a product review. */
export type ProductReviewRatingValueMetadata = {
  /** A ratings scale, such as the number of stars awarded. */
  value: Scalars['String']['output'];
  /** An encoded rating value ID. */
  value_id: Scalars['String']['output'];
};

/** Contains the completed product review. */
export type CreateProductReviewOutput = {
  /** Product review details. */
  review: ProductReview;
};

/** Defines a new product review. */
export type CreateProductReviewInput = {
  /** The customer's nickname. Defaults to the customer name, if logged in. */
  nickname: Scalars['String']['input'];
  /** The ratings details by category. For example, Price: 5 stars, Quality: 4 stars, etc. */
  ratings: Array<InputMaybe<ProductReviewRatingInput>>;
  /** The SKU of the reviewed product. */
  sku: Scalars['String']['input'];
  /** The summary (title) of the review. */
  summary: Scalars['String']['input'];
  /** The review text. */
  text: Scalars['String']['input'];
};

/** Contains the reviewer's rating for a single aspect of a review. */
export type ProductReviewRatingInput = {
  /** An encoded rating ID. */
  id: Scalars['String']['input'];
  /** An encoded rating value ID. */
  value_id: Scalars['String']['input'];
};

/** Contains the cart and any errors after adding products. */
export type ReorderItemsOutput = {
  /** Detailed information about the customer's cart. */
  cart: Cart;
  /** An array of reordering errors. */
  userInputErrors: Array<Maybe<CheckoutUserInputError>>;
};

/** An error encountered while adding an item to the cart. */
export type CheckoutUserInputError = {
  /** An error code that is specific to Checkout. */
  code: CheckoutUserInputErrorCodes;
  /** A localized error message. */
  message: Scalars['String']['output'];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']['output']>>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export type CustomerOrderSortableField =
  /** Sorts customer orders by number */
  | 'NUMBER'
  /** Sorts customer orders by created_at field */
  | 'CREATED_AT';

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  /** The city or town. */
  city: Scalars['String']['output'];
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String']['output'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']['output']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']['output']>;
};

export type OrderItem = OrderItemInterface & {
  /** An array containing the artwork attached to the order item. */
  artwork?: Maybe<Array<Maybe<ArtworkInterface>>>;
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The selected gift message for the order item */
  gift_message?: Maybe<GiftMessage>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Indicates whether product exists.  */
  product_exists?: Maybe<Scalars['Boolean']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  production_time?: Maybe<Scalars['String']['output']>;
  /** An array containing the proofs attached to the order item. */
  proofs?: Maybe<Array<Maybe<ProofInterface>>>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  /** The name of the option. */
  label: Scalars['String']['output'];
  /** The value of the option. */
  value: Scalars['String']['output'];
};

/** Contains tax item details. */
export type TaxItem = {
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float']['output'];
  /** A title that describes the tax. */
  title: Scalars['String']['output'];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** An array containing all setup fees applied to the order. */
  setup_fees?: Maybe<Array<Maybe<SetupFee>>>;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

/** Contains invoice details. */
export type Invoice = {
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID']['output'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String']['output'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceItem = InvoiceItemInterface & {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  /** The amount of the discount. */
  amount: Money;
};

/** Contains order shipment details. */
export type OrderShipment = {
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID']['output'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String']['output'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  /** The text of the message. */
  message: Scalars['String']['output'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String']['output'];
};

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

export type ShipmentItem = ShipmentItemInterface & {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String']['output'];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The shipment tracking title. */
  title: Scalars['String']['output'];
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String']['output'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String']['output'];
};

/** Contains credit memo details. */
export type CreditMemo = {
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID']['output'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String']['output'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

export type CreditMemoItem = CreditMemoItemInterface & {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

/** Contains a key-value pair. */
export type KeyValue = {
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']['output']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']['output']>;
};

export type CheckoutUserInputErrorCodes =
  | 'REORDER_NOT_AVAILABLE'
  | 'PRODUCT_NOT_FOUND'
  | 'NOT_SALABLE'
  | 'INSUFFICIENT_STOCK'
  | 'UNDEFINED';

/** This enumeration defines the scope type for customer orders. */
export type ScopeTypeEnum =
  | 'GLOBAL'
  | 'WEBSITE'
  | 'STORE';

/** Contains the `uid`, `relative_url`, and `type` attributes. */
export type EntityUrl = {
  /** @deprecated Use `relative_url` instead. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `ProductInterface`, `CategoryInterface`, `CmsPage`, or similar object associated with the specified URL. This could be a product, category, or CMS page UID. */
  entity_uid?: Maybe<Scalars['ID']['output']>;
  /**
   * The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID.
   * @deprecated Use `entity_uid` instead.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirectCode?: Maybe<Scalars['Int']['output']>;
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Contains URL rewrite details. */
export type UrlRewrite = {
  /** An array of request parameters. */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** The request URL. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Contains target path parameters. */
export type HttpQueryParameter = {
  /** A parameter name. */
  name?: Maybe<Scalars['String']['output']>;
  /** A parameter value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Routable entities serve as the model for a rendered page. */
export type RoutableInterface = {
  /** Contains 0 when there is no redirect error. A value of 301 indicates the URL of the requested resource has been changed permanently, while a value of 302 indicates a temporary redirect. */
  redirect_code: Scalars['Int']['output'];
  /** The internal relative URL. If the specified URL is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
};

/** Defines the referenced product and the email sender and recipients. */
export type SendEmailToFriendInput = {
  /** The ID of the product that the sender is referencing. */
  product_id: Scalars['Int']['input'];
  /** An array containing information about each recipient. */
  recipients: Array<InputMaybe<SendEmailToFriendRecipientInput>>;
  /** Information about the customer and the content of the message. */
  sender: SendEmailToFriendSenderInput;
};

/** Contains details about the sender. */
export type SendEmailToFriendSenderInput = {
  /** The email address of the sender. */
  email: Scalars['String']['input'];
  /** The text of the message to be sent. */
  message: Scalars['String']['input'];
  /** The name of the sender. */
  name: Scalars['String']['input'];
};

/** Contains details about a recipient. */
export type SendEmailToFriendRecipientInput = {
  /** The email address of the recipient. */
  email: Scalars['String']['input'];
  /** The name of the recipient. */
  name: Scalars['String']['input'];
};

/** Contains information about the sender and recipients. */
export type SendEmailToFriendOutput = {
  /** An array containing information about each recipient. */
  recipients?: Maybe<Array<Maybe<SendEmailToFriendRecipient>>>;
  /** Information about the customer and the content of the message. */
  sender?: Maybe<SendEmailToFriendSender>;
};

/** An output object that contains information about the sender. */
export type SendEmailToFriendSender = {
  /** The email address of the sender. */
  email: Scalars['String']['output'];
  /** The text of the message to be sent. */
  message: Scalars['String']['output'];
  /** The name of the sender. */
  name: Scalars['String']['output'];
};

/** An output object that contains information about the recipient. */
export type SendEmailToFriendRecipient = {
  /** The email address of the recipient. */
  email: Scalars['String']['output'];
  /** The name of the recipient. */
  name: Scalars['String']['output'];
};

/** Contains details about the configuration of the Email to a Friend feature. */
export type SendFriendConfiguration = {
  /** Indicates whether the Email to a Friend feature is enabled. */
  enabled_for_customers: Scalars['Boolean']['output'];
  /** Indicates whether the Email to a Friend feature is enabled for guests. */
  enabled_for_guests: Scalars['Boolean']['output'];
};

export type SwatchLayerFilterItemInterface = {
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
};

export type SwatchLayerFilterItem = LayerFilterItemInterface & SwatchLayerFilterItemInterface & {
  /**
   * The count of items per filter.
   * @deprecated Use `AggregationOption.count` instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * The label for a filter.
   * @deprecated Use `AggregationOption.label` instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Data required to render a swatch filter item. */
  swatch_data?: Maybe<SwatchData>;
  /**
   * The value of a filter request variable to be used in query.
   * @deprecated Use `AggregationOption.value` instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

/** Describes the swatch type and a value. */
export type SwatchData = {
  /** The type of swatch filter item: 1 - text; 2 - image. */
  type?: Maybe<Scalars['String']['output']>;
  /** The value for the swatch item. It could be text or an image link. */
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchDataInterface = {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  /** The URL assigned to the thumbnail of the swatch image. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

export type TextSwatchData = SwatchDataInterface & {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

export type ColorSwatchData = SwatchDataInterface & {
  /** The value can be represented as color (HEX code), image link, or text. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Indicates whether the request succeeded and returns the remaining customer payment tokens. */
export type DeletePaymentTokenOutput = {
  /** A container for the customer's remaining payment tokens. */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  /** Indicates whether the request succeeded. */
  result: Scalars['Boolean']['output'];
};

/** Contains payment tokens stored in the customer's vault. */
export type CustomerPaymentTokens = {
  /** An array of payment tokens. */
  items: Array<Maybe<PaymentToken>>;
};

/** The stored payment method available to the customer. */
export type PaymentToken = {
  /** A description of the stored account details. */
  details?: Maybe<Scalars['String']['output']>;
  /** The payment method code associated with the token. */
  payment_method_code: Scalars['String']['output'];
  /** The public hash of the token. */
  public_hash: Scalars['String']['output'];
  /** Specifies the payment token type. */
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types. */
export type PaymentTokenTypeEnum =
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  | 'card'
  /** phpcs:ignore Magento2.GraphQL.ValidArgumentName */
  | 'account';

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  /** The amount of the Fixed Product Tax. */
  amount?: Maybe<Money>;
  /** The display label assigned to the Fixed Product Tax. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Lists display settings for the Fixed Product Tax. */
export type FixedProductTaxDisplaySettings =
  /** The displayed price includes the FPT amount without displaying the `ProductPrice.fixed_product_taxes` values. This value corresponds to 'Including FPT only'. */
  | 'INCLUDE_FPT_WITHOUT_DETAILS'
  /** The displayed price includes the FPT amount while displaying the values of `ProductPrice.fixed_product_taxes` separately. This value corresponds to 'Including FPT and FPT description'. */
  | 'INCLUDE_FPT_WITH_DETAILS'
  /** The displayed price does not include the FPT amount. The values of `ProductPrice.fixed_product_taxes` and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price.' */
  | 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS'
  /** The displayed price does not include the FPT amount. The values from `ProductPrice.fixed_product_taxes` are not displayed. This value corresponds to 'Excluding FPT'. */
  | 'EXCLUDE_FPT_WITHOUT_DETAILS'
  /** The FPT feature is not enabled. You can omit `ProductPrice.fixed_product_taxes` from your query. */
  | 'FPT_DISABLED';

/** Deprecated: Use the `Wishlist` type instead. */
export type WishlistOutput = {
  /**
   * An array of items in the customer's wish list
   * @deprecated Use the `Wishlist.items` field instead.
   */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /**
   * The number of items in the wish list.
   * @deprecated Use the `Wishlist.items_count` field instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * When multiple wish lists are enabled, the name the customer assigns to the wishlist.
   * @deprecated This field is related to Commerce functionality and is always `null` in Open Source.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * An encrypted code that links to the wish list.
   * @deprecated Use the `Wishlist.sharing_code` field instead.
   */
  sharing_code?: Maybe<Scalars['String']['output']>;
  /**
   * The time of the last modification to the wish list.
   * @deprecated Use the `Wishlist.updated_at` field instead.
   */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** Contains a customer wish list. */
export type Wishlist = {
  /** The unique ID for a `Wishlist` object. */
  id?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use the `items_v2` field instead. */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list. */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** An array of items in the customer's wish list. */
  items_v2?: Maybe<WishlistItems>;
  /** An encrypted code that Magento uses to link to the wish list. */
  sharing_code?: Maybe<Scalars['String']['output']>;
  /** The time of the last modification to the wish list. */
  updated_at?: Maybe<Scalars['String']['output']>;
};


/** Contains a customer wish list. */
export type Wishlistitems_v2Args = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** The interface for wish list items. */
export type WishlistItemInterface = {
  /** The date and time the item was added to the wish list. */
  added_at: Scalars['String']['output'];
  /** Custom options selected for the wish list item. */
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  /** The description of the item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Product details of the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item. */
  quantity: Scalars['Float']['output'];
};

/** Contains an array of items in a wish list. */
export type WishlistItems = {
  /** A list of items in the wish list. */
  items: Array<Maybe<WishlistItemInterface>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
};

/** Contains details about a wish list item. */
export type WishlistItem = {
  /** The time when the customer added the item to the wish list. */
  added_at?: Maybe<Scalars['String']['output']>;
  /** The customer's comment about this item. */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `WishlistItem` object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Details about the wish list item. */
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']['output']>;
};

/** Contains the resultant wish list and any error information. */
export type AddWishlistItemsToCartOutput = {
  /** An array of errors encountered while adding products to the customer's cart. */
  add_wishlist_items_to_cart_user_errors: Array<Maybe<WishlistCartUserInputError>>;
  /** Indicates whether the attempt to add items to the customer's cart was successful. */
  status: Scalars['Boolean']['output'];
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

/** Contains details about errors encountered when a customer added wish list items to the cart. */
export type WishlistCartUserInputError = {
  /** An error code that describes the error encountered. */
  code: WishlistCartUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
  /** The unique ID of the `Wishlist` object containing an error. */
  wishlistId: Scalars['ID']['output'];
  /** The unique ID of the wish list item containing an error. */
  wishlistItemId: Scalars['ID']['output'];
};

/** A list of possible error types. */
export type WishlistCartUserInputErrorType =
  | 'PRODUCT_NOT_FOUND'
  | 'NOT_SALABLE'
  | 'INSUFFICIENT_STOCK'
  | 'UNDEFINED';

/** Defines the items to add to a wish list. */
export type WishlistItemInput = {
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** For complex product types, the SKU of the parent product. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  /** The amount or number of items to add. */
  quantity: Scalars['Float']['input'];
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The SKU of the product to add. For complex product types, specify the child product SKU. */
  sku: Scalars['String']['input'];
};

/** Contains the customer's wish list and any errors encountered. */
export type AddProductsToWishlistOutput = {
  /** An array of errors encountered while adding products to a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully added. */
  wishlist: Wishlist;
};

/** Contains the customer's wish list and any errors encountered. */
export type RemoveProductsFromWishlistOutput = {
  /** An array of errors encountered while deleting products from a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with after items were successfully deleted. */
  wishlist: Wishlist;
};

/** Defines updates to items in a wish list. */
export type WishlistItemUpdateInput = {
  /** Customer-entered comments about the item. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** An array of options that the customer entered. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** The new amount or number of this item. */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** An array of strings corresponding to options the customer selected. */
  selected_options?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The unique ID for a `WishlistItemInterface` object. */
  wishlist_item_id: Scalars['ID']['input'];
};

/** Contains the customer's wish list and any errors encountered. */
export type UpdateProductsInWishlistOutput = {
  /** An array of errors encountered while updating products in a wish list. */
  user_errors: Array<Maybe<WishListUserInputError>>;
  /** Contains the wish list with all items that were successfully updated. */
  wishlist: Wishlist;
};

/** An error encountered while performing operations with WishList. */
export type WishListUserInputError = {
  /** A wish list-specific error code. */
  code: WishListUserInputErrorType;
  /** A localized error message. */
  message: Scalars['String']['output'];
};

/** A list of possible error types. */
export type WishListUserInputErrorType =
  | 'PRODUCT_NOT_FOUND'
  | 'UNDEFINED';

export type AmFaqCategoryFilterInput = {
  /** ID of a Category. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** ID of a Customer Group that Category is assigned to. */
  customer_group_id?: InputMaybe<FilterTypeInput>;
  /** ID of a Question that is assigned to Category. */
  question_id?: InputMaybe<FilterTypeInput>;
  /** ID of a Store that Category is assigned to. */
  store_id?: InputMaybe<FilterTypeInput>;
  /** Title of a Category. */
  title?: InputMaybe<FilterTypeInput>;
};

export type AmFaqQuestionFilterInput = {
  /** ID of a Category that Question is assigned to. */
  category_id?: InputMaybe<FilterTypeInput>;
  /** ID of a Customer Group that Question is assigned to. */
  customer_group_id?: InputMaybe<FilterTypeInput>;
  /** ID of a Product that Question is assigned to. */
  product_id?: InputMaybe<FilterTypeInput>;
  /** ID of a Question. */
  question_id?: InputMaybe<FilterTypeInput>;
  /** Status of a Question. */
  status?: InputMaybe<FilterTypeInput>;
  /** ID of a Store that Question is assigned to. */
  store_id?: InputMaybe<FilterTypeInput>;
  /** Title of a Tag that is assigned to a Question. */
  tag?: InputMaybe<FilterTypeInput>;
  /** Visibility of a Question. */
  visibility?: InputMaybe<FilterTypeInput>;
};

export type AmFaqCategorySortInput = {
  /** ID of a Category */
  category_id?: InputMaybe<SortEnum>;
  /** SortOrder of a Category. */
  position?: InputMaybe<SortEnum>;
  /** Title of a Category. */
  title?: InputMaybe<SortEnum>;
  /** Visit count of a Category. */
  visit_count?: InputMaybe<SortEnum>;
};

export type AmFaqQuestionSortInput = {
  /** SortOrder of a Question. */
  position?: InputMaybe<SortEnum>;
  /** ID of a Question. */
  question_id?: InputMaybe<SortEnum>;
  /** Title of a Question. */
  title?: InputMaybe<SortEnum>;
  /** Visit Count of a Question. */
  visit_count?: InputMaybe<SortEnum>;
};

export type PlaceAmFaqQuestionInput = {
  /** ID of a Category From Wich Question Was Asked. */
  category_id?: InputMaybe<Scalars['Int']['input']>;
  /** Email of Customer Who Asked the Question. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Name of Customer Who Asked the Question. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of a Product From Wich Question Was Asked. */
  product_id?: InputMaybe<Scalars['Int']['input']>;
  /** Asked Question Text. */
  title: Scalars['String']['input'];
};

export type RateAmFaqQuestionInput = {
  /** Flag that identifyes is voting is revote. */
  is_revote?: InputMaybe<Scalars['Boolean']['input']>;
  /** Old voted value. */
  old_value?: InputMaybe<Scalars['String']['input']>;
  /** ID of a Rated Question. */
  question_id: Scalars['Int']['input'];
  /** Voted value. */
  value: Scalars['String']['input'];
  /** Type of a Voting. */
  vote_type: AmFaqVoteTypeEnum;
};

export type AmFaqCategoriesSearch = {
  /** A list of FAQ Categories. */
  items?: Maybe<Array<Maybe<AmFaqCategory>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of return requests. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AmFaqQuestionsSearch = {
  /** A list of FAQ Questions. */
  items?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** Pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total number of return requests. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AmFaqSettings = {
  /** Sorting Type for Categories. */
  categoriesSort?: Maybe<Scalars['String']['output']>;
  /** Limit for Showed Questions on Category Page. */
  categoryPageSize?: Maybe<Scalars['Int']['output']>;
  /** Limit for Displayed Short Answer. */
  displayedAnswerLengthLimit?: Maybe<Scalars['Int']['output']>;
  faqPageLayout?: Maybe<Scalars['String']['output']>;
  /** GDPR Consent Text to Display. */
  gdprConsentText?: Maybe<Scalars['String']['output']>;
  /** Is Add Rich Data Breadcrumbs Flag. */
  isAddRichDataBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /** Is Add Rich Data Contact Information Flag. */
  isAddRichDataContact?: Maybe<Scalars['Boolean']['output']>;
  /** Is Add Rich Data Organization Flag. */
  isAddRichDataOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Is Mark Up FAQ with Structured Data Flag. */
  isAddStructuredData?: Maybe<Scalars['Boolean']['output']>;
  /** Is GDPR Consent Enabled Flag. */
  isEnableGdprConsent?: Maybe<Scalars['Boolean']['output']>;
  /** Is Question and Category Url Suffix Enabled Flag. */
  isEnableUrlSuffix?: Maybe<Scalars['Boolean']['output']>;
  /** Is FAQ Module Enabled Flag. */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is Not Logged In Customers Allowed to Ask Questions Flag. */
  isGuestQuestionsAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Is Not Logged In Customers Allowed to Rate Questions Flag. */
  isGuestRatingAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Is Hide Zero Total Rating for Average Rating Type. */
  isHideZeroTotalRating?: Maybe<Scalars['Boolean']['output']>;
  /** Is Rating Enabled Flag. */
  isRatingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is Trailing Slash Must Be Removed Flag. */
  isRemoveTrailingSlash?: Maybe<Scalars['Boolean']['output']>;
  /** Is Ask Question Buttons Must Be Shown Flag. */
  isShowAskQuestionButton?: Maybe<Scalars['Boolean']['output']>;
  /** Is Ask Question Buttons on the Product Page Must Be Shown Flag. */
  isShowAskQuestionButtonProduct?: Maybe<Scalars['Boolean']['output']>;
  /** Are Breadcrumbs Must Be Shown At FAQ Pages Flag. */
  isShowBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /** Is FAQ Link Must Be Shown In Categories Menu Flag. */
  isShowLinkCategories?: Maybe<Scalars['Boolean']['output']>;
  /** Is FAQ Link Must Be Shown In Footer Flag. */
  isShowLinkFooter?: Maybe<Scalars['Boolean']['output']>;
  /** Is FAQ Link Must Be Shown In Toolbar Flag. */
  isShowLinkToolbar?: Maybe<Scalars['Boolean']['output']>;
  /** Is Product Questions Tab Must Be Shown at the Product Page Flag. */
  isShowProductQuestionsTab?: Maybe<Scalars['Boolean']['output']>;
  /** Is Search Box Must Be Shown Flag. */
  isShowSearch?: Maybe<Scalars['Boolean']['output']>;
  /** Is Social Buttons Enabled Flag. */
  isSocialButtonsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is Use Canonical Url on Pages Flag. */
  isUseCanonicalUrl?: Maybe<Scalars['Boolean']['output']>;
  /** Text To Be Shown When No Search Result Found. */
  noResultText?: Maybe<Scalars['String']['output']>;
  /** Limit for Showed Questions on Product Page. */
  productPageSize?: Maybe<Scalars['Int']['output']>;
  /** Displayed Name of Product Questions Tab. */
  productQuestionsTabName?: Maybe<Scalars['String']['output']>;
  /** Position of Product Question Tab. */
  productQuestionsTabPosition?: Maybe<Scalars['Int']['output']>;
  /** Sorting Type for Questions. */
  questionsSort?: Maybe<Scalars['String']['output']>;
  /** Rating Type. */
  ratingType?: Maybe<Scalars['String']['output']>;
  /** Type of Organization Contact. */
  richDataContactType?: Maybe<Scalars['String']['output']>;
  /** The URL of a Logo That Is Representative of the Organization. */
  richDataLogoUrl?: Maybe<Scalars['String']['output']>;
  /** The Name of a Organization. */
  richDataName?: Maybe<Scalars['String']['output']>;
  /** Telephone of Organization. */
  richDataTelephone?: Maybe<Scalars['String']['output']>;
  /** The URL of the Website Associated With the Logo. */
  richDataWebsiteUrl?: Maybe<Scalars['String']['output']>;
  /** Limit for Showed Questions on Search Result Page. */
  searchPageSize?: Maybe<Scalars['Int']['output']>;
  /** Behavior of Short Answer. */
  shortAnswerBehavior?: Maybe<Scalars['Int']['output']>;
  /** Behavior of Short Answer on the Product Page. */
  shortAnswerBehaviorProduct?: Maybe<Scalars['Int']['output']>;
  socialButtons?: Maybe<Array<Maybe<AmFaqSocialButton>>>;
  /** Limit for Tags in Menu. */
  tagsLimit?: Maybe<Scalars['Int']['output']>;
  /** The Name of FAQ Page. */
  title?: Maybe<Scalars['String']['output']>;
  /** Base Url FAQ Prefix. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** Url Suffx. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type AmFaqSocialButton = {
  /** Link Template of Social Button. */
  hrefTemplate?: Maybe<Scalars['String']['output']>;
  /** Image Path of Social Button. */
  imagePath?: Maybe<Scalars['String']['output']>;
  /** Image File Name of Social Button. */
  imgName?: Maybe<Scalars['String']['output']>;
  /** Label of Social Button. */
  name?: Maybe<Scalars['String']['output']>;
};

export type AmFaqQuestion = {
  /** Displayed Full Answer of a Question. */
  answer?: Maybe<Scalars['String']['output']>;
  /** ID of a Store from Wich Question Was Asked. */
  asked_from_store?: Maybe<Scalars['String']['output']>;
  /** Average Rating Value. */
  avg_rating?: Maybe<Scalars['Float']['output']>;
  /** Average Total Value. */
  avg_total?: Maybe<Scalars['Int']['output']>;
  /** Canonical Url of a Question. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** FAQ Categories IDs Questions is Assigned To. */
  category_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Customer Groud IDs Question is Assigned To. */
  customer_groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Email of a Customer Who Asked a Question. */
  email?: Maybe<Scalars['String']['output']>;
  /** Is Show Full Answer Flag. */
  is_show_full_answer?: Maybe<Scalars['Boolean']['output']>;
  /** Meta Description of a Question. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Meta Robots of a Question. */
  meta_robots?: Maybe<Scalars['String']['output']>;
  /** Meta Title of a Question. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Name of a Customer Who Asked a Question. */
  name?: Maybe<Scalars['String']['output']>;
  /** Negative Rating Value of a Question. */
  negative_rating?: Maybe<Scalars['Float']['output']>;
  /** Nofollow Flag of a Question. */
  nofollow?: Maybe<Scalars['Boolean']['output']>;
  /** Noindex Flag of a Question. */
  noindex?: Maybe<Scalars['Boolean']['output']>;
  /** Sort Order of a Question. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Positive Rating Value of a Question. */
  positive_rating?: Maybe<Scalars['Float']['output']>;
  /** Product Category IDs Question is Assigned To. */
  product_category_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Product IDs Question is Assigned To. */
  product_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** ID of a Question. */
  question_id?: Maybe<Scalars['Int']['output']>;
  /** Displayed Short Answer of a Question. */
  short_answer?: Maybe<Scalars['String']['output']>;
  /** Questions Status. */
  status?: Maybe<Scalars['Int']['output']>;
  /** Store IDs Question is Assigned To. */
  store_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Tag Titles Assigned To a Question. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Displayed Title of a Question. */
  title?: Maybe<Scalars['String']['output']>;
  /** Total Rating Vaue of a Question. */
  total_rating?: Maybe<Scalars['Float']['output']>;
  /** Url Key of a Question. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** Visibility Type of a Question. */
  visibility?: Maybe<Scalars['Int']['output']>;
};

export type AmFaqCategory = {
  /** Canonical Url of a Category. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** ID of a Category. */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** Customer Groud IDs Category is Assigned To. */
  customer_groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Description of a Category. */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon Path of a Category. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Meta Description of a Category. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Meta Title of a Category. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Nofollow Flag of a Category. */
  nofollow?: Maybe<Scalars['Boolean']['output']>;
  /** Noindex Flag of a Category. */
  noindex?: Maybe<Scalars['Boolean']['output']>;
  /** Title of a Category on a Category Page. */
  page_title?: Maybe<Scalars['String']['output']>;
  /** Sort Order of a Category. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Questions Assigned to the Category. */
  questions?: Maybe<Array<Maybe<AmFaqQuestion>>>;
  /** Status of a Category. */
  status?: Maybe<Scalars['Int']['output']>;
  /** Store IDs Category is Assigned To. */
  store_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Title of a Category. */
  title?: Maybe<Scalars['String']['output']>;
  /** Url Key of a Category. */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type AmFaqCommonOutput = {
  /** Is an error occurred flag. */
  error?: Maybe<Scalars['Boolean']['output']>;
  /** Result message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** This enumeration defines types of question voting. */
export type AmFaqVoteTypeEnum =
  | 'VOTING'
  | 'YESNO'
  | 'AVERAGE';

export type AmMostviewedBundlePacks = {
  /** Display Bundle Pack in Cart. */
  is_display_cart_block?: Maybe<Scalars['Boolean']['output']>;
  /** Display Upsell Message in Cart. */
  is_display_cart_message?: Maybe<Scalars['Boolean']['output']>;
  /** Add Bundle Packs Link to Top Menu. */
  is_top_menu_enabled?: Maybe<Scalars['Int']['output']>;
  /** An array of bundle packs. */
  items?: Maybe<Array<Maybe<AmMostviewedBundlePack>>>;
  /** Main Product. */
  main_product?: Maybe<ProductInterface>;
};

export type AmMostviewedBundlePack = {
  /** Apply Discount to the Main Product. */
  apply_for_parent?: Maybe<Scalars['Boolean']['output']>;
  /** Title. */
  block_title?: Maybe<Scalars['String']['output']>;
  /** Upsell Message. */
  cart_message?: Maybe<Scalars['String']['output']>;
  /** Discount Amount. */
  discount_amount?: Maybe<Scalars['Int']['output']>;
  /** Discount Type. */
  discount_type?: Maybe<Scalars['Int']['output']>;
  /** Bundle Pack Items. */
  items?: Maybe<Array<Maybe<AmMostviewedBundleItem>>>;
};

export type AmMostviewedBundleItem = {
  /** Custom discount. */
  discount_amount?: Maybe<Scalars['Float']['output']>;
  /** Product model. */
  product?: Maybe<ProductInterface>;
  /** Selected(required) qty. */
  qty?: Maybe<Scalars['Int']['output']>;
};

export type AmMostviewedRelated = {
  /** Display 'Add to Cart' Button. */
  add_to_cart?: Maybe<Scalars['Boolean']['output']>;
  /** Block Layout. */
  block_layout?: Maybe<Scalars['Int']['output']>;
  /** Block Title. */
  block_title?: Maybe<Scalars['String']['output']>;
  /** Display 'Add to Compare' Button. */
  display_add_to_compare?: Maybe<Scalars['Boolean']['output']>;
  /** Display 'Add to Wish List' Button. */
  display_add_to_wishlist?: Maybe<Scalars['Boolean']['output']>;
  /** An array of products. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Block Position. */
  position?: Maybe<Scalars['String']['output']>;
};

export type AmMostviewedRelatedRules = {
  /** An array of Related Rules. */
  items?: Maybe<Array<Maybe<AmMostviewedRelated>>>;
};

export type AmProductAttachmentSettings = {
  /** Will Category Files Be Attached to All Category Products. */
  addCategoryFilesToProducts?: Maybe<Scalars['Boolean']['output']>;
  /** Will Include In Order Files Be Displayed on Product Pages. */
  displayInOrderFiles?: Maybe<Scalars['Boolean']['output']>;
  /** Is Product Attachment Module Enabled Flag. */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is Product Attahcments Must Be Show in Order View Page. */
  isShowInOrderView?: Maybe<Scalars['Boolean']['output']>;
  /** Is Product Attachment Tab Must Be Shown at the Product Page. */
  isShowProductAttachmentTab?: Maybe<Scalars['Boolean']['output']>;
  /** Displayed Title of Order View Product Attachments. */
  orderViewAttachmentsTitle?: Maybe<Scalars['String']['output']>;
  /** Attachment Type To Be Shown in Order View Page. */
  orderViewAttachmentsType?: Maybe<Scalars['Int']['output']>;
  /** Order Statuses for which Attachments Will Be Shown. */
  orderViewStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Customer Groups That Can See The Tab. */
  productAttachmentTabCustomerGroups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Position of Product Attachment Tab. */
  productAttachmentTabPosition?: Maybe<Scalars['Int']['output']>;
  /** Displayed Title of Product Attachment Tab. */
  productAttachmentTabTitle?: Maybe<Scalars['String']['output']>;
  /** Is File Icon Should Be Shown Flag. */
  showFileIcon?: Maybe<Scalars['Boolean']['output']>;
  /** Is File Icon Should Be Shown in Order View Flag. */
  showFileIconOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Is File Size Should Be Show Flag. */
  showFileSize?: Maybe<Scalars['Boolean']['output']>;
  /** Is File Size Should Be Show in Order View Flag. */
  showFileSizeOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Type of Attachment URL. */
  urlCreationType?: Maybe<Scalars['Int']['output']>;
};

export type AmFile = {
  file_id?: Maybe<Scalars['Int']['output']>;
  /** Real File Name. */
  filename?: Maybe<Scalars['String']['output']>;
  /** Icon Url of a File. */
  icon_url?: Maybe<Scalars['String']['output']>;
  /** Displayed Name of a File. */
  label?: Maybe<Scalars['String']['output']>;
  /** Mime Type of a File. */
  mime_type?: Maybe<Scalars['String']['output']>;
  /** File Size. */
  size?: Maybe<Scalars['Int']['output']>;
  /** Urlf of a File. */
  url?: Maybe<Scalars['String']['output']>;
};

export type AmSocialLoginButton = {
  /** Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Social Platform Type */
  type?: Maybe<Scalars['String']['output']>;
  /** Social Url */
  url?: Maybe<Scalars['String']['output']>;
};

export type AmLinkedSocialAccounts = {
  /** Customer Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Social platform type */
  type?: Maybe<Scalars['String']['output']>;
};

export type AmUnlinkData = {
  /** Is unlink successful. */
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Result message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type SortingOrder = {
  /** Order code. */
  attribute: Scalars['String']['output'];
  /** Order id. */
  id: Scalars['String']['output'];
  sortDirection: Scalars['String']['output'];
  /** Order label. */
  text: Scalars['String']['output'];
};

export type ProductData = {
  /** Product add to cart URL. */
  addToCartUrl?: Maybe<Scalars['String']['output']>;
  /** Product add to compare params. */
  addToCompareParams?: Maybe<Scalars['String']['output']>;
  /** Product has required options. */
  hasRequiredOptions?: Maybe<Scalars['Boolean']['output']>;
  /** Item id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Product is salable. */
  isSalable?: Maybe<Scalars['Boolean']['output']>;
  /** Product name. */
  name?: Maybe<Scalars['String']['output']>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** Product URL. */
  productUrl?: Maybe<Scalars['String']['output']>;
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** The relative path to the product's small image. */
  small_image?: Maybe<ProductImage>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
};

export type PageTypeEnum =
  | 'CATEGORY'
  | 'SEARCH';

export type RevokeSubUserTokenOutput = {
  result: Scalars['Boolean']['output'];
};

export type SubUserToken = {
  /** The sub-user token */
  token?: Maybe<Scalars['String']['output']>;
};

/** Sub role input */
export type SubRoleInput = {
  /** Company Account own the role */
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  /** Order amount sub-user can checkout per order, not defined, or leave null to unlimited. */
  max_order_amount?: InputMaybe<Scalars['Int']['input']>;
  /** Number of order sub-user can order perday, not defined, or leave null to unlimited. */
  order_per_day?: InputMaybe<Scalars['Int']['input']>;
  /** Role id, not defined, leave null will be create new */
  role_id?: InputMaybe<Scalars['Int']['input']>;
  /** What name that role will be call? */
  role_name?: InputMaybe<Scalars['String']['input']>;
  /** The values of role permissions defined in `etc/company_rules.xml`, format example: `'1,2,3,4,5'` */
  role_type?: InputMaybe<Scalars['String']['input']>;
};

/** Sub user input */
export type SubUsers = {
  /** Customer Id */
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  /** Role Id */
  role_id: Scalars['Int']['input'];
  /** Sub Email */
  sub_email: Scalars['String']['input'];
  /** Sub Name */
  sub_name: Scalars['String']['input'];
  /** Sub Status */
  sub_status: Scalars['Int']['input'];
};

/** Sub user input for edit */
export type SubUserForEdit = {
  /** Customer Id */
  customer_id?: InputMaybe<Scalars['Int']['input']>;
  /** Role Id */
  role_id: Scalars['Int']['input'];
  /** Sub Email */
  sub_email: Scalars['String']['input'];
  /** Sub Id */
  sub_id: Scalars['Int']['input'];
  /** Sub Name */
  sub_name: Scalars['String']['input'];
  /** Sub Status */
  sub_status: Scalars['Int']['input'];
};

/** Sub user input for reset password */
export type SubUserResetPass = {
  /** Sub Password */
  new_password: Scalars['String']['input'];
  /** Sub Password Confirm */
  password_confirm: Scalars['String']['input'];
  /** Sub Email */
  sub_email: Scalars['String']['input'];
  /** Sub Token */
  token: Scalars['String']['input'];
};

/** Sub user input for request send email to reset password */
export type SubUserRequestResetPass = {
  /** Sub user Email */
  sub_email: Scalars['String']['input'];
};

/** Change Sub user password */
export type SubUserChangePass = {
  /** Sub User New Password */
  new_password: Scalars['String']['input'];
  /** Sub Password Confirm */
  password_confirm: Scalars['String']['input'];
  /** Sub User Email */
  sub_email: Scalars['String']['input'];
  /** Sub user Password */
  sub_password: Scalars['String']['input'];
};

/** SalesRep information */
export type SalesRepUser = {
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** Sub-user of company account */
export type SubUser = {
  /** The create time of sub-user */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The owner company account */
  customer?: Maybe<Customer>;
  /** The owner of current sub-user */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** The quote id for sub-user */
  quote_id?: Maybe<Scalars['Int']['output']>;
  /** The full role data was assigned to sub-user */
  role?: Maybe<SubRole>;
  /** The role id was assigned to sub-user */
  role_id?: Maybe<Scalars['Int']['output']>;
  /** Sub-user email */
  sub_email?: Maybe<Scalars['String']['output']>;
  /** Sub-user ID */
  sub_id?: Maybe<Scalars['Int']['output']>;
  /** Sub-user name */
  sub_name?: Maybe<Scalars['String']['output']>;
  /** Sub-user account status */
  sub_status?: Maybe<Scalars['Int']['output']>;
};

/** Company Account role */
export type SubRole = {
  /** The owner company account */
  customer?: Maybe<Customer>;
  /** The company account id */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** The max order amount that sub-user can checkout per order */
  max_order_amount?: Maybe<Scalars['Float']['output']>;
  /** The number of order that sub-user can order per day */
  order_per_day?: Maybe<Scalars['Int']['output']>;
  /** Role id */
  role_id?: Maybe<Scalars['Int']['output']>;
  /** Role name */
  role_name?: Maybe<Scalars['String']['output']>;
  /** The values of role defined in `etc/company_rules.xml` */
  role_type?: Maybe<Scalars['String']['output']>;
};

export type MpFilters = {
  /** Filter From Date. */
  from: Scalars['String']['input'];
  /** Period. */
  period_type?: InputMaybe<Scalars['String']['input']>;
  /** Show Empty Rows. */
  show_empty_rows?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter Store Id. */
  store_id?: InputMaybe<Scalars['Int']['input']>;
  /** Filter To Date. */
  to: Scalars['String']['input'];
};

export type SmtpBestsellersOutput = {
  /** Bestsellers Product Information. */
  mpBestsellers?: Maybe<Array<Maybe<BestsellersProductOutput>>>;
};

export type BestsellersProductOutput = {
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Period. */
  period?: Maybe<Scalars['String']['output']>;
  /** Product ID */
  product_id?: Maybe<Scalars['String']['output']>;
  /** Product Image URL */
  product_image_url?: Maybe<Scalars['String']['output']>;
  /** Product Name */
  product_name?: Maybe<Scalars['String']['output']>;
  /** Product Price */
  product_price?: Maybe<Scalars['String']['output']>;
  /** Product SKU */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** Product URL */
  product_url?: Maybe<Scalars['String']['output']>;
  /** Order Quantity. */
  qty_ordered?: Maybe<Scalars['Int']['output']>;
};

export type BraintreeInput = {
  /** Contains a fingerprint provided by Braintree JS SDK and should be sent with sale transaction details to the Braintree payment gateway. */
  device_data?: InputMaybe<Scalars['String']['input']>;
  /** States whether an entered by a customer credit/debit card should be tokenized for later usage. Required only if Vault is enabled for Braintree payment integration. */
  is_active_payment_token_enabler: Scalars['Boolean']['input'];
  /** The one-time payment token generated by Braintree payment gateway based on card details. Required field to make sale transaction. */
  payment_method_nonce: Scalars['String']['input'];
};

export type BraintreeCcVaultInput = {
  device_data?: InputMaybe<Scalars['String']['input']>;
  public_hash: Scalars['String']['input'];
};

export type ArtworkInterface = {
  comments?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  file_name: Scalars['String']['output'];
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  proofing_option?: Maybe<PROOFING_OPTION>;
};

export type PROOFING_OPTION =
  | 'NO_PROOF_NEEDED'
  | 'PROOF_NEEDED';

export type GenericError = {
  /** An error code. */
  code: Scalars['String']['output'];
  /** A localized error message. */
  message: Scalars['String']['output'];
  /** The path to the input field that caused an error. See the GraphQL specification about path errors for details: http://spec.graphql.org/draft/#sec-Errors */
  path: Array<Maybe<Scalars['String']['output']>>;
};

export type AttachArtworkOutput = {
  artwork: ArtworkInterface;
  userInputErrors?: Maybe<Array<Maybe<GenericError>>>;
};

export type DetachArtworkOutput = {
  userInputErrors?: Maybe<Array<Maybe<GenericError>>>;
};

export type Source = {
  code: Scalars['String']['output'];
  province: Scalars['String']['output'];
};

export type PriceBreak = {
  case_depth?: Maybe<Scalars['String']['output']>;
  case_height?: Maybe<Scalars['String']['output']>;
  case_weight?: Maybe<Scalars['String']['output']>;
  case_width?: Maybe<Scalars['String']['output']>;
  final_price?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  units_per_case?: Maybe<Scalars['String']['output']>;
};

export type Color = {
  code?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type AttachProjectDataOutput = {
  userInputErrors?: Maybe<Array<Maybe<GenericError>>>;
};

export type ProofStatus =
  | 'APPROVED'
  | 'DENIED'
  | 'PENDING_APPROVAL';

export type ProofInterface = {
  author: Scalars['String']['output'];
  author_comments?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  date_reviewed?: Maybe<Scalars['String']['output']>;
  date_uploaded: Scalars['String']['output'];
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type GenericProofOutput = {
  proof?: Maybe<ProofInterface>;
  userInputErrors?: Maybe<GenericError>;
};

export type CartItemsBySource = {
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  source_code?: Maybe<Scalars['String']['output']>;
};

export type SignedCommandUrlOutput = {
  url: Scalars['String']['output'];
  user_errors?: Maybe<Array<Maybe<CartUserInputError>>>;
};

export type FourOverItemQuantity = {
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** Contains details about the cart after removing an item. */
export type Update4OverItemQuantityOutput = {
  /** The cart after removing an item. */
  cart: Cart;
};

export type Update4OverItemQuantityInput = {
  cart_id: Scalars['String']['input'];
  cart_item_uid: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type ArtworkRequirement = {
  /** File Code. */
  code?: Maybe<Scalars['String']['output']>;
  /** Reason Uuid. */
  fileReasonCodeUuid?: Maybe<Scalars['String']['output']>;
  /** File Title. */
  title?: Maybe<Scalars['String']['output']>;
};

export type FourOverFile = {
  /** File Path or URL. */
  path?: InputMaybe<Scalars['String']['input']>;
};

export type ArtworkPreflightResponse = {
  files?: Maybe<Array<Maybe<ArtworkPreflightFile>>>;
};

export type ArtworkPreflightFile = {
  messages?: Maybe<Array<Maybe<ArtworkPreflightFileMessage>>>;
  /** File Path or URL. */
  path?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ArtworkPreflightFileMessage = {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type OptionFourOverData = {
  conditions?: Maybe<OptionFourOverDataConditions>;
};

export type OptionFourOverDataConditions = {
  colorSpec?: Maybe<Scalars['String']['output']>;
  runSize?: Maybe<Scalars['String']['output']>;
};

export type FourOverCustomOptionModifier = {
  modifier?: Maybe<Scalars['String']['output']>;
  optionLabel?: Maybe<Scalars['String']['output']>;
};

export type DeliveryDateRange = {
  available?: Maybe<Scalars['Boolean']['output']>;
  from: Scalars['String']['output'];
  label: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type DeliveryDateRangeInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['String']['input'];
  label: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

/** Identifies which customer requires remote shopping assistance. */
export type GenerateCustomerTokenBySecretInput = {
  /** The secret. */
  secret: Scalars['String']['input'];
};

/** Contains the generated customer token. */
export type GenerateCustomerTokenBySecretOutput = {
  /** The generated customer token. */
  customer_token: Scalars['String']['output'];
};

export type NewsletterCustomFieldsInput = {
  /** The source of the subscriber. For example, the URL of the page where the subscriber signed up. We are not usng just source, coz Klaviyo has a reserved field with the same name. */
  source_location?: InputMaybe<Scalars['String']['input']>;
};

/** Applies one or shipping methods to the cart. */
export type SetCustomerNoteToCartInput = {
  /** The unique ID of a `Cart` object. */
  cart_id: Scalars['String']['input'];
  /** Customer Note */
  customer_note?: InputMaybe<Scalars['String']['input']>;
};

/** Defines the configurable products to add to the cart. */
export type ReorderItemInput = {
  /** The ID of the cart. */
  cart_id: Scalars['String']['input'];
  /** An array of entered options for the base product, such as personalization text. */
  entered_options?: InputMaybe<Array<InputMaybe<EnteredOptionInput>>>;
  /** ID of the order item */
  item_id: Scalars['String']['input'];
};

/** Contains details about the cart after adding configurable products. */
export type ReorderItemOutput = {
  addedItemIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The cart after adding products. */
  cart: Cart;
  failedItems?: Maybe<Array<Maybe<ReorderFailedItem>>>;
};

export type ReorderFailedItem = {
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

/** Contains information about setup fees applied to the cart. */
export type SetupFee = {
  /** The amount of the fee applied to the item. */
  amount: Money;
  /** A description of the fee. */
  label: Scalars['String']['output'];
};

export type Aggregate = {
  count: Scalars['Int']['output'];
};

/** Asset system model */
export type Asset = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The file handle */
  handle: Scalars['String']['output'];
  /** The file name */
  fileName: Scalars['String']['output'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  mainImageRowProductHighlight: Array<RowProductHighlight>;
  assetRowProduct: Array<RowProduct>;
  assetPage: Array<Page>;
  assetPageLink: Array<PageLink>;
  mainImageMobileRowProductHighlight: Array<RowProductHighlight>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
};


/** Asset system model */
export type AssetmainImageRowProductHighlightArgs = {
  where?: InputMaybe<RowProductHighlightWhereInput>;
  orderBy?: InputMaybe<RowProductHighlightOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Asset system model */
export type AssetassetRowProductArgs = {
  where?: InputMaybe<RowProductWhereInput>;
  orderBy?: InputMaybe<RowProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Asset system model */
export type AssetassetPageArgs = {
  where?: InputMaybe<PageWhereInput>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Asset system model */
export type AssetassetPageLinkArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Asset system model */
export type AssetmainImageMobileRowProductHighlightArgs = {
  where?: InputMaybe<RowProductHighlightWhereInput>;
  orderBy?: InputMaybe<RowProductHighlightOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Asset system model */
export type AsseturlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  image?: InputMaybe<ImageTransformationInput>;
  document?: InputMaybe<DocumentTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Asset Upload */
export type AssetUpload = {
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
};

/** System Asset Upload Status */
export type AssetUploadStatus =
  | 'ASSET_CREATE_PENDING'
  | 'ASSET_UPLOAD_COMPLETE'
  | 'ASSET_UPDATE_PENDING'
  | 'ASSET_ERROR_UPLOAD';

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  alt_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  alt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  mainImageRowProductHighlight_every?: InputMaybe<RowProductHighlightWhereInput>;
  mainImageRowProductHighlight_some?: InputMaybe<RowProductHighlightWhereInput>;
  mainImageRowProductHighlight_none?: InputMaybe<RowProductHighlightWhereInput>;
  assetRowProduct_every?: InputMaybe<RowProductWhereInput>;
  assetRowProduct_some?: InputMaybe<RowProductWhereInput>;
  assetRowProduct_none?: InputMaybe<RowProductWhereInput>;
  assetPage_every?: InputMaybe<PageWhereInput>;
  assetPage_some?: InputMaybe<PageWhereInput>;
  assetPage_none?: InputMaybe<PageWhereInput>;
  assetPageLink_every?: InputMaybe<PageLinkWhereInput>;
  assetPageLink_some?: InputMaybe<PageLinkWhereInput>;
  assetPageLink_none?: InputMaybe<PageLinkWhereInput>;
  mainImageMobileRowProductHighlight_every?: InputMaybe<RowProductHighlightWhereInput>;
  mainImageMobileRowProductHighlight_some?: InputMaybe<RowProductHighlightWhereInput>;
  mainImageMobileRowProductHighlight_none?: InputMaybe<RowProductHighlightWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export type Banner = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  isMobile?: Maybe<Scalars['Boolean']['output']>;
  image: Asset;
};


export type BannerimageArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type BannerOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'isMobile_ASC'
  | 'isMobile_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type BannerWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BannerWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<AssetWhereInput>;
};

export type Brand = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
  alt?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
};


export type BrandimageArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type BrandOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'alt_ASC'
  | 'alt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type BrandWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BrandWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BrandWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BrandWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  alt_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  alt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetWhereInput>;
};

export type DocumentFileTypes =
  | 'jpg'
  | 'png'
  | 'svg'
  | 'webp'
  | 'bmp'
  | 'gif'
  | 'tiff'
  | 'avif'
  | 'heic'
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  | 'autoImage';

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export type EntityTypeName =
  /** Asset system model */
  | 'Asset'
  | 'Page'
  | 'RowHeroBanner'
  | 'PageLink'
  | 'Footer'
  | 'RowServiceOptions'
  | 'RowBlogContent'
  | 'Usps'
  | 'RowProduct'
  | 'RowLinks'
  | 'ProductSideInfo'
  /** For the "brands that trust us" carousel */
  | 'RowBrandsBanner'
  /** This is the module that displays the "how to order" or "what makes us different" row in the home page */
  | 'RowOrderProcess'
  /** This row is an image grid that shows products that we wish to highlight in the home page */
  | 'RowProductHighlight'
  /** Footer for all pages */
  | 'PageFooter'
  | 'ProductThingsToKnow'
  | 'RowServicePageContent'
  /** Scheduled Operation system model */
  | 'ScheduledOperation'
  /** Scheduled Release system model */
  | 'ScheduledRelease'
  /** User system model */
  | 'User'
  /** Customer Testimonials section in home page */
  | 'RowReviewHighlight'
  /** home page section for featured categories */
  | 'RowFeaturedCategory'
  | 'RowParagraph'
  | 'OrderStep'
  | 'FooterLink'
  | 'FooterImageLink'
  | 'LabelAndContent'
  | 'Brand'
  | 'Banner'
  | 'Image'
  | 'ReviewItem'
  | 'ProductCategory';

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  /** The Type name of an object */
  typename: EntityTypeName;
  stage: Stage;
  locale?: InputMaybe<Locale>;
};

export type Footer = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  copyright?: Maybe<Scalars['String']['output']>;
  promoText?: Maybe<Scalars['String']['output']>;
  socialLinks: Array<PageLink>;
  legalLinks: Array<PageLink>;
};


export type FootersocialLinksArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FooterlegalLinksArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type FooterConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<FooterEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type FooterEdge = {
  /** The item at the end of the edge. */
  node: Footer;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type FooterImageLink = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  alt: Scalars['String']['output'];
  image: Asset;
};


export type FooterImageLinkimageArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type FooterImageLinkOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'alt_ASC'
  | 'alt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type FooterImageLinkWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterImageLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterImageLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterImageLinkWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  alt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  alt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  alt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  alt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  alt_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  alt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  alt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  alt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetWhereInput>;
};

export type FooterLink = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FooterLinkOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type FooterLinkWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterLinkWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
};

export type FooterOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'copyright_ASC'
  | 'copyright_DESC'
  | 'promoText_ASC'
  | 'promoText_DESC';

/** Identifies documents */
export type FooterWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  copyright_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  copyright_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  copyright_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  copyright_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  copyright_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  copyright_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  copyright_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  copyright_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  copyright_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  promoText?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  promoText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  promoText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  promoText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  promoText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  promoText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  promoText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  promoText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  promoText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  promoText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  socialLinks_every?: InputMaybe<PageLinkWhereInput>;
  socialLinks_some?: InputMaybe<PageLinkWhereInput>;
  socialLinks_none?: InputMaybe<PageLinkWhereInput>;
  legalLinks_every?: InputMaybe<PageLinkWhereInput>;
  legalLinks_some?: InputMaybe<PageLinkWhereInput>;
  legalLinks_none?: InputMaybe<PageLinkWhereInput>;
};

/** References Footer record uniquely */
export type FooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type Image = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
  buttonLabel?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Asset>;
};


export type ImageimageArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
};

export type ImageFit =
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  | 'clip'
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  | 'crop'
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  | 'scale'
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  | 'max';

export type ImageOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'buttonLabel_ASC'
  | 'buttonLabel_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
};

/** Identifies documents */
export type ImageWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  buttonLabel?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  buttonLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  buttonLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  buttonLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetWhereInput>;
};

export type LabelAndContent = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  content: Scalars['String']['output'];
};

export type LabelAndContentOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'content_ASC'
  | 'content_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type LabelAndContentWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LabelAndContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LabelAndContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LabelAndContentWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
};

/** Locale system enumeration */
export type Locale =
  | 'nl'
  /** System locale */
  | 'en_us';

export type MetaRobots =
  | 'INDEX_FOLLOW'
  | 'INDEX_NOFOLLOW'
  | 'NOINDEX_FOLLOW'
  | 'NOINDEX_NOFOLLOW';

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type OrderStep = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  isMobile?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Asset>;
};


export type OrderStepimageArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type OrderStepOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'index_ASC'
  | 'index_DESC'
  | 'label_ASC'
  | 'label_DESC'
  | 'isMobile_ASC'
  | 'isMobile_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type OrderStepWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<OrderStepWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<OrderStepWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<OrderStepWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  index_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  index_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values that are not contained in given list. */
  index_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  index_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  index_lte?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  index_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  index_gte?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isMobile_not?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<AssetWhereInput>;
};

export type Page = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  metaTitle: Scalars['String']['output'];
  metaDescription: Scalars['String']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  /** 9:6 for general usage */
  asset?: Maybe<Asset>;
  relatedPages: Array<Page>;
  childPages: Array<Page>;
  metaRobots: MetaRobots;
  content: Array<PageContent>;
};


export type PageassetArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type PagerelatedPagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PagechildPagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  orderBy?: InputMaybe<PageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PagecontentArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type PageConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<PageEdge>;
  aggregate: Aggregate;
};

export type PageContent = PageFooter | ProductThingsToKnow | RowBlogContent | RowBrandsBanner | RowFeaturedCategory | RowHeroBanner | RowLinks | RowOrderProcess | RowParagraph | RowProduct | RowProductHighlight | RowReviewHighlight | RowServiceOptions | RowServicePageContent;

export type PageContentWhereInput = {
  ProductThingsToKnow?: InputMaybe<ProductThingsToKnowWhereInput>;
  RowProductHighlight?: InputMaybe<RowProductHighlightWhereInput>;
  RowServicePageContent?: InputMaybe<RowServicePageContentWhereInput>;
  RowLinks?: InputMaybe<RowLinksWhereInput>;
  RowBrandsBanner?: InputMaybe<RowBrandsBannerWhereInput>;
  PageFooter?: InputMaybe<PageFooterWhereInput>;
  RowProduct?: InputMaybe<RowProductWhereInput>;
  RowHeroBanner?: InputMaybe<RowHeroBannerWhereInput>;
  RowBlogContent?: InputMaybe<RowBlogContentWhereInput>;
  RowServiceOptions?: InputMaybe<RowServiceOptionsWhereInput>;
  RowOrderProcess?: InputMaybe<RowOrderProcessWhereInput>;
  RowReviewHighlight?: InputMaybe<RowReviewHighlightWhereInput>;
  RowFeaturedCategory?: InputMaybe<RowFeaturedCategoryWhereInput>;
  RowParagraph?: InputMaybe<RowParagraphWhereInput>;
};

/** An edge in a connection. */
export type PageEdge = {
  /** The item at the end of the edge. */
  node: Page;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

/** Footer for all pages */
export type PageFooter = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  resources: Array<FooterLink>;
  topProducts: Array<FooterLink>;
  socialMediaLinks: Array<FooterImageLink>;
  pages: Array<Page>;
};


/** Footer for all pages */
export type PageFooterresourcesArgs = {
  where?: InputMaybe<FooterLinkWhereInput>;
  orderBy?: InputMaybe<FooterLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Footer for all pages */
export type PageFootertopProductsArgs = {
  where?: InputMaybe<FooterLinkWhereInput>;
  orderBy?: InputMaybe<FooterLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Footer for all pages */
export type PageFootersocialMediaLinksArgs = {
  where?: InputMaybe<FooterImageLinkWhereInput>;
  orderBy?: InputMaybe<FooterImageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Footer for all pages */
export type PageFooterpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type PageFooterConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<PageFooterEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type PageFooterEdge = {
  /** The item at the end of the edge. */
  node: PageFooter;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type PageFooterOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC';

/** Identifies documents */
export type PageFooterWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  resources_every?: InputMaybe<FooterLinkWhereInput>;
  resources_some?: InputMaybe<FooterLinkWhereInput>;
  resources_none?: InputMaybe<FooterLinkWhereInput>;
  topProducts_every?: InputMaybe<FooterLinkWhereInput>;
  topProducts_some?: InputMaybe<FooterLinkWhereInput>;
  topProducts_none?: InputMaybe<FooterLinkWhereInput>;
  socialMediaLinks_every?: InputMaybe<FooterImageLinkWhereInput>;
  socialMediaLinks_some?: InputMaybe<FooterImageLinkWhereInput>;
  socialMediaLinks_none?: InputMaybe<FooterImageLinkWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References PageFooter record uniquely */
export type PageFooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
};

export type PageLink = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  description?: Maybe<RichText>;
  url: Scalars['String']['output'];
  rowHeroBanners: Array<RowHeroBanner>;
  rowLinks: Array<RowLinks>;
  uspsMultiple: Array<Usps>;
  footerSocialLinks: Array<Footer>;
  rowServiceOptionsMultiple: Array<RowServiceOptions>;
  footerLegalLinks: Array<Footer>;
  rowProductMultiple: Array<RowProduct>;
  asset?: Maybe<Asset>;
};


export type PageLinkrowHeroBannersArgs = {
  where?: InputMaybe<RowHeroBannerWhereInput>;
  orderBy?: InputMaybe<RowHeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkrowLinksArgs = {
  where?: InputMaybe<RowLinksWhereInput>;
  orderBy?: InputMaybe<RowLinksOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkuspsMultipleArgs = {
  where?: InputMaybe<UspsWhereInput>;
  orderBy?: InputMaybe<UspsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkfooterSocialLinksArgs = {
  where?: InputMaybe<FooterWhereInput>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkrowServiceOptionsMultipleArgs = {
  where?: InputMaybe<RowServiceOptionsWhereInput>;
  orderBy?: InputMaybe<RowServiceOptionsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkfooterLegalLinksArgs = {
  where?: InputMaybe<FooterWhereInput>;
  orderBy?: InputMaybe<FooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkrowProductMultipleArgs = {
  where?: InputMaybe<RowProductWhereInput>;
  orderBy?: InputMaybe<RowProductOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PageLinkassetArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

/** A connection to a list of items. */
export type PageLinkConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<PageLinkEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type PageLinkEdge = {
  /** The item at the end of the edge. */
  node: PageLink;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type PageLinkOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'url_ASC'
  | 'url_DESC';

/** Identifies documents */
export type PageLinkWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageLinkWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  rowHeroBanners_every?: InputMaybe<RowHeroBannerWhereInput>;
  rowHeroBanners_some?: InputMaybe<RowHeroBannerWhereInput>;
  rowHeroBanners_none?: InputMaybe<RowHeroBannerWhereInput>;
  rowLinks_every?: InputMaybe<RowLinksWhereInput>;
  rowLinks_some?: InputMaybe<RowLinksWhereInput>;
  rowLinks_none?: InputMaybe<RowLinksWhereInput>;
  uspsMultiple_every?: InputMaybe<UspsWhereInput>;
  uspsMultiple_some?: InputMaybe<UspsWhereInput>;
  uspsMultiple_none?: InputMaybe<UspsWhereInput>;
  footerSocialLinks_every?: InputMaybe<FooterWhereInput>;
  footerSocialLinks_some?: InputMaybe<FooterWhereInput>;
  footerSocialLinks_none?: InputMaybe<FooterWhereInput>;
  rowServiceOptionsMultiple_every?: InputMaybe<RowServiceOptionsWhereInput>;
  rowServiceOptionsMultiple_some?: InputMaybe<RowServiceOptionsWhereInput>;
  rowServiceOptionsMultiple_none?: InputMaybe<RowServiceOptionsWhereInput>;
  footerLegalLinks_every?: InputMaybe<FooterWhereInput>;
  footerLegalLinks_some?: InputMaybe<FooterWhereInput>;
  footerLegalLinks_none?: InputMaybe<FooterWhereInput>;
  rowProductMultiple_every?: InputMaybe<RowProductWhereInput>;
  rowProductMultiple_some?: InputMaybe<RowProductWhereInput>;
  rowProductMultiple_none?: InputMaybe<RowProductWhereInput>;
  asset?: InputMaybe<AssetWhereInput>;
};

/** References PageLink record uniquely */
export type PageLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'url_ASC'
  | 'url_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'metaTitle_ASC'
  | 'metaTitle_DESC'
  | 'metaDescription_ASC'
  | 'metaDescription_DESC'
  | 'date_ASC'
  | 'date_DESC'
  | 'author_ASC'
  | 'author_DESC'
  | 'metaRobots_ASC'
  | 'metaRobots_DESC';

/** Identifies documents */
export type PageWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  metaTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  metaTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  metaTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  metaTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  metaTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  metaTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  metaTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  metaTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  metaDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  metaDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  metaDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  metaDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  metaDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  metaDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  metaDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  metaDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['DateTime']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  author_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  author_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  author_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  author_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  author_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  author_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  author_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  author_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  asset?: InputMaybe<AssetWhereInput>;
  relatedPages_every?: InputMaybe<PageWhereInput>;
  relatedPages_some?: InputMaybe<PageWhereInput>;
  relatedPages_none?: InputMaybe<PageWhereInput>;
  childPages_every?: InputMaybe<PageWhereInput>;
  childPages_some?: InputMaybe<PageWhereInput>;
  childPages_none?: InputMaybe<PageWhereInput>;
  metaRobots?: InputMaybe<MetaRobots>;
  /** Any other value that exists and is not equal to the given value. */
  metaRobots_not?: InputMaybe<MetaRobots>;
  /** All values that are contained in given list. */
  metaRobots_in?: InputMaybe<Array<InputMaybe<MetaRobots>>>;
  /** All values that are not contained in given list. */
  metaRobots_not_in?: InputMaybe<Array<InputMaybe<MetaRobots>>>;
  /** All values in which the union is empty */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  content_some?: InputMaybe<PageContentWhereInput>;
};

/** References Page record uniquely */
export type PageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductCategory = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  categoryLabel?: Maybe<Scalars['String']['output']>;
  categoryImage?: Maybe<Image>;
};

export type ProductCategoryOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'categoryLabel_ASC'
  | 'categoryLabel_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type ProductCategoryWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductCategoryWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  categoryLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  categoryLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  categoryLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  categoryLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  categoryImage?: InputMaybe<ImageWhereInput>;
};

export type ProductSideInfo = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type ProductSideInfoConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<ProductSideInfoEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type ProductSideInfoEdge = {
  /** The item at the end of the edge. */
  node: ProductSideInfo;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type ProductSideInfoOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'heading_ASC'
  | 'heading_DESC'
  | 'content_ASC'
  | 'content_DESC';

/** Identifies documents */
export type ProductSideInfoWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductSideInfoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductSideInfoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductSideInfoWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
};

/** References ProductSideInfo record uniquely */
export type ProductSideInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductThingsToKnow = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  thingsToKnow: Array<LabelAndContent>;
  pages: Array<Page>;
};


export type ProductThingsToKnowthingsToKnowArgs = {
  where?: InputMaybe<LabelAndContentWhereInput>;
  orderBy?: InputMaybe<LabelAndContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductThingsToKnowpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type ProductThingsToKnowConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<ProductThingsToKnowEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type ProductThingsToKnowEdge = {
  /** The item at the end of the edge. */
  node: ProductThingsToKnow;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type ProductThingsToKnowOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC';

/** Identifies documents */
export type ProductThingsToKnowWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProductThingsToKnowWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProductThingsToKnowWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProductThingsToKnowWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  thingsToKnow_every?: InputMaybe<LabelAndContentWhereInput>;
  thingsToKnow_some?: InputMaybe<LabelAndContentWhereInput>;
  thingsToKnow_none?: InputMaybe<LabelAndContentWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References ProductThingsToKnow record uniquely */
export type ProductThingsToKnowWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewItem = Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  score: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  content: Scalars['String']['output'];
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Asset>;
};


export type ReviewItemavatarArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};

export type ReviewItemOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'score_ASC'
  | 'score_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'content_ASC'
  | 'content_DESC'
  | 'dateCreated_ASC'
  | 'dateCreated_DESC'
  | 'userName_ASC'
  | 'userName_DESC'
  | 'companyName_ASC'
  | 'companyName_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

/** Identifies documents */
export type ReviewItemWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ReviewItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ReviewItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ReviewItemWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  score_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  score_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values that are not contained in given list. */
  score_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  score_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  score_lte?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  score_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  score_gte?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  content_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  content_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  content_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  content_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  content_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  content_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  content_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  content_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  content_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  dateCreated_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  dateCreated_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values that are not contained in given list. */
  dateCreated_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  dateCreated_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  dateCreated_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  dateCreated_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  dateCreated_gte?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  userName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  userName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  userName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  userName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  userName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  userName_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  userName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  userName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  userName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  companyName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  companyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  companyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  companyName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  companyName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  companyName_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  companyName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  companyName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  companyName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<AssetWhereInput>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type RowBlogContent = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  content?: Maybe<RichText>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  pages: Array<Page>;
};


export type RowBlogContentpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowBlogContentConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowBlogContentEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowBlogContentEdge = {
  /** The item at the end of the edge. */
  node: RowBlogContent;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowBlogContentOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'htmlContent_ASC'
  | 'htmlContent_DESC';

/** Identifies documents */
export type RowBlogContentWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowBlogContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowBlogContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowBlogContentWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  htmlContent_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  htmlContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  htmlContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  htmlContent_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  htmlContent_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  htmlContent_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  htmlContent_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  htmlContent_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  htmlContent_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowBlogContent record uniquely */
export type RowBlogContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

/** For the "brands that trust us" carousel */
export type RowBrandsBanner = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity?: Maybe<Scalars['String']['output']>;
  sectionLabel?: Maybe<Scalars['String']['output']>;
  brands: Array<Brand>;
  pages: Array<Page>;
};


/** For the "brands that trust us" carousel */
export type RowBrandsBannerbrandsArgs = {
  where?: InputMaybe<BrandWhereInput>;
  orderBy?: InputMaybe<BrandOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** For the "brands that trust us" carousel */
export type RowBrandsBannerpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowBrandsBannerConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowBrandsBannerEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowBrandsBannerEdge = {
  /** The item at the end of the edge. */
  node: RowBrandsBanner;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowBrandsBannerOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'sectionLabel_ASC'
  | 'sectionLabel_DESC';

/** Identifies documents */
export type RowBrandsBannerWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowBrandsBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowBrandsBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowBrandsBannerWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sectionLabel?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sectionLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  sectionLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  sectionLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  sectionLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  brands_every?: InputMaybe<BrandWhereInput>;
  brands_some?: InputMaybe<BrandWhereInput>;
  brands_none?: InputMaybe<BrandWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowBrandsBanner record uniquely */
export type RowBrandsBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** home page section for featured categories */
export type RowFeaturedCategory = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  sectionLabel?: Maybe<Scalars['String']['output']>;
  categoryItems: Array<ProductCategory>;
  pages: Array<Page>;
};


/** home page section for featured categories */
export type RowFeaturedCategorycategoryItemsArgs = {
  where?: InputMaybe<ProductCategoryWhereInput>;
  orderBy?: InputMaybe<ProductCategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** home page section for featured categories */
export type RowFeaturedCategorypagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowFeaturedCategoryConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowFeaturedCategoryEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowFeaturedCategoryEdge = {
  /** The item at the end of the edge. */
  node: RowFeaturedCategory;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowFeaturedCategoryOrderByInput =
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'sectionLabel_ASC'
  | 'sectionLabel_DESC';

/** Identifies documents */
export type RowFeaturedCategoryWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowFeaturedCategoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowFeaturedCategoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowFeaturedCategoryWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sectionLabel?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  sectionLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  sectionLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  sectionLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  sectionLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  categoryItems_every?: InputMaybe<ProductCategoryWhereInput>;
  categoryItems_some?: InputMaybe<ProductCategoryWhereInput>;
  categoryItems_none?: InputMaybe<ProductCategoryWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowFeaturedCategory record uniquely */
export type RowFeaturedCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type RowHeroBanner = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  headerText?: Maybe<Scalars['String']['output']>;
  headerTitle?: Maybe<Scalars['String']['output']>;
  banners: Array<Banner>;
  pageLinks: Array<PageLink>;
  pages: Array<Page>;
};


export type RowHeroBannerbannersArgs = {
  where?: InputMaybe<BannerWhereInput>;
  orderBy?: InputMaybe<BannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RowHeroBannerpageLinksArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RowHeroBannerpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowHeroBannerConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowHeroBannerEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowHeroBannerEdge = {
  /** The item at the end of the edge. */
  node: RowHeroBanner;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowHeroBannerOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'headerText_ASC'
  | 'headerText_DESC'
  | 'headerTitle_ASC'
  | 'headerTitle_DESC';

/** Identifies documents */
export type RowHeroBannerWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowHeroBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowHeroBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowHeroBannerWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  headerText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headerText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  headerText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  headerText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headerText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headerText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  headerText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headerText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headerText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  headerTitle?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  headerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  headerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  headerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  headerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  banners_every?: InputMaybe<BannerWhereInput>;
  banners_some?: InputMaybe<BannerWhereInput>;
  banners_none?: InputMaybe<BannerWhereInput>;
  pageLinks_every?: InputMaybe<PageLinkWhereInput>;
  pageLinks_some?: InputMaybe<PageLinkWhereInput>;
  pageLinks_none?: InputMaybe<PageLinkWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowHeroBanner record uniquely */
export type RowHeroBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type RowLinks = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  title: Scalars['String']['output'];
  rowLinksCopy?: Maybe<RichText>;
  pageLinks: Array<PageLink>;
  linksVariant?: Maybe<RowLinksVariants>;
  pages: Array<Page>;
};


export type RowLinkspageLinksArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RowLinkspagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowLinksConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowLinksEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowLinksEdge = {
  /** The item at the end of the edge. */
  node: RowLinks;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowLinksOrderByInput =
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'linksVariant_ASC'
  | 'linksVariant_DESC';

export type RowLinksVariants =
  | 'ImageLabelSwiper'
  | 'Inline'
  | 'LogoSwiper'
  | 'Usps';

/** Identifies documents */
export type RowLinksWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowLinksWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowLinksWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowLinksWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pageLinks_every?: InputMaybe<PageLinkWhereInput>;
  pageLinks_some?: InputMaybe<PageLinkWhereInput>;
  pageLinks_none?: InputMaybe<PageLinkWhereInput>;
  linksVariant?: InputMaybe<RowLinksVariants>;
  /** Any other value that exists and is not equal to the given value. */
  linksVariant_not?: InputMaybe<RowLinksVariants>;
  /** All values that are contained in given list. */
  linksVariant_in?: InputMaybe<Array<InputMaybe<RowLinksVariants>>>;
  /** All values that are not contained in given list. */
  linksVariant_not_in?: InputMaybe<Array<InputMaybe<RowLinksVariants>>>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowLinks record uniquely */
export type RowLinksWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

/** This is the module that displays the "how to order" or "what makes us different" row in the home page */
export type RowOrderProcess = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity?: Maybe<Scalars['String']['output']>;
  labelDesktop?: Maybe<Scalars['String']['output']>;
  labelMobile?: Maybe<Scalars['String']['output']>;
  orderSteps: Array<OrderStep>;
  pages: Array<Page>;
};


/** This is the module that displays the "how to order" or "what makes us different" row in the home page */
export type RowOrderProcessorderStepsArgs = {
  where?: InputMaybe<OrderStepWhereInput>;
  orderBy?: InputMaybe<OrderStepOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the module that displays the "how to order" or "what makes us different" row in the home page */
export type RowOrderProcesspagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowOrderProcessConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowOrderProcessEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowOrderProcessEdge = {
  /** The item at the end of the edge. */
  node: RowOrderProcess;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowOrderProcessOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'labelDesktop_ASC'
  | 'labelDesktop_DESC'
  | 'labelMobile_ASC'
  | 'labelMobile_DESC';

/** Identifies documents */
export type RowOrderProcessWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowOrderProcessWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowOrderProcessWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowOrderProcessWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  labelDesktop?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  labelDesktop_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  labelDesktop_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  labelDesktop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  labelDesktop_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  labelDesktop_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  labelDesktop_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  labelDesktop_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  labelDesktop_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  labelDesktop_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  labelMobile?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  labelMobile_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  labelMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  labelMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  labelMobile_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  labelMobile_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  labelMobile_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  labelMobile_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  labelMobile_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  labelMobile_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  orderSteps_every?: InputMaybe<OrderStepWhereInput>;
  orderSteps_some?: InputMaybe<OrderStepWhereInput>;
  orderSteps_none?: InputMaybe<OrderStepWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowOrderProcess record uniquely */
export type RowOrderProcessWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RowParagraph = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  paragraphTitle?: Maybe<Scalars['String']['output']>;
  paragraph?: Maybe<Scalars['String']['output']>;
  pages: Array<Page>;
};


export type RowParagraphpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowParagraphConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowParagraphEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowParagraphEdge = {
  /** The item at the end of the edge. */
  node: RowParagraph;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowParagraphOrderByInput =
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'paragraphTitle_ASC'
  | 'paragraphTitle_DESC'
  | 'paragraph_ASC'
  | 'paragraph_DESC';

/** Identifies documents */
export type RowParagraphWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowParagraphWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowParagraphWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowParagraphWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  paragraphTitle?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  paragraphTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  paragraphTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  paragraphTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  paragraphTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  paragraphTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  paragraphTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  paragraphTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  paragraphTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  paragraphTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  paragraph_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  paragraph_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  paragraph_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  paragraph_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  paragraph_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  paragraph_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  paragraph_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  paragraph_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  paragraph_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowParagraph record uniquely */
export type RowParagraphWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type RowProduct = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  title: Scalars['String']['output'];
  productCopy?: Maybe<RichText>;
  pageLinks: Array<PageLink>;
  asset?: Maybe<Asset>;
  /** Row Product component to render */
  variant?: Maybe<RowProductVariants>;
  pages: Array<Page>;
};


export type RowProductpageLinksArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RowProductassetArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type RowProductpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowProductConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowProductEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowProductEdge = {
  /** The item at the end of the edge. */
  node: RowProduct;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

/** This row is an image grid that shows products that we wish to highlight in the home page */
export type RowProductHighlight = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity?: Maybe<Scalars['String']['output']>;
  mainLabel?: Maybe<Scalars['String']['output']>;
  secondaryImages: Array<Image>;
  mainImage?: Maybe<Asset>;
  mainImageMobile?: Maybe<Asset>;
  pages: Array<Page>;
};


/** This row is an image grid that shows products that we wish to highlight in the home page */
export type RowProductHighlightsecondaryImagesArgs = {
  where?: InputMaybe<ImageWhereInput>;
  orderBy?: InputMaybe<ImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** This row is an image grid that shows products that we wish to highlight in the home page */
export type RowProductHighlightmainImageArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** This row is an image grid that shows products that we wish to highlight in the home page */
export type RowProductHighlightmainImageMobileArgs = {
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** This row is an image grid that shows products that we wish to highlight in the home page */
export type RowProductHighlightpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowProductHighlightConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowProductHighlightEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowProductHighlightEdge = {
  /** The item at the end of the edge. */
  node: RowProductHighlight;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowProductHighlightOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'mainLabel_ASC'
  | 'mainLabel_DESC';

/** Identifies documents */
export type RowProductHighlightWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowProductHighlightWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowProductHighlightWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowProductHighlightWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  mainLabel?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  mainLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mainLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  mainLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  mainLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mainLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mainLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  mainLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mainLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mainLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  secondaryImages_every?: InputMaybe<ImageWhereInput>;
  secondaryImages_some?: InputMaybe<ImageWhereInput>;
  secondaryImages_none?: InputMaybe<ImageWhereInput>;
  mainImage?: InputMaybe<AssetWhereInput>;
  mainImageMobile?: InputMaybe<AssetWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowProductHighlight record uniquely */
export type RowProductHighlightWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RowProductOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'title_ASC'
  | 'title_DESC'
  | 'variant_ASC'
  | 'variant_DESC';

/** All different kind of possible Row Product components to render */
export type RowProductVariants =
  | 'Backstory'
  | 'Feature'
  | 'FeatureBoxed'
  | 'Grid'
  | 'Related'
  | 'Reviews'
  | 'Specs'
  | 'Swipeable'
  | 'Upsells';

/** Identifies documents */
export type RowProductWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowProductWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowProductWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowProductWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pageLinks_every?: InputMaybe<PageLinkWhereInput>;
  pageLinks_some?: InputMaybe<PageLinkWhereInput>;
  pageLinks_none?: InputMaybe<PageLinkWhereInput>;
  asset?: InputMaybe<AssetWhereInput>;
  variant?: InputMaybe<RowProductVariants>;
  /** Any other value that exists and is not equal to the given value. */
  variant_not?: InputMaybe<RowProductVariants>;
  /** All values that are contained in given list. */
  variant_in?: InputMaybe<Array<InputMaybe<RowProductVariants>>>;
  /** All values that are not contained in given list. */
  variant_not_in?: InputMaybe<Array<InputMaybe<RowProductVariants>>>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowProduct record uniquely */
export type RowProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

/** Customer Testimonials section in home page */
export type RowReviewHighlight = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  reviewItems: Array<ReviewItem>;
  pages: Array<Page>;
};


/** Customer Testimonials section in home page */
export type RowReviewHighlightreviewItemsArgs = {
  where?: InputMaybe<ReviewItemWhereInput>;
  orderBy?: InputMaybe<ReviewItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Customer Testimonials section in home page */
export type RowReviewHighlightpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowReviewHighlightConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowReviewHighlightEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowReviewHighlightEdge = {
  /** The item at the end of the edge. */
  node: RowReviewHighlight;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowReviewHighlightOrderByInput =
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'identity_ASC'
  | 'identity_DESC';

/** Identifies documents */
export type RowReviewHighlightWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowReviewHighlightWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowReviewHighlightWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowReviewHighlightWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  reviewItems_every?: InputMaybe<ReviewItemWhereInput>;
  reviewItems_some?: InputMaybe<ReviewItemWhereInput>;
  reviewItems_none?: InputMaybe<ReviewItemWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowReviewHighlight record uniquely */
export type RowReviewHighlightWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type RowServiceOptions = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  title: Scalars['String']['output'];
  serviceOptions: Array<PageLink>;
  pages: Array<Page>;
};


export type RowServiceOptionsserviceOptionsArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type RowServiceOptionspagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowServiceOptionsConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowServiceOptionsEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowServiceOptionsEdge = {
  /** The item at the end of the edge. */
  node: RowServiceOptions;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowServiceOptionsOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'title_ASC'
  | 'title_DESC';

/** Identifies documents */
export type RowServiceOptionsWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowServiceOptionsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowServiceOptionsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowServiceOptionsWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  serviceOptions_every?: InputMaybe<PageLinkWhereInput>;
  serviceOptions_some?: InputMaybe<PageLinkWhereInput>;
  serviceOptions_none?: InputMaybe<PageLinkWhereInput>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowServiceOptions record uniquely */
export type RowServiceOptionsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

export type RowServicePageContent = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  content?: Maybe<RichText>;
  pages: Array<Page>;
};


export type RowServicePageContentpagesArgs = {
  where?: InputMaybe<PageWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type RowServicePageContentConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<RowServicePageContentEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type RowServicePageContentEdge = {
  /** The item at the end of the edge. */
  node: RowServicePageContent;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type RowServicePageContentOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC'
  | 'pageTitle_ASC'
  | 'pageTitle_DESC';

/** Identifies documents */
export type RowServicePageContentWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RowServicePageContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RowServicePageContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RowServicePageContentWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  pageTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pageTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  pageTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  pageTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pageTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pageTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  pageTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pageTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pageTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  pages_every?: InputMaybe<PageWhereInput>;
  pages_some?: InputMaybe<PageWhereInput>;
  pages_none?: InputMaybe<PageWhereInput>;
};

/** References RowServicePageContent record uniquely */
export type RowServicePageContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperation = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** operation Status */
  status: ScheduledOperationStatus;
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
};


/** Scheduled Operation system model */
export type ScheduledOperationaffectedDocumentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduledOperationAffectedDocument = Asset | Footer | Page | PageFooter | PageLink | ProductSideInfo | ProductThingsToKnow | RowBlogContent | RowBrandsBanner | RowFeaturedCategory | RowHeroBanner | RowLinks | RowOrderProcess | RowParagraph | RowProduct | RowProductHighlight | RowReviewHighlight | RowServiceOptions | RowServicePageContent | Usps;

export type ScheduledOperationOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'description_ASC'
  | 'description_DESC'
  | 'errorMessage_ASC'
  | 'errorMessage_DESC'
  | 'status_ASC'
  | 'status_DESC';

/** System Scheduled Operation Status */
export type ScheduledOperationStatus =
  | 'CANCELED'
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'PENDING';

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** Release Status */
  status: ScheduledReleaseStatus;
};


/** Scheduled Release system model */
export type ScheduledReleaseoperationsArgs = {
  where?: InputMaybe<ScheduledOperationWhereInput>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** System Scheduled Release Status */
export type ScheduledReleaseStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'PENDING';

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
};

/** Stage system enumeration */
export type Stage =
  /** The Draft is the default stage for all your content. */
  | 'DRAFT'
  /** The Published stage is where you can publish your content to. */
  | 'PUBLISHED';

/** User system model */
export type User = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
};

/** System User Kind */
export type UserKind =
  | 'MEMBER'
  | 'PAT'
  | 'PUBLIC'
  | 'WEBHOOK';

export type Usps = Node & Entity & {
  /** System stage field */
  stage: Stage;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  identity: Scalars['String']['output'];
  uspsMultiple: Array<PageLink>;
};


export type UspsuspsMultipleArgs = {
  where?: InputMaybe<PageLinkWhereInput>;
  orderBy?: InputMaybe<PageLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type UspsConnection = {
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<UspsEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type UspsEdge = {
  /** The item at the end of the edge. */
  node: Usps;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
};

export type UspsOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'publishedAt_ASC'
  | 'publishedAt_DESC'
  | 'identity_ASC'
  | 'identity_DESC';

/** Identifies documents */
export type UspsWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UspsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UspsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UspsWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  identity_not?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  identity_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values that are not contained in given list. */
  identity_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values containing the given string. */
  identity_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  identity_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  identity_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not starting with the given string. */
  identity_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  identity_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  identity_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  uspsMultiple_every?: InputMaybe<PageLinkWhereInput>;
  uspsMultiple_some?: InputMaybe<PageLinkWhereInput>;
  uspsMultiple_none?: InputMaybe<PageLinkWhereInput>;
};

/** References Usps record uniquely */
export type UspsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
};

/** All storefront configuration for the project */
export type GraphCommerceStorefrontConfig = {
  hotjarId?: InputMaybe<Scalars['String']['input']>;
  hotjarVersion?: InputMaybe<Scalars['String']['input']>;
  /**
   * Configure different Google Analytics IDs for different locales.
   *
   * To disable for a specific locale, set the value to null.
   */
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  /** Locale specific google reCAPTCHA key. */
  googleRecaptchaKey?: InputMaybe<Scalars['String']['input']>;
  /** The Google Tagmanager ID to be used per locale. */
  googleTagmanagerId?: InputMaybe<Scalars['String']['input']>;
  /** Add a gcms-locales header to make sure queries return in a certain language, can be an array to define fallbacks. */
  hygraphLocales?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specify a custom locale for to load translations. */
  linguiLocale?: InputMaybe<Scalars['String']['input']>;
  /** Due to a limitation of the GraphQL API it is not possible to determine if a cart should be displayed including or excluding tax. */
  cartDisplayPricesInclTax?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Magento store code.
   *
   * Stores => All Stores => [Store View] => Store View Code
   *
   * Examples:
   * - default
   * - en-us
   * - b2b-us
   */
  magentoStoreCode: Scalars['String']['input'];
  /**
   * There can only be one entry with defaultLocale set to true.
   * - If there are more, the first one is used.
   * - If there is none, the first entry is used.
   */
  defaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
  /** Domain configuration, must be a domain https://tools.ietf.org/html/rfc3986 */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Must be a locale string https://www.unicode.org/reports/tr35/tr35-59/tr35.html#Identifiers */
  locale: Scalars['String']['input'];
  /**
   * The canonical base URL is used for SEO purposes.
   *
   * Examples:
   * - https://example.com
   * - https://example.com/en
   * - https://example.com/en-US
   */
  canonicalBaseUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * # GraphCommerce configuration system
 *
 * Global GraphCommerce configuration can be configured in your `graphcommerce.config.js` file
 * in the root of your project and are automatically validated on startup.
 *
 * ## Configuring with the configuration file.
 *
 * The configuration file is a javascript file that exports a `GraphCommerceConfig` object. See graphcommerce.config.js.example for an example.
 *
 * ## Using configuration
 *
 * Configuration can be accessed in your project with the `import.meta.graphCommerce` object.
 *
 * ```tsx
 * import { storefrontAll, storefrontConfig, storefrontConfigDefault, useStorefrontConfig } from '@graphcommerce/next-ui'
 *
 * // Accessing a global value
 * const globalConf = import.meta.graphCommerce.cartDisplayPricesInclTax
 *
 * function MyComponent() {
 *   // Configuration configured per storefront locale.
 *   const scopedConfig = useStorefrontConfig().cartDisplayPricesInclTax
 *
 *   // Creating a fallback system
 *   const scopedConfigWithFallback = scopedConfig ?? globalConf
 *
 *   // Or as single line
 *   const scopedConfigWithFallback2 =
 *     useStorefrontConfig().cartDisplayPricesInclTax ?? import.meta.graphCommerce.cartDisplayPricesInclTax
 *
 *   return <div>{googleRecaptchaKey}</div>
 * }
 * ```
 *
 * You can also use the configuration in your `.meshrc.yml` by accessing
 * `{graphCommerce.myField}`
 *
 * ```yml
 * endpoint: '{graphCommerce.magentoEndpoint}'
 * ```
 *
 * ## Environment variables to override configuration
 *
 * Configuration values can be overwriten by environment variables, with the following rules:
 * - Convert from camelCase to `SCREAMING_SNAKE_CASE`
 * - Prefix with `GC_`
 * - Arrays can be indexed with `_0`, `_1`, `_2`, etc.
 * - Objects can be accessed with `_<key>`.
 *
 * Examples:
 * - `limitSsg` -> `GC_LIMIT_SSG="1"`
 * - `storefront[0].locale` -> `GC_STOREFRONT_0_LOCALE="en"`
 * - `debug.pluginStatus` -> `GC_DEBUG_PLUGIN_STATUS="1"`
 *
 *
 * ## Exporting current configuration to environment variables
 *
 * You can export configuration by running `yarn graphcommerce export-config`
 *
 * ## Extending the configuration in your  project
 *
 * Create a graphql/Config.graphqls file in your project and extend the GraphCommerceConfig, GraphCommerceStorefrontConfig inputs to add configuration.
 *
 * ```graphql
 * extend input GraphCommerceConfig {
 *   myConfig: String # or Boolean, or Int, or Float, make required with `!`
 * }
 * extend input GraphCommerceStorefrontConfig {
 *   myField: Boolean
 * }
 * ```
 *
 * ## All configuration values
 *
 * Below is a list of all possible configurations that can be set by GraphCommerce.
 */
export type GraphCommerceConfig = {
  hotjarId?: InputMaybe<Scalars['String']['input']>;
  hotjarVersion?: InputMaybe<Scalars['String']['input']>;
  fbPixelId?: InputMaybe<Scalars['String']['input']>;
  klaviyoPublicKey?: InputMaybe<Scalars['String']['input']>;
  googleMapsApiKey?: InputMaybe<Scalars['String']['input']>;
  gorgiasId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Enables some demo specific code that is probably not useful for a project:
   *
   * - Adds the "BY GC" to the product list items.
   * - Adds "dominant_color" attribute swatches to the product list items.
   * - Creates a big list items in the product list.
   */
  demoMode?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * See https://support.google.com/analytics/answer/9539598?hl=en
   *
   * Provide a value to enable Google Analytics for your store.
   *
   * To override the value for a specific locale, configure in i18n config.
   */
  googleAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Google reCAPTCHA site key.
   * When using reCAPTCHA, this value is required, even if you are configuring different values for each locale.
   *
   * Get a site key and a secret key from https://developers.google.com/recaptcha/docs/v3
   *
   * The secret key should be added in the Magento admin panel (Stores > Configuration > Security > Google ReCAPTCHA Storefront > reCAPTCHA v3 Invisible)
   * ReCAPTCHA can then be enabled/disabled for the different forms, separately (Stores > Configuration > Security > Google ReCAPTCHA Storefront > Storefront)
   */
  googleRecaptchaKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * The Google Tagmanager ID to be used on the site.
   *
   * This value is required even if you are configuring different values for each locale.
   */
  googleTagmanagerId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The HyGraph endpoint.
   *
   * > Read-only endpoint that allows low latency and high read-throughput content delivery.
   *
   * Project settings -> API Access -> High Performance Read-only Content API
   */
  hygraphEndpoint: Scalars['String']['input'];
  /**
   * Content API. **Only used for migrations.**
   *
   * > Regular read & write endpoint that allows querying and mutating data in your project.
   *
   * Project settings -> API Access -> Content API
   */
  hygraphWriteAccessEndpoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * Hygraph Management SDK Authorization Token. **Only used for migrations.**
   *
   * Project settings -> API Access -> Permanent Auth Tokens
   *
   * 1. Click  'Add token' and give it a name, something like 'GraphCommerce Write Access Token' and keep stage on 'Published'.
   * 2. Under 'Management API', click 'Yes, Initialize defaults'
   * 3. Click 'Edit Permissions' and enable: 'Update' and 'Delete' permissions for 'models', 'enumerations', 'fields', 'components' and 'sources'
   *   - Update existing models
   *   - Delete existing models
   *   - Update existing fields
   *   - Delete existing fields
   *   - Update existing enumerations
   *   - Delete existing enumerations
   *   - Update existing components
   *   - Delete existing components
   *   - Update remote sources
   *   - Delete remote sources
   *
   * ```
   * GC_HYGRAPH_WRITE_ACCESS_ENDPOINT="https://...hygraph.com/v2/..."
   * GC_HYGRAPH_WRITE_ACCESS_TOKEN="AccessTokenFromHygraph"
   * yarn graphcommerce hygraph-migrate
   * ```
   */
  hygraphWriteAccessToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Due to a limitation of the GraphQL API it is not possible to determine if a cart should be displayed including or excluding tax.
   *
   * When Magento's StoreConfig adds this value, this can be replaced.
   */
  cartDisplayPricesInclTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use compare functionality */
  compare?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * By default the compare feature is denoted with a 'compare ICON' (2 arrows facing one another).
   * This may be fine for experienced users, but for more clarity it's also possible to present the compare feature as a CHECKBOX accompanied by the 'Compare' label
   */
  compareVariant?: InputMaybe<CompareVariant>;
  /**
   * Due to a limitation in the GraphQL API of Magento 2, we need to know if the
   * customer requires email confirmation.
   *
   * This value should match Magento 2's configuration value for
   * `customer/create_account/confirm` and should be removed once we can query
   */
  customerRequireEmailConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * GraphQL Magento endpoint.
   *
   * Examples:
   * - https://magento2.test/graphql
   */
  magentoEndpoint: Scalars['String']['input'];
  /**
   * If a simple product is part of a Configurable product page, should the simple product be
   * rendered as a configured option of the configurable product page?
   *
   * How does this work:
   *
   * When the `products(filters: { url_key: { eq: 'simple-product' } }) { ... }` query is ran,
   * Magento also returns the Simple product and the Configurable product the simple belongs to.
   *
   * If that is the case we render the configurable product page instead of the simple product page but
   * the options to select the simple product are pre-selected.
   */
  configurableVariantForSimple?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * On older versions of GraphCommerce products would use a product type specific route.
   *
   * This should only be set to true if you use the /product/[url] AND /product/configurable/[url] routes.
   *
   * @deprecated Will be removed in a future version. [migration](../upgrading/graphcommerce-5-to-6.md#product-routing-changes)
   */
  legacyProductRoute?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Product filters with better UI for mobile and desktop.
   *
   * @experimental This is an experimental feature and may change in the future.
   */
  productFiltersPro?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Layout how the filters are rendered.
   * DEFAULT: Will be rendered as horzontal chips on desktop and mobile
   * SIDEBAR: Will be rendered as a sidebar on desktop and horizontal chips on mobile
   */
  productFiltersLayout?: InputMaybe<ProductFiltersLayout>;
  /**
   * By default we route products to /p/[url] but you can change this to /product/[url] if you wish.
   *
   * Default: '/p/'
   * Example: '/product/'
   */
  productRoute?: InputMaybe<Scalars['String']['input']>;
  /** Hide the wishlist functionality for guests. */
  wishlistHideForGuests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ignores whether a product is already in the wishlist, makes the toggle an add only. */
  wishlistIgnoreProductWishlistStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Show a message when the product is added to the wishlist. */
  wishlistShowFeedbackMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** All storefront configuration for the project */
  storefront: Array<GraphCommerceStorefrontConfig>;
  /** Limit the static generation of SSG when building */
  limitSsg?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Allow the site to be indexed by search engines.
   * If false, the robots.txt file will be set to disallow all.
   */
  robotsAllow?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The canonical base URL is used for SEO purposes.
   *
   * Examples:
   * - https://example.com
   * - https://example.com/en
   * - https://example.com/en-US
   */
  canonicalBaseUrl: Scalars['String']['input'];
  /** To enable next.js' preview mode, configure the secret you'd like to use. */
  previewSecret?: InputMaybe<Scalars['String']['input']>;
  /** Debug configuration for GraphCommerce */
  debug?: InputMaybe<GraphCommerceDebugConfig>;
};

export type CurrentCartId = {
  id?: Maybe<Scalars['String']['output']>;
};

export type RegisterCartIdInput = {
  cart_id: Scalars['String']['input'];
};

export type CompareVariant =
  | 'ICON'
  | 'CHECKBOX';

export type CurrentCompareUid = {
  uid?: Maybe<Scalars['String']['output']>;
};

export type ProductFiltersLayout =
  | 'DEFAULT'
  | 'SIDEBAR';

export type GuestWishlist = {
  items: Array<GuestWishlistItem>;
};

export type GuestWishlistItem = {
  sku: Scalars['String']['output'];
  url_key: Scalars['String']['output'];
  selected_options?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  quantity: Scalars['Float']['output'];
};

/** Debug configuration for GraphCommerce */
export type GraphCommerceDebugConfig = {
  /**
   * When updating packages it can happen that the same package is included with different versions in the same project.
   *
   * Issues that this can cause are:
   * - The same package is included multiple times in the bundle, increasing the bundle size.
   * - The Typescript types of the package are not compatible with each other, causing Typescript errors.
   */
  webpackDuplicatesPlugin?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Cyclic dependencies can cause memory issues and other strange bugs.
   * This plugin will warn you when it detects a cyclic dependency.
   *
   * When running into memory issues, it can be useful to enable this plugin.
   */
  webpackCircularDependencyPlugin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reports which plugins are enabled or disabled. */
  pluginStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string | ((fieldNode: FieldNode) => SelectionSetNode);
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<RefType extends Record<string, unknown>> = ResolversObject<{
  PageContent: ( PageFooter ) | ( ProductThingsToKnow ) | ( RowBlogContent ) | ( RowBrandsBanner ) | ( RowFeaturedCategory ) | ( RowHeroBanner ) | ( RowLinks ) | ( RowOrderProcess ) | ( RowParagraph ) | ( RowProduct ) | ( RowProductHighlight ) | ( RowReviewHighlight ) | ( RowServiceOptions ) | ( RowServicePageContent );
  ScheduledOperationAffectedDocument: ( Asset ) | ( Footer ) | ( Omit<Page, 'content'> & { content: Array<RefType['PageContent']> } ) | ( PageFooter ) | ( PageLink ) | ( ProductSideInfo ) | ( ProductThingsToKnow ) | ( RowBlogContent ) | ( RowBrandsBanner ) | ( RowFeaturedCategory ) | ( RowHeroBanner ) | ( RowLinks ) | ( RowOrderProcess ) | ( RowParagraph ) | ( RowProduct ) | ( RowProductHighlight ) | ( RowReviewHighlight ) | ( RowServiceOptions ) | ( RowServicePageContent ) | ( Usps );
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<RefType extends Record<string, unknown>> = ResolversObject<{
  ErrorInterface: ( NoSuchEntityUidError ) | ( InternalError );
  ProductLinksInterface: ( ProductLinks );
  ProductInterface: ( VirtualProduct ) | ( SimpleProduct ) | ( DownloadableProduct ) | ( BundleProduct ) | ( GroupedProduct ) | ( ConfigurableProduct );
  PhysicalProductInterface: ( SimpleProduct ) | ( BundleProduct ) | ( GroupedProduct ) | ( ConfigurableProduct );
  MediaGalleryInterface: ( ProductImage ) | ( ProductVideo );
  CustomizableOptionInterface: ( CustomizableAreaOption ) | ( CustomizableDateOption ) | ( CustomizableDropDownOption ) | ( CustomizableMultipleOption ) | ( CustomizableFieldOption ) | ( CustomizableFileOption ) | ( CustomizableRadioOption ) | ( CustomizableCheckboxOption );
  CustomizableProductInterface: ( VirtualProduct ) | ( SimpleProduct ) | ( DownloadableProduct ) | ( BundleProduct ) | ( ConfigurableProduct );
  CategoryInterface: ( CategoryTree );
  LayerFilterItemInterface: ( LayerFilterItem ) | ( SwatchLayerFilterItem );
  AggregationOptionInterface: ( AggregationOption );
  CartAddressInterface: ( ShippingCartAddress ) | ( BillingCartAddress );
  CartItemInterface: ( SimpleCartItem ) | ( VirtualCartItem ) | ( DownloadableCartItem ) | ( ConfigurableCartItem ) | ( BundleCartItem );
  OrderItemInterface: ( DownloadableOrderItem ) | ( BundleOrderItem ) | ( OrderItem );
  InvoiceItemInterface: ( DownloadableInvoiceItem ) | ( BundleInvoiceItem ) | ( InvoiceItem );
  ShipmentItemInterface: ( BundleShipmentItem ) | ( ShipmentItem );
  CreditMemoItemInterface: ( DownloadableCreditMemoItem ) | ( BundleCreditMemoItem ) | ( CreditMemoItem );
  RoutableInterface: ( CmsPage ) | ( CategoryTree ) | ( VirtualProduct ) | ( SimpleProduct ) | ( DownloadableProduct ) | ( BundleProduct ) | ( GroupedProduct ) | ( ConfigurableProduct );
  SwatchLayerFilterItemInterface: ( SwatchLayerFilterItem );
  SwatchDataInterface: ( ImageSwatchData ) | ( TextSwatchData ) | ( ColorSwatchData );
  WishlistItemInterface: ( SimpleWishlistItem ) | ( VirtualWishlistItem ) | ( DownloadableWishlistItem ) | ( BundleWishlistItem ) | ( GroupedProductWishlistItem ) | ( ConfigurableWishlistItem );
  Entity: ( Asset ) | ( Banner ) | ( Brand ) | ( Footer ) | ( FooterImageLink ) | ( FooterLink ) | ( Image ) | ( LabelAndContent ) | ( OrderStep ) | ( Omit<Page, 'content'> & { content: Array<RefType['PageContent']> } ) | ( PageFooter ) | ( PageLink ) | ( ProductCategory ) | ( ProductSideInfo ) | ( ProductThingsToKnow ) | ( ReviewItem ) | ( RowBlogContent ) | ( RowBrandsBanner ) | ( RowFeaturedCategory ) | ( RowHeroBanner ) | ( RowLinks ) | ( RowOrderProcess ) | ( RowParagraph ) | ( RowProduct ) | ( RowProductHighlight ) | ( RowReviewHighlight ) | ( RowServiceOptions ) | ( RowServicePageContent ) | ( Omit<ScheduledOperation, 'affectedDocuments'> & { affectedDocuments: Array<RefType['ScheduledOperationAffectedDocument']> } ) | ( ScheduledRelease ) | ( User ) | ( Usps );
  Node: ( Asset ) | ( Footer ) | ( Omit<Page, 'content'> & { content: Array<RefType['PageContent']> } ) | ( PageFooter ) | ( PageLink ) | ( ProductSideInfo ) | ( ProductThingsToKnow ) | ( RowBlogContent ) | ( RowBrandsBanner ) | ( RowFeaturedCategory ) | ( RowHeroBanner ) | ( RowLinks ) | ( RowOrderProcess ) | ( RowParagraph ) | ( RowProduct ) | ( RowProductHighlight ) | ( RowReviewHighlight ) | ( RowServiceOptions ) | ( RowServicePageContent ) | ( Omit<ScheduledOperation, 'affectedDocuments'> & { affectedDocuments: Array<RefType['ScheduledOperationAffectedDocument']> } ) | ( ScheduledRelease ) | ( User ) | ( Usps );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  Query: ResolverTypeWrapper<{}>;
  Mutation: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  FilterTypeInput: FilterTypeInput;
  FilterEqualTypeInput: FilterEqualTypeInput;
  FilterRangeTypeInput: FilterRangeTypeInput;
  FilterMatchTypeInput: FilterMatchTypeInput;
  FilterStringTypeInput: FilterStringTypeInput;
  SearchResultPageInfo: ResolverTypeWrapper<SearchResultPageInfo>;
  SortEnum: SortEnum;
  ComplexTextValue: ResolverTypeWrapper<ComplexTextValue>;
  Money: ResolverTypeWrapper<Money>;
  CurrencyEnum: CurrencyEnum;
  EnteredOptionInput: EnteredOptionInput;
  BatchMutationStatus: BatchMutationStatus;
  ErrorInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ErrorInterface']>;
  NoSuchEntityUidError: ResolverTypeWrapper<NoSuchEntityUidError>;
  InternalError: ResolverTypeWrapper<InternalError>;
  StoreConfig: ResolverTypeWrapper<StoreConfig>;
  CmsPage: ResolverTypeWrapper<CmsPage>;
  CmsBlocks: ResolverTypeWrapper<CmsBlocks>;
  CmsBlock: ResolverTypeWrapper<CmsBlock>;
  CustomAttributeMetadata: ResolverTypeWrapper<CustomAttributeMetadata>;
  Attribute: ResolverTypeWrapper<Attribute>;
  StorefrontProperties: ResolverTypeWrapper<StorefrontProperties>;
  UseInLayeredNavigationOptions: UseInLayeredNavigationOptions;
  AttributeOption: ResolverTypeWrapper<AttributeOption>;
  AttributeInput: AttributeInput;
  Website: ResolverTypeWrapper<Website>;
  CheckoutAgreement: ResolverTypeWrapper<CheckoutAgreement>;
  CheckoutAgreementMode: CheckoutAgreementMode;
  Price: ResolverTypeWrapper<Price>;
  PriceAdjustment: ResolverTypeWrapper<PriceAdjustment>;
  PriceAdjustmentCodesEnum: PriceAdjustmentCodesEnum;
  PriceAdjustmentDescriptionEnum: PriceAdjustmentDescriptionEnum;
  PriceTypeEnum: PriceTypeEnum;
  CustomizableDateTypeEnum: CustomizableDateTypeEnum;
  ProductPrices: ResolverTypeWrapper<ProductPrices>;
  PriceRange: ResolverTypeWrapper<PriceRange>;
  ProductPrice: ResolverTypeWrapper<ProductPrice>;
  ProductDiscount: ResolverTypeWrapper<ProductDiscount>;
  ProductLinks: ResolverTypeWrapper<ProductLinks>;
  ProductLinksInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ProductLinksInterface']>;
  ProductInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ProductInterface']>;
  PhysicalProductInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PhysicalProductInterface']>;
  CustomizableAreaOption: ResolverTypeWrapper<CustomizableAreaOption>;
  CustomizableAreaValue: ResolverTypeWrapper<CustomizableAreaValue>;
  CategoryTree: ResolverTypeWrapper<CategoryTree>;
  CategoryResult: ResolverTypeWrapper<CategoryResult>;
  CustomizableDateOption: ResolverTypeWrapper<CustomizableDateOption>;
  CustomizableDateValue: ResolverTypeWrapper<CustomizableDateValue>;
  CustomizableDropDownOption: ResolverTypeWrapper<CustomizableDropDownOption>;
  CustomizableDropDownValue: ResolverTypeWrapper<CustomizableDropDownValue>;
  CustomizableMultipleOption: ResolverTypeWrapper<CustomizableMultipleOption>;
  CustomizableMultipleValue: ResolverTypeWrapper<CustomizableMultipleValue>;
  CustomizableFieldOption: ResolverTypeWrapper<CustomizableFieldOption>;
  CustomizableFieldValue: ResolverTypeWrapper<CustomizableFieldValue>;
  CustomizableFileOption: ResolverTypeWrapper<CustomizableFileOption>;
  CustomizableFileValue: ResolverTypeWrapper<CustomizableFileValue>;
  MediaGalleryInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['MediaGalleryInterface']>;
  ProductImage: ResolverTypeWrapper<ProductImage>;
  ProductVideo: ResolverTypeWrapper<ProductVideo>;
  CustomizableOptionInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CustomizableOptionInterface']>;
  CustomizableProductInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CustomizableProductInterface']>;
  CategoryInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CategoryInterface']>;
  Breadcrumb: ResolverTypeWrapper<Breadcrumb>;
  CustomizableRadioOption: ResolverTypeWrapper<CustomizableRadioOption>;
  CustomizableRadioValue: ResolverTypeWrapper<CustomizableRadioValue>;
  CustomizableCheckboxOption: ResolverTypeWrapper<CustomizableCheckboxOption>;
  CustomizableCheckboxValue: ResolverTypeWrapper<CustomizableCheckboxValue>;
  VirtualProduct: ResolverTypeWrapper<VirtualProduct>;
  SimpleProduct: ResolverTypeWrapper<SimpleProduct>;
  Products: ResolverTypeWrapper<Products>;
  AggregationsFilterInput: AggregationsFilterInput;
  AggregationsCategoryFilterInput: AggregationsCategoryFilterInput;
  CategoryProducts: ResolverTypeWrapper<CategoryProducts>;
  ProductAttributeFilterInput: ProductAttributeFilterInput;
  CategoryFilterInput: CategoryFilterInput;
  ProductFilterInput: ProductFilterInput;
  ProductMediaGalleryEntriesContent: ResolverTypeWrapper<ProductMediaGalleryEntriesContent>;
  ProductMediaGalleryEntriesVideoContent: ResolverTypeWrapper<ProductMediaGalleryEntriesVideoContent>;
  ProductSortInput: ProductSortInput;
  ProductAttributeSortInput: ProductAttributeSortInput;
  MediaGalleryEntry: ResolverTypeWrapper<MediaGalleryEntry>;
  LayerFilter: ResolverTypeWrapper<LayerFilter>;
  LayerFilterItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LayerFilterItemInterface']>;
  LayerFilterItem: ResolverTypeWrapper<LayerFilterItem>;
  Aggregation: ResolverTypeWrapper<Aggregation>;
  SearchSuggestion: ResolverTypeWrapper<SearchSuggestion>;
  AggregationOptionInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AggregationOptionInterface']>;
  AggregationOption: ResolverTypeWrapper<AggregationOption>;
  SortField: ResolverTypeWrapper<SortField>;
  SortFields: ResolverTypeWrapper<SortFields>;
  SimpleWishlistItem: ResolverTypeWrapper<SimpleWishlistItem>;
  VirtualWishlistItem: ResolverTypeWrapper<VirtualWishlistItem>;
  UrlRewriteEntityTypeEnum: UrlRewriteEntityTypeEnum;
  ComparableItem: ResolverTypeWrapper<ComparableItem>;
  ProductAttribute: ResolverTypeWrapper<ProductAttribute>;
  ComparableAttribute: ResolverTypeWrapper<ComparableAttribute>;
  CompareList: ResolverTypeWrapper<CompareList>;
  Customer: ResolverTypeWrapper<Customer>;
  CreateCompareListInput: CreateCompareListInput;
  AddProductsToCompareListInput: AddProductsToCompareListInput;
  RemoveProductsFromCompareListInput: RemoveProductsFromCompareListInput;
  DeleteCompareListOutput: ResolverTypeWrapper<DeleteCompareListOutput>;
  AssignCompareListToCustomerOutput: ResolverTypeWrapper<AssignCompareListToCustomerOutput>;
  createEmptyCartInput: createEmptyCartInput;
  AddSimpleProductsToCartInput: AddSimpleProductsToCartInput;
  SimpleProductCartItemInput: SimpleProductCartItemInput;
  AddVirtualProductsToCartInput: AddVirtualProductsToCartInput;
  VirtualProductCartItemInput: VirtualProductCartItemInput;
  CartItemInput: CartItemInput;
  CustomizableOptionInput: CustomizableOptionInput;
  ApplyCouponToCartInput: ApplyCouponToCartInput;
  UpdateCartItemsInput: UpdateCartItemsInput;
  CartItemUpdateInput: CartItemUpdateInput;
  RemoveItemFromCartInput: RemoveItemFromCartInput;
  SetShippingAddressesOnCartInput: SetShippingAddressesOnCartInput;
  ShippingAddressInput: ShippingAddressInput;
  SetBillingAddressOnCartInput: SetBillingAddressOnCartInput;
  BillingAddressInput: BillingAddressInput;
  CartAddressInput: CartAddressInput;
  SetShippingMethodsOnCartInput: SetShippingMethodsOnCartInput;
  ShippingMethodInput: ShippingMethodInput;
  SetPaymentMethodAndPlaceOrderInput: SetPaymentMethodAndPlaceOrderInput;
  PlaceOrderInput: PlaceOrderInput;
  SetPaymentMethodOnCartInput: SetPaymentMethodOnCartInput;
  PaymentMethodInput: PaymentMethodInput;
  SetGuestEmailOnCartInput: SetGuestEmailOnCartInput;
  CartPrices: ResolverTypeWrapper<CartPrices>;
  CartTaxItem: ResolverTypeWrapper<CartTaxItem>;
  CartDiscount: ResolverTypeWrapper<CartDiscount>;
  SetPaymentMethodOnCartOutput: ResolverTypeWrapper<SetPaymentMethodOnCartOutput>;
  SetBillingAddressOnCartOutput: ResolverTypeWrapper<SetBillingAddressOnCartOutput>;
  SetShippingAddressesOnCartOutput: ResolverTypeWrapper<SetShippingAddressesOnCartOutput>;
  SetShippingMethodsOnCartOutput: ResolverTypeWrapper<SetShippingMethodsOnCartOutput>;
  ApplyCouponToCartOutput: ResolverTypeWrapper<ApplyCouponToCartOutput>;
  PlaceOrderOutput: ResolverTypeWrapper<PlaceOrderOutput>;
  Cart: ResolverTypeWrapper<Cart>;
  CartAddressInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CartAddressInterface']>;
  ShippingCartAddress: ResolverTypeWrapper<ShippingCartAddress>;
  BillingCartAddress: ResolverTypeWrapper<BillingCartAddress>;
  CartItemQuantity: ResolverTypeWrapper<CartItemQuantity>;
  CartAddressRegion: ResolverTypeWrapper<CartAddressRegion>;
  CartAddressCountry: ResolverTypeWrapper<CartAddressCountry>;
  SelectedShippingMethod: ResolverTypeWrapper<SelectedShippingMethod>;
  AvailableShippingMethod: ResolverTypeWrapper<AvailableShippingMethod>;
  AvailablePaymentMethod: ResolverTypeWrapper<AvailablePaymentMethod>;
  SelectedPaymentMethod: ResolverTypeWrapper<SelectedPaymentMethod>;
  AppliedCoupon: ResolverTypeWrapper<AppliedCoupon>;
  RemoveCouponFromCartInput: RemoveCouponFromCartInput;
  RemoveCouponFromCartOutput: ResolverTypeWrapper<RemoveCouponFromCartOutput>;
  AddSimpleProductsToCartOutput: ResolverTypeWrapper<AddSimpleProductsToCartOutput>;
  AddVirtualProductsToCartOutput: ResolverTypeWrapper<AddVirtualProductsToCartOutput>;
  UpdateCartItemsOutput: ResolverTypeWrapper<UpdateCartItemsOutput>;
  RemoveItemFromCartOutput: ResolverTypeWrapper<RemoveItemFromCartOutput>;
  SetGuestEmailOnCartOutput: ResolverTypeWrapper<SetGuestEmailOnCartOutput>;
  SimpleCartItem: ResolverTypeWrapper<SimpleCartItem>;
  VirtualCartItem: ResolverTypeWrapper<VirtualCartItem>;
  CartItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CartItemInterface']>;
  CartItemError: ResolverTypeWrapper<CartItemError>;
  CartItemErrorType: CartItemErrorType;
  Discount: ResolverTypeWrapper<Discount>;
  CartItemPrices: ResolverTypeWrapper<CartItemPrices>;
  SelectedCustomizableOption: ResolverTypeWrapper<SelectedCustomizableOption>;
  SelectedCustomizableOptionValue: ResolverTypeWrapper<SelectedCustomizableOptionValue>;
  CartItemSelectedOptionValuePrice: ResolverTypeWrapper<CartItemSelectedOptionValuePrice>;
  Order: ResolverTypeWrapper<Order>;
  CartUserInputError: ResolverTypeWrapper<CartUserInputError>;
  AddProductsToCartOutput: ResolverTypeWrapper<AddProductsToCartOutput>;
  CartUserInputErrorType: CartUserInputErrorType;
  CustomerAddressInput: CustomerAddressInput;
  CustomerAddressRegionInput: CustomerAddressRegionInput;
  CustomerAddressAttributeInput: CustomerAddressAttributeInput;
  CustomerToken: ResolverTypeWrapper<CustomerToken>;
  CustomerInput: CustomerInput;
  CustomerCreateInput: CustomerCreateInput;
  CustomerUpdateInput: CustomerUpdateInput;
  CustomerOutput: ResolverTypeWrapper<CustomerOutput>;
  RevokeCustomerTokenOutput: ResolverTypeWrapper<RevokeCustomerTokenOutput>;
  CustomerAddress: ResolverTypeWrapper<CustomerAddress>;
  CustomerAddressRegion: ResolverTypeWrapper<CustomerAddressRegion>;
  CustomerAddressAttribute: ResolverTypeWrapper<CustomerAddressAttribute>;
  IsEmailAvailableOutput: ResolverTypeWrapper<IsEmailAvailableOutput>;
  CountryCodeEnum: CountryCodeEnum;
  Currency: ResolverTypeWrapper<Currency>;
  ExchangeRate: ResolverTypeWrapper<ExchangeRate>;
  Country: ResolverTypeWrapper<Country>;
  Region: ResolverTypeWrapper<Region>;
  AddDownloadableProductsToCartInput: AddDownloadableProductsToCartInput;
  DownloadableProductCartItemInput: DownloadableProductCartItemInput;
  DownloadableProductLinksInput: DownloadableProductLinksInput;
  AddDownloadableProductsToCartOutput: ResolverTypeWrapper<AddDownloadableProductsToCartOutput>;
  DownloadableCartItem: ResolverTypeWrapper<DownloadableCartItem>;
  DownloadableProduct: ResolverTypeWrapper<DownloadableProduct>;
  DownloadableFileTypeEnum: DownloadableFileTypeEnum;
  DownloadableProductLinks: ResolverTypeWrapper<DownloadableProductLinks>;
  DownloadableProductSamples: ResolverTypeWrapper<DownloadableProductSamples>;
  DownloadableOrderItem: ResolverTypeWrapper<DownloadableOrderItem>;
  DownloadableInvoiceItem: ResolverTypeWrapper<DownloadableInvoiceItem>;
  DownloadableCreditMemoItem: ResolverTypeWrapper<DownloadableCreditMemoItem>;
  DownloadableItemsLinks: ResolverTypeWrapper<DownloadableItemsLinks>;
  DownloadableWishlistItem: ResolverTypeWrapper<DownloadableWishlistItem>;
  CustomerDownloadableProducts: ResolverTypeWrapper<CustomerDownloadableProducts>;
  CustomerDownloadableProduct: ResolverTypeWrapper<CustomerDownloadableProduct>;
  ProductTierPrices: ResolverTypeWrapper<ProductTierPrices>;
  TierPrice: ResolverTypeWrapper<TierPrice>;
  ConfigurableCartItem: ResolverTypeWrapper<ConfigurableCartItem>;
  BundleCartItem: ResolverTypeWrapper<BundleCartItem>;
  GiftMessage: ResolverTypeWrapper<GiftMessage>;
  GiftMessageInput: GiftMessageInput;
  SalesItemInterface: ResolverTypeWrapper<SalesItemInterface>;
  CustomerOrder: ResolverTypeWrapper<CustomerOrder>;
  OrderItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['OrderItemInterface']>;
  AddBundleProductsToCartInput: AddBundleProductsToCartInput;
  BundleProductCartItemInput: BundleProductCartItemInput;
  BundleOptionInput: BundleOptionInput;
  AddBundleProductsToCartOutput: ResolverTypeWrapper<AddBundleProductsToCartOutput>;
  SelectedBundleOption: ResolverTypeWrapper<SelectedBundleOption>;
  SelectedBundleOptionValue: ResolverTypeWrapper<SelectedBundleOptionValue>;
  BundleItem: ResolverTypeWrapper<BundleItem>;
  BundleItemOption: ResolverTypeWrapper<BundleItemOption>;
  BundleProduct: ResolverTypeWrapper<BundleProduct>;
  PriceViewEnum: PriceViewEnum;
  ShipBundleItemsEnum: ShipBundleItemsEnum;
  BundleOrderItem: ResolverTypeWrapper<BundleOrderItem>;
  BundleInvoiceItem: ResolverTypeWrapper<BundleInvoiceItem>;
  BundleShipmentItem: ResolverTypeWrapper<BundleShipmentItem>;
  BundleCreditMemoItem: ResolverTypeWrapper<BundleCreditMemoItem>;
  ItemSelectedBundleOption: ResolverTypeWrapper<ItemSelectedBundleOption>;
  ItemSelectedBundleOptionValue: ResolverTypeWrapper<ItemSelectedBundleOptionValue>;
  BundleWishlistItem: ResolverTypeWrapper<BundleWishlistItem>;
  GroupedProduct: ResolverTypeWrapper<GroupedProduct>;
  GroupedProductItem: ResolverTypeWrapper<GroupedProductItem>;
  GroupedProductWishlistItem: ResolverTypeWrapper<GroupedProductWishlistItem>;
  ConfigurableProduct: ResolverTypeWrapper<ConfigurableProduct>;
  ConfigurableVariant: ResolverTypeWrapper<ConfigurableVariant>;
  ConfigurableAttributeOption: ResolverTypeWrapper<ConfigurableAttributeOption>;
  ConfigurableProductOptions: ResolverTypeWrapper<ConfigurableProductOptions>;
  ConfigurableProductOptionsValues: ResolverTypeWrapper<ConfigurableProductOptionsValues>;
  AddConfigurableProductsToCartInput: AddConfigurableProductsToCartInput;
  AddConfigurableProductsToCartOutput: ResolverTypeWrapper<AddConfigurableProductsToCartOutput>;
  ConfigurableProductCartItemInput: ConfigurableProductCartItemInput;
  SelectedConfigurableOption: ResolverTypeWrapper<SelectedConfigurableOption>;
  ConfigurableWishlistItem: ResolverTypeWrapper<ConfigurableWishlistItem>;
  ConfigurableProductOptionsSelection: ResolverTypeWrapper<ConfigurableProductOptionsSelection>;
  ConfigurableOptionAvailableForSelection: ResolverTypeWrapper<ConfigurableOptionAvailableForSelection>;
  ConfigurableProductOption: ResolverTypeWrapper<ConfigurableProductOption>;
  ConfigurableProductOptionValue: ResolverTypeWrapper<ConfigurableProductOptionValue>;
  AreaInput: AreaInput;
  PickupLocationFilterInput: PickupLocationFilterInput;
  PickupLocationSortInput: PickupLocationSortInput;
  PickupLocations: ResolverTypeWrapper<PickupLocations>;
  PickupLocation: ResolverTypeWrapper<PickupLocation>;
  ProductInfoInput: ProductInfoInput;
  ProductStockStatus: ProductStockStatus;
  GenerateCustomerTokenAsAdminInput: GenerateCustomerTokenAsAdminInput;
  GenerateCustomerTokenAsAdminOutput: ResolverTypeWrapper<GenerateCustomerTokenAsAdminOutput>;
  SubscribeEmailToNewsletterOutput: ResolverTypeWrapper<SubscribeEmailToNewsletterOutput>;
  SubscriptionStatusesEnum: SubscriptionStatusesEnum;
  PaypalExpressTokenInput: PaypalExpressTokenInput;
  PaypalExpressToken: ResolverTypeWrapper<PaypalExpressToken>;
  PaypalExpressTokenOutput: ResolverTypeWrapper<PaypalExpressTokenOutput>;
  PayflowLinkToken: ResolverTypeWrapper<PayflowLinkToken>;
  HostedProUrl: ResolverTypeWrapper<HostedProUrl>;
  HostedProUrlInput: HostedProUrlInput;
  HostedProInput: HostedProInput;
  PaypalExpressInput: PaypalExpressInput;
  PayflowExpressInput: PayflowExpressInput;
  PaypalExpressUrlsInput: PaypalExpressUrlsInput;
  PaypalExpressUrlList: ResolverTypeWrapper<PaypalExpressUrlList>;
  PayflowLinkInput: PayflowLinkInput;
  PayflowLinkTokenInput: PayflowLinkTokenInput;
  PayflowLinkMode: PayflowLinkMode;
  PayflowProTokenInput: PayflowProTokenInput;
  PayflowProInput: PayflowProInput;
  CreditCardDetailsInput: CreditCardDetailsInput;
  PayflowProUrlInput: PayflowProUrlInput;
  PayflowProToken: ResolverTypeWrapper<PayflowProToken>;
  CreatePayflowProTokenOutput: ResolverTypeWrapper<CreatePayflowProTokenOutput>;
  PayflowProResponseInput: PayflowProResponseInput;
  PayflowProResponseOutput: ResolverTypeWrapper<PayflowProResponseOutput>;
  VaultTokenInput: VaultTokenInput;
  ProductReviews: ResolverTypeWrapper<ProductReviews>;
  ProductReview: ResolverTypeWrapper<ProductReview>;
  ProductReviewRating: ResolverTypeWrapper<ProductReviewRating>;
  ProductReviewRatingsMetadata: ResolverTypeWrapper<ProductReviewRatingsMetadata>;
  ProductReviewRatingMetadata: ResolverTypeWrapper<ProductReviewRatingMetadata>;
  ProductReviewRatingValueMetadata: ResolverTypeWrapper<ProductReviewRatingValueMetadata>;
  CreateProductReviewOutput: ResolverTypeWrapper<CreateProductReviewOutput>;
  CreateProductReviewInput: CreateProductReviewInput;
  ProductReviewRatingInput: ProductReviewRatingInput;
  ReorderItemsOutput: ResolverTypeWrapper<ReorderItemsOutput>;
  CheckoutUserInputError: ResolverTypeWrapper<CheckoutUserInputError>;
  CustomerOrdersFilterInput: CustomerOrdersFilterInput;
  CustomerOrderSortInput: CustomerOrderSortInput;
  CustomerOrderSortableField: CustomerOrderSortableField;
  CustomerOrders: ResolverTypeWrapper<CustomerOrders>;
  OrderAddress: ResolverTypeWrapper<OrderAddress>;
  OrderItem: ResolverTypeWrapper<OrderItem>;
  OrderItemOption: ResolverTypeWrapper<OrderItemOption>;
  TaxItem: ResolverTypeWrapper<TaxItem>;
  OrderTotal: ResolverTypeWrapper<OrderTotal>;
  Invoice: ResolverTypeWrapper<Invoice>;
  InvoiceItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['InvoiceItemInterface']>;
  InvoiceItem: ResolverTypeWrapper<InvoiceItem>;
  InvoiceTotal: ResolverTypeWrapper<InvoiceTotal>;
  ShippingHandling: ResolverTypeWrapper<ShippingHandling>;
  ShippingDiscount: ResolverTypeWrapper<ShippingDiscount>;
  OrderShipment: ResolverTypeWrapper<OrderShipment>;
  SalesCommentItem: ResolverTypeWrapper<SalesCommentItem>;
  ShipmentItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ShipmentItemInterface']>;
  ShipmentItem: ResolverTypeWrapper<ShipmentItem>;
  ShipmentTracking: ResolverTypeWrapper<ShipmentTracking>;
  OrderPaymentMethod: ResolverTypeWrapper<OrderPaymentMethod>;
  CreditMemo: ResolverTypeWrapper<CreditMemo>;
  CreditMemoItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['CreditMemoItemInterface']>;
  CreditMemoItem: ResolverTypeWrapper<CreditMemoItem>;
  CreditMemoTotal: ResolverTypeWrapper<CreditMemoTotal>;
  KeyValue: ResolverTypeWrapper<KeyValue>;
  CheckoutUserInputErrorCodes: CheckoutUserInputErrorCodes;
  ScopeTypeEnum: ScopeTypeEnum;
  EntityUrl: ResolverTypeWrapper<EntityUrl>;
  UrlRewrite: ResolverTypeWrapper<UrlRewrite>;
  HttpQueryParameter: ResolverTypeWrapper<HttpQueryParameter>;
  RoutableInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['RoutableInterface']>;
  SendEmailToFriendInput: SendEmailToFriendInput;
  SendEmailToFriendSenderInput: SendEmailToFriendSenderInput;
  SendEmailToFriendRecipientInput: SendEmailToFriendRecipientInput;
  SendEmailToFriendOutput: ResolverTypeWrapper<SendEmailToFriendOutput>;
  SendEmailToFriendSender: ResolverTypeWrapper<SendEmailToFriendSender>;
  SendEmailToFriendRecipient: ResolverTypeWrapper<SendEmailToFriendRecipient>;
  SendFriendConfiguration: ResolverTypeWrapper<SendFriendConfiguration>;
  SwatchLayerFilterItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SwatchLayerFilterItemInterface']>;
  SwatchLayerFilterItem: ResolverTypeWrapper<SwatchLayerFilterItem>;
  SwatchData: ResolverTypeWrapper<SwatchData>;
  SwatchDataInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['SwatchDataInterface']>;
  ImageSwatchData: ResolverTypeWrapper<ImageSwatchData>;
  TextSwatchData: ResolverTypeWrapper<TextSwatchData>;
  ColorSwatchData: ResolverTypeWrapper<ColorSwatchData>;
  DeletePaymentTokenOutput: ResolverTypeWrapper<DeletePaymentTokenOutput>;
  CustomerPaymentTokens: ResolverTypeWrapper<CustomerPaymentTokens>;
  PaymentToken: ResolverTypeWrapper<PaymentToken>;
  PaymentTokenTypeEnum: PaymentTokenTypeEnum;
  FixedProductTax: ResolverTypeWrapper<FixedProductTax>;
  FixedProductTaxDisplaySettings: FixedProductTaxDisplaySettings;
  WishlistOutput: ResolverTypeWrapper<WishlistOutput>;
  Wishlist: ResolverTypeWrapper<Wishlist>;
  WishlistItemInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['WishlistItemInterface']>;
  WishlistItems: ResolverTypeWrapper<WishlistItems>;
  WishlistItem: ResolverTypeWrapper<WishlistItem>;
  AddWishlistItemsToCartOutput: ResolverTypeWrapper<AddWishlistItemsToCartOutput>;
  WishlistCartUserInputError: ResolverTypeWrapper<WishlistCartUserInputError>;
  WishlistCartUserInputErrorType: WishlistCartUserInputErrorType;
  WishlistItemInput: WishlistItemInput;
  AddProductsToWishlistOutput: ResolverTypeWrapper<AddProductsToWishlistOutput>;
  RemoveProductsFromWishlistOutput: ResolverTypeWrapper<RemoveProductsFromWishlistOutput>;
  WishlistItemUpdateInput: WishlistItemUpdateInput;
  UpdateProductsInWishlistOutput: ResolverTypeWrapper<UpdateProductsInWishlistOutput>;
  WishListUserInputError: ResolverTypeWrapper<WishListUserInputError>;
  WishListUserInputErrorType: WishListUserInputErrorType;
  AmFaqCategoryFilterInput: AmFaqCategoryFilterInput;
  AmFaqQuestionFilterInput: AmFaqQuestionFilterInput;
  AmFaqCategorySortInput: AmFaqCategorySortInput;
  AmFaqQuestionSortInput: AmFaqQuestionSortInput;
  PlaceAmFaqQuestionInput: PlaceAmFaqQuestionInput;
  RateAmFaqQuestionInput: RateAmFaqQuestionInput;
  AmFaqCategoriesSearch: ResolverTypeWrapper<AmFaqCategoriesSearch>;
  AmFaqQuestionsSearch: ResolverTypeWrapper<AmFaqQuestionsSearch>;
  AmFaqSettings: ResolverTypeWrapper<AmFaqSettings>;
  AmFaqSocialButton: ResolverTypeWrapper<AmFaqSocialButton>;
  AmFaqQuestion: ResolverTypeWrapper<AmFaqQuestion>;
  AmFaqCategory: ResolverTypeWrapper<AmFaqCategory>;
  AmFaqCommonOutput: ResolverTypeWrapper<AmFaqCommonOutput>;
  AmFaqVoteTypeEnum: AmFaqVoteTypeEnum;
  AmMostviewedBundlePacks: ResolverTypeWrapper<AmMostviewedBundlePacks>;
  AmMostviewedBundlePack: ResolverTypeWrapper<AmMostviewedBundlePack>;
  AmMostviewedBundleItem: ResolverTypeWrapper<AmMostviewedBundleItem>;
  AmMostviewedRelated: ResolverTypeWrapper<AmMostviewedRelated>;
  AmMostviewedRelatedRules: ResolverTypeWrapper<AmMostviewedRelatedRules>;
  AmProductAttachmentSettings: ResolverTypeWrapper<AmProductAttachmentSettings>;
  AmFile: ResolverTypeWrapper<AmFile>;
  AmSocialLoginButton: ResolverTypeWrapper<AmSocialLoginButton>;
  AmLinkedSocialAccounts: ResolverTypeWrapper<AmLinkedSocialAccounts>;
  AmUnlinkData: ResolverTypeWrapper<AmUnlinkData>;
  SortingOrder: ResolverTypeWrapper<SortingOrder>;
  ProductData: ResolverTypeWrapper<ProductData>;
  PageTypeEnum: PageTypeEnum;
  RevokeSubUserTokenOutput: ResolverTypeWrapper<RevokeSubUserTokenOutput>;
  SubUserToken: ResolverTypeWrapper<SubUserToken>;
  SubRoleInput: SubRoleInput;
  SubUsers: SubUsers;
  SubUserForEdit: SubUserForEdit;
  SubUserResetPass: SubUserResetPass;
  SubUserRequestResetPass: SubUserRequestResetPass;
  SubUserChangePass: SubUserChangePass;
  SalesRepUser: ResolverTypeWrapper<SalesRepUser>;
  SubUser: ResolverTypeWrapper<SubUser>;
  SubRole: ResolverTypeWrapper<SubRole>;
  MpFilters: MpFilters;
  SmtpBestsellersOutput: ResolverTypeWrapper<SmtpBestsellersOutput>;
  BestsellersProductOutput: ResolverTypeWrapper<BestsellersProductOutput>;
  BraintreeInput: BraintreeInput;
  BraintreeCcVaultInput: BraintreeCcVaultInput;
  ArtworkInterface: ResolverTypeWrapper<ArtworkInterface>;
  PROOFING_OPTION: PROOFING_OPTION;
  GenericError: ResolverTypeWrapper<GenericError>;
  AttachArtworkOutput: ResolverTypeWrapper<AttachArtworkOutput>;
  DetachArtworkOutput: ResolverTypeWrapper<DetachArtworkOutput>;
  Source: ResolverTypeWrapper<Source>;
  PriceBreak: ResolverTypeWrapper<PriceBreak>;
  Color: ResolverTypeWrapper<Color>;
  AttachProjectDataOutput: ResolverTypeWrapper<AttachProjectDataOutput>;
  ProofStatus: ProofStatus;
  ProofInterface: ResolverTypeWrapper<ProofInterface>;
  GenericProofOutput: ResolverTypeWrapper<GenericProofOutput>;
  CartItemsBySource: ResolverTypeWrapper<CartItemsBySource>;
  SignedCommandUrlOutput: ResolverTypeWrapper<SignedCommandUrlOutput>;
  FourOverItemQuantity: ResolverTypeWrapper<FourOverItemQuantity>;
  Update4OverItemQuantityOutput: ResolverTypeWrapper<Update4OverItemQuantityOutput>;
  Update4OverItemQuantityInput: Update4OverItemQuantityInput;
  ArtworkRequirement: ResolverTypeWrapper<ArtworkRequirement>;
  FourOverFile: FourOverFile;
  ArtworkPreflightResponse: ResolverTypeWrapper<ArtworkPreflightResponse>;
  ArtworkPreflightFile: ResolverTypeWrapper<ArtworkPreflightFile>;
  ArtworkPreflightFileMessage: ResolverTypeWrapper<ArtworkPreflightFileMessage>;
  OptionFourOverData: ResolverTypeWrapper<OptionFourOverData>;
  OptionFourOverDataConditions: ResolverTypeWrapper<OptionFourOverDataConditions>;
  FourOverCustomOptionModifier: ResolverTypeWrapper<FourOverCustomOptionModifier>;
  DeliveryDateRange: ResolverTypeWrapper<DeliveryDateRange>;
  DeliveryDateRangeInput: DeliveryDateRangeInput;
  GenerateCustomerTokenBySecretInput: GenerateCustomerTokenBySecretInput;
  GenerateCustomerTokenBySecretOutput: ResolverTypeWrapper<GenerateCustomerTokenBySecretOutput>;
  NewsletterCustomFieldsInput: NewsletterCustomFieldsInput;
  SetCustomerNoteToCartInput: SetCustomerNoteToCartInput;
  ReorderItemInput: ReorderItemInput;
  ReorderItemOutput: ResolverTypeWrapper<ReorderItemOutput>;
  ReorderFailedItem: ResolverTypeWrapper<ReorderFailedItem>;
  SetupFee: ResolverTypeWrapper<SetupFee>;
  Aggregate: ResolverTypeWrapper<Aggregate>;
  Asset: ResolverTypeWrapper<Asset>;
  AssetSingleRelationWhereInput: AssetSingleRelationWhereInput;
  AssetTransformationInput: AssetTransformationInput;
  AssetUpload: ResolverTypeWrapper<AssetUpload>;
  AssetUploadError: ResolverTypeWrapper<AssetUploadError>;
  AssetUploadRequestPostData: ResolverTypeWrapper<AssetUploadRequestPostData>;
  AssetUploadStatus: AssetUploadStatus;
  AssetUploadWhereInput: AssetUploadWhereInput;
  AssetWhereInput: AssetWhereInput;
  Banner: ResolverTypeWrapper<Banner>;
  BannerOrderByInput: BannerOrderByInput;
  BannerWhereInput: BannerWhereInput;
  Brand: ResolverTypeWrapper<Brand>;
  BrandOrderByInput: BrandOrderByInput;
  BrandWhereInput: BrandWhereInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DocumentFileTypes: DocumentFileTypes;
  DocumentOutputInput: DocumentOutputInput;
  DocumentTransformationInput: DocumentTransformationInput;
  Entity: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Entity']>;
  EntityTypeName: EntityTypeName;
  EntityWhereInput: EntityWhereInput;
  Footer: ResolverTypeWrapper<Footer>;
  FooterConnection: ResolverTypeWrapper<FooterConnection>;
  FooterEdge: ResolverTypeWrapper<FooterEdge>;
  FooterImageLink: ResolverTypeWrapper<FooterImageLink>;
  FooterImageLinkOrderByInput: FooterImageLinkOrderByInput;
  FooterImageLinkWhereInput: FooterImageLinkWhereInput;
  FooterLink: ResolverTypeWrapper<FooterLink>;
  FooterLinkOrderByInput: FooterLinkOrderByInput;
  FooterLinkWhereInput: FooterLinkWhereInput;
  FooterOrderByInput: FooterOrderByInput;
  FooterWhereInput: FooterWhereInput;
  FooterWhereUniqueInput: FooterWhereUniqueInput;
  Image: ResolverTypeWrapper<Image>;
  ImageBlurInput: ImageBlurInput;
  ImageBorderInput: ImageBorderInput;
  ImageCompressInput: ImageCompressInput;
  ImageCropInput: ImageCropInput;
  ImageFit: ImageFit;
  ImageOrderByInput: ImageOrderByInput;
  ImageQualityInput: ImageQualityInput;
  ImageResizeInput: ImageResizeInput;
  ImageSharpenInput: ImageSharpenInput;
  ImageTransformationInput: ImageTransformationInput;
  ImageWhereInput: ImageWhereInput;
  Json: ResolverTypeWrapper<Scalars['Json']['output']>;
  LabelAndContent: ResolverTypeWrapper<LabelAndContent>;
  LabelAndContentOrderByInput: LabelAndContentOrderByInput;
  LabelAndContentWhereInput: LabelAndContentWhereInput;
  Locale: Locale;
  MetaRobots: MetaRobots;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  OrderStep: ResolverTypeWrapper<OrderStep>;
  OrderStepOrderByInput: OrderStepOrderByInput;
  OrderStepWhereInput: OrderStepWhereInput;
  Page: ResolverTypeWrapper<Omit<Page, 'content'> & { content: Array<ResolversTypes['PageContent']> }>;
  PageConnection: ResolverTypeWrapper<PageConnection>;
  PageContent: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PageContent']>;
  PageContentWhereInput: PageContentWhereInput;
  PageEdge: ResolverTypeWrapper<PageEdge>;
  PageFooter: ResolverTypeWrapper<PageFooter>;
  PageFooterConnection: ResolverTypeWrapper<PageFooterConnection>;
  PageFooterEdge: ResolverTypeWrapper<PageFooterEdge>;
  PageFooterOrderByInput: PageFooterOrderByInput;
  PageFooterWhereInput: PageFooterWhereInput;
  PageFooterWhereUniqueInput: PageFooterWhereUniqueInput;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PageLink: ResolverTypeWrapper<PageLink>;
  PageLinkConnection: ResolverTypeWrapper<PageLinkConnection>;
  PageLinkEdge: ResolverTypeWrapper<PageLinkEdge>;
  PageLinkOrderByInput: PageLinkOrderByInput;
  PageLinkWhereInput: PageLinkWhereInput;
  PageLinkWhereUniqueInput: PageLinkWhereUniqueInput;
  PageOrderByInput: PageOrderByInput;
  PageWhereInput: PageWhereInput;
  PageWhereUniqueInput: PageWhereUniqueInput;
  ProductCategory: ResolverTypeWrapper<ProductCategory>;
  ProductCategoryOrderByInput: ProductCategoryOrderByInput;
  ProductCategoryWhereInput: ProductCategoryWhereInput;
  ProductSideInfo: ResolverTypeWrapper<ProductSideInfo>;
  ProductSideInfoConnection: ResolverTypeWrapper<ProductSideInfoConnection>;
  ProductSideInfoEdge: ResolverTypeWrapper<ProductSideInfoEdge>;
  ProductSideInfoOrderByInput: ProductSideInfoOrderByInput;
  ProductSideInfoWhereInput: ProductSideInfoWhereInput;
  ProductSideInfoWhereUniqueInput: ProductSideInfoWhereUniqueInput;
  ProductThingsToKnow: ResolverTypeWrapper<ProductThingsToKnow>;
  ProductThingsToKnowConnection: ResolverTypeWrapper<ProductThingsToKnowConnection>;
  ProductThingsToKnowEdge: ResolverTypeWrapper<ProductThingsToKnowEdge>;
  ProductThingsToKnowOrderByInput: ProductThingsToKnowOrderByInput;
  ProductThingsToKnowWhereInput: ProductThingsToKnowWhereInput;
  ProductThingsToKnowWhereUniqueInput: ProductThingsToKnowWhereUniqueInput;
  ReviewItem: ResolverTypeWrapper<ReviewItem>;
  ReviewItemOrderByInput: ReviewItemOrderByInput;
  ReviewItemWhereInput: ReviewItemWhereInput;
  RichText: ResolverTypeWrapper<RichText>;
  RichTextAST: ResolverTypeWrapper<Scalars['RichTextAST']['output']>;
  RowBlogContent: ResolverTypeWrapper<RowBlogContent>;
  RowBlogContentConnection: ResolverTypeWrapper<RowBlogContentConnection>;
  RowBlogContentEdge: ResolverTypeWrapper<RowBlogContentEdge>;
  RowBlogContentOrderByInput: RowBlogContentOrderByInput;
  RowBlogContentWhereInput: RowBlogContentWhereInput;
  RowBlogContentWhereUniqueInput: RowBlogContentWhereUniqueInput;
  RowBrandsBanner: ResolverTypeWrapper<RowBrandsBanner>;
  RowBrandsBannerConnection: ResolverTypeWrapper<RowBrandsBannerConnection>;
  RowBrandsBannerEdge: ResolverTypeWrapper<RowBrandsBannerEdge>;
  RowBrandsBannerOrderByInput: RowBrandsBannerOrderByInput;
  RowBrandsBannerWhereInput: RowBrandsBannerWhereInput;
  RowBrandsBannerWhereUniqueInput: RowBrandsBannerWhereUniqueInput;
  RowFeaturedCategory: ResolverTypeWrapper<RowFeaturedCategory>;
  RowFeaturedCategoryConnection: ResolverTypeWrapper<RowFeaturedCategoryConnection>;
  RowFeaturedCategoryEdge: ResolverTypeWrapper<RowFeaturedCategoryEdge>;
  RowFeaturedCategoryOrderByInput: RowFeaturedCategoryOrderByInput;
  RowFeaturedCategoryWhereInput: RowFeaturedCategoryWhereInput;
  RowFeaturedCategoryWhereUniqueInput: RowFeaturedCategoryWhereUniqueInput;
  RowHeroBanner: ResolverTypeWrapper<RowHeroBanner>;
  RowHeroBannerConnection: ResolverTypeWrapper<RowHeroBannerConnection>;
  RowHeroBannerEdge: ResolverTypeWrapper<RowHeroBannerEdge>;
  RowHeroBannerOrderByInput: RowHeroBannerOrderByInput;
  RowHeroBannerWhereInput: RowHeroBannerWhereInput;
  RowHeroBannerWhereUniqueInput: RowHeroBannerWhereUniqueInput;
  RowLinks: ResolverTypeWrapper<RowLinks>;
  RowLinksConnection: ResolverTypeWrapper<RowLinksConnection>;
  RowLinksEdge: ResolverTypeWrapper<RowLinksEdge>;
  RowLinksOrderByInput: RowLinksOrderByInput;
  RowLinksVariants: RowLinksVariants;
  RowLinksWhereInput: RowLinksWhereInput;
  RowLinksWhereUniqueInput: RowLinksWhereUniqueInput;
  RowOrderProcess: ResolverTypeWrapper<RowOrderProcess>;
  RowOrderProcessConnection: ResolverTypeWrapper<RowOrderProcessConnection>;
  RowOrderProcessEdge: ResolverTypeWrapper<RowOrderProcessEdge>;
  RowOrderProcessOrderByInput: RowOrderProcessOrderByInput;
  RowOrderProcessWhereInput: RowOrderProcessWhereInput;
  RowOrderProcessWhereUniqueInput: RowOrderProcessWhereUniqueInput;
  RowParagraph: ResolverTypeWrapper<RowParagraph>;
  RowParagraphConnection: ResolverTypeWrapper<RowParagraphConnection>;
  RowParagraphEdge: ResolverTypeWrapper<RowParagraphEdge>;
  RowParagraphOrderByInput: RowParagraphOrderByInput;
  RowParagraphWhereInput: RowParagraphWhereInput;
  RowParagraphWhereUniqueInput: RowParagraphWhereUniqueInput;
  RowProduct: ResolverTypeWrapper<RowProduct>;
  RowProductConnection: ResolverTypeWrapper<RowProductConnection>;
  RowProductEdge: ResolverTypeWrapper<RowProductEdge>;
  RowProductHighlight: ResolverTypeWrapper<RowProductHighlight>;
  RowProductHighlightConnection: ResolverTypeWrapper<RowProductHighlightConnection>;
  RowProductHighlightEdge: ResolverTypeWrapper<RowProductHighlightEdge>;
  RowProductHighlightOrderByInput: RowProductHighlightOrderByInput;
  RowProductHighlightWhereInput: RowProductHighlightWhereInput;
  RowProductHighlightWhereUniqueInput: RowProductHighlightWhereUniqueInput;
  RowProductOrderByInput: RowProductOrderByInput;
  RowProductVariants: RowProductVariants;
  RowProductWhereInput: RowProductWhereInput;
  RowProductWhereUniqueInput: RowProductWhereUniqueInput;
  RowReviewHighlight: ResolverTypeWrapper<RowReviewHighlight>;
  RowReviewHighlightConnection: ResolverTypeWrapper<RowReviewHighlightConnection>;
  RowReviewHighlightEdge: ResolverTypeWrapper<RowReviewHighlightEdge>;
  RowReviewHighlightOrderByInput: RowReviewHighlightOrderByInput;
  RowReviewHighlightWhereInput: RowReviewHighlightWhereInput;
  RowReviewHighlightWhereUniqueInput: RowReviewHighlightWhereUniqueInput;
  RowServiceOptions: ResolverTypeWrapper<RowServiceOptions>;
  RowServiceOptionsConnection: ResolverTypeWrapper<RowServiceOptionsConnection>;
  RowServiceOptionsEdge: ResolverTypeWrapper<RowServiceOptionsEdge>;
  RowServiceOptionsOrderByInput: RowServiceOptionsOrderByInput;
  RowServiceOptionsWhereInput: RowServiceOptionsWhereInput;
  RowServiceOptionsWhereUniqueInput: RowServiceOptionsWhereUniqueInput;
  RowServicePageContent: ResolverTypeWrapper<RowServicePageContent>;
  RowServicePageContentConnection: ResolverTypeWrapper<RowServicePageContentConnection>;
  RowServicePageContentEdge: ResolverTypeWrapper<RowServicePageContentEdge>;
  RowServicePageContentOrderByInput: RowServicePageContentOrderByInput;
  RowServicePageContentWhereInput: RowServicePageContentWhereInput;
  RowServicePageContentWhereUniqueInput: RowServicePageContentWhereUniqueInput;
  ScheduledOperation: ResolverTypeWrapper<Omit<ScheduledOperation, 'affectedDocuments'> & { affectedDocuments: Array<ResolversTypes['ScheduledOperationAffectedDocument']> }>;
  ScheduledOperationAffectedDocument: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ScheduledOperationAffectedDocument']>;
  ScheduledOperationOrderByInput: ScheduledOperationOrderByInput;
  ScheduledOperationStatus: ScheduledOperationStatus;
  ScheduledOperationWhereInput: ScheduledOperationWhereInput;
  ScheduledRelease: ResolverTypeWrapper<ScheduledRelease>;
  ScheduledReleaseStatus: ScheduledReleaseStatus;
  ScheduledReleaseWhereInput: ScheduledReleaseWhereInput;
  Stage: Stage;
  User: ResolverTypeWrapper<User>;
  UserKind: UserKind;
  Usps: ResolverTypeWrapper<Usps>;
  UspsConnection: ResolverTypeWrapper<UspsConnection>;
  UspsEdge: ResolverTypeWrapper<UspsEdge>;
  UspsOrderByInput: UspsOrderByInput;
  UspsWhereInput: UspsWhereInput;
  UspsWhereUniqueInput: UspsWhereUniqueInput;
  GraphCommerceStorefrontConfig: GraphCommerceStorefrontConfig;
  GraphCommerceConfig: GraphCommerceConfig;
  CurrentCartId: ResolverTypeWrapper<CurrentCartId>;
  RegisterCartIdInput: RegisterCartIdInput;
  CompareVariant: CompareVariant;
  CurrentCompareUid: ResolverTypeWrapper<CurrentCompareUid>;
  ProductFiltersLayout: ProductFiltersLayout;
  GuestWishlist: ResolverTypeWrapper<GuestWishlist>;
  GuestWishlistItem: ResolverTypeWrapper<GuestWishlistItem>;
  GraphCommerceDebugConfig: GraphCommerceDebugConfig;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  Query: {};
  Mutation: {};
  String: Scalars['String']['output'];
  Boolean: Scalars['Boolean']['output'];
  Int: Scalars['Int']['output'];
  Float: Scalars['Float']['output'];
  ID: Scalars['ID']['output'];
  FilterTypeInput: FilterTypeInput;
  FilterEqualTypeInput: FilterEqualTypeInput;
  FilterRangeTypeInput: FilterRangeTypeInput;
  FilterMatchTypeInput: FilterMatchTypeInput;
  FilterStringTypeInput: FilterStringTypeInput;
  SearchResultPageInfo: SearchResultPageInfo;
  ComplexTextValue: ComplexTextValue;
  Money: Money;
  EnteredOptionInput: EnteredOptionInput;
  ErrorInterface: ResolversInterfaceTypes<ResolversParentTypes>['ErrorInterface'];
  NoSuchEntityUidError: NoSuchEntityUidError;
  InternalError: InternalError;
  StoreConfig: StoreConfig;
  CmsPage: CmsPage;
  CmsBlocks: CmsBlocks;
  CmsBlock: CmsBlock;
  CustomAttributeMetadata: CustomAttributeMetadata;
  Attribute: Attribute;
  StorefrontProperties: StorefrontProperties;
  AttributeOption: AttributeOption;
  AttributeInput: AttributeInput;
  Website: Website;
  CheckoutAgreement: CheckoutAgreement;
  Price: Price;
  PriceAdjustment: PriceAdjustment;
  ProductPrices: ProductPrices;
  PriceRange: PriceRange;
  ProductPrice: ProductPrice;
  ProductDiscount: ProductDiscount;
  ProductLinks: ProductLinks;
  ProductLinksInterface: ResolversInterfaceTypes<ResolversParentTypes>['ProductLinksInterface'];
  ProductInterface: ResolversInterfaceTypes<ResolversParentTypes>['ProductInterface'];
  PhysicalProductInterface: ResolversInterfaceTypes<ResolversParentTypes>['PhysicalProductInterface'];
  CustomizableAreaOption: CustomizableAreaOption;
  CustomizableAreaValue: CustomizableAreaValue;
  CategoryTree: CategoryTree;
  CategoryResult: CategoryResult;
  CustomizableDateOption: CustomizableDateOption;
  CustomizableDateValue: CustomizableDateValue;
  CustomizableDropDownOption: CustomizableDropDownOption;
  CustomizableDropDownValue: CustomizableDropDownValue;
  CustomizableMultipleOption: CustomizableMultipleOption;
  CustomizableMultipleValue: CustomizableMultipleValue;
  CustomizableFieldOption: CustomizableFieldOption;
  CustomizableFieldValue: CustomizableFieldValue;
  CustomizableFileOption: CustomizableFileOption;
  CustomizableFileValue: CustomizableFileValue;
  MediaGalleryInterface: ResolversInterfaceTypes<ResolversParentTypes>['MediaGalleryInterface'];
  ProductImage: ProductImage;
  ProductVideo: ProductVideo;
  CustomizableOptionInterface: ResolversInterfaceTypes<ResolversParentTypes>['CustomizableOptionInterface'];
  CustomizableProductInterface: ResolversInterfaceTypes<ResolversParentTypes>['CustomizableProductInterface'];
  CategoryInterface: ResolversInterfaceTypes<ResolversParentTypes>['CategoryInterface'];
  Breadcrumb: Breadcrumb;
  CustomizableRadioOption: CustomizableRadioOption;
  CustomizableRadioValue: CustomizableRadioValue;
  CustomizableCheckboxOption: CustomizableCheckboxOption;
  CustomizableCheckboxValue: CustomizableCheckboxValue;
  VirtualProduct: VirtualProduct;
  SimpleProduct: SimpleProduct;
  Products: Products;
  AggregationsFilterInput: AggregationsFilterInput;
  AggregationsCategoryFilterInput: AggregationsCategoryFilterInput;
  CategoryProducts: CategoryProducts;
  ProductAttributeFilterInput: ProductAttributeFilterInput;
  CategoryFilterInput: CategoryFilterInput;
  ProductFilterInput: ProductFilterInput;
  ProductMediaGalleryEntriesContent: ProductMediaGalleryEntriesContent;
  ProductMediaGalleryEntriesVideoContent: ProductMediaGalleryEntriesVideoContent;
  ProductSortInput: ProductSortInput;
  ProductAttributeSortInput: ProductAttributeSortInput;
  MediaGalleryEntry: MediaGalleryEntry;
  LayerFilter: LayerFilter;
  LayerFilterItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['LayerFilterItemInterface'];
  LayerFilterItem: LayerFilterItem;
  Aggregation: Aggregation;
  SearchSuggestion: SearchSuggestion;
  AggregationOptionInterface: ResolversInterfaceTypes<ResolversParentTypes>['AggregationOptionInterface'];
  AggregationOption: AggregationOption;
  SortField: SortField;
  SortFields: SortFields;
  SimpleWishlistItem: SimpleWishlistItem;
  VirtualWishlistItem: VirtualWishlistItem;
  ComparableItem: ComparableItem;
  ProductAttribute: ProductAttribute;
  ComparableAttribute: ComparableAttribute;
  CompareList: CompareList;
  Customer: Customer;
  CreateCompareListInput: CreateCompareListInput;
  AddProductsToCompareListInput: AddProductsToCompareListInput;
  RemoveProductsFromCompareListInput: RemoveProductsFromCompareListInput;
  DeleteCompareListOutput: DeleteCompareListOutput;
  AssignCompareListToCustomerOutput: AssignCompareListToCustomerOutput;
  createEmptyCartInput: createEmptyCartInput;
  AddSimpleProductsToCartInput: AddSimpleProductsToCartInput;
  SimpleProductCartItemInput: SimpleProductCartItemInput;
  AddVirtualProductsToCartInput: AddVirtualProductsToCartInput;
  VirtualProductCartItemInput: VirtualProductCartItemInput;
  CartItemInput: CartItemInput;
  CustomizableOptionInput: CustomizableOptionInput;
  ApplyCouponToCartInput: ApplyCouponToCartInput;
  UpdateCartItemsInput: UpdateCartItemsInput;
  CartItemUpdateInput: CartItemUpdateInput;
  RemoveItemFromCartInput: RemoveItemFromCartInput;
  SetShippingAddressesOnCartInput: SetShippingAddressesOnCartInput;
  ShippingAddressInput: ShippingAddressInput;
  SetBillingAddressOnCartInput: SetBillingAddressOnCartInput;
  BillingAddressInput: BillingAddressInput;
  CartAddressInput: CartAddressInput;
  SetShippingMethodsOnCartInput: SetShippingMethodsOnCartInput;
  ShippingMethodInput: ShippingMethodInput;
  SetPaymentMethodAndPlaceOrderInput: SetPaymentMethodAndPlaceOrderInput;
  PlaceOrderInput: PlaceOrderInput;
  SetPaymentMethodOnCartInput: SetPaymentMethodOnCartInput;
  PaymentMethodInput: PaymentMethodInput;
  SetGuestEmailOnCartInput: SetGuestEmailOnCartInput;
  CartPrices: CartPrices;
  CartTaxItem: CartTaxItem;
  CartDiscount: CartDiscount;
  SetPaymentMethodOnCartOutput: SetPaymentMethodOnCartOutput;
  SetBillingAddressOnCartOutput: SetBillingAddressOnCartOutput;
  SetShippingAddressesOnCartOutput: SetShippingAddressesOnCartOutput;
  SetShippingMethodsOnCartOutput: SetShippingMethodsOnCartOutput;
  ApplyCouponToCartOutput: ApplyCouponToCartOutput;
  PlaceOrderOutput: PlaceOrderOutput;
  Cart: Cart;
  CartAddressInterface: ResolversInterfaceTypes<ResolversParentTypes>['CartAddressInterface'];
  ShippingCartAddress: ShippingCartAddress;
  BillingCartAddress: BillingCartAddress;
  CartItemQuantity: CartItemQuantity;
  CartAddressRegion: CartAddressRegion;
  CartAddressCountry: CartAddressCountry;
  SelectedShippingMethod: SelectedShippingMethod;
  AvailableShippingMethod: AvailableShippingMethod;
  AvailablePaymentMethod: AvailablePaymentMethod;
  SelectedPaymentMethod: SelectedPaymentMethod;
  AppliedCoupon: AppliedCoupon;
  RemoveCouponFromCartInput: RemoveCouponFromCartInput;
  RemoveCouponFromCartOutput: RemoveCouponFromCartOutput;
  AddSimpleProductsToCartOutput: AddSimpleProductsToCartOutput;
  AddVirtualProductsToCartOutput: AddVirtualProductsToCartOutput;
  UpdateCartItemsOutput: UpdateCartItemsOutput;
  RemoveItemFromCartOutput: RemoveItemFromCartOutput;
  SetGuestEmailOnCartOutput: SetGuestEmailOnCartOutput;
  SimpleCartItem: SimpleCartItem;
  VirtualCartItem: VirtualCartItem;
  CartItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['CartItemInterface'];
  CartItemError: CartItemError;
  Discount: Discount;
  CartItemPrices: CartItemPrices;
  SelectedCustomizableOption: SelectedCustomizableOption;
  SelectedCustomizableOptionValue: SelectedCustomizableOptionValue;
  CartItemSelectedOptionValuePrice: CartItemSelectedOptionValuePrice;
  Order: Order;
  CartUserInputError: CartUserInputError;
  AddProductsToCartOutput: AddProductsToCartOutput;
  CustomerAddressInput: CustomerAddressInput;
  CustomerAddressRegionInput: CustomerAddressRegionInput;
  CustomerAddressAttributeInput: CustomerAddressAttributeInput;
  CustomerToken: CustomerToken;
  CustomerInput: CustomerInput;
  CustomerCreateInput: CustomerCreateInput;
  CustomerUpdateInput: CustomerUpdateInput;
  CustomerOutput: CustomerOutput;
  RevokeCustomerTokenOutput: RevokeCustomerTokenOutput;
  CustomerAddress: CustomerAddress;
  CustomerAddressRegion: CustomerAddressRegion;
  CustomerAddressAttribute: CustomerAddressAttribute;
  IsEmailAvailableOutput: IsEmailAvailableOutput;
  Currency: Currency;
  ExchangeRate: ExchangeRate;
  Country: Country;
  Region: Region;
  AddDownloadableProductsToCartInput: AddDownloadableProductsToCartInput;
  DownloadableProductCartItemInput: DownloadableProductCartItemInput;
  DownloadableProductLinksInput: DownloadableProductLinksInput;
  AddDownloadableProductsToCartOutput: AddDownloadableProductsToCartOutput;
  DownloadableCartItem: DownloadableCartItem;
  DownloadableProduct: DownloadableProduct;
  DownloadableProductLinks: DownloadableProductLinks;
  DownloadableProductSamples: DownloadableProductSamples;
  DownloadableOrderItem: DownloadableOrderItem;
  DownloadableInvoiceItem: DownloadableInvoiceItem;
  DownloadableCreditMemoItem: DownloadableCreditMemoItem;
  DownloadableItemsLinks: DownloadableItemsLinks;
  DownloadableWishlistItem: DownloadableWishlistItem;
  CustomerDownloadableProducts: CustomerDownloadableProducts;
  CustomerDownloadableProduct: CustomerDownloadableProduct;
  ProductTierPrices: ProductTierPrices;
  TierPrice: TierPrice;
  ConfigurableCartItem: ConfigurableCartItem;
  BundleCartItem: BundleCartItem;
  GiftMessage: GiftMessage;
  GiftMessageInput: GiftMessageInput;
  SalesItemInterface: SalesItemInterface;
  CustomerOrder: CustomerOrder;
  OrderItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['OrderItemInterface'];
  AddBundleProductsToCartInput: AddBundleProductsToCartInput;
  BundleProductCartItemInput: BundleProductCartItemInput;
  BundleOptionInput: BundleOptionInput;
  AddBundleProductsToCartOutput: AddBundleProductsToCartOutput;
  SelectedBundleOption: SelectedBundleOption;
  SelectedBundleOptionValue: SelectedBundleOptionValue;
  BundleItem: BundleItem;
  BundleItemOption: BundleItemOption;
  BundleProduct: BundleProduct;
  BundleOrderItem: BundleOrderItem;
  BundleInvoiceItem: BundleInvoiceItem;
  BundleShipmentItem: BundleShipmentItem;
  BundleCreditMemoItem: BundleCreditMemoItem;
  ItemSelectedBundleOption: ItemSelectedBundleOption;
  ItemSelectedBundleOptionValue: ItemSelectedBundleOptionValue;
  BundleWishlistItem: BundleWishlistItem;
  GroupedProduct: GroupedProduct;
  GroupedProductItem: GroupedProductItem;
  GroupedProductWishlistItem: GroupedProductWishlistItem;
  ConfigurableProduct: ConfigurableProduct;
  ConfigurableVariant: ConfigurableVariant;
  ConfigurableAttributeOption: ConfigurableAttributeOption;
  ConfigurableProductOptions: ConfigurableProductOptions;
  ConfigurableProductOptionsValues: ConfigurableProductOptionsValues;
  AddConfigurableProductsToCartInput: AddConfigurableProductsToCartInput;
  AddConfigurableProductsToCartOutput: AddConfigurableProductsToCartOutput;
  ConfigurableProductCartItemInput: ConfigurableProductCartItemInput;
  SelectedConfigurableOption: SelectedConfigurableOption;
  ConfigurableWishlistItem: ConfigurableWishlistItem;
  ConfigurableProductOptionsSelection: ConfigurableProductOptionsSelection;
  ConfigurableOptionAvailableForSelection: ConfigurableOptionAvailableForSelection;
  ConfigurableProductOption: ConfigurableProductOption;
  ConfigurableProductOptionValue: ConfigurableProductOptionValue;
  AreaInput: AreaInput;
  PickupLocationFilterInput: PickupLocationFilterInput;
  PickupLocationSortInput: PickupLocationSortInput;
  PickupLocations: PickupLocations;
  PickupLocation: PickupLocation;
  ProductInfoInput: ProductInfoInput;
  GenerateCustomerTokenAsAdminInput: GenerateCustomerTokenAsAdminInput;
  GenerateCustomerTokenAsAdminOutput: GenerateCustomerTokenAsAdminOutput;
  SubscribeEmailToNewsletterOutput: SubscribeEmailToNewsletterOutput;
  PaypalExpressTokenInput: PaypalExpressTokenInput;
  PaypalExpressToken: PaypalExpressToken;
  PaypalExpressTokenOutput: PaypalExpressTokenOutput;
  PayflowLinkToken: PayflowLinkToken;
  HostedProUrl: HostedProUrl;
  HostedProUrlInput: HostedProUrlInput;
  HostedProInput: HostedProInput;
  PaypalExpressInput: PaypalExpressInput;
  PayflowExpressInput: PayflowExpressInput;
  PaypalExpressUrlsInput: PaypalExpressUrlsInput;
  PaypalExpressUrlList: PaypalExpressUrlList;
  PayflowLinkInput: PayflowLinkInput;
  PayflowLinkTokenInput: PayflowLinkTokenInput;
  PayflowProTokenInput: PayflowProTokenInput;
  PayflowProInput: PayflowProInput;
  CreditCardDetailsInput: CreditCardDetailsInput;
  PayflowProUrlInput: PayflowProUrlInput;
  PayflowProToken: PayflowProToken;
  CreatePayflowProTokenOutput: CreatePayflowProTokenOutput;
  PayflowProResponseInput: PayflowProResponseInput;
  PayflowProResponseOutput: PayflowProResponseOutput;
  VaultTokenInput: VaultTokenInput;
  ProductReviews: ProductReviews;
  ProductReview: ProductReview;
  ProductReviewRating: ProductReviewRating;
  ProductReviewRatingsMetadata: ProductReviewRatingsMetadata;
  ProductReviewRatingMetadata: ProductReviewRatingMetadata;
  ProductReviewRatingValueMetadata: ProductReviewRatingValueMetadata;
  CreateProductReviewOutput: CreateProductReviewOutput;
  CreateProductReviewInput: CreateProductReviewInput;
  ProductReviewRatingInput: ProductReviewRatingInput;
  ReorderItemsOutput: ReorderItemsOutput;
  CheckoutUserInputError: CheckoutUserInputError;
  CustomerOrdersFilterInput: CustomerOrdersFilterInput;
  CustomerOrderSortInput: CustomerOrderSortInput;
  CustomerOrders: CustomerOrders;
  OrderAddress: OrderAddress;
  OrderItem: OrderItem;
  OrderItemOption: OrderItemOption;
  TaxItem: TaxItem;
  OrderTotal: OrderTotal;
  Invoice: Invoice;
  InvoiceItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['InvoiceItemInterface'];
  InvoiceItem: InvoiceItem;
  InvoiceTotal: InvoiceTotal;
  ShippingHandling: ShippingHandling;
  ShippingDiscount: ShippingDiscount;
  OrderShipment: OrderShipment;
  SalesCommentItem: SalesCommentItem;
  ShipmentItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['ShipmentItemInterface'];
  ShipmentItem: ShipmentItem;
  ShipmentTracking: ShipmentTracking;
  OrderPaymentMethod: OrderPaymentMethod;
  CreditMemo: CreditMemo;
  CreditMemoItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['CreditMemoItemInterface'];
  CreditMemoItem: CreditMemoItem;
  CreditMemoTotal: CreditMemoTotal;
  KeyValue: KeyValue;
  EntityUrl: EntityUrl;
  UrlRewrite: UrlRewrite;
  HttpQueryParameter: HttpQueryParameter;
  RoutableInterface: ResolversInterfaceTypes<ResolversParentTypes>['RoutableInterface'];
  SendEmailToFriendInput: SendEmailToFriendInput;
  SendEmailToFriendSenderInput: SendEmailToFriendSenderInput;
  SendEmailToFriendRecipientInput: SendEmailToFriendRecipientInput;
  SendEmailToFriendOutput: SendEmailToFriendOutput;
  SendEmailToFriendSender: SendEmailToFriendSender;
  SendEmailToFriendRecipient: SendEmailToFriendRecipient;
  SendFriendConfiguration: SendFriendConfiguration;
  SwatchLayerFilterItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['SwatchLayerFilterItemInterface'];
  SwatchLayerFilterItem: SwatchLayerFilterItem;
  SwatchData: SwatchData;
  SwatchDataInterface: ResolversInterfaceTypes<ResolversParentTypes>['SwatchDataInterface'];
  ImageSwatchData: ImageSwatchData;
  TextSwatchData: TextSwatchData;
  ColorSwatchData: ColorSwatchData;
  DeletePaymentTokenOutput: DeletePaymentTokenOutput;
  CustomerPaymentTokens: CustomerPaymentTokens;
  PaymentToken: PaymentToken;
  FixedProductTax: FixedProductTax;
  WishlistOutput: WishlistOutput;
  Wishlist: Wishlist;
  WishlistItemInterface: ResolversInterfaceTypes<ResolversParentTypes>['WishlistItemInterface'];
  WishlistItems: WishlistItems;
  WishlistItem: WishlistItem;
  AddWishlistItemsToCartOutput: AddWishlistItemsToCartOutput;
  WishlistCartUserInputError: WishlistCartUserInputError;
  WishlistItemInput: WishlistItemInput;
  AddProductsToWishlistOutput: AddProductsToWishlistOutput;
  RemoveProductsFromWishlistOutput: RemoveProductsFromWishlistOutput;
  WishlistItemUpdateInput: WishlistItemUpdateInput;
  UpdateProductsInWishlistOutput: UpdateProductsInWishlistOutput;
  WishListUserInputError: WishListUserInputError;
  AmFaqCategoryFilterInput: AmFaqCategoryFilterInput;
  AmFaqQuestionFilterInput: AmFaqQuestionFilterInput;
  AmFaqCategorySortInput: AmFaqCategorySortInput;
  AmFaqQuestionSortInput: AmFaqQuestionSortInput;
  PlaceAmFaqQuestionInput: PlaceAmFaqQuestionInput;
  RateAmFaqQuestionInput: RateAmFaqQuestionInput;
  AmFaqCategoriesSearch: AmFaqCategoriesSearch;
  AmFaqQuestionsSearch: AmFaqQuestionsSearch;
  AmFaqSettings: AmFaqSettings;
  AmFaqSocialButton: AmFaqSocialButton;
  AmFaqQuestion: AmFaqQuestion;
  AmFaqCategory: AmFaqCategory;
  AmFaqCommonOutput: AmFaqCommonOutput;
  AmMostviewedBundlePacks: AmMostviewedBundlePacks;
  AmMostviewedBundlePack: AmMostviewedBundlePack;
  AmMostviewedBundleItem: AmMostviewedBundleItem;
  AmMostviewedRelated: AmMostviewedRelated;
  AmMostviewedRelatedRules: AmMostviewedRelatedRules;
  AmProductAttachmentSettings: AmProductAttachmentSettings;
  AmFile: AmFile;
  AmSocialLoginButton: AmSocialLoginButton;
  AmLinkedSocialAccounts: AmLinkedSocialAccounts;
  AmUnlinkData: AmUnlinkData;
  SortingOrder: SortingOrder;
  ProductData: ProductData;
  RevokeSubUserTokenOutput: RevokeSubUserTokenOutput;
  SubUserToken: SubUserToken;
  SubRoleInput: SubRoleInput;
  SubUsers: SubUsers;
  SubUserForEdit: SubUserForEdit;
  SubUserResetPass: SubUserResetPass;
  SubUserRequestResetPass: SubUserRequestResetPass;
  SubUserChangePass: SubUserChangePass;
  SalesRepUser: SalesRepUser;
  SubUser: SubUser;
  SubRole: SubRole;
  MpFilters: MpFilters;
  SmtpBestsellersOutput: SmtpBestsellersOutput;
  BestsellersProductOutput: BestsellersProductOutput;
  BraintreeInput: BraintreeInput;
  BraintreeCcVaultInput: BraintreeCcVaultInput;
  ArtworkInterface: ArtworkInterface;
  GenericError: GenericError;
  AttachArtworkOutput: AttachArtworkOutput;
  DetachArtworkOutput: DetachArtworkOutput;
  Source: Source;
  PriceBreak: PriceBreak;
  Color: Color;
  AttachProjectDataOutput: AttachProjectDataOutput;
  ProofInterface: ProofInterface;
  GenericProofOutput: GenericProofOutput;
  CartItemsBySource: CartItemsBySource;
  SignedCommandUrlOutput: SignedCommandUrlOutput;
  FourOverItemQuantity: FourOverItemQuantity;
  Update4OverItemQuantityOutput: Update4OverItemQuantityOutput;
  Update4OverItemQuantityInput: Update4OverItemQuantityInput;
  ArtworkRequirement: ArtworkRequirement;
  FourOverFile: FourOverFile;
  ArtworkPreflightResponse: ArtworkPreflightResponse;
  ArtworkPreflightFile: ArtworkPreflightFile;
  ArtworkPreflightFileMessage: ArtworkPreflightFileMessage;
  OptionFourOverData: OptionFourOverData;
  OptionFourOverDataConditions: OptionFourOverDataConditions;
  FourOverCustomOptionModifier: FourOverCustomOptionModifier;
  DeliveryDateRange: DeliveryDateRange;
  DeliveryDateRangeInput: DeliveryDateRangeInput;
  GenerateCustomerTokenBySecretInput: GenerateCustomerTokenBySecretInput;
  GenerateCustomerTokenBySecretOutput: GenerateCustomerTokenBySecretOutput;
  NewsletterCustomFieldsInput: NewsletterCustomFieldsInput;
  SetCustomerNoteToCartInput: SetCustomerNoteToCartInput;
  ReorderItemInput: ReorderItemInput;
  ReorderItemOutput: ReorderItemOutput;
  ReorderFailedItem: ReorderFailedItem;
  SetupFee: SetupFee;
  Aggregate: Aggregate;
  Asset: Asset;
  AssetSingleRelationWhereInput: AssetSingleRelationWhereInput;
  AssetTransformationInput: AssetTransformationInput;
  AssetUpload: AssetUpload;
  AssetUploadError: AssetUploadError;
  AssetUploadRequestPostData: AssetUploadRequestPostData;
  AssetUploadWhereInput: AssetUploadWhereInput;
  AssetWhereInput: AssetWhereInput;
  Banner: Banner;
  BannerWhereInput: BannerWhereInput;
  Brand: Brand;
  BrandWhereInput: BrandWhereInput;
  DateTime: Scalars['DateTime']['output'];
  DocumentOutputInput: DocumentOutputInput;
  DocumentTransformationInput: DocumentTransformationInput;
  Entity: ResolversInterfaceTypes<ResolversParentTypes>['Entity'];
  EntityWhereInput: EntityWhereInput;
  Footer: Footer;
  FooterConnection: FooterConnection;
  FooterEdge: FooterEdge;
  FooterImageLink: FooterImageLink;
  FooterImageLinkWhereInput: FooterImageLinkWhereInput;
  FooterLink: FooterLink;
  FooterLinkWhereInput: FooterLinkWhereInput;
  FooterWhereInput: FooterWhereInput;
  FooterWhereUniqueInput: FooterWhereUniqueInput;
  Image: Image;
  ImageBlurInput: ImageBlurInput;
  ImageBorderInput: ImageBorderInput;
  ImageCompressInput: ImageCompressInput;
  ImageCropInput: ImageCropInput;
  ImageQualityInput: ImageQualityInput;
  ImageResizeInput: ImageResizeInput;
  ImageSharpenInput: ImageSharpenInput;
  ImageTransformationInput: ImageTransformationInput;
  ImageWhereInput: ImageWhereInput;
  Json: Scalars['Json']['output'];
  LabelAndContent: LabelAndContent;
  LabelAndContentWhereInput: LabelAndContentWhereInput;
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  OrderStep: OrderStep;
  OrderStepWhereInput: OrderStepWhereInput;
  Page: Omit<Page, 'content'> & { content: Array<ResolversParentTypes['PageContent']> };
  PageConnection: PageConnection;
  PageContent: ResolversUnionTypes<ResolversParentTypes>['PageContent'];
  PageContentWhereInput: PageContentWhereInput;
  PageEdge: PageEdge;
  PageFooter: PageFooter;
  PageFooterConnection: PageFooterConnection;
  PageFooterEdge: PageFooterEdge;
  PageFooterWhereInput: PageFooterWhereInput;
  PageFooterWhereUniqueInput: PageFooterWhereUniqueInput;
  PageInfo: PageInfo;
  PageLink: PageLink;
  PageLinkConnection: PageLinkConnection;
  PageLinkEdge: PageLinkEdge;
  PageLinkWhereInput: PageLinkWhereInput;
  PageLinkWhereUniqueInput: PageLinkWhereUniqueInput;
  PageWhereInput: PageWhereInput;
  PageWhereUniqueInput: PageWhereUniqueInput;
  ProductCategory: ProductCategory;
  ProductCategoryWhereInput: ProductCategoryWhereInput;
  ProductSideInfo: ProductSideInfo;
  ProductSideInfoConnection: ProductSideInfoConnection;
  ProductSideInfoEdge: ProductSideInfoEdge;
  ProductSideInfoWhereInput: ProductSideInfoWhereInput;
  ProductSideInfoWhereUniqueInput: ProductSideInfoWhereUniqueInput;
  ProductThingsToKnow: ProductThingsToKnow;
  ProductThingsToKnowConnection: ProductThingsToKnowConnection;
  ProductThingsToKnowEdge: ProductThingsToKnowEdge;
  ProductThingsToKnowWhereInput: ProductThingsToKnowWhereInput;
  ProductThingsToKnowWhereUniqueInput: ProductThingsToKnowWhereUniqueInput;
  ReviewItem: ReviewItem;
  ReviewItemWhereInput: ReviewItemWhereInput;
  RichText: RichText;
  RichTextAST: Scalars['RichTextAST']['output'];
  RowBlogContent: RowBlogContent;
  RowBlogContentConnection: RowBlogContentConnection;
  RowBlogContentEdge: RowBlogContentEdge;
  RowBlogContentWhereInput: RowBlogContentWhereInput;
  RowBlogContentWhereUniqueInput: RowBlogContentWhereUniqueInput;
  RowBrandsBanner: RowBrandsBanner;
  RowBrandsBannerConnection: RowBrandsBannerConnection;
  RowBrandsBannerEdge: RowBrandsBannerEdge;
  RowBrandsBannerWhereInput: RowBrandsBannerWhereInput;
  RowBrandsBannerWhereUniqueInput: RowBrandsBannerWhereUniqueInput;
  RowFeaturedCategory: RowFeaturedCategory;
  RowFeaturedCategoryConnection: RowFeaturedCategoryConnection;
  RowFeaturedCategoryEdge: RowFeaturedCategoryEdge;
  RowFeaturedCategoryWhereInput: RowFeaturedCategoryWhereInput;
  RowFeaturedCategoryWhereUniqueInput: RowFeaturedCategoryWhereUniqueInput;
  RowHeroBanner: RowHeroBanner;
  RowHeroBannerConnection: RowHeroBannerConnection;
  RowHeroBannerEdge: RowHeroBannerEdge;
  RowHeroBannerWhereInput: RowHeroBannerWhereInput;
  RowHeroBannerWhereUniqueInput: RowHeroBannerWhereUniqueInput;
  RowLinks: RowLinks;
  RowLinksConnection: RowLinksConnection;
  RowLinksEdge: RowLinksEdge;
  RowLinksWhereInput: RowLinksWhereInput;
  RowLinksWhereUniqueInput: RowLinksWhereUniqueInput;
  RowOrderProcess: RowOrderProcess;
  RowOrderProcessConnection: RowOrderProcessConnection;
  RowOrderProcessEdge: RowOrderProcessEdge;
  RowOrderProcessWhereInput: RowOrderProcessWhereInput;
  RowOrderProcessWhereUniqueInput: RowOrderProcessWhereUniqueInput;
  RowParagraph: RowParagraph;
  RowParagraphConnection: RowParagraphConnection;
  RowParagraphEdge: RowParagraphEdge;
  RowParagraphWhereInput: RowParagraphWhereInput;
  RowParagraphWhereUniqueInput: RowParagraphWhereUniqueInput;
  RowProduct: RowProduct;
  RowProductConnection: RowProductConnection;
  RowProductEdge: RowProductEdge;
  RowProductHighlight: RowProductHighlight;
  RowProductHighlightConnection: RowProductHighlightConnection;
  RowProductHighlightEdge: RowProductHighlightEdge;
  RowProductHighlightWhereInput: RowProductHighlightWhereInput;
  RowProductHighlightWhereUniqueInput: RowProductHighlightWhereUniqueInput;
  RowProductWhereInput: RowProductWhereInput;
  RowProductWhereUniqueInput: RowProductWhereUniqueInput;
  RowReviewHighlight: RowReviewHighlight;
  RowReviewHighlightConnection: RowReviewHighlightConnection;
  RowReviewHighlightEdge: RowReviewHighlightEdge;
  RowReviewHighlightWhereInput: RowReviewHighlightWhereInput;
  RowReviewHighlightWhereUniqueInput: RowReviewHighlightWhereUniqueInput;
  RowServiceOptions: RowServiceOptions;
  RowServiceOptionsConnection: RowServiceOptionsConnection;
  RowServiceOptionsEdge: RowServiceOptionsEdge;
  RowServiceOptionsWhereInput: RowServiceOptionsWhereInput;
  RowServiceOptionsWhereUniqueInput: RowServiceOptionsWhereUniqueInput;
  RowServicePageContent: RowServicePageContent;
  RowServicePageContentConnection: RowServicePageContentConnection;
  RowServicePageContentEdge: RowServicePageContentEdge;
  RowServicePageContentWhereInput: RowServicePageContentWhereInput;
  RowServicePageContentWhereUniqueInput: RowServicePageContentWhereUniqueInput;
  ScheduledOperation: Omit<ScheduledOperation, 'affectedDocuments'> & { affectedDocuments: Array<ResolversParentTypes['ScheduledOperationAffectedDocument']> };
  ScheduledOperationAffectedDocument: ResolversUnionTypes<ResolversParentTypes>['ScheduledOperationAffectedDocument'];
  ScheduledOperationWhereInput: ScheduledOperationWhereInput;
  ScheduledRelease: ScheduledRelease;
  ScheduledReleaseWhereInput: ScheduledReleaseWhereInput;
  User: User;
  Usps: Usps;
  UspsConnection: UspsConnection;
  UspsEdge: UspsEdge;
  UspsWhereInput: UspsWhereInput;
  UspsWhereUniqueInput: UspsWhereUniqueInput;
  GraphCommerceStorefrontConfig: GraphCommerceStorefrontConfig;
  GraphCommerceConfig: GraphCommerceConfig;
  CurrentCartId: CurrentCartId;
  RegisterCartIdInput: RegisterCartIdInput;
  CurrentCompareUid: CurrentCompareUid;
  GuestWishlist: GuestWishlist;
  GuestWishlistItem: GuestWishlistItem;
  GraphCommerceDebugConfig: GraphCommerceDebugConfig;
}>;

export type envDirectiveArgs = {
  if: Scalars['String']['input'];
};

export type envDirectiveResolver<Result, Parent, ContextType = MeshContext, Args = envDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type injectableDirectiveArgs = { };

export type injectableDirectiveResolver<Result, Parent, ContextType = MeshContext, Args = injectableDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type injectDirectiveArgs = {
  into: Array<Scalars['String']['input']>;
};

export type injectDirectiveResolver<Result, Parent, ContextType = MeshContext, Args = injectDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type QueryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  amMostviewedBundlePacks?: Resolver<Maybe<ResolversTypes['AmMostviewedBundlePacks']>, ParentType, ContextType, Partial<QueryamMostviewedBundlePacksArgs>>;
  amMostviewedGroups?: Resolver<Maybe<ResolversTypes['AmMostviewedRelatedRules']>, ParentType, ContextType, RequireFields<QueryamMostviewedGroupsArgs, 'uid'>>;
  amMostviewedGroupsByPosition?: Resolver<Maybe<ResolversTypes['AmMostviewedRelatedRules']>, ParentType, ContextType, Partial<QueryamMostviewedGroupsByPositionArgs>>;
  amOrderList?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortingOrder']>>>, ParentType, ContextType>;
  amSocialLoginAccountData?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmLinkedSocialAccounts']>>>, ParentType, ContextType>;
  amSocialLoginButtonConfig?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmSocialLoginButton']>>>, ParentType, ContextType>;
  amfeaturedWidget?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductData']>>>, ParentType, ContextType, RequireFields<QueryamfeaturedWidgetArgs, 'sortBy' | 'amsortingSortOrder' | 'productsCount' | 'conditions'>>;
  availableStores?: Resolver<Maybe<Array<Maybe<ResolversTypes['StoreConfig']>>>, ParentType, ContextType, Partial<QueryavailableStoresArgs>>;
  bssCompanyAccountGetRole?: Resolver<Maybe<ResolversTypes['SubRole']>, ParentType, ContextType, RequireFields<QuerybssCompanyAccountGetRoleArgs, 'role_id'>>;
  bssCompanyAccountGetSubUser?: Resolver<Maybe<ResolversTypes['SubUser']>, ParentType, ContextType, RequireFields<QuerybssCompanyAccountGetSubUserArgs, 'sub_id'>>;
  bssCompanyAccountGetSubUsersByRole?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubUser']>>>, ParentType, ContextType, RequireFields<QuerybssCompanyAccountGetSubUsersByRoleArgs, 'role_id'>>;
  bssSubUser?: Resolver<Maybe<ResolversTypes['SubUser']>, ParentType, ContextType>;
  bssSubUserCart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType, RequireFields<QuerycartArgs, 'cart_id'>>;
  categories?: Resolver<Maybe<ResolversTypes['CategoryResult']>, ParentType, ContextType, RequireFields<QuerycategoriesArgs, 'pageSize' | 'currentPage'>>;
  category?: Resolver<Maybe<ResolversTypes['CategoryTree']>, ParentType, ContextType, Partial<QuerycategoryArgs>>;
  categoryList?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryTree']>>>, ParentType, ContextType, RequireFields<QuerycategoryListArgs, 'pageSize' | 'currentPage'>>;
  checkoutAgreements?: Resolver<Maybe<Array<Maybe<ResolversTypes['CheckoutAgreement']>>>, ParentType, ContextType>;
  cmsBlocks?: Resolver<Maybe<ResolversTypes['CmsBlocks']>, ParentType, ContextType, Partial<QuerycmsBlocksArgs>>;
  cmsPage?: Resolver<Maybe<ResolversTypes['CmsPage']>, ParentType, ContextType, Partial<QuerycmsPageArgs>>;
  compareList?: Resolver<Maybe<ResolversTypes['CompareList']>, ParentType, ContextType, RequireFields<QuerycompareListArgs, 'uid'>>;
  countries?: Resolver<Maybe<Array<Maybe<ResolversTypes['Country']>>>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['Country']>, ParentType, ContextType, Partial<QuerycountryArgs>>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  customAttributeMetadata?: Resolver<Maybe<ResolversTypes['CustomAttributeMetadata']>, ParentType, ContextType, RequireFields<QuerycustomAttributeMetadataArgs, 'attributes'>>;
  customer?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  customerCart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  customerDownloadableProducts?: Resolver<Maybe<ResolversTypes['CustomerDownloadableProducts']>, ParentType, ContextType>;
  customerOrders?: Resolver<Maybe<ResolversTypes['CustomerOrders']>, ParentType, ContextType>;
  customerPaymentTokens?: Resolver<Maybe<ResolversTypes['CustomerPaymentTokens']>, ParentType, ContextType>;
  defaultSorting?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortingOrder']>>>, ParentType, ContextType, RequireFields<QuerydefaultSortingArgs, 'pageType'>>;
  fourOverCartItemAvailableQuantities?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverItemQuantity']>>>, ParentType, ContextType, RequireFields<QueryfourOverCartItemAvailableQuantitiesArgs, 'cart_id'>>;
  fourOverProductArtworkPreflight?: Resolver<Maybe<ResolversTypes['ArtworkPreflightResponse']>, ParentType, ContextType, Partial<QueryfourOverProductArtworkPreflightArgs>>;
  fourOverProductArtworkRequirements?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkRequirement']>>>, ParentType, ContextType, Partial<QueryfourOverProductArtworkRequirementsArgs>>;
  getAmFaqSettings?: Resolver<Maybe<ResolversTypes['AmFaqSettings']>, ParentType, ContextType>;
  getAmFiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType, Partial<QuerygetAmFilesArgs>>;
  getAmProductAttachmentSettings?: Resolver<Maybe<ResolversTypes['AmProductAttachmentSettings']>, ParentType, ContextType>;
  getHostedProUrl?: Resolver<Maybe<ResolversTypes['HostedProUrl']>, ParentType, ContextType, RequireFields<QuerygetHostedProUrlArgs, 'input'>>;
  getPayflowLinkToken?: Resolver<Maybe<ResolversTypes['PayflowLinkToken']>, ParentType, ContextType, RequireFields<QuerygetPayflowLinkTokenArgs, 'input'>>;
  isEmailAvailable?: Resolver<Maybe<ResolversTypes['IsEmailAvailableOutput']>, ParentType, ContextType, RequireFields<QueryisEmailAvailableArgs, 'email'>>;
  mpSmtpBestsellers?: Resolver<Maybe<ResolversTypes['SmtpBestsellersOutput']>, ParentType, ContextType, RequireFields<QuerympSmtpBestsellersArgs, 'app_id' | 'secret_key'>>;
  pickupLocations?: Resolver<Maybe<ResolversTypes['PickupLocations']>, ParentType, ContextType, RequireFields<QuerypickupLocationsArgs, 'pageSize' | 'currentPage'>>;
  productReviewRatingsMetadata?: Resolver<ResolversTypes['ProductReviewRatingsMetadata'], ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['Products']>, ParentType, ContextType, RequireFields<QueryproductsArgs, 'pageSize' | 'currentPage'>>;
  route?: Resolver<Maybe<ResolversTypes['RoutableInterface']>, ParentType, ContextType, RequireFields<QueryrouteArgs, 'url'>>;
  searchAmFaqCategories?: Resolver<Maybe<ResolversTypes['AmFaqCategoriesSearch']>, ParentType, ContextType, RequireFields<QuerysearchAmFaqCategoriesArgs, 'pageSize' | 'currentPage'>>;
  searchAmFaqQuestions?: Resolver<Maybe<ResolversTypes['AmFaqQuestionsSearch']>, ParentType, ContextType, RequireFields<QuerysearchAmFaqQuestionsArgs, 'pageSize' | 'currentPage'>>;
  storeConfig?: Resolver<Maybe<ResolversTypes['StoreConfig']>, ParentType, ContextType>;
  urlResolver?: Resolver<Maybe<ResolversTypes['EntityUrl']>, ParentType, ContextType, RequireFields<QueryurlResolverArgs, 'url'>>;
  wishlist?: Resolver<Maybe<ResolversTypes['WishlistOutput']>, ParentType, ContextType>;
  entities?: Resolver<Maybe<Array<ResolversTypes['Entity']>>, ParentType, ContextType, RequireFields<QueryentitiesArgs, 'where'>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, RequireFields<QuerypagesArgs, 'stage'>>;
  page?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType, RequireFields<QuerypageArgs, 'where' | 'stage'>>;
  pagesConnection?: Resolver<ResolversTypes['PageConnection'], ParentType, ContextType, RequireFields<QuerypagesConnectionArgs, 'stage'>>;
  rowHeroBanners?: Resolver<Array<ResolversTypes['RowHeroBanner']>, ParentType, ContextType, RequireFields<QueryrowHeroBannersArgs, 'stage'>>;
  rowHeroBanner?: Resolver<Maybe<ResolversTypes['RowHeroBanner']>, ParentType, ContextType, RequireFields<QueryrowHeroBannerArgs, 'where' | 'stage'>>;
  rowHeroBannersConnection?: Resolver<ResolversTypes['RowHeroBannerConnection'], ParentType, ContextType, RequireFields<QueryrowHeroBannersConnectionArgs, 'stage'>>;
  pageLinks?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, RequireFields<QuerypageLinksArgs, 'stage'>>;
  pageLink?: Resolver<Maybe<ResolversTypes['PageLink']>, ParentType, ContextType, RequireFields<QuerypageLinkArgs, 'where' | 'stage'>>;
  pageLinksConnection?: Resolver<ResolversTypes['PageLinkConnection'], ParentType, ContextType, RequireFields<QuerypageLinksConnectionArgs, 'stage'>>;
  footers?: Resolver<Array<ResolversTypes['Footer']>, ParentType, ContextType, RequireFields<QueryfootersArgs, 'stage'>>;
  footer?: Resolver<Maybe<ResolversTypes['Footer']>, ParentType, ContextType, RequireFields<QueryfooterArgs, 'where' | 'stage'>>;
  footersConnection?: Resolver<ResolversTypes['FooterConnection'], ParentType, ContextType, RequireFields<QueryfootersConnectionArgs, 'stage'>>;
  rowServiceOptionsMultiple?: Resolver<Array<ResolversTypes['RowServiceOptions']>, ParentType, ContextType, RequireFields<QueryrowServiceOptionsMultipleArgs, 'stage'>>;
  rowServiceOptions?: Resolver<Maybe<ResolversTypes['RowServiceOptions']>, ParentType, ContextType, RequireFields<QueryrowServiceOptionsArgs, 'where' | 'stage'>>;
  rowServiceOptionsMultipleConnection?: Resolver<ResolversTypes['RowServiceOptionsConnection'], ParentType, ContextType, RequireFields<QueryrowServiceOptionsMultipleConnectionArgs, 'stage'>>;
  rowBlogContents?: Resolver<Array<ResolversTypes['RowBlogContent']>, ParentType, ContextType, RequireFields<QueryrowBlogContentsArgs, 'stage'>>;
  rowBlogContent?: Resolver<Maybe<ResolversTypes['RowBlogContent']>, ParentType, ContextType, RequireFields<QueryrowBlogContentArgs, 'where' | 'stage'>>;
  rowBlogContentsConnection?: Resolver<ResolversTypes['RowBlogContentConnection'], ParentType, ContextType, RequireFields<QueryrowBlogContentsConnectionArgs, 'stage'>>;
  uspsMultiple?: Resolver<Array<ResolversTypes['Usps']>, ParentType, ContextType, RequireFields<QueryuspsMultipleArgs, 'stage'>>;
  usps?: Resolver<Maybe<ResolversTypes['Usps']>, ParentType, ContextType, RequireFields<QueryuspsArgs, 'where' | 'stage'>>;
  uspsMultipleConnection?: Resolver<ResolversTypes['UspsConnection'], ParentType, ContextType, RequireFields<QueryuspsMultipleConnectionArgs, 'stage'>>;
  rowProductMultiple?: Resolver<Array<ResolversTypes['RowProduct']>, ParentType, ContextType, RequireFields<QueryrowProductMultipleArgs, 'stage'>>;
  rowProduct?: Resolver<Maybe<ResolversTypes['RowProduct']>, ParentType, ContextType, RequireFields<QueryrowProductArgs, 'where' | 'stage'>>;
  rowProductMultipleConnection?: Resolver<ResolversTypes['RowProductConnection'], ParentType, ContextType, RequireFields<QueryrowProductMultipleConnectionArgs, 'stage'>>;
  rowLinksMultiple?: Resolver<Array<ResolversTypes['RowLinks']>, ParentType, ContextType, RequireFields<QueryrowLinksMultipleArgs, 'stage'>>;
  rowLinks?: Resolver<Maybe<ResolversTypes['RowLinks']>, ParentType, ContextType, RequireFields<QueryrowLinksArgs, 'where' | 'stage'>>;
  rowLinksMultipleConnection?: Resolver<ResolversTypes['RowLinksConnection'], ParentType, ContextType, RequireFields<QueryrowLinksMultipleConnectionArgs, 'stage'>>;
  productSideInfos?: Resolver<Array<ResolversTypes['ProductSideInfo']>, ParentType, ContextType, RequireFields<QueryproductSideInfosArgs, 'stage'>>;
  productSideInfo?: Resolver<Maybe<ResolversTypes['ProductSideInfo']>, ParentType, ContextType, RequireFields<QueryproductSideInfoArgs, 'where' | 'stage'>>;
  productSideInfosConnection?: Resolver<ResolversTypes['ProductSideInfoConnection'], ParentType, ContextType, RequireFields<QueryproductSideInfosConnectionArgs, 'stage'>>;
  rowBrandsBanners?: Resolver<Array<ResolversTypes['RowBrandsBanner']>, ParentType, ContextType, RequireFields<QueryrowBrandsBannersArgs, 'stage'>>;
  rowBrandsBanner?: Resolver<Maybe<ResolversTypes['RowBrandsBanner']>, ParentType, ContextType, RequireFields<QueryrowBrandsBannerArgs, 'where' | 'stage'>>;
  rowBrandsBannersConnection?: Resolver<ResolversTypes['RowBrandsBannerConnection'], ParentType, ContextType, RequireFields<QueryrowBrandsBannersConnectionArgs, 'stage'>>;
  rowOrderProcesses?: Resolver<Array<ResolversTypes['RowOrderProcess']>, ParentType, ContextType, RequireFields<QueryrowOrderProcessesArgs, 'stage'>>;
  rowOrderProcess?: Resolver<Maybe<ResolversTypes['RowOrderProcess']>, ParentType, ContextType, RequireFields<QueryrowOrderProcessArgs, 'where' | 'stage'>>;
  rowOrderProcessesConnection?: Resolver<ResolversTypes['RowOrderProcessConnection'], ParentType, ContextType, RequireFields<QueryrowOrderProcessesConnectionArgs, 'stage'>>;
  rowProductHighlights?: Resolver<Array<ResolversTypes['RowProductHighlight']>, ParentType, ContextType, RequireFields<QueryrowProductHighlightsArgs, 'stage'>>;
  rowProductHighlight?: Resolver<Maybe<ResolversTypes['RowProductHighlight']>, ParentType, ContextType, RequireFields<QueryrowProductHighlightArgs, 'where' | 'stage'>>;
  rowProductHighlightsConnection?: Resolver<ResolversTypes['RowProductHighlightConnection'], ParentType, ContextType, RequireFields<QueryrowProductHighlightsConnectionArgs, 'stage'>>;
  pageFooters?: Resolver<Array<ResolversTypes['PageFooter']>, ParentType, ContextType, RequireFields<QuerypageFootersArgs, 'stage'>>;
  pageFooter?: Resolver<Maybe<ResolversTypes['PageFooter']>, ParentType, ContextType, RequireFields<QuerypageFooterArgs, 'where' | 'stage'>>;
  pageFootersConnection?: Resolver<ResolversTypes['PageFooterConnection'], ParentType, ContextType, RequireFields<QuerypageFootersConnectionArgs, 'stage'>>;
  productThingsToKnows?: Resolver<Array<ResolversTypes['ProductThingsToKnow']>, ParentType, ContextType, RequireFields<QueryproductThingsToKnowsArgs, 'stage'>>;
  productThingsToKnow?: Resolver<Maybe<ResolversTypes['ProductThingsToKnow']>, ParentType, ContextType, RequireFields<QueryproductThingsToKnowArgs, 'where' | 'stage'>>;
  productThingsToKnowsConnection?: Resolver<ResolversTypes['ProductThingsToKnowConnection'], ParentType, ContextType, RequireFields<QueryproductThingsToKnowsConnectionArgs, 'stage'>>;
  rowServicePageContents?: Resolver<Array<ResolversTypes['RowServicePageContent']>, ParentType, ContextType, RequireFields<QueryrowServicePageContentsArgs, 'stage'>>;
  rowServicePageContent?: Resolver<Maybe<ResolversTypes['RowServicePageContent']>, ParentType, ContextType, RequireFields<QueryrowServicePageContentArgs, 'where' | 'stage'>>;
  rowServicePageContentsConnection?: Resolver<ResolversTypes['RowServicePageContentConnection'], ParentType, ContextType, RequireFields<QueryrowServicePageContentsConnectionArgs, 'stage'>>;
  rowReviewHighlights?: Resolver<Array<ResolversTypes['RowReviewHighlight']>, ParentType, ContextType, RequireFields<QueryrowReviewHighlightsArgs, 'stage'>>;
  rowReviewHighlight?: Resolver<Maybe<ResolversTypes['RowReviewHighlight']>, ParentType, ContextType, RequireFields<QueryrowReviewHighlightArgs, 'where' | 'stage'>>;
  rowReviewHighlightsConnection?: Resolver<ResolversTypes['RowReviewHighlightConnection'], ParentType, ContextType, RequireFields<QueryrowReviewHighlightsConnectionArgs, 'stage'>>;
  rowFeaturedCategories?: Resolver<Array<ResolversTypes['RowFeaturedCategory']>, ParentType, ContextType, RequireFields<QueryrowFeaturedCategoriesArgs, 'stage'>>;
  rowFeaturedCategory?: Resolver<Maybe<ResolversTypes['RowFeaturedCategory']>, ParentType, ContextType, RequireFields<QueryrowFeaturedCategoryArgs, 'where' | 'stage'>>;
  rowFeaturedCategoriesConnection?: Resolver<ResolversTypes['RowFeaturedCategoryConnection'], ParentType, ContextType, RequireFields<QueryrowFeaturedCategoriesConnectionArgs, 'stage'>>;
  rowParagraphs?: Resolver<Array<ResolversTypes['RowParagraph']>, ParentType, ContextType, RequireFields<QueryrowParagraphsArgs, 'stage'>>;
  rowParagraph?: Resolver<Maybe<ResolversTypes['RowParagraph']>, ParentType, ContextType, RequireFields<QueryrowParagraphArgs, 'where' | 'stage'>>;
  rowParagraphsConnection?: Resolver<ResolversTypes['RowParagraphConnection'], ParentType, ContextType, RequireFields<QueryrowParagraphsConnectionArgs, 'stage'>>;
  currentCartId?: Resolver<Maybe<ResolversTypes['CurrentCartId']>, ParentType, ContextType>;
  currentCompareUid?: Resolver<Maybe<ResolversTypes['CurrentCompareUid']>, ParentType, ContextType>;
  customerToken?: Resolver<Maybe<ResolversTypes['CustomerToken']>, ParentType, ContextType>;
  guestWishlist?: Resolver<Maybe<ResolversTypes['GuestWishlist']>, ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  addBundleProductsToCart?: Resolver<Maybe<ResolversTypes['AddBundleProductsToCartOutput']>, ParentType, ContextType, Partial<MutationaddBundleProductsToCartArgs>>;
  addConfigurableProductsToCart?: Resolver<Maybe<ResolversTypes['AddConfigurableProductsToCartOutput']>, ParentType, ContextType, Partial<MutationaddConfigurableProductsToCartArgs>>;
  addCustomerNoteToCart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType, RequireFields<MutationaddCustomerNoteToCartArgs, 'input'>>;
  addDownloadableProductsToCart?: Resolver<Maybe<ResolversTypes['AddDownloadableProductsToCartOutput']>, ParentType, ContextType, Partial<MutationaddDownloadableProductsToCartArgs>>;
  addProductsToCart?: Resolver<Maybe<ResolversTypes['AddProductsToCartOutput']>, ParentType, ContextType, RequireFields<MutationaddProductsToCartArgs, 'cartId' | 'cartItems'>>;
  addProductsToCompareList?: Resolver<Maybe<ResolversTypes['CompareList']>, ParentType, ContextType, Partial<MutationaddProductsToCompareListArgs>>;
  addProductsToWishlist?: Resolver<Maybe<ResolversTypes['AddProductsToWishlistOutput']>, ParentType, ContextType, RequireFields<MutationaddProductsToWishlistArgs, 'wishlistId' | 'wishlistItems'>>;
  addSimpleProductsToCart?: Resolver<Maybe<ResolversTypes['AddSimpleProductsToCartOutput']>, ParentType, ContextType, Partial<MutationaddSimpleProductsToCartArgs>>;
  addVirtualProductsToCart?: Resolver<Maybe<ResolversTypes['AddVirtualProductsToCartOutput']>, ParentType, ContextType, Partial<MutationaddVirtualProductsToCartArgs>>;
  addWishlistItemsToCart?: Resolver<Maybe<ResolversTypes['AddWishlistItemsToCartOutput']>, ParentType, ContextType, RequireFields<MutationaddWishlistItemsToCartArgs, 'wishlistId'>>;
  amSocialLoginLinkAccount?: Resolver<Maybe<ResolversTypes['AmUnlinkData']>, ParentType, ContextType, RequireFields<MutationamSocialLoginLinkAccountArgs, 'type'>>;
  amSocialLoginUnlinkAccount?: Resolver<Maybe<ResolversTypes['AmUnlinkData']>, ParentType, ContextType, RequireFields<MutationamSocialLoginUnlinkAccountArgs, 'type'>>;
  applyCouponToCart?: Resolver<Maybe<ResolversTypes['ApplyCouponToCartOutput']>, ParentType, ContextType, Partial<MutationapplyCouponToCartArgs>>;
  approveProof?: Resolver<Maybe<ResolversTypes['GenericProofOutput']>, ParentType, ContextType, RequireFields<MutationapproveProofArgs, 'proofId' | 'comments'>>;
  assignCompareListToCustomer?: Resolver<Maybe<ResolversTypes['AssignCompareListToCustomerOutput']>, ParentType, ContextType, RequireFields<MutationassignCompareListToCustomerArgs, 'uid'>>;
  assignCustomerToGuestCart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType, RequireFields<MutationassignCustomerToGuestCartArgs, 'cart_id'>>;
  attachArtwork?: Resolver<Maybe<ResolversTypes['AttachArtworkOutput']>, ParentType, ContextType, RequireFields<MutationattachArtworkArgs, 'fileUrl' | 'fileName' | 'cartItemUid'>>;
  attachProjectData?: Resolver<Maybe<ResolversTypes['AttachProjectDataOutput']>, ParentType, ContextType, RequireFields<MutationattachProjectDataArgs, 'cartUid' | 'cartItemUid' | 'projectId'>>;
  bssCompanyAccountChangeSubPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationbssCompanyAccountChangeSubPasswordArgs>>;
  bssCompanyAccountCreateSubUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationbssCompanyAccountCreateSubUserArgs>>;
  bssCompanyAccountDeleteRole?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationbssCompanyAccountDeleteRoleArgs, 'role_id'>>;
  bssCompanyAccountDeleteSubUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationbssCompanyAccountDeleteSubUserArgs, 'sub_id'>>;
  bssCompanyAccountEditSubUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationbssCompanyAccountEditSubUserArgs>>;
  bssCompanyAccountRequestResetSubPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationbssCompanyAccountRequestResetSubPasswordArgs>>;
  bssCompanyAccountResetSubPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationbssCompanyAccountResetSubPasswordArgs>>;
  bssCompanyAccountSaveRole?: Resolver<Maybe<ResolversTypes['SubRole']>, ParentType, ContextType, Partial<MutationbssCompanyAccountSaveRoleArgs>>;
  bssGenerateSubUserToken?: Resolver<Maybe<ResolversTypes['SubUserToken']>, ParentType, ContextType, RequireFields<MutationbssGenerateSubUserTokenArgs, 'email' | 'password'>>;
  bssRevokeSubUserToken?: Resolver<Maybe<ResolversTypes['RevokeSubUserTokenOutput']>, ParentType, ContextType>;
  bssUpdateToCompanyAccount?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, Partial<MutationbssUpdateToCompanyAccountArgs>>;
  changeCustomerPassword?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType, RequireFields<MutationchangeCustomerPasswordArgs, 'currentPassword' | 'newPassword'>>;
  createBraintreeClientToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createCompareList?: Resolver<Maybe<ResolversTypes['CompareList']>, ParentType, ContextType, Partial<MutationcreateCompareListArgs>>;
  createCustomer?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationcreateCustomerArgs, 'input'>>;
  createCustomerAddress?: Resolver<Maybe<ResolversTypes['CustomerAddress']>, ParentType, ContextType, RequireFields<MutationcreateCustomerAddressArgs, 'input'>>;
  createCustomerV2?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationcreateCustomerV2Args, 'input'>>;
  createEmptyCart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, Partial<MutationcreateEmptyCartArgs>>;
  createFourOverProductArtworkFiles?: Resolver<Maybe<ResolversTypes['ArtworkPreflightResponse']>, ParentType, ContextType, Partial<MutationcreateFourOverProductArtworkFilesArgs>>;
  createPayflowProToken?: Resolver<Maybe<ResolversTypes['CreatePayflowProTokenOutput']>, ParentType, ContextType, RequireFields<MutationcreatePayflowProTokenArgs, 'input'>>;
  createPaypalExpressToken?: Resolver<Maybe<ResolversTypes['PaypalExpressTokenOutput']>, ParentType, ContextType, RequireFields<MutationcreatePaypalExpressTokenArgs, 'input'>>;
  createProductReview?: Resolver<ResolversTypes['CreateProductReviewOutput'], ParentType, ContextType, RequireFields<MutationcreateProductReviewArgs, 'input'>>;
  declineProof?: Resolver<Maybe<ResolversTypes['GenericProofOutput']>, ParentType, ContextType, RequireFields<MutationdeclineProofArgs, 'proofId' | 'comments'>>;
  deleteCompareList?: Resolver<Maybe<ResolversTypes['DeleteCompareListOutput']>, ParentType, ContextType, RequireFields<MutationdeleteCompareListArgs, 'uid'>>;
  deleteCustomer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deleteCustomerAddress?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationdeleteCustomerAddressArgs, 'id'>>;
  deletePaymentToken?: Resolver<Maybe<ResolversTypes['DeletePaymentTokenOutput']>, ParentType, ContextType, RequireFields<MutationdeletePaymentTokenArgs, 'public_hash'>>;
  detachArtwork?: Resolver<Maybe<ResolversTypes['DetachArtworkOutput']>, ParentType, ContextType, RequireFields<MutationdetachArtworkArgs, 'artworkId'>>;
  generateCustomerToken?: Resolver<Maybe<ResolversTypes['CustomerToken']>, ParentType, ContextType, RequireFields<MutationgenerateCustomerTokenArgs, 'email' | 'password'>>;
  generateCustomerTokenAsAdmin?: Resolver<Maybe<ResolversTypes['GenerateCustomerTokenAsAdminOutput']>, ParentType, ContextType, RequireFields<MutationgenerateCustomerTokenAsAdminArgs, 'input'>>;
  generateCustomerTokenBySecret?: Resolver<Maybe<ResolversTypes['GenerateCustomerTokenBySecretOutput']>, ParentType, ContextType, RequireFields<MutationgenerateCustomerTokenBySecretArgs, 'input'>>;
  generateSignedCommandUrl?: Resolver<Maybe<ResolversTypes['SignedCommandUrlOutput']>, ParentType, ContextType, RequireFields<MutationgenerateSignedCommandUrlArgs, 'objectKey'>>;
  handlePayflowProResponse?: Resolver<Maybe<ResolversTypes['PayflowProResponseOutput']>, ParentType, ContextType, RequireFields<MutationhandlePayflowProResponseArgs, 'input'>>;
  mergeCarts?: Resolver<ResolversTypes['Cart'], ParentType, ContextType, RequireFields<MutationmergeCartsArgs, 'source_cart_id'>>;
  placeAmFaqQuestion?: Resolver<Maybe<ResolversTypes['AmFaqCommonOutput']>, ParentType, ContextType, Partial<MutationplaceAmFaqQuestionArgs>>;
  placeOrder?: Resolver<Maybe<ResolversTypes['PlaceOrderOutput']>, ParentType, ContextType, Partial<MutationplaceOrderArgs>>;
  prepareCheckout?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType, RequireFields<MutationprepareCheckoutArgs, 'cart_id'>>;
  rateAmFaqQuestion?: Resolver<Maybe<ResolversTypes['AmFaqCommonOutput']>, ParentType, ContextType, Partial<MutationrateAmFaqQuestionArgs>>;
  removeCouponFromCart?: Resolver<Maybe<ResolversTypes['RemoveCouponFromCartOutput']>, ParentType, ContextType, Partial<MutationremoveCouponFromCartArgs>>;
  removeItemFromCart?: Resolver<Maybe<ResolversTypes['RemoveItemFromCartOutput']>, ParentType, ContextType, Partial<MutationremoveItemFromCartArgs>>;
  removeProductsFromCompareList?: Resolver<Maybe<ResolversTypes['CompareList']>, ParentType, ContextType, Partial<MutationremoveProductsFromCompareListArgs>>;
  removeProductsFromWishlist?: Resolver<Maybe<ResolversTypes['RemoveProductsFromWishlistOutput']>, ParentType, ContextType, RequireFields<MutationremoveProductsFromWishlistArgs, 'wishlistId' | 'wishlistItemsIds'>>;
  reorderItem?: Resolver<Maybe<ResolversTypes['ReorderItemOutput']>, ParentType, ContextType, RequireFields<MutationreorderItemArgs, 'input'>>;
  reorderItems?: Resolver<Maybe<ResolversTypes['ReorderItemsOutput']>, ParentType, ContextType, RequireFields<MutationreorderItemsArgs, 'orderNumber'>>;
  requestPasswordResetEmail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationrequestPasswordResetEmailArgs, 'email'>>;
  resetCheckout?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType, RequireFields<MutationresetCheckoutArgs, 'cart_id'>>;
  resetPassword?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationresetPasswordArgs, 'email' | 'resetPasswordToken' | 'newPassword'>>;
  revokeCustomerToken?: Resolver<Maybe<ResolversTypes['RevokeCustomerTokenOutput']>, ParentType, ContextType>;
  sendEmailToFriend?: Resolver<Maybe<ResolversTypes['SendEmailToFriendOutput']>, ParentType, ContextType, Partial<MutationsendEmailToFriendArgs>>;
  setBillingAddressOnCart?: Resolver<Maybe<ResolversTypes['SetBillingAddressOnCartOutput']>, ParentType, ContextType, Partial<MutationsetBillingAddressOnCartArgs>>;
  setGuestEmailOnCart?: Resolver<Maybe<ResolversTypes['SetGuestEmailOnCartOutput']>, ParentType, ContextType, Partial<MutationsetGuestEmailOnCartArgs>>;
  setPaymentMethodAndPlaceOrder?: Resolver<Maybe<ResolversTypes['PlaceOrderOutput']>, ParentType, ContextType, Partial<MutationsetPaymentMethodAndPlaceOrderArgs>>;
  setPaymentMethodOnCart?: Resolver<Maybe<ResolversTypes['SetPaymentMethodOnCartOutput']>, ParentType, ContextType, Partial<MutationsetPaymentMethodOnCartArgs>>;
  setShippingAddressesOnCart?: Resolver<Maybe<ResolversTypes['SetShippingAddressesOnCartOutput']>, ParentType, ContextType, Partial<MutationsetShippingAddressesOnCartArgs>>;
  setShippingMethodsOnCart?: Resolver<Maybe<ResolversTypes['SetShippingMethodsOnCartOutput']>, ParentType, ContextType, Partial<MutationsetShippingMethodsOnCartArgs>>;
  subscribeEmailToNewsletter?: Resolver<Maybe<ResolversTypes['SubscribeEmailToNewsletterOutput']>, ParentType, ContextType, RequireFields<MutationsubscribeEmailToNewsletterArgs, 'email'>>;
  update4OverItemQuantity?: Resolver<Maybe<ResolversTypes['Update4OverItemQuantityOutput']>, ParentType, ContextType, Partial<Mutationupdate4OverItemQuantityArgs>>;
  updateCartItems?: Resolver<Maybe<ResolversTypes['UpdateCartItemsOutput']>, ParentType, ContextType, Partial<MutationupdateCartItemsArgs>>;
  updateCustomer?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationupdateCustomerArgs, 'input'>>;
  updateCustomerAddress?: Resolver<Maybe<ResolversTypes['CustomerAddress']>, ParentType, ContextType, RequireFields<MutationupdateCustomerAddressArgs, 'id'>>;
  updateCustomerEmail?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationupdateCustomerEmailArgs, 'email' | 'password'>>;
  updateCustomerIsCompanyAccount?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationupdateCustomerIsCompanyAccountArgs, 'isCompanyAccount'>>;
  updateCustomerV2?: Resolver<Maybe<ResolversTypes['CustomerOutput']>, ParentType, ContextType, RequireFields<MutationupdateCustomerV2Args, 'input'>>;
  updateProductsInWishlist?: Resolver<Maybe<ResolversTypes['UpdateProductsInWishlistOutput']>, ParentType, ContextType, RequireFields<MutationupdateProductsInWishlistArgs, 'wishlistId' | 'wishlistItems'>>;
}>;

export type SearchResultPageInfoResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SearchResultPageInfo'] = ResolversParentTypes['SearchResultPageInfo']> = ResolversObject<{
  current_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page_size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total_pages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComplexTextValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ComplexTextValue'] = ResolversParentTypes['ComplexTextValue']> = ResolversObject<{
  html?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MoneyResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Money'] = ResolversParentTypes['Money']> = ResolversObject<{
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ErrorInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ErrorInterface'] = ResolversParentTypes['ErrorInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'NoSuchEntityUidError' | 'InternalError', ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type NoSuchEntityUidErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['NoSuchEntityUidError'] = ResolversParentTypes['NoSuchEntityUidError']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InternalErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['InternalError'] = ResolversParentTypes['InternalError']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StoreConfigResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['StoreConfig'] = ResolversParentTypes['StoreConfig']> = ResolversObject<{
  absolute_footer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allow_guests_to_write_product_reviews?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allow_items?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  allow_order?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsociallogin_general_button_position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsociallogin_general_button_shape?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amsociallogin_general_custom_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsociallogin_general_enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amsociallogin_general_login_position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amsociallogin_general_popup_enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  amsociallogin_general_redirect_type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  autocomplete_on_storefront?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  base_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_link_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_media_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_static_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  braintree_cc_vault_active?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  catalog_default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySettings']>, ParentType, ContextType>;
  category_url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_enable_for_specific_countries?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  check_money_order_enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  check_money_order_make_check_payable_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_max_order_total?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_min_order_total?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_new_order_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_payment_from_specific_countries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_send_check_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  check_money_order_sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  check_money_order_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_home_page?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_no_cookies?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_no_route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_ca_approval?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_ca_remove?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_email_sender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_enable?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_send_approval_copy_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_send_remove_copy_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_subuser_remove?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_subuser_reset_password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_account_subuser_welcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configurable_thumbnail_source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  demonotice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  front?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grid_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  grid_per_page_values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head_includes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head_shortcut_icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  header_logo_src?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_default_store?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_default_store_group?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  list_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  list_per_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  list_per_page_values?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo_height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  logo_width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  magento_wishlist_general_is_enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimum_password_length?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  no_route?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment_payflowpro_cc_vault_active?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pitch_print_api_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySettings']>, ParentType, ContextType>;
  product_reviews_enabled?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required_character_classes_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  root_category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  root_category_uid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sales_fixed_product_tax_display_setting?: Resolver<Maybe<ResolversTypes['FixedProductTaxDisplaySettings']>, ParentType, ContextType>;
  secure_base_link_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_media_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_static_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_base_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  send_friend?: Resolver<Maybe<ResolversTypes['SendFriendConfiguration']>, ParentType, ContextType>;
  show_cms_breadcrumbs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_code?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  store_group_code?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  store_group_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  store_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  store_sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_separator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  use_store_in_url?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  website_code?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  website_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  website_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight_unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  welcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zero_subtotal_enable_for_specific_countries?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  zero_subtotal_enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  zero_subtotal_new_order_status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zero_subtotal_payment_action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zero_subtotal_payment_from_specific_countries?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zero_subtotal_sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  zero_subtotal_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CmsPageResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CmsPage'] = ResolversParentTypes['CmsPage']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  page_layout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CmsBlocksResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CmsBlocks'] = ResolversParentTypes['CmsBlocks']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CmsBlock']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CmsBlockResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CmsBlock'] = ResolversParentTypes['CmsBlock']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomAttributeMetadataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomAttributeMetadata'] = ResolversParentTypes['CustomAttributeMetadata']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['Attribute']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttributeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Attribute'] = ResolversParentTypes['Attribute']> = ResolversObject<{
  attribute_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['AttributeOption']>>>, ParentType, ContextType>;
  attribute_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entity_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  input_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storefront_properties?: Resolver<Maybe<ResolversTypes['StorefrontProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StorefrontPropertiesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['StorefrontProperties'] = ResolversParentTypes['StorefrontProperties']> = ResolversObject<{
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  use_in_layered_navigation?: Resolver<Maybe<ResolversTypes['UseInLayeredNavigationOptions']>, ParentType, ContextType>;
  use_in_product_listing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  use_in_search_results_layered_navigation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  visible_on_catalog_pages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttributeOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AttributeOption'] = ResolversParentTypes['AttributeOption']> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebsiteResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Website'] = ResolversParentTypes['Website']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_group_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckoutAgreementResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CheckoutAgreement'] = ResolversParentTypes['CheckoutAgreement']> = ResolversObject<{
  agreement_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  checkbox_text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_html?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['CheckoutAgreementMode'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PriceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Price'] = ResolversParentTypes['Price']> = ResolversObject<{
  adjustments?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceAdjustment']>>>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PriceAdjustmentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PriceAdjustment'] = ResolversParentTypes['PriceAdjustment']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['PriceAdjustmentCodesEnum']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['PriceAdjustmentDescriptionEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductPricesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductPrices'] = ResolversParentTypes['ProductPrices']> = ResolversObject<{
  maximalPrice?: Resolver<Maybe<ResolversTypes['Price']>, ParentType, ContextType>;
  minimalPrice?: Resolver<Maybe<ResolversTypes['Price']>, ParentType, ContextType>;
  regularPrice?: Resolver<Maybe<ResolversTypes['Price']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PriceRangeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PriceRange'] = ResolversParentTypes['PriceRange']> = ResolversObject<{
  maximum_price?: Resolver<Maybe<ResolversTypes['ProductPrice']>, ParentType, ContextType>;
  minimum_price?: Resolver<ResolversTypes['ProductPrice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductPriceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductPrice'] = ResolversParentTypes['ProductPrice']> = ResolversObject<{
  discount?: Resolver<Maybe<ResolversTypes['ProductDiscount']>, ParentType, ContextType>;
  final_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  fixed_product_taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FixedProductTax']>>>, ParentType, ContextType>;
  regular_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductDiscountResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductDiscount'] = ResolversParentTypes['ProductDiscount']> = ResolversObject<{
  amount_off?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percent_off?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductLinksResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductLinks'] = ResolversParentTypes['ProductLinks']> = ResolversObject<{
  link_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductLinksInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductLinksInterface'] = ResolversParentTypes['ProductLinksInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ProductLinks', ParentType, ContextType>;
  link_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linked_product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ProductInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductInterface'] = ResolversParentTypes['ProductInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'VirtualProduct' | 'SimpleProduct' | 'DownloadableProduct' | 'BundleProduct' | 'GroupedProduct' | 'ConfigurableProduct', ParentType, ContextType>;
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<ProductInterfacereviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
}>;

export type PhysicalProductInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PhysicalProductInterface'] = ResolversParentTypes['PhysicalProductInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SimpleProduct' | 'BundleProduct' | 'GroupedProduct' | 'ConfigurableProduct', ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type CustomizableAreaOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableAreaOption'] = ResolversParentTypes['CustomizableAreaOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['CustomizableAreaValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableAreaValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableAreaValue'] = ResolversParentTypes['CustomizableAreaValue']> = ResolversObject<{
  max_characters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CategoryTreeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CategoryTree'] = ResolversParentTypes['CategoryTree']> = ResolversObject<{
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  available_sort_by?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  children?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryTree']>>>, ParentType, ContextType>;
  children_count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_block?: Resolver<Maybe<ResolversTypes['CmsBlock']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_layout_update_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter_price_range?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  h1_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  include_in_menu?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_anchor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  landing_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path_in_store?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<CategoryTreeproductsArgs, 'pageSize' | 'currentPage'>>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  synced_to_yotpo_collection?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CategoryResultResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CategoryResult'] = ResolversParentTypes['CategoryResult']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryTree']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableDateOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableDateOption'] = ResolversParentTypes['CustomizableDateOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['CustomizableDateValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableDateValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableDateValue'] = ResolversParentTypes['CustomizableDateValue']> = ResolversObject<{
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['CustomizableDateTypeEnum']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableDropDownOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableDropDownOption'] = ResolversParentTypes['CustomizableDropDownOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableDropDownValue']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableDropDownValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableDropDownValue'] = ResolversParentTypes['CustomizableDropDownValue']> = ResolversObject<{
  fourover_data?: Resolver<Maybe<ResolversTypes['OptionFourOverData']>, ParentType, ContextType>;
  option_type_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableMultipleOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableMultipleOption'] = ResolversParentTypes['CustomizableMultipleOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableMultipleValue']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableMultipleValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableMultipleValue'] = ResolversParentTypes['CustomizableMultipleValue']> = ResolversObject<{
  option_type_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableFieldOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableFieldOption'] = ResolversParentTypes['CustomizableFieldOption']> = ResolversObject<{
  color_list?: Resolver<Maybe<Array<Maybe<ResolversTypes['Color']>>>, ParentType, ContextType>;
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  simples?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['CustomizableFieldValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableFieldValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableFieldValue'] = ResolversParentTypes['CustomizableFieldValue']> = ResolversObject<{
  max_characters?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableFileOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableFileOption'] = ResolversParentTypes['CustomizableFileOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['CustomizableFileValue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableFileValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableFileValue'] = ResolversParentTypes['CustomizableFileValue']> = ResolversObject<{
  file_extension?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_size_x?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image_size_y?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaGalleryInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['MediaGalleryInterface'] = ResolversParentTypes['MediaGalleryInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ProductImage' | 'ProductVideo', ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ProductImageResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductImage'] = ResolversParentTypes['ProductImage']> = ResolversObject<{
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductVideoResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductVideo'] = ResolversParentTypes['ProductVideo']> = ResolversObject<{
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_content?: Resolver<Maybe<ResolversTypes['ProductMediaGalleryEntriesVideoContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableOptionInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableOptionInterface'] = ResolversParentTypes['CustomizableOptionInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CustomizableAreaOption' | 'CustomizableDateOption' | 'CustomizableDropDownOption' | 'CustomizableMultipleOption' | 'CustomizableFieldOption' | 'CustomizableFileOption' | 'CustomizableRadioOption' | 'CustomizableCheckboxOption', ParentType, ContextType>;
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type CustomizableProductInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableProductInterface'] = ResolversParentTypes['CustomizableProductInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'VirtualProduct' | 'SimpleProduct' | 'DownloadableProduct' | 'BundleProduct' | 'ConfigurableProduct', ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
}>;

export type CategoryInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CategoryInterface'] = ResolversParentTypes['CategoryInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CategoryTree', ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  available_sort_by?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Breadcrumb']>>>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  children_count?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cms_block?: Resolver<Maybe<ResolversTypes['CmsBlock']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_layout_update_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_sort_by?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_mode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  filter_price_range?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  h1_content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  include_in_menu?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_anchor?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  landing_page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keywords?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  path_in_store?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  products?: Resolver<Maybe<ResolversTypes['CategoryProducts']>, ParentType, ContextType, RequireFields<CategoryInterfaceproductsArgs, 'pageSize' | 'currentPage'>>;
  synced_to_yotpo_collection?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail_alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type BreadcrumbResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Breadcrumb'] = ResolversParentTypes['Breadcrumb']> = ResolversObject<{
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category_level?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  category_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableRadioOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableRadioOption'] = ResolversParentTypes['CustomizableRadioOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableRadioValue']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableRadioValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableRadioValue'] = ResolversParentTypes['CustomizableRadioValue']> = ResolversObject<{
  option_type_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableCheckboxOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableCheckboxOption'] = ResolversParentTypes['CustomizableCheckboxOption']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableCheckboxValue']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomizableCheckboxValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomizableCheckboxValue'] = ResolversParentTypes['CustomizableCheckboxValue']> = ResolversObject<{
  option_type_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VirtualProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VirtualProduct'] = ResolversParentTypes['VirtualProduct']> = ResolversObject<{
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<VirtualProductreviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimpleProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SimpleProduct'] = ResolversParentTypes['SimpleProduct']> = ResolversObject<{
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<SimpleProductreviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Products'] = ResolversParentTypes['Products']> = ResolversObject<{
  aggregations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Aggregation']>>>, ParentType, ContextType, Partial<ProductsaggregationsArgs>>;
  filters?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayerFilter']>>>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  sort_fields?: Resolver<Maybe<ResolversTypes['SortFields']>, ParentType, ContextType>;
  suggestions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SearchSuggestion']>>>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CategoryProductsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CategoryProducts'] = ResolversParentTypes['CategoryProducts']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductMediaGalleryEntriesContentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductMediaGalleryEntriesContent'] = ResolversParentTypes['ProductMediaGalleryEntriesContent']> = ResolversObject<{
  base64_encoded_data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductMediaGalleryEntriesVideoContentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductMediaGalleryEntriesVideoContent'] = ResolversParentTypes['ProductMediaGalleryEntriesVideoContent']> = ResolversObject<{
  media_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaGalleryEntryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['MediaGalleryEntry'] = ResolversParentTypes['MediaGalleryEntry']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['ProductMediaGalleryEntriesContent']>, ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  media_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  types?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  video_content?: Resolver<Maybe<ResolversTypes['ProductMediaGalleryEntriesVideoContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LayerFilterResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['LayerFilter'] = ResolversParentTypes['LayerFilter']> = ResolversObject<{
  filter_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayerFilterItemInterface']>>>, ParentType, ContextType>;
  filter_items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  request_var?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LayerFilterItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['LayerFilterItemInterface'] = ResolversParentTypes['LayerFilterItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'LayerFilterItem' | 'SwatchLayerFilterItem', ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value_string?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type LayerFilterItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['LayerFilterItem'] = ResolversParentTypes['LayerFilterItem']> = ResolversObject<{
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value_string?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AggregationResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Aggregation'] = ResolversParentTypes['Aggregation']> = ResolversObject<{
  attribute_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['AggregationOption']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SearchSuggestionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SearchSuggestion'] = ResolversParentTypes['SearchSuggestion']> = ResolversObject<{
  search?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AggregationOptionInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AggregationOptionInterface'] = ResolversParentTypes['AggregationOptionInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'AggregationOption', ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type AggregationOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AggregationOption'] = ResolversParentTypes['AggregationOption']> = ResolversObject<{
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SortFieldResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SortField'] = ResolversParentTypes['SortField']> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SortFieldsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SortFields'] = ResolversParentTypes['SortFields']> = ResolversObject<{
  default?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortField']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimpleWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SimpleWishlistItem'] = ResolversParentTypes['SimpleWishlistItem']> = ResolversObject<{
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VirtualWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VirtualWishlistItem'] = ResolversParentTypes['VirtualWishlistItem']> = ResolversObject<{
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComparableItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ComparableItem'] = ResolversParentTypes['ComparableItem']> = ResolversObject<{
  attributes?: Resolver<Array<Maybe<ResolversTypes['ProductAttribute']>>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductAttributeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductAttribute'] = ResolversParentTypes['ProductAttribute']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ComparableAttributeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ComparableAttribute'] = ResolversParentTypes['ComparableAttribute']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompareListResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CompareList'] = ResolversParentTypes['CompareList']> = ResolversObject<{
  attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComparableAttribute']>>>, ParentType, ContextType>;
  item_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ComparableItem']>>>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = ResolversObject<{
  addresses?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerAddress']>>>, ParentType, ContextType>;
  allow_remote_shopping_assistance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bss_is_company_account?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  company_categories?: Resolver<Maybe<ResolversTypes['CategoryResult']>, ParentType, ContextType>;
  company_industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compare_list?: Resolver<Maybe<ResolversTypes['CompareList']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_of_birth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_billing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_shipping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  group_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_subscribed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orders?: Resolver<Maybe<ResolversTypes['CustomerOrders']>, ParentType, ContextType, RequireFields<CustomerordersArgs, 'currentPage' | 'pageSize'>>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<CustomerreviewsArgs, 'pageSize' | 'currentPage'>>;
  salesrep?: Resolver<Maybe<ResolversTypes['SalesRepUser']>, ParentType, ContextType>;
  sub_roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubRole']>>>, ParentType, ContextType>;
  sub_users?: Resolver<Maybe<Array<Maybe<ResolversTypes['SubUser']>>>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxvat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wishlist?: Resolver<ResolversTypes['Wishlist'], ParentType, ContextType>;
  wishlist_v2?: Resolver<Maybe<ResolversTypes['Wishlist']>, ParentType, ContextType, RequireFields<Customerwishlist_v2Args, 'id'>>;
  wishlists?: Resolver<Array<Maybe<ResolversTypes['Wishlist']>>, ParentType, ContextType, RequireFields<CustomerwishlistsArgs, 'pageSize' | 'currentPage'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteCompareListOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DeleteCompareListOutput'] = ResolversParentTypes['DeleteCompareListOutput']> = ResolversObject<{
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssignCompareListToCustomerOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AssignCompareListToCustomerOutput'] = ResolversParentTypes['AssignCompareListToCustomerOutput']> = ResolversObject<{
  compare_list?: Resolver<Maybe<ResolversTypes['CompareList']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartPricesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartPrices'] = ResolversParentTypes['CartPrices']> = ResolversObject<{
  applied_taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartTaxItem']>>>, ParentType, ContextType>;
  discount?: Resolver<Maybe<ResolversTypes['CartDiscount']>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  setup_fees?: Resolver<Maybe<Array<Maybe<ResolversTypes['SetupFee']>>>, ParentType, ContextType>;
  setup_fees_total?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_excluding_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_excluding_tax_and_setup?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_including_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_including_tax_and_setup?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  subtotal_with_discount_excluding_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartTaxItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartTaxItem'] = ResolversParentTypes['CartTaxItem']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartDiscountResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartDiscount'] = ResolversParentTypes['CartDiscount']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetPaymentMethodOnCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SetPaymentMethodOnCartOutput'] = ResolversParentTypes['SetPaymentMethodOnCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetBillingAddressOnCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SetBillingAddressOnCartOutput'] = ResolversParentTypes['SetBillingAddressOnCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetShippingAddressesOnCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SetShippingAddressesOnCartOutput'] = ResolversParentTypes['SetShippingAddressesOnCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetShippingMethodsOnCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SetShippingMethodsOnCartOutput'] = ResolversParentTypes['SetShippingMethodsOnCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplyCouponToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ApplyCouponToCartOutput'] = ResolversParentTypes['ApplyCouponToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlaceOrderOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PlaceOrderOutput'] = ResolversParentTypes['PlaceOrderOutput']> = ResolversObject<{
  order?: Resolver<ResolversTypes['Order'], ParentType, ContextType>;
  orders?: Resolver<Maybe<Array<Maybe<ResolversTypes['Order']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Cart'] = ResolversParentTypes['Cart']> = ResolversObject<{
  applied_coupon?: Resolver<Maybe<ResolversTypes['AppliedCoupon']>, ParentType, ContextType>;
  applied_coupons?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppliedCoupon']>>>, ParentType, ContextType>;
  available_payment_methods?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailablePaymentMethod']>>>, ParentType, ContextType>;
  billing_address?: Resolver<Maybe<ResolversTypes['BillingCartAddress']>, ParentType, ContextType>;
  customer_note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  is_virtual?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  itemsBySource?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemsBySource']>>>, ParentType, ContextType>;
  prepared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartPrices']>, ParentType, ContextType>;
  selected_payment_method?: Resolver<Maybe<ResolversTypes['SelectedPaymentMethod']>, ParentType, ContextType>;
  shipping_addresses?: Resolver<Array<Maybe<ResolversTypes['ShippingCartAddress']>>, ParentType, ContextType>;
  total_quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartAddressInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartAddressInterface'] = ResolversParentTypes['CartAddressInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ShippingCartAddress' | 'BillingCartAddress', ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CartAddressCountry'], ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CartAddressRegion']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ShippingCartAddressResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ShippingCartAddress'] = ResolversParentTypes['ShippingCartAddress']> = ResolversObject<{
  appointment_required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  available_shipping_methods?: Resolver<Maybe<Array<Maybe<ResolversTypes['AvailableShippingMethod']>>>, ParentType, ContextType>;
  cart_items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemQuantity']>>>, ParentType, ContextType>;
  cart_items_v2?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CartAddressCountry'], ParentType, ContextType>;
  customer_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  days_hours_delivery?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeliveryDateRange']>>>, ParentType, ContextType>;
  delivery_to_door?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  is_freight_address?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  items_weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  limited_access_delivery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loading_dock?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pickup_location_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CartAddressRegion']>, ParentType, ContextType>;
  residential_delivery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  selected_shipping_method?: Resolver<Maybe<ResolversTypes['SelectedShippingMethod']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BillingCartAddressResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BillingCartAddress'] = ResolversParentTypes['BillingCartAddress']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CartAddressCountry'], ParentType, ContextType>;
  customer_notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CartAddressRegion']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartItemQuantityResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartItemQuantity'] = ResolversParentTypes['CartItemQuantity']> = ResolversObject<{
  cart_item_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartAddressRegionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartAddressRegion'] = ResolversParentTypes['CartAddressRegion']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartAddressCountryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartAddressCountry'] = ResolversParentTypes['CartAddressCountry']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedShippingMethodResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedShippingMethod'] = ResolversParentTypes['SelectedShippingMethod']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  base_amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  carrier_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrier_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  method_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price_excl_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  price_incl_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvailableShippingMethodResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AvailableShippingMethod'] = ResolversParentTypes['AvailableShippingMethod']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  base_amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  carrier_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrier_title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  method_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price_excl_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  price_incl_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvailablePaymentMethodResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AvailablePaymentMethod'] = ResolversParentTypes['AvailablePaymentMethod']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  is_deferred?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedPaymentMethodResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedPaymentMethod'] = ResolversParentTypes['SelectedPaymentMethod']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchase_order_number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppliedCouponResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AppliedCoupon'] = ResolversParentTypes['AppliedCoupon']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveCouponFromCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RemoveCouponFromCartOutput'] = ResolversParentTypes['RemoveCouponFromCartOutput']> = ResolversObject<{
  cart?: Resolver<Maybe<ResolversTypes['Cart']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddSimpleProductsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddSimpleProductsToCartOutput'] = ResolversParentTypes['AddSimpleProductsToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddVirtualProductsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddVirtualProductsToCartOutput'] = ResolversParentTypes['AddVirtualProductsToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCartItemsOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['UpdateCartItemsOutput'] = ResolversParentTypes['UpdateCartItemsOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveItemFromCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RemoveItemFromCartOutput'] = ResolversParentTypes['RemoveItemFromCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetGuestEmailOnCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SetGuestEmailOnCartOutput'] = ResolversParentTypes['SetGuestEmailOnCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimpleCartItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SimpleCartItem'] = ResolversParentTypes['SimpleCartItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemError']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VirtualCartItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VirtualCartItem'] = ResolversParentTypes['VirtualCartItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemError']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartItemInterface'] = ResolversParentTypes['CartItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SimpleCartItem' | 'VirtualCartItem' | 'DownloadableCartItem' | 'ConfigurableCartItem' | 'BundleCartItem', ParentType, ContextType>;
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemError']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type CartItemErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartItemError'] = ResolversParentTypes['CartItemError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['CartItemErrorType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DiscountResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Discount'] = ResolversParentTypes['Discount']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartItemPricesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartItemPrices'] = ResolversParentTypes['CartItemPrices']> = ResolversObject<{
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  fixed_product_taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['FixedProductTax']>>>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  price_including_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  row_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  row_total_including_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  setup_fee?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_item_discount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedCustomizableOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedCustomizableOption'] = ResolversParentTypes['SelectedCustomizableOption']> = ResolversObject<{
  customizable_option_uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  is_required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sort_order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOptionValue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedCustomizableOptionValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedCustomizableOptionValue'] = ResolversParentTypes['SelectedCustomizableOptionValue']> = ResolversObject<{
  customizable_option_value_uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['CartItemSelectedOptionValuePrice'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartItemSelectedOptionValuePriceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartItemSelectedOptionValuePrice'] = ResolversParentTypes['CartItemSelectedOptionValuePrice']> = ResolversObject<{
  type?: Resolver<ResolversTypes['PriceTypeEnum'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = ResolversObject<{
  display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartUserInputErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartUserInputError'] = ResolversParentTypes['CartUserInputError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['CartUserInputErrorType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddProductsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddProductsToCartOutput'] = ResolversParentTypes['AddProductsToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  user_errors?: Resolver<Array<Maybe<ResolversTypes['CartUserInputError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerToken'] = ResolversParentTypes['CustomerToken']> = ResolversObject<{
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerOutput'] = ResolversParentTypes['CustomerOutput']> = ResolversObject<{
  customer?: Resolver<ResolversTypes['Customer'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RevokeCustomerTokenOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RevokeCustomerTokenOutput'] = ResolversParentTypes['RevokeCustomerTokenOutput']> = ResolversObject<{
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerAddressResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerAddress'] = ResolversParentTypes['CustomerAddress']> = ResolversObject<{
  appointment_required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_code?: Resolver<Maybe<ResolversTypes['CountryCodeEnum']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerAddressAttribute']>>>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  days_hours_delivery?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeliveryDateRange']>>>, ParentType, ContextType>;
  default_billing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  default_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  delivery_to_door?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  extension_attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerAddressAttribute']>>>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_freight_address?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limited_access_delivery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loading_dock?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['CustomerAddressRegion']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  residential_delivery?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  street?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerAddressRegionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerAddressRegion'] = ResolversParentTypes['CustomerAddressRegion']> = ResolversObject<{
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerAddressAttributeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerAddressAttribute'] = ResolversParentTypes['CustomerAddressAttribute']> = ResolversObject<{
  attribute_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IsEmailAvailableOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['IsEmailAvailableOutput'] = ResolversParentTypes['IsEmailAvailableOutput']> = ResolversObject<{
  is_email_available?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_sub_user?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrencyResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Currency'] = ResolversParentTypes['Currency']> = ResolversObject<{
  available_currency_codes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  base_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  base_currency_symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currecy_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currecy_symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default_display_currency_symbol?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exchange_rates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExchangeRate']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExchangeRateResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ExchangeRate'] = ResolversParentTypes['ExchangeRate']> = ResolversObject<{
  currency_to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CountryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = ResolversObject<{
  available_regions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType>;
  full_name_english?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  full_name_locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  three_letter_abbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  two_letter_abbreviation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RegionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Region'] = ResolversParentTypes['Region']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddDownloadableProductsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddDownloadableProductsToCartOutput'] = ResolversParentTypes['AddDownloadableProductsToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableCartItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableCartItem'] = ResolversParentTypes['DownloadableCartItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemError']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductLinks']>>>, ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductSamples']>>>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableProduct'] = ResolversParentTypes['DownloadableProduct']> = ResolversObject<{
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downloadable_product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductLinks']>>>, ParentType, ContextType>;
  downloadable_product_samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductSamples']>>>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  links_purchased_separately?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  links_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<DownloadableProductreviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableProductLinksResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableProductLinks'] = ResolversParentTypes['DownloadableProductLinks']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_shareable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  link_type?: Resolver<Maybe<ResolversTypes['DownloadableFileTypeEnum']>, ParentType, ContextType>;
  number_of_downloads?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sample_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sample_type?: Resolver<Maybe<ResolversTypes['DownloadableFileTypeEnum']>, ParentType, ContextType>;
  sample_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableProductSamplesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableProductSamples'] = ResolversParentTypes['DownloadableProductSamples']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sample_file?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sample_type?: Resolver<Maybe<ResolversTypes['DownloadableFileTypeEnum']>, ParentType, ContextType>;
  sample_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableOrderItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableOrderItem'] = ResolversParentTypes['DownloadableOrderItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  downloadable_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableItemsLinks']>>>, ParentType, ContextType>;
  entered_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product_exists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proofs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProofInterface']>>>, ParentType, ContextType>;
  quantity_canceled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_ordered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_returned?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_shipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableInvoiceItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableInvoiceItem'] = ResolversParentTypes['DownloadableInvoiceItem']> = ResolversObject<{
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  downloadable_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableItemsLinks']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableCreditMemoItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableCreditMemoItem'] = ResolversParentTypes['DownloadableCreditMemoItem']> = ResolversObject<{
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  downloadable_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableItemsLinks']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableItemsLinksResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableItemsLinks'] = ResolversParentTypes['DownloadableItemsLinks']> = ResolversObject<{
  sort_order?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadableWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DownloadableWishlistItem'] = ResolversParentTypes['DownloadableWishlistItem']> = ResolversObject<{
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  links_v2?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductLinks']>>>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  samples?: Resolver<Maybe<Array<Maybe<ResolversTypes['DownloadableProductSamples']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerDownloadableProductsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerDownloadableProducts'] = ResolversParentTypes['CustomerDownloadableProducts']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomerDownloadableProduct']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerDownloadableProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerDownloadableProduct'] = ResolversParentTypes['CustomerDownloadableProduct']> = ResolversObject<{
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  download_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  order_increment_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remaining_downloads?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductTierPricesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductTierPrices'] = ResolversParentTypes['ProductTierPrices']> = ResolversObject<{
  customer_group_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  percentage_value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  website_id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TierPriceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['TierPrice'] = ResolversParentTypes['TierPrice']> = ResolversObject<{
  discount?: Resolver<Maybe<ResolversTypes['ProductDiscount']>, ParentType, ContextType>;
  final_price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableCartItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableCartItem'] = ResolversParentTypes['ConfigurableCartItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  configurable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedConfigurableOption']>>, ParentType, ContextType>;
  configured_variant?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemError']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleCartItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleCartItem'] = ResolversParentTypes['BundleCartItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  bundle_options?: Resolver<Array<Maybe<ResolversTypes['SelectedBundleOption']>>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemError']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prices?: Resolver<Maybe<ResolversTypes['CartItemPrices']>, ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reorder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GiftMessageResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GiftMessage'] = ResolversParentTypes['GiftMessage']> = ResolversObject<{
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SalesItemInterface'] = ResolversParentTypes['SalesItemInterface']> = ResolversObject<{
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerOrderResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerOrder'] = ResolversParentTypes['CustomerOrder']> = ResolversObject<{
  billing_address?: Resolver<Maybe<ResolversTypes['OrderAddress']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  credit_memos?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditMemo']>>>, ParentType, ContextType>;
  customer_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  estimated_ship_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  grand_total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  increment_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoices?: Resolver<Array<Maybe<ResolversTypes['Invoice']>>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order_date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order_number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payment_methods?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderPaymentMethod']>>>, ParentType, ContextType>;
  shipments?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderShipment']>>>, ParentType, ContextType>;
  shipping_address?: Resolver<Maybe<ResolversTypes['OrderAddress']>, ParentType, ContextType>;
  shipping_method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sub_user?: Resolver<Maybe<ResolversTypes['SubUser']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['OrderTotal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderItemInterface'] = ResolversParentTypes['OrderItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DownloadableOrderItem' | 'BundleOrderItem' | 'OrderItem', ParentType, ContextType>;
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  entered_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product_exists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proofs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProofInterface']>>>, ParentType, ContextType>;
  quantity_canceled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_ordered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_returned?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_shipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type AddBundleProductsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddBundleProductsToCartOutput'] = ResolversParentTypes['AddBundleProductsToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedBundleOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedBundleOption'] = ResolversParentTypes['SelectedBundleOption']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['SelectedBundleOptionValue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedBundleOptionValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedBundleOptionValue'] = ResolversParentTypes['SelectedBundleOptionValue']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleItem'] = ResolversParentTypes['BundleItem']> = ResolversObject<{
  option_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['BundleItemOption']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  required?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleItemOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleItemOption'] = ResolversParentTypes['BundleItemOption']> = ResolversObject<{
  can_change_quantity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  is_default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price_type?: Resolver<Maybe<ResolversTypes['PriceTypeEnum']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleProduct'] = ResolversParentTypes['BundleProduct']> = ResolversObject<{
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dynamic_price?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dynamic_sku?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dynamic_weight?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['BundleItem']>>>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  price_view?: Resolver<Maybe<ResolversTypes['PriceViewEnum']>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<BundleProductreviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  ship_bundle_items?: Resolver<Maybe<ResolversTypes['ShipBundleItemsEnum']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleOrderItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleOrderItem'] = ResolversParentTypes['BundleOrderItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  bundle_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ItemSelectedBundleOption']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  entered_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product_exists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proofs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProofInterface']>>>, ParentType, ContextType>;
  quantity_canceled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_ordered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_returned?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_shipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleInvoiceItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleInvoiceItem'] = ResolversParentTypes['BundleInvoiceItem']> = ResolversObject<{
  bundle_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ItemSelectedBundleOption']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleShipmentItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleShipmentItem'] = ResolversParentTypes['BundleShipmentItem']> = ResolversObject<{
  bundle_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ItemSelectedBundleOption']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_shipped?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleCreditMemoItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleCreditMemoItem'] = ResolversParentTypes['BundleCreditMemoItem']> = ResolversObject<{
  bundle_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ItemSelectedBundleOption']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ItemSelectedBundleOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ItemSelectedBundleOption'] = ResolversParentTypes['ItemSelectedBundleOption']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['ItemSelectedBundleOptionValue']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ItemSelectedBundleOptionValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ItemSelectedBundleOptionValue'] = ResolversParentTypes['ItemSelectedBundleOptionValue']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BundleWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BundleWishlistItem'] = ResolversParentTypes['BundleWishlistItem']> = ResolversObject<{
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bundle_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedBundleOption']>>>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GroupedProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GroupedProduct'] = ResolversParentTypes['GroupedProduct']> = ResolversObject<{
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['GroupedProductItem']>>>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<GroupedProductreviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GroupedProductItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GroupedProductItem'] = ResolversParentTypes['GroupedProductItem']> = ResolversObject<{
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GroupedProductWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GroupedProductWishlistItem'] = ResolversParentTypes['GroupedProductWishlistItem']> = ResolversObject<{
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableProduct'] = ResolversParentTypes['ConfigurableProduct']> = ResolversObject<{
  add_to_cart_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  add_to_wishlist?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amfaq_questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  amfiles?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFile']>>>, ParentType, ContextType>;
  attribute_set_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<Maybe<ResolversTypes['CategoryInterface']>>>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  configurable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableProductOptions']>>>, ParentType, ContextType>;
  configurable_product_options_selection?: Resolver<Maybe<ResolversTypes['ConfigurableProductOptionsSelection']>, ParentType, ContextType, Partial<ConfigurableProductconfigurable_product_options_selectionArgs>>;
  country_of_manufacture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crosssell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  design_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fourover_options_modifier?: Resolver<Maybe<Array<Maybe<ResolversTypes['FourOverCustomOptionModifier']>>>, ParentType, ContextType>;
  free_shipping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  gift_message_available?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  last_price_break?: Resolver<Maybe<ResolversTypes['PriceBreak']>, ParentType, ContextType>;
  manufacturer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  media_gallery_entries?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryEntry']>>>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_keyword?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min_tier_max_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_min_unit_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min_tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  moq?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  only_x_left_in_stock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  options?: Resolver<Maybe<Array<Maybe<ResolversTypes['CustomizableOptionInterface']>>>, ParentType, ContextType>;
  options_container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pallet_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['ProductPrices']>, ParentType, ContextType>;
  price_breaks?: Resolver<Maybe<Array<Maybe<ResolversTypes['PriceBreak']>>>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  price_tiers?: Resolver<Maybe<Array<Maybe<ResolversTypes['TierPrice']>>>, ParentType, ContextType>;
  product_links?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductLinksInterface']>>>, ParentType, ContextType>;
  product_qbo_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rating_summary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  related_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requires_artwork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  review_count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reviews?: Resolver<ResolversTypes['ProductReviews'], ParentType, ContextType, RequireFields<ConfigurableProductreviewsArgs, 'pageSize' | 'currentPage'>>;
  setup_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_discount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_quantity_threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  setup_price_type?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  short_description?: Resolver<Maybe<ResolversTypes['ComplexTextValue']>, ParentType, ContextType>;
  sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['Source']>, ParentType, ContextType>;
  special_from_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  special_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  special_to_date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stock_status?: Resolver<Maybe<ResolversTypes['ProductStockStatus']>, ParentType, ContextType>;
  swatch_image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  tier_price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tier_prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductTierPrices']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  type_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  units_per_pallet?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  upsell_products?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_rewrites?: Resolver<Maybe<Array<Maybe<ResolversTypes['UrlRewrite']>>>, ParentType, ContextType>;
  url_suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  variants?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableVariant']>>>, ParentType, ContextType>;
  websites?: Resolver<Maybe<Array<Maybe<ResolversTypes['Website']>>>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_average_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  yotpo_review_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableVariantResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableVariant'] = ResolversParentTypes['ConfigurableVariant']> = ResolversObject<{
  attributes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableAttributeOption']>>>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['SimpleProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableAttributeOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableAttributeOption'] = ResolversParentTypes['ConfigurableAttributeOption']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value_index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableProductOptionsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableProductOptions'] = ResolversParentTypes['ConfigurableProductOptions']> = ResolversObject<{
  attribute_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  attribute_id_v2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  attribute_uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  use_default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableProductOptionsValues']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableProductOptionsValuesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableProductOptionsValues'] = ResolversParentTypes['ConfigurableProductOptionsValues']> = ResolversObject<{
  default_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  store_label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchDataInterface']>, ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  use_default_value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value_index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddConfigurableProductsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddConfigurableProductsToCartOutput'] = ResolversParentTypes['AddConfigurableProductsToCartOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SelectedConfigurableOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SelectedConfigurableOption'] = ResolversParentTypes['SelectedConfigurableOption']> = ResolversObject<{
  configurable_product_option_uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  configurable_product_option_value_uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  option_label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value_id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  value_label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableWishlistItem'] = ResolversParentTypes['ConfigurableWishlistItem']> = ResolversObject<{
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  child_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  configurable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['SelectedConfigurableOption']>>>, ParentType, ContextType>;
  configured_variant?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableProductOptionsSelectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableProductOptionsSelection'] = ResolversParentTypes['ConfigurableProductOptionsSelection']> = ResolversObject<{
  configurable_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableProductOption']>>>, ParentType, ContextType>;
  media_gallery?: Resolver<Maybe<Array<Maybe<ResolversTypes['MediaGalleryInterface']>>>, ParentType, ContextType>;
  options_available_for_selection?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableOptionAvailableForSelection']>>>, ParentType, ContextType>;
  variant?: Resolver<Maybe<ResolversTypes['SimpleProduct']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableOptionAvailableForSelectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableOptionAvailableForSelection'] = ResolversParentTypes['ConfigurableOptionAvailableForSelection']> = ResolversObject<{
  attribute_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  option_value_uids?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableProductOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableProductOption'] = ResolversParentTypes['ConfigurableProductOption']> = ResolversObject<{
  attribute_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['ConfigurableProductOptionValue']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigurableProductOptionValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ConfigurableProductOptionValue'] = ResolversParentTypes['ConfigurableProductOptionValue']> = ResolversObject<{
  is_available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  is_use_default?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  swatch?: Resolver<Maybe<ResolversTypes['SwatchDataInterface']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PickupLocationsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PickupLocations'] = ResolversParentTypes['PickupLocations']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['PickupLocation']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PickupLocationResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PickupLocation'] = ResolversParentTypes['PickupLocation']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contact_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pickup_location_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  street?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCustomerTokenAsAdminOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GenerateCustomerTokenAsAdminOutput'] = ResolversParentTypes['GenerateCustomerTokenAsAdminOutput']> = ResolversObject<{
  customer_token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscribeEmailToNewsletterOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SubscribeEmailToNewsletterOutput'] = ResolversParentTypes['SubscribeEmailToNewsletterOutput']> = ResolversObject<{
  status?: Resolver<Maybe<ResolversTypes['SubscriptionStatusesEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaypalExpressTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PaypalExpressToken'] = ResolversParentTypes['PaypalExpressToken']> = ResolversObject<{
  paypal_urls?: Resolver<Maybe<ResolversTypes['PaypalExpressUrlList']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaypalExpressTokenOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PaypalExpressTokenOutput'] = ResolversParentTypes['PaypalExpressTokenOutput']> = ResolversObject<{
  paypal_urls?: Resolver<Maybe<ResolversTypes['PaypalExpressUrlList']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayflowLinkTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PayflowLinkToken'] = ResolversParentTypes['PayflowLinkToken']> = ResolversObject<{
  mode?: Resolver<Maybe<ResolversTypes['PayflowLinkMode']>, ParentType, ContextType>;
  paypal_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secure_token_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HostedProUrlResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['HostedProUrl'] = ResolversParentTypes['HostedProUrl']> = ResolversObject<{
  secure_form_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaypalExpressUrlListResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PaypalExpressUrlList'] = ResolversParentTypes['PaypalExpressUrlList']> = ResolversObject<{
  edit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayflowProTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PayflowProToken'] = ResolversParentTypes['PayflowProToken']> = ResolversObject<{
  response_message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  result_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  secure_token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secure_token_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatePayflowProTokenOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CreatePayflowProTokenOutput'] = ResolversParentTypes['CreatePayflowProTokenOutput']> = ResolversObject<{
  response_message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  result_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  secure_token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secure_token_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayflowProResponseOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PayflowProResponseOutput'] = ResolversParentTypes['PayflowProResponseOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductReviewsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductReviews'] = ResolversParentTypes['ProductReviews']> = ResolversObject<{
  items?: Resolver<Array<Maybe<ResolversTypes['ProductReview']>>, ParentType, ContextType>;
  page_info?: Resolver<ResolversTypes['SearchResultPageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductReviewResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductReview'] = ResolversParentTypes['ProductReview']> = ResolversObject<{
  average_rating?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  created_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductInterface'], ParentType, ContextType>;
  ratings_breakdown?: Resolver<Array<Maybe<ResolversTypes['ProductReviewRating']>>, ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductReviewRatingResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductReviewRating'] = ResolversParentTypes['ProductReviewRating']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductReviewRatingsMetadataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductReviewRatingsMetadata'] = ResolversParentTypes['ProductReviewRatingsMetadata']> = ResolversObject<{
  items?: Resolver<Array<Maybe<ResolversTypes['ProductReviewRatingMetadata']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductReviewRatingMetadataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductReviewRatingMetadata'] = ResolversParentTypes['ProductReviewRatingMetadata']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<Array<Maybe<ResolversTypes['ProductReviewRatingValueMetadata']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductReviewRatingValueMetadataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductReviewRatingValueMetadata'] = ResolversParentTypes['ProductReviewRatingValueMetadata']> = ResolversObject<{
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateProductReviewOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CreateProductReviewOutput'] = ResolversParentTypes['CreateProductReviewOutput']> = ResolversObject<{
  review?: Resolver<ResolversTypes['ProductReview'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReorderItemsOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ReorderItemsOutput'] = ResolversParentTypes['ReorderItemsOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  userInputErrors?: Resolver<Array<Maybe<ResolversTypes['CheckoutUserInputError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckoutUserInputErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CheckoutUserInputError'] = ResolversParentTypes['CheckoutUserInputError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['CheckoutUserInputErrorCodes'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerOrdersResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerOrders'] = ResolversParentTypes['CustomerOrders']> = ResolversObject<{
  items?: Resolver<Array<Maybe<ResolversTypes['CustomerOrder']>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderAddressResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderAddress'] = ResolversParentTypes['OrderAddress']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country_code?: Resolver<Maybe<ResolversTypes['CountryCodeEnum']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middlename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  region_id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  street?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  suffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  telephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderItem'] = ResolversParentTypes['OrderItem']> = ResolversObject<{
  artwork?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkInterface']>>>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  entered_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  gift_message?: Resolver<Maybe<ResolversTypes['GiftMessage']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product_exists?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  product_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production_time?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proofs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProofInterface']>>>, ParentType, ContextType>;
  quantity_canceled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_ordered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_returned?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity_shipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrderItemOption']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderItemOptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderItemOption'] = ResolversParentTypes['OrderItemOption']> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TaxItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['TaxItem'] = ResolversParentTypes['TaxItem']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderTotalResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderTotal'] = ResolversParentTypes['OrderTotal']> = ResolversObject<{
  base_grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  setup_fees?: Resolver<Maybe<Array<Maybe<ResolversTypes['SetupFee']>>>, ParentType, ContextType>;
  shipping_handling?: Resolver<Maybe<ResolversTypes['ShippingHandling']>, ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_shipping?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoiceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = ResolversObject<{
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['InvoiceItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['InvoiceTotal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoiceItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['InvoiceItemInterface'] = ResolversParentTypes['InvoiceItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DownloadableInvoiceItem' | 'BundleInvoiceItem' | 'InvoiceItem', ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type InvoiceItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['InvoiceItem'] = ResolversParentTypes['InvoiceItem']> = ResolversObject<{
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_invoiced?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoiceTotalResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['InvoiceTotal'] = ResolversParentTypes['InvoiceTotal']> = ResolversObject<{
  base_grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  shipping_handling?: Resolver<Maybe<ResolversTypes['ShippingHandling']>, ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_shipping?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShippingHandlingResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ShippingHandling'] = ResolversParentTypes['ShippingHandling']> = ResolversObject<{
  amount_excluding_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  amount_including_tax?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShippingDiscount']>>>, ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShippingDiscountResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ShippingDiscount'] = ResolversParentTypes['ShippingDiscount']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderShipmentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderShipment'] = ResolversParentTypes['OrderShipment']> = ResolversObject<{
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShipmentItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tracking?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShipmentTracking']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesCommentItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SalesCommentItem'] = ResolversParentTypes['SalesCommentItem']> = ResolversObject<{
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShipmentItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ShipmentItemInterface'] = ResolversParentTypes['ShipmentItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'BundleShipmentItem' | 'ShipmentItem', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_shipped?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type ShipmentItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ShipmentItem'] = ResolversParentTypes['ShipmentItem']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_shipped?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ShipmentTrackingResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ShipmentTracking'] = ResolversParentTypes['ShipmentTracking']> = ResolversObject<{
  carrier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderPaymentMethodResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderPaymentMethod'] = ResolversParentTypes['OrderPaymentMethod']> = ResolversObject<{
  additional_data?: Resolver<Maybe<Array<Maybe<ResolversTypes['KeyValue']>>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreditMemoResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CreditMemo'] = ResolversParentTypes['CreditMemo']> = ResolversObject<{
  comments?: Resolver<Maybe<Array<Maybe<ResolversTypes['SalesCommentItem']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CreditMemoItemInterface']>>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['CreditMemoTotal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreditMemoItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CreditMemoItemInterface'] = ResolversParentTypes['CreditMemoItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DownloadableCreditMemoItem' | 'BundleCreditMemoItem' | 'CreditMemoItem', ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
}>;

export type CreditMemoItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CreditMemoItem'] = ResolversParentTypes['CreditMemoItem']> = ResolversObject<{
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order_item?: Resolver<Maybe<ResolversTypes['OrderItemInterface']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sale_price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  product_sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity_refunded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreditMemoTotalResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CreditMemoTotal'] = ResolversParentTypes['CreditMemoTotal']> = ResolversObject<{
  adjustment?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  base_grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  discounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Discount']>>>, ParentType, ContextType>;
  grand_total?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  shipping_handling?: Resolver<Maybe<ResolversTypes['ShippingHandling']>, ParentType, ContextType>;
  subtotal?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  taxes?: Resolver<Maybe<Array<Maybe<ResolversTypes['TaxItem']>>>, ParentType, ContextType>;
  total_shipping?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  total_tax?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type KeyValueResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['KeyValue'] = ResolversParentTypes['KeyValue']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EntityUrlResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['EntityUrl'] = ResolversParentTypes['EntityUrl']> = ResolversObject<{
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entity_uid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redirectCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UrlRewriteResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['UrlRewrite'] = ResolversParentTypes['UrlRewrite']> = ResolversObject<{
  parameters?: Resolver<Maybe<Array<Maybe<ResolversTypes['HttpQueryParameter']>>>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HttpQueryParameterResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['HttpQueryParameter'] = ResolversParentTypes['HttpQueryParameter']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoutableInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RoutableInterface'] = ResolversParentTypes['RoutableInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CmsPage' | 'CategoryTree' | 'VirtualProduct' | 'SimpleProduct' | 'DownloadableProduct' | 'BundleProduct' | 'GroupedProduct' | 'ConfigurableProduct', ParentType, ContextType>;
  redirect_code?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  relative_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UrlRewriteEntityTypeEnum']>, ParentType, ContextType>;
}>;

export type SendEmailToFriendOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SendEmailToFriendOutput'] = ResolversParentTypes['SendEmailToFriendOutput']> = ResolversObject<{
  recipients?: Resolver<Maybe<Array<Maybe<ResolversTypes['SendEmailToFriendRecipient']>>>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['SendEmailToFriendSender']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendEmailToFriendSenderResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SendEmailToFriendSender'] = ResolversParentTypes['SendEmailToFriendSender']> = ResolversObject<{
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendEmailToFriendRecipientResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SendEmailToFriendRecipient'] = ResolversParentTypes['SendEmailToFriendRecipient']> = ResolversObject<{
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendFriendConfigurationResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SendFriendConfiguration'] = ResolversParentTypes['SendFriendConfiguration']> = ResolversObject<{
  enabled_for_customers?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enabled_for_guests?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SwatchLayerFilterItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SwatchLayerFilterItemInterface'] = ResolversParentTypes['SwatchLayerFilterItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SwatchLayerFilterItem', ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchData']>, ParentType, ContextType>;
}>;

export type SwatchLayerFilterItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SwatchLayerFilterItem'] = ResolversParentTypes['SwatchLayerFilterItem']> = ResolversObject<{
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  swatch_data?: Resolver<Maybe<ResolversTypes['SwatchData']>, ParentType, ContextType>;
  value_string?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SwatchDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SwatchData'] = ResolversParentTypes['SwatchData']> = ResolversObject<{
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SwatchDataInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SwatchDataInterface'] = ResolversParentTypes['SwatchDataInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ImageSwatchData' | 'TextSwatchData' | 'ColorSwatchData', ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
}>;

export type ImageSwatchDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ImageSwatchData'] = ResolversParentTypes['ImageSwatchData']> = ResolversObject<{
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TextSwatchDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['TextSwatchData'] = ResolversParentTypes['TextSwatchData']> = ResolversObject<{
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ColorSwatchDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ColorSwatchData'] = ResolversParentTypes['ColorSwatchData']> = ResolversObject<{
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeletePaymentTokenOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DeletePaymentTokenOutput'] = ResolversParentTypes['DeletePaymentTokenOutput']> = ResolversObject<{
  customerPaymentTokens?: Resolver<Maybe<ResolversTypes['CustomerPaymentTokens']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomerPaymentTokensResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CustomerPaymentTokens'] = ResolversParentTypes['CustomerPaymentTokens']> = ResolversObject<{
  items?: Resolver<Array<Maybe<ResolversTypes['PaymentToken']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PaymentToken'] = ResolversParentTypes['PaymentToken']> = ResolversObject<{
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payment_method_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  public_hash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentTokenTypeEnum'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FixedProductTaxResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FixedProductTax'] = ResolversParentTypes['FixedProductTax']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishlistOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['WishlistOutput'] = ResolversParentTypes['WishlistOutput']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['WishlistItem']>>>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sharing_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishlistResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Wishlist'] = ResolversParentTypes['Wishlist']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['WishlistItem']>>>, ParentType, ContextType>;
  items_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items_v2?: Resolver<Maybe<ResolversTypes['WishlistItems']>, ParentType, ContextType, RequireFields<Wishlistitems_v2Args, 'currentPage' | 'pageSize'>>;
  sharing_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishlistItemInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['WishlistItemInterface'] = ResolversParentTypes['WishlistItemInterface']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SimpleWishlistItem' | 'VirtualWishlistItem' | 'DownloadableWishlistItem' | 'BundleWishlistItem' | 'GroupedProductWishlistItem' | 'ConfigurableWishlistItem', ParentType, ContextType>;
  added_at?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customizable_options?: Resolver<Array<Maybe<ResolversTypes['SelectedCustomizableOption']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
}>;

export type WishlistItemsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['WishlistItems'] = ResolversParentTypes['WishlistItems']> = ResolversObject<{
  items?: Resolver<Array<Maybe<ResolversTypes['WishlistItemInterface']>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['WishlistItem'] = ResolversParentTypes['WishlistItem']> = ResolversObject<{
  added_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddWishlistItemsToCartOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddWishlistItemsToCartOutput'] = ResolversParentTypes['AddWishlistItemsToCartOutput']> = ResolversObject<{
  add_wishlist_items_to_cart_user_errors?: Resolver<Array<Maybe<ResolversTypes['WishlistCartUserInputError']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  wishlist?: Resolver<ResolversTypes['Wishlist'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishlistCartUserInputErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['WishlistCartUserInputError'] = ResolversParentTypes['WishlistCartUserInputError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['WishlistCartUserInputErrorType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  wishlistId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  wishlistItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddProductsToWishlistOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AddProductsToWishlistOutput'] = ResolversParentTypes['AddProductsToWishlistOutput']> = ResolversObject<{
  user_errors?: Resolver<Array<Maybe<ResolversTypes['WishListUserInputError']>>, ParentType, ContextType>;
  wishlist?: Resolver<ResolversTypes['Wishlist'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveProductsFromWishlistOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RemoveProductsFromWishlistOutput'] = ResolversParentTypes['RemoveProductsFromWishlistOutput']> = ResolversObject<{
  user_errors?: Resolver<Array<Maybe<ResolversTypes['WishListUserInputError']>>, ParentType, ContextType>;
  wishlist?: Resolver<ResolversTypes['Wishlist'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateProductsInWishlistOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['UpdateProductsInWishlistOutput'] = ResolversParentTypes['UpdateProductsInWishlistOutput']> = ResolversObject<{
  user_errors?: Resolver<Array<Maybe<ResolversTypes['WishListUserInputError']>>, ParentType, ContextType>;
  wishlist?: Resolver<ResolversTypes['Wishlist'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WishListUserInputErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['WishListUserInputError'] = ResolversParentTypes['WishListUserInputError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['WishListUserInputErrorType'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqCategoriesSearchResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqCategoriesSearch'] = ResolversParentTypes['AmFaqCategoriesSearch']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqCategory']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqQuestionsSearchResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqQuestionsSearch'] = ResolversParentTypes['AmFaqQuestionsSearch']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  page_info?: Resolver<Maybe<ResolversTypes['SearchResultPageInfo']>, ParentType, ContextType>;
  total_count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqSettingsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqSettings'] = ResolversParentTypes['AmFaqSettings']> = ResolversObject<{
  categoriesSort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryPageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  displayedAnswerLengthLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  faqPageLayout?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gdprConsentText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAddRichDataBreadcrumbs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAddRichDataContact?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAddRichDataOrganization?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAddStructuredData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEnableGdprConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEnableUrlSuffix?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isGuestQuestionsAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isGuestRatingAllowed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHideZeroTotalRating?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRatingEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRemoveTrailingSlash?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowAskQuestionButton?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowAskQuestionButtonProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowBreadcrumbs?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowLinkCategories?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowLinkFooter?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowLinkToolbar?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowProductQuestionsTab?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowSearch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSocialButtonsEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUseCanonicalUrl?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noResultText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productPageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productQuestionsTabName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productQuestionsTabPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  questionsSort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  richDataContactType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  richDataLogoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  richDataName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  richDataTelephone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  richDataWebsiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  searchPageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortAnswerBehavior?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shortAnswerBehaviorProduct?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  socialButtons?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqSocialButton']>>>, ParentType, ContextType>;
  tagsLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urlPrefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urlSuffix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqSocialButtonResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqSocialButton'] = ResolversParentTypes['AmFaqSocialButton']> = ResolversObject<{
  hrefTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imagePath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imgName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqQuestionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqQuestion'] = ResolversParentTypes['AmFaqQuestion']> = ResolversObject<{
  answer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  asked_from_store?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avg_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  avg_total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  customer_groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_show_full_answer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_robots?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  negative_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nofollow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noindex?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  positive_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  product_category_ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  product_ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  question_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  short_answer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total_rating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visibility?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqCategoryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqCategory'] = ResolversParentTypes['AmFaqCategory']> = ResolversObject<{
  canonical_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  customer_groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  meta_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nofollow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  noindex?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  page_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmFaqQuestion']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  store_ids?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFaqCommonOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFaqCommonOutput'] = ResolversParentTypes['AmFaqCommonOutput']> = ResolversObject<{
  error?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmMostviewedBundlePacksResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmMostviewedBundlePacks'] = ResolversParentTypes['AmMostviewedBundlePacks']> = ResolversObject<{
  is_display_cart_block?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_display_cart_message?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  is_top_menu_enabled?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmMostviewedBundlePack']>>>, ParentType, ContextType>;
  main_product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmMostviewedBundlePackResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmMostviewedBundlePack'] = ResolversParentTypes['AmMostviewedBundlePack']> = ResolversObject<{
  apply_for_parent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  block_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cart_message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discount_amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discount_type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmMostviewedBundleItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmMostviewedBundleItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmMostviewedBundleItem'] = ResolversParentTypes['AmMostviewedBundleItem']> = ResolversObject<{
  discount_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['ProductInterface']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmMostviewedRelatedResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmMostviewedRelated'] = ResolversParentTypes['AmMostviewedRelated']> = ResolversObject<{
  add_to_cart?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  block_layout?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  block_title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  display_add_to_compare?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  display_add_to_wishlist?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProductInterface']>>>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmMostviewedRelatedRulesResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmMostviewedRelatedRules'] = ResolversParentTypes['AmMostviewedRelatedRules']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['AmMostviewedRelated']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmProductAttachmentSettingsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmProductAttachmentSettings'] = ResolversParentTypes['AmProductAttachmentSettings']> = ResolversObject<{
  addCategoryFilesToProducts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  displayInOrderFiles?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowInOrderView?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShowProductAttachmentTab?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  orderViewAttachmentsTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderViewAttachmentsType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orderViewStatuses?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  productAttachmentTabCustomerGroups?: Resolver<Maybe<Array<Maybe<ResolversTypes['Int']>>>, ParentType, ContextType>;
  productAttachmentTabPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productAttachmentTabTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showFileIcon?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showFileIconOrder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showFileSize?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showFileSizeOrder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  urlCreationType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmFileResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmFile'] = ResolversParentTypes['AmFile']> = ResolversObject<{
  file_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mime_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmSocialLoginButtonResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmSocialLoginButton'] = ResolversParentTypes['AmSocialLoginButton']> = ResolversObject<{
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmLinkedSocialAccountsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmLinkedSocialAccounts'] = ResolversParentTypes['AmLinkedSocialAccounts']> = ResolversObject<{
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AmUnlinkDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AmUnlinkData'] = ResolversParentTypes['AmUnlinkData']> = ResolversObject<{
  isSuccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SortingOrderResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SortingOrder'] = ResolversParentTypes['SortingOrder']> = ResolversObject<{
  attribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sortDirection?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductData'] = ResolversParentTypes['ProductData']> = ResolversObject<{
  addToCartUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  addToCompareParams?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasRequiredOptions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isSalable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price_range?: Resolver<ResolversTypes['PriceRange'], ParentType, ContextType>;
  productUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  small_image?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['ProductImage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RevokeSubUserTokenOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RevokeSubUserTokenOutput'] = ResolversParentTypes['RevokeSubUserTokenOutput']> = ResolversObject<{
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubUserTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SubUserToken'] = ResolversParentTypes['SubUserToken']> = ResolversObject<{
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SalesRepUserResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SalesRepUser'] = ResolversParentTypes['SalesRepUser']> = ResolversObject<{
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  is_active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubUserResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SubUser'] = ResolversParentTypes['SubUser']> = ResolversObject<{
  created_at?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customer?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quote_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['SubRole']>, ParentType, ContextType>;
  role_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sub_email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sub_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub_status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubRoleResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SubRole'] = ResolversParentTypes['SubRole']> = ResolversObject<{
  customer?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  customer_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  max_order_amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  order_per_day?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role_id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SmtpBestsellersOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SmtpBestsellersOutput'] = ResolversParentTypes['SmtpBestsellersOutput']> = ResolversObject<{
  mpBestsellers?: Resolver<Maybe<Array<Maybe<ResolversTypes['BestsellersProductOutput']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BestsellersProductOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['BestsellersProductOutput'] = ResolversParentTypes['BestsellersProductOutput']> = ResolversObject<{
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  period?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_image_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_sku?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  product_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  qty_ordered?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ArtworkInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ArtworkInterface'] = ResolversParentTypes['ArtworkInterface']> = ResolversObject<{
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extra?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file_name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  file_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  proofing_option?: Resolver<Maybe<ResolversTypes['PROOFING_OPTION']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenericErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GenericError'] = ResolversParentTypes['GenericError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttachArtworkOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AttachArtworkOutput'] = ResolversParentTypes['AttachArtworkOutput']> = ResolversObject<{
  artwork?: Resolver<ResolversTypes['ArtworkInterface'], ParentType, ContextType>;
  userInputErrors?: Resolver<Maybe<Array<Maybe<ResolversTypes['GenericError']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DetachArtworkOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DetachArtworkOutput'] = ResolversParentTypes['DetachArtworkOutput']> = ResolversObject<{
  userInputErrors?: Resolver<Maybe<Array<Maybe<ResolversTypes['GenericError']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SourceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Source'] = ResolversParentTypes['Source']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  province?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PriceBreakResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PriceBreak'] = ResolversParentTypes['PriceBreak']> = ResolversObject<{
  case_depth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  case_height?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  case_weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  case_width?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  final_price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  units_per_case?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ColorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Color'] = ResolversParentTypes['Color']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  default?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AttachProjectDataOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AttachProjectDataOutput'] = ResolversParentTypes['AttachProjectDataOutput']> = ResolversObject<{
  userInputErrors?: Resolver<Maybe<Array<Maybe<ResolversTypes['GenericError']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProofInterfaceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProofInterface'] = ResolversParentTypes['ProofInterface']> = ResolversObject<{
  author?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  author_comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_reviewed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date_uploaded?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  file_url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenericProofOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GenericProofOutput'] = ResolversParentTypes['GenericProofOutput']> = ResolversObject<{
  proof?: Resolver<Maybe<ResolversTypes['ProofInterface']>, ParentType, ContextType>;
  userInputErrors?: Resolver<Maybe<ResolversTypes['GenericError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CartItemsBySourceResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CartItemsBySource'] = ResolversParentTypes['CartItemsBySource']> = ResolversObject<{
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartItemInterface']>>>, ParentType, ContextType>;
  source_code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignedCommandUrlOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SignedCommandUrlOutput'] = ResolversParentTypes['SignedCommandUrlOutput']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user_errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CartUserInputError']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FourOverItemQuantityResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FourOverItemQuantity'] = ResolversParentTypes['FourOverItemQuantity']> = ResolversObject<{
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Update4OverItemQuantityOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Update4OverItemQuantityOutput'] = ResolversParentTypes['Update4OverItemQuantityOutput']> = ResolversObject<{
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ArtworkRequirementResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ArtworkRequirement'] = ResolversParentTypes['ArtworkRequirement']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileReasonCodeUuid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ArtworkPreflightResponseResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ArtworkPreflightResponse'] = ResolversParentTypes['ArtworkPreflightResponse']> = ResolversObject<{
  files?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkPreflightFile']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ArtworkPreflightFileResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ArtworkPreflightFile'] = ResolversParentTypes['ArtworkPreflightFile']> = ResolversObject<{
  messages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ArtworkPreflightFileMessage']>>>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ArtworkPreflightFileMessageResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ArtworkPreflightFileMessage'] = ResolversParentTypes['ArtworkPreflightFileMessage']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OptionFourOverDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OptionFourOverData'] = ResolversParentTypes['OptionFourOverData']> = ResolversObject<{
  conditions?: Resolver<Maybe<ResolversTypes['OptionFourOverDataConditions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OptionFourOverDataConditionsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OptionFourOverDataConditions'] = ResolversParentTypes['OptionFourOverDataConditions']> = ResolversObject<{
  colorSpec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  runSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FourOverCustomOptionModifierResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FourOverCustomOptionModifier'] = ResolversParentTypes['FourOverCustomOptionModifier']> = ResolversObject<{
  modifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  optionLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeliveryDateRangeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DeliveryDateRange'] = ResolversParentTypes['DeliveryDateRange']> = ResolversObject<{
  available?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCustomerTokenBySecretOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GenerateCustomerTokenBySecretOutput'] = ResolversParentTypes['GenerateCustomerTokenBySecretOutput']> = ResolversObject<{
  customer_token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReorderItemOutputResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ReorderItemOutput'] = ResolversParentTypes['ReorderItemOutput']> = ResolversObject<{
  addedItemIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  cart?: Resolver<ResolversTypes['Cart'], ParentType, ContextType>;
  failedItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReorderFailedItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReorderFailedItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ReorderFailedItem'] = ResolversParentTypes['ReorderFailedItem']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetupFeeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['SetupFee'] = ResolversParentTypes['SetupFee']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AggregateResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Aggregate'] = ResolversParentTypes['Aggregate']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Asset'] = ResolversParentTypes['Asset']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  handle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainImageRowProductHighlight?: Resolver<Array<ResolversTypes['RowProductHighlight']>, ParentType, ContextType, Partial<AssetmainImageRowProductHighlightArgs>>;
  assetRowProduct?: Resolver<Array<ResolversTypes['RowProduct']>, ParentType, ContextType, Partial<AssetassetRowProductArgs>>;
  assetPage?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<AssetassetPageArgs>>;
  assetPageLink?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<AssetassetPageLinkArgs>>;
  mainImageMobileRowProductHighlight?: Resolver<Array<ResolversTypes['RowProductHighlight']>, ParentType, ContextType, Partial<AssetmainImageMobileRowProductHighlightArgs>>;
  upload?: Resolver<Maybe<ResolversTypes['AssetUpload']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType, Partial<AsseturlArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetUploadResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AssetUpload'] = ResolversParentTypes['AssetUpload']> = ResolversObject<{
  requestPostData?: Resolver<Maybe<ResolversTypes['AssetUploadRequestPostData']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['AssetUploadError']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['AssetUploadStatus']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetUploadErrorResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AssetUploadError'] = ResolversParentTypes['AssetUploadError']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AssetUploadRequestPostDataResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['AssetUploadRequestPostData'] = ResolversParentTypes['AssetUploadRequestPostData']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  algorithm?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  policy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  credential?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securityToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BannerResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Banner'] = ResolversParentTypes['Banner']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isMobile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  image?: Resolver<ResolversTypes['Asset'], ParentType, ContextType, Partial<BannerimageArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BrandResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Brand'] = ResolversParentTypes['Brand']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<BrandimageArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type EntityResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Entity'] = ResolversParentTypes['Entity']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Asset' | 'Banner' | 'Brand' | 'Footer' | 'FooterImageLink' | 'FooterLink' | 'Image' | 'LabelAndContent' | 'OrderStep' | 'Page' | 'PageFooter' | 'PageLink' | 'ProductCategory' | 'ProductSideInfo' | 'ProductThingsToKnow' | 'ReviewItem' | 'RowBlogContent' | 'RowBrandsBanner' | 'RowFeaturedCategory' | 'RowHeroBanner' | 'RowLinks' | 'RowOrderProcess' | 'RowParagraph' | 'RowProduct' | 'RowProductHighlight' | 'RowReviewHighlight' | 'RowServiceOptions' | 'RowServicePageContent' | 'ScheduledOperation' | 'ScheduledRelease' | 'User' | 'Usps', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
}>;

export type FooterResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Footer'] = ResolversParentTypes['Footer']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  copyright?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  promoText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  socialLinks?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<FootersocialLinksArgs>>;
  legalLinks?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<FooterlegalLinksArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FooterConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FooterConnection'] = ResolversParentTypes['FooterConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['FooterEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FooterEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FooterEdge'] = ResolversParentTypes['FooterEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['Footer'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FooterImageLinkResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FooterImageLink'] = ResolversParentTypes['FooterImageLink']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  alt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image?: Resolver<ResolversTypes['Asset'], ParentType, ContextType, Partial<FooterImageLinkimageArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FooterLinkResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['FooterLink'] = ResolversParentTypes['FooterLink']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<ImageimageArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Json'], any> {
  name: 'Json';
}

export type LabelAndContentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['LabelAndContent'] = ResolversParentTypes['LabelAndContent']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NodeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Asset' | 'Footer' | 'Page' | 'PageFooter' | 'PageLink' | 'ProductSideInfo' | 'ProductThingsToKnow' | 'RowBlogContent' | 'RowBrandsBanner' | 'RowFeaturedCategory' | 'RowHeroBanner' | 'RowLinks' | 'RowOrderProcess' | 'RowParagraph' | 'RowProduct' | 'RowProductHighlight' | 'RowReviewHighlight' | 'RowServiceOptions' | 'RowServicePageContent' | 'ScheduledOperation' | 'ScheduledRelease' | 'User' | 'Usps', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
}>;

export type OrderStepResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['OrderStep'] = ResolversParentTypes['OrderStep']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  index?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isMobile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<OrderStepimageArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  metaDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  author?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<PageassetArgs>>;
  relatedPages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<PagerelatedPagesArgs>>;
  childPages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<PagechildPagesArgs>>;
  metaRobots?: Resolver<ResolversTypes['MetaRobots'], ParentType, ContextType>;
  content?: Resolver<Array<ResolversTypes['PageContent']>, ParentType, ContextType, Partial<PagecontentArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageConnection'] = ResolversParentTypes['PageConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['PageEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageContentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageContent'] = ResolversParentTypes['PageContent']> = ResolversObject<{
  __resolveType: TypeResolveFn<'PageFooter' | 'ProductThingsToKnow' | 'RowBlogContent' | 'RowBrandsBanner' | 'RowFeaturedCategory' | 'RowHeroBanner' | 'RowLinks' | 'RowOrderProcess' | 'RowParagraph' | 'RowProduct' | 'RowProductHighlight' | 'RowReviewHighlight' | 'RowServiceOptions' | 'RowServicePageContent', ParentType, ContextType>;
}>;

export type PageEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageEdge'] = ResolversParentTypes['PageEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageFooterResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageFooter'] = ResolversParentTypes['PageFooter']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resources?: Resolver<Array<ResolversTypes['FooterLink']>, ParentType, ContextType, Partial<PageFooterresourcesArgs>>;
  topProducts?: Resolver<Array<ResolversTypes['FooterLink']>, ParentType, ContextType, Partial<PageFootertopProductsArgs>>;
  socialMediaLinks?: Resolver<Array<ResolversTypes['FooterImageLink']>, ParentType, ContextType, Partial<PageFootersocialMediaLinksArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<PageFooterpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageFooterConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageFooterConnection'] = ResolversParentTypes['PageFooterConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['PageFooterEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageFooterEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageFooterEdge'] = ResolversParentTypes['PageFooterEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['PageFooter'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageLinkResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageLink'] = ResolversParentTypes['PageLink']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['RichText']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowHeroBanners?: Resolver<Array<ResolversTypes['RowHeroBanner']>, ParentType, ContextType, Partial<PageLinkrowHeroBannersArgs>>;
  rowLinks?: Resolver<Array<ResolversTypes['RowLinks']>, ParentType, ContextType, Partial<PageLinkrowLinksArgs>>;
  uspsMultiple?: Resolver<Array<ResolversTypes['Usps']>, ParentType, ContextType, Partial<PageLinkuspsMultipleArgs>>;
  footerSocialLinks?: Resolver<Array<ResolversTypes['Footer']>, ParentType, ContextType, Partial<PageLinkfooterSocialLinksArgs>>;
  rowServiceOptionsMultiple?: Resolver<Array<ResolversTypes['RowServiceOptions']>, ParentType, ContextType, Partial<PageLinkrowServiceOptionsMultipleArgs>>;
  footerLegalLinks?: Resolver<Array<ResolversTypes['Footer']>, ParentType, ContextType, Partial<PageLinkfooterLegalLinksArgs>>;
  rowProductMultiple?: Resolver<Array<ResolversTypes['RowProduct']>, ParentType, ContextType, Partial<PageLinkrowProductMultipleArgs>>;
  asset?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<PageLinkassetArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageLinkConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageLinkConnection'] = ResolversParentTypes['PageLinkConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['PageLinkEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageLinkEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['PageLinkEdge'] = ResolversParentTypes['PageLinkEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['PageLink'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductCategoryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductCategory'] = ResolversParentTypes['ProductCategory']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  categoryLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryImage?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSideInfoResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductSideInfo'] = ResolversParentTypes['ProductSideInfo']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  heading?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSideInfoConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductSideInfoConnection'] = ResolversParentTypes['ProductSideInfoConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['ProductSideInfoEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductSideInfoEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductSideInfoEdge'] = ResolversParentTypes['ProductSideInfoEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['ProductSideInfo'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductThingsToKnowResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductThingsToKnow'] = ResolversParentTypes['ProductThingsToKnow']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thingsToKnow?: Resolver<Array<ResolversTypes['LabelAndContent']>, ParentType, ContextType, Partial<ProductThingsToKnowthingsToKnowArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<ProductThingsToKnowpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductThingsToKnowConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductThingsToKnowConnection'] = ResolversParentTypes['ProductThingsToKnowConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['ProductThingsToKnowEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProductThingsToKnowEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProductThingsToKnowEdge'] = ResolversParentTypes['ProductThingsToKnowEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['ProductThingsToKnow'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReviewItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ReviewItem'] = ResolversParentTypes['ReviewItem']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  score?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dateCreated?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<ReviewItemavatarArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RichTextResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RichText'] = ResolversParentTypes['RichText']> = ResolversObject<{
  raw?: Resolver<ResolversTypes['RichTextAST'], ParentType, ContextType>;
  html?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  markdown?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface RichTextASTScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['RichTextAST'], any> {
  name: 'RichTextAST';
}

export type RowBlogContentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowBlogContent'] = ResolversParentTypes['RowBlogContent']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['RichText']>, ParentType, ContextType>;
  htmlContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowBlogContentpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowBlogContentConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowBlogContentConnection'] = ResolversParentTypes['RowBlogContentConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowBlogContentEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowBlogContentEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowBlogContentEdge'] = ResolversParentTypes['RowBlogContentEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowBlogContent'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowBrandsBannerResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowBrandsBanner'] = ResolversParentTypes['RowBrandsBanner']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sectionLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brands?: Resolver<Array<ResolversTypes['Brand']>, ParentType, ContextType, Partial<RowBrandsBannerbrandsArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowBrandsBannerpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowBrandsBannerConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowBrandsBannerConnection'] = ResolversParentTypes['RowBrandsBannerConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowBrandsBannerEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowBrandsBannerEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowBrandsBannerEdge'] = ResolversParentTypes['RowBrandsBannerEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowBrandsBanner'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowFeaturedCategoryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowFeaturedCategory'] = ResolversParentTypes['RowFeaturedCategory']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sectionLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryItems?: Resolver<Array<ResolversTypes['ProductCategory']>, ParentType, ContextType, Partial<RowFeaturedCategorycategoryItemsArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowFeaturedCategorypagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowFeaturedCategoryConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowFeaturedCategoryConnection'] = ResolversParentTypes['RowFeaturedCategoryConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowFeaturedCategoryEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowFeaturedCategoryEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowFeaturedCategoryEdge'] = ResolversParentTypes['RowFeaturedCategoryEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowFeaturedCategory'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowHeroBannerResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowHeroBanner'] = ResolversParentTypes['RowHeroBanner']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headerText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headerTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  banners?: Resolver<Array<ResolversTypes['Banner']>, ParentType, ContextType, Partial<RowHeroBannerbannersArgs>>;
  pageLinks?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<RowHeroBannerpageLinksArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowHeroBannerpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowHeroBannerConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowHeroBannerConnection'] = ResolversParentTypes['RowHeroBannerConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowHeroBannerEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowHeroBannerEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowHeroBannerEdge'] = ResolversParentTypes['RowHeroBannerEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowHeroBanner'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowLinksResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowLinks'] = ResolversParentTypes['RowLinks']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowLinksCopy?: Resolver<Maybe<ResolversTypes['RichText']>, ParentType, ContextType>;
  pageLinks?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<RowLinkspageLinksArgs>>;
  linksVariant?: Resolver<Maybe<ResolversTypes['RowLinksVariants']>, ParentType, ContextType>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowLinkspagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowLinksConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowLinksConnection'] = ResolversParentTypes['RowLinksConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowLinksEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowLinksEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowLinksEdge'] = ResolversParentTypes['RowLinksEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowLinks'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowOrderProcessResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowOrderProcess'] = ResolversParentTypes['RowOrderProcess']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labelDesktop?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  labelMobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderSteps?: Resolver<Array<ResolversTypes['OrderStep']>, ParentType, ContextType, Partial<RowOrderProcessorderStepsArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowOrderProcesspagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowOrderProcessConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowOrderProcessConnection'] = ResolversParentTypes['RowOrderProcessConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowOrderProcessEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowOrderProcessEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowOrderProcessEdge'] = ResolversParentTypes['RowOrderProcessEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowOrderProcess'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowParagraphResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowParagraph'] = ResolversParentTypes['RowParagraph']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paragraphTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paragraph?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowParagraphpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowParagraphConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowParagraphConnection'] = ResolversParentTypes['RowParagraphConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowParagraphEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowParagraphEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowParagraphEdge'] = ResolversParentTypes['RowParagraphEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowParagraph'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowProductResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowProduct'] = ResolversParentTypes['RowProduct']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productCopy?: Resolver<Maybe<ResolversTypes['RichText']>, ParentType, ContextType>;
  pageLinks?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<RowProductpageLinksArgs>>;
  asset?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<RowProductassetArgs>>;
  variant?: Resolver<Maybe<ResolversTypes['RowProductVariants']>, ParentType, ContextType>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowProductpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowProductConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowProductConnection'] = ResolversParentTypes['RowProductConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowProductEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowProductEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowProductEdge'] = ResolversParentTypes['RowProductEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowProduct'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowProductHighlightResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowProductHighlight'] = ResolversParentTypes['RowProductHighlight']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryImages?: Resolver<Array<ResolversTypes['Image']>, ParentType, ContextType, Partial<RowProductHighlightsecondaryImagesArgs>>;
  mainImage?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<RowProductHighlightmainImageArgs>>;
  mainImageMobile?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType, Partial<RowProductHighlightmainImageMobileArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowProductHighlightpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowProductHighlightConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowProductHighlightConnection'] = ResolversParentTypes['RowProductHighlightConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowProductHighlightEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowProductHighlightEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowProductHighlightEdge'] = ResolversParentTypes['RowProductHighlightEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowProductHighlight'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowReviewHighlightResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowReviewHighlight'] = ResolversParentTypes['RowReviewHighlight']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reviewItems?: Resolver<Array<ResolversTypes['ReviewItem']>, ParentType, ContextType, Partial<RowReviewHighlightreviewItemsArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowReviewHighlightpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowReviewHighlightConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowReviewHighlightConnection'] = ResolversParentTypes['RowReviewHighlightConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowReviewHighlightEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowReviewHighlightEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowReviewHighlightEdge'] = ResolversParentTypes['RowReviewHighlightEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowReviewHighlight'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowServiceOptionsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowServiceOptions'] = ResolversParentTypes['RowServiceOptions']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceOptions?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<RowServiceOptionsserviceOptionsArgs>>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowServiceOptionspagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowServiceOptionsConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowServiceOptionsConnection'] = ResolversParentTypes['RowServiceOptionsConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowServiceOptionsEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowServiceOptionsEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowServiceOptionsEdge'] = ResolversParentTypes['RowServiceOptionsEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowServiceOptions'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowServicePageContentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowServicePageContent'] = ResolversParentTypes['RowServicePageContent']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['RichText']>, ParentType, ContextType>;
  pages?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, Partial<RowServicePageContentpagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowServicePageContentConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowServicePageContentConnection'] = ResolversParentTypes['RowServicePageContentConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['RowServicePageContentEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RowServicePageContentEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['RowServicePageContentEdge'] = ResolversParentTypes['RowServicePageContentEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['RowServicePageContent'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScheduledOperationResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ScheduledOperation'] = ResolversParentTypes['ScheduledOperation']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawPayload?: Resolver<ResolversTypes['Json'], ParentType, ContextType>;
  release?: Resolver<Maybe<ResolversTypes['ScheduledRelease']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ScheduledOperationStatus'], ParentType, ContextType>;
  affectedDocuments?: Resolver<Array<ResolversTypes['ScheduledOperationAffectedDocument']>, ParentType, ContextType, Partial<ScheduledOperationaffectedDocumentsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ScheduledOperationAffectedDocumentResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ScheduledOperationAffectedDocument'] = ResolversParentTypes['ScheduledOperationAffectedDocument']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Asset' | 'Footer' | 'Page' | 'PageFooter' | 'PageLink' | 'ProductSideInfo' | 'ProductThingsToKnow' | 'RowBlogContent' | 'RowBrandsBanner' | 'RowFeaturedCategory' | 'RowHeroBanner' | 'RowLinks' | 'RowOrderProcess' | 'RowParagraph' | 'RowProduct' | 'RowProductHighlight' | 'RowReviewHighlight' | 'RowServiceOptions' | 'RowServicePageContent' | 'Usps', ParentType, ContextType>;
}>;

export type ScheduledReleaseResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ScheduledRelease'] = ResolversParentTypes['ScheduledRelease']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isImplicit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  releaseAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  operations?: Resolver<Array<ResolversTypes['ScheduledOperation']>, ParentType, ContextType, Partial<ScheduledReleaseoperationsArgs>>;
  status?: Resolver<ResolversTypes['ScheduledReleaseStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  picture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['UserKind'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UspsResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Usps'] = ResolversParentTypes['Usps']> = ResolversObject<{
  stage?: Resolver<ResolversTypes['Stage'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uspsMultiple?: Resolver<Array<ResolversTypes['PageLink']>, ParentType, ContextType, Partial<UspsuspsMultipleArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UspsConnectionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['UspsConnection'] = ResolversParentTypes['UspsConnection']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<Array<ResolversTypes['UspsEdge']>, ParentType, ContextType>;
  aggregate?: Resolver<ResolversTypes['Aggregate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UspsEdgeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['UspsEdge'] = ResolversParentTypes['UspsEdge']> = ResolversObject<{
  node?: Resolver<ResolversTypes['Usps'], ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrentCartIdResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CurrentCartId'] = ResolversParentTypes['CurrentCartId']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CurrentCompareUidResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['CurrentCompareUid'] = ResolversParentTypes['CurrentCompareUid']> = ResolversObject<{
  uid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestWishlistResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GuestWishlist'] = ResolversParentTypes['GuestWishlist']> = ResolversObject<{
  items?: Resolver<Array<ResolversTypes['GuestWishlistItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestWishlistItemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GuestWishlistItem'] = ResolversParentTypes['GuestWishlistItem']> = ResolversObject<{
  sku?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url_key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selected_options?: Resolver<Maybe<Array<Maybe<ResolversTypes['ID']>>>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = MeshContext> = ResolversObject<{
  Query?: QueryResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  SearchResultPageInfo?: SearchResultPageInfoResolvers<ContextType>;
  ComplexTextValue?: ComplexTextValueResolvers<ContextType>;
  Money?: MoneyResolvers<ContextType>;
  ErrorInterface?: ErrorInterfaceResolvers<ContextType>;
  NoSuchEntityUidError?: NoSuchEntityUidErrorResolvers<ContextType>;
  InternalError?: InternalErrorResolvers<ContextType>;
  StoreConfig?: StoreConfigResolvers<ContextType>;
  CmsPage?: CmsPageResolvers<ContextType>;
  CmsBlocks?: CmsBlocksResolvers<ContextType>;
  CmsBlock?: CmsBlockResolvers<ContextType>;
  CustomAttributeMetadata?: CustomAttributeMetadataResolvers<ContextType>;
  Attribute?: AttributeResolvers<ContextType>;
  StorefrontProperties?: StorefrontPropertiesResolvers<ContextType>;
  AttributeOption?: AttributeOptionResolvers<ContextType>;
  Website?: WebsiteResolvers<ContextType>;
  CheckoutAgreement?: CheckoutAgreementResolvers<ContextType>;
  Price?: PriceResolvers<ContextType>;
  PriceAdjustment?: PriceAdjustmentResolvers<ContextType>;
  ProductPrices?: ProductPricesResolvers<ContextType>;
  PriceRange?: PriceRangeResolvers<ContextType>;
  ProductPrice?: ProductPriceResolvers<ContextType>;
  ProductDiscount?: ProductDiscountResolvers<ContextType>;
  ProductLinks?: ProductLinksResolvers<ContextType>;
  ProductLinksInterface?: ProductLinksInterfaceResolvers<ContextType>;
  ProductInterface?: ProductInterfaceResolvers<ContextType>;
  PhysicalProductInterface?: PhysicalProductInterfaceResolvers<ContextType>;
  CustomizableAreaOption?: CustomizableAreaOptionResolvers<ContextType>;
  CustomizableAreaValue?: CustomizableAreaValueResolvers<ContextType>;
  CategoryTree?: CategoryTreeResolvers<ContextType>;
  CategoryResult?: CategoryResultResolvers<ContextType>;
  CustomizableDateOption?: CustomizableDateOptionResolvers<ContextType>;
  CustomizableDateValue?: CustomizableDateValueResolvers<ContextType>;
  CustomizableDropDownOption?: CustomizableDropDownOptionResolvers<ContextType>;
  CustomizableDropDownValue?: CustomizableDropDownValueResolvers<ContextType>;
  CustomizableMultipleOption?: CustomizableMultipleOptionResolvers<ContextType>;
  CustomizableMultipleValue?: CustomizableMultipleValueResolvers<ContextType>;
  CustomizableFieldOption?: CustomizableFieldOptionResolvers<ContextType>;
  CustomizableFieldValue?: CustomizableFieldValueResolvers<ContextType>;
  CustomizableFileOption?: CustomizableFileOptionResolvers<ContextType>;
  CustomizableFileValue?: CustomizableFileValueResolvers<ContextType>;
  MediaGalleryInterface?: MediaGalleryInterfaceResolvers<ContextType>;
  ProductImage?: ProductImageResolvers<ContextType>;
  ProductVideo?: ProductVideoResolvers<ContextType>;
  CustomizableOptionInterface?: CustomizableOptionInterfaceResolvers<ContextType>;
  CustomizableProductInterface?: CustomizableProductInterfaceResolvers<ContextType>;
  CategoryInterface?: CategoryInterfaceResolvers<ContextType>;
  Breadcrumb?: BreadcrumbResolvers<ContextType>;
  CustomizableRadioOption?: CustomizableRadioOptionResolvers<ContextType>;
  CustomizableRadioValue?: CustomizableRadioValueResolvers<ContextType>;
  CustomizableCheckboxOption?: CustomizableCheckboxOptionResolvers<ContextType>;
  CustomizableCheckboxValue?: CustomizableCheckboxValueResolvers<ContextType>;
  VirtualProduct?: VirtualProductResolvers<ContextType>;
  SimpleProduct?: SimpleProductResolvers<ContextType>;
  Products?: ProductsResolvers<ContextType>;
  CategoryProducts?: CategoryProductsResolvers<ContextType>;
  ProductMediaGalleryEntriesContent?: ProductMediaGalleryEntriesContentResolvers<ContextType>;
  ProductMediaGalleryEntriesVideoContent?: ProductMediaGalleryEntriesVideoContentResolvers<ContextType>;
  MediaGalleryEntry?: MediaGalleryEntryResolvers<ContextType>;
  LayerFilter?: LayerFilterResolvers<ContextType>;
  LayerFilterItemInterface?: LayerFilterItemInterfaceResolvers<ContextType>;
  LayerFilterItem?: LayerFilterItemResolvers<ContextType>;
  Aggregation?: AggregationResolvers<ContextType>;
  SearchSuggestion?: SearchSuggestionResolvers<ContextType>;
  AggregationOptionInterface?: AggregationOptionInterfaceResolvers<ContextType>;
  AggregationOption?: AggregationOptionResolvers<ContextType>;
  SortField?: SortFieldResolvers<ContextType>;
  SortFields?: SortFieldsResolvers<ContextType>;
  SimpleWishlistItem?: SimpleWishlistItemResolvers<ContextType>;
  VirtualWishlistItem?: VirtualWishlistItemResolvers<ContextType>;
  ComparableItem?: ComparableItemResolvers<ContextType>;
  ProductAttribute?: ProductAttributeResolvers<ContextType>;
  ComparableAttribute?: ComparableAttributeResolvers<ContextType>;
  CompareList?: CompareListResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  DeleteCompareListOutput?: DeleteCompareListOutputResolvers<ContextType>;
  AssignCompareListToCustomerOutput?: AssignCompareListToCustomerOutputResolvers<ContextType>;
  CartPrices?: CartPricesResolvers<ContextType>;
  CartTaxItem?: CartTaxItemResolvers<ContextType>;
  CartDiscount?: CartDiscountResolvers<ContextType>;
  SetPaymentMethodOnCartOutput?: SetPaymentMethodOnCartOutputResolvers<ContextType>;
  SetBillingAddressOnCartOutput?: SetBillingAddressOnCartOutputResolvers<ContextType>;
  SetShippingAddressesOnCartOutput?: SetShippingAddressesOnCartOutputResolvers<ContextType>;
  SetShippingMethodsOnCartOutput?: SetShippingMethodsOnCartOutputResolvers<ContextType>;
  ApplyCouponToCartOutput?: ApplyCouponToCartOutputResolvers<ContextType>;
  PlaceOrderOutput?: PlaceOrderOutputResolvers<ContextType>;
  Cart?: CartResolvers<ContextType>;
  CartAddressInterface?: CartAddressInterfaceResolvers<ContextType>;
  ShippingCartAddress?: ShippingCartAddressResolvers<ContextType>;
  BillingCartAddress?: BillingCartAddressResolvers<ContextType>;
  CartItemQuantity?: CartItemQuantityResolvers<ContextType>;
  CartAddressRegion?: CartAddressRegionResolvers<ContextType>;
  CartAddressCountry?: CartAddressCountryResolvers<ContextType>;
  SelectedShippingMethod?: SelectedShippingMethodResolvers<ContextType>;
  AvailableShippingMethod?: AvailableShippingMethodResolvers<ContextType>;
  AvailablePaymentMethod?: AvailablePaymentMethodResolvers<ContextType>;
  SelectedPaymentMethod?: SelectedPaymentMethodResolvers<ContextType>;
  AppliedCoupon?: AppliedCouponResolvers<ContextType>;
  RemoveCouponFromCartOutput?: RemoveCouponFromCartOutputResolvers<ContextType>;
  AddSimpleProductsToCartOutput?: AddSimpleProductsToCartOutputResolvers<ContextType>;
  AddVirtualProductsToCartOutput?: AddVirtualProductsToCartOutputResolvers<ContextType>;
  UpdateCartItemsOutput?: UpdateCartItemsOutputResolvers<ContextType>;
  RemoveItemFromCartOutput?: RemoveItemFromCartOutputResolvers<ContextType>;
  SetGuestEmailOnCartOutput?: SetGuestEmailOnCartOutputResolvers<ContextType>;
  SimpleCartItem?: SimpleCartItemResolvers<ContextType>;
  VirtualCartItem?: VirtualCartItemResolvers<ContextType>;
  CartItemInterface?: CartItemInterfaceResolvers<ContextType>;
  CartItemError?: CartItemErrorResolvers<ContextType>;
  Discount?: DiscountResolvers<ContextType>;
  CartItemPrices?: CartItemPricesResolvers<ContextType>;
  SelectedCustomizableOption?: SelectedCustomizableOptionResolvers<ContextType>;
  SelectedCustomizableOptionValue?: SelectedCustomizableOptionValueResolvers<ContextType>;
  CartItemSelectedOptionValuePrice?: CartItemSelectedOptionValuePriceResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  CartUserInputError?: CartUserInputErrorResolvers<ContextType>;
  AddProductsToCartOutput?: AddProductsToCartOutputResolvers<ContextType>;
  CustomerToken?: CustomerTokenResolvers<ContextType>;
  CustomerOutput?: CustomerOutputResolvers<ContextType>;
  RevokeCustomerTokenOutput?: RevokeCustomerTokenOutputResolvers<ContextType>;
  CustomerAddress?: CustomerAddressResolvers<ContextType>;
  CustomerAddressRegion?: CustomerAddressRegionResolvers<ContextType>;
  CustomerAddressAttribute?: CustomerAddressAttributeResolvers<ContextType>;
  IsEmailAvailableOutput?: IsEmailAvailableOutputResolvers<ContextType>;
  Currency?: CurrencyResolvers<ContextType>;
  ExchangeRate?: ExchangeRateResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  Region?: RegionResolvers<ContextType>;
  AddDownloadableProductsToCartOutput?: AddDownloadableProductsToCartOutputResolvers<ContextType>;
  DownloadableCartItem?: DownloadableCartItemResolvers<ContextType>;
  DownloadableProduct?: DownloadableProductResolvers<ContextType>;
  DownloadableProductLinks?: DownloadableProductLinksResolvers<ContextType>;
  DownloadableProductSamples?: DownloadableProductSamplesResolvers<ContextType>;
  DownloadableOrderItem?: DownloadableOrderItemResolvers<ContextType>;
  DownloadableInvoiceItem?: DownloadableInvoiceItemResolvers<ContextType>;
  DownloadableCreditMemoItem?: DownloadableCreditMemoItemResolvers<ContextType>;
  DownloadableItemsLinks?: DownloadableItemsLinksResolvers<ContextType>;
  DownloadableWishlistItem?: DownloadableWishlistItemResolvers<ContextType>;
  CustomerDownloadableProducts?: CustomerDownloadableProductsResolvers<ContextType>;
  CustomerDownloadableProduct?: CustomerDownloadableProductResolvers<ContextType>;
  ProductTierPrices?: ProductTierPricesResolvers<ContextType>;
  TierPrice?: TierPriceResolvers<ContextType>;
  ConfigurableCartItem?: ConfigurableCartItemResolvers<ContextType>;
  BundleCartItem?: BundleCartItemResolvers<ContextType>;
  GiftMessage?: GiftMessageResolvers<ContextType>;
  SalesItemInterface?: SalesItemInterfaceResolvers<ContextType>;
  CustomerOrder?: CustomerOrderResolvers<ContextType>;
  OrderItemInterface?: OrderItemInterfaceResolvers<ContextType>;
  AddBundleProductsToCartOutput?: AddBundleProductsToCartOutputResolvers<ContextType>;
  SelectedBundleOption?: SelectedBundleOptionResolvers<ContextType>;
  SelectedBundleOptionValue?: SelectedBundleOptionValueResolvers<ContextType>;
  BundleItem?: BundleItemResolvers<ContextType>;
  BundleItemOption?: BundleItemOptionResolvers<ContextType>;
  BundleProduct?: BundleProductResolvers<ContextType>;
  BundleOrderItem?: BundleOrderItemResolvers<ContextType>;
  BundleInvoiceItem?: BundleInvoiceItemResolvers<ContextType>;
  BundleShipmentItem?: BundleShipmentItemResolvers<ContextType>;
  BundleCreditMemoItem?: BundleCreditMemoItemResolvers<ContextType>;
  ItemSelectedBundleOption?: ItemSelectedBundleOptionResolvers<ContextType>;
  ItemSelectedBundleOptionValue?: ItemSelectedBundleOptionValueResolvers<ContextType>;
  BundleWishlistItem?: BundleWishlistItemResolvers<ContextType>;
  GroupedProduct?: GroupedProductResolvers<ContextType>;
  GroupedProductItem?: GroupedProductItemResolvers<ContextType>;
  GroupedProductWishlistItem?: GroupedProductWishlistItemResolvers<ContextType>;
  ConfigurableProduct?: ConfigurableProductResolvers<ContextType>;
  ConfigurableVariant?: ConfigurableVariantResolvers<ContextType>;
  ConfigurableAttributeOption?: ConfigurableAttributeOptionResolvers<ContextType>;
  ConfigurableProductOptions?: ConfigurableProductOptionsResolvers<ContextType>;
  ConfigurableProductOptionsValues?: ConfigurableProductOptionsValuesResolvers<ContextType>;
  AddConfigurableProductsToCartOutput?: AddConfigurableProductsToCartOutputResolvers<ContextType>;
  SelectedConfigurableOption?: SelectedConfigurableOptionResolvers<ContextType>;
  ConfigurableWishlistItem?: ConfigurableWishlistItemResolvers<ContextType>;
  ConfigurableProductOptionsSelection?: ConfigurableProductOptionsSelectionResolvers<ContextType>;
  ConfigurableOptionAvailableForSelection?: ConfigurableOptionAvailableForSelectionResolvers<ContextType>;
  ConfigurableProductOption?: ConfigurableProductOptionResolvers<ContextType>;
  ConfigurableProductOptionValue?: ConfigurableProductOptionValueResolvers<ContextType>;
  PickupLocations?: PickupLocationsResolvers<ContextType>;
  PickupLocation?: PickupLocationResolvers<ContextType>;
  GenerateCustomerTokenAsAdminOutput?: GenerateCustomerTokenAsAdminOutputResolvers<ContextType>;
  SubscribeEmailToNewsletterOutput?: SubscribeEmailToNewsletterOutputResolvers<ContextType>;
  PaypalExpressToken?: PaypalExpressTokenResolvers<ContextType>;
  PaypalExpressTokenOutput?: PaypalExpressTokenOutputResolvers<ContextType>;
  PayflowLinkToken?: PayflowLinkTokenResolvers<ContextType>;
  HostedProUrl?: HostedProUrlResolvers<ContextType>;
  PaypalExpressUrlList?: PaypalExpressUrlListResolvers<ContextType>;
  PayflowProToken?: PayflowProTokenResolvers<ContextType>;
  CreatePayflowProTokenOutput?: CreatePayflowProTokenOutputResolvers<ContextType>;
  PayflowProResponseOutput?: PayflowProResponseOutputResolvers<ContextType>;
  ProductReviews?: ProductReviewsResolvers<ContextType>;
  ProductReview?: ProductReviewResolvers<ContextType>;
  ProductReviewRating?: ProductReviewRatingResolvers<ContextType>;
  ProductReviewRatingsMetadata?: ProductReviewRatingsMetadataResolvers<ContextType>;
  ProductReviewRatingMetadata?: ProductReviewRatingMetadataResolvers<ContextType>;
  ProductReviewRatingValueMetadata?: ProductReviewRatingValueMetadataResolvers<ContextType>;
  CreateProductReviewOutput?: CreateProductReviewOutputResolvers<ContextType>;
  ReorderItemsOutput?: ReorderItemsOutputResolvers<ContextType>;
  CheckoutUserInputError?: CheckoutUserInputErrorResolvers<ContextType>;
  CustomerOrders?: CustomerOrdersResolvers<ContextType>;
  OrderAddress?: OrderAddressResolvers<ContextType>;
  OrderItem?: OrderItemResolvers<ContextType>;
  OrderItemOption?: OrderItemOptionResolvers<ContextType>;
  TaxItem?: TaxItemResolvers<ContextType>;
  OrderTotal?: OrderTotalResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  InvoiceItemInterface?: InvoiceItemInterfaceResolvers<ContextType>;
  InvoiceItem?: InvoiceItemResolvers<ContextType>;
  InvoiceTotal?: InvoiceTotalResolvers<ContextType>;
  ShippingHandling?: ShippingHandlingResolvers<ContextType>;
  ShippingDiscount?: ShippingDiscountResolvers<ContextType>;
  OrderShipment?: OrderShipmentResolvers<ContextType>;
  SalesCommentItem?: SalesCommentItemResolvers<ContextType>;
  ShipmentItemInterface?: ShipmentItemInterfaceResolvers<ContextType>;
  ShipmentItem?: ShipmentItemResolvers<ContextType>;
  ShipmentTracking?: ShipmentTrackingResolvers<ContextType>;
  OrderPaymentMethod?: OrderPaymentMethodResolvers<ContextType>;
  CreditMemo?: CreditMemoResolvers<ContextType>;
  CreditMemoItemInterface?: CreditMemoItemInterfaceResolvers<ContextType>;
  CreditMemoItem?: CreditMemoItemResolvers<ContextType>;
  CreditMemoTotal?: CreditMemoTotalResolvers<ContextType>;
  KeyValue?: KeyValueResolvers<ContextType>;
  EntityUrl?: EntityUrlResolvers<ContextType>;
  UrlRewrite?: UrlRewriteResolvers<ContextType>;
  HttpQueryParameter?: HttpQueryParameterResolvers<ContextType>;
  RoutableInterface?: RoutableInterfaceResolvers<ContextType>;
  SendEmailToFriendOutput?: SendEmailToFriendOutputResolvers<ContextType>;
  SendEmailToFriendSender?: SendEmailToFriendSenderResolvers<ContextType>;
  SendEmailToFriendRecipient?: SendEmailToFriendRecipientResolvers<ContextType>;
  SendFriendConfiguration?: SendFriendConfigurationResolvers<ContextType>;
  SwatchLayerFilterItemInterface?: SwatchLayerFilterItemInterfaceResolvers<ContextType>;
  SwatchLayerFilterItem?: SwatchLayerFilterItemResolvers<ContextType>;
  SwatchData?: SwatchDataResolvers<ContextType>;
  SwatchDataInterface?: SwatchDataInterfaceResolvers<ContextType>;
  ImageSwatchData?: ImageSwatchDataResolvers<ContextType>;
  TextSwatchData?: TextSwatchDataResolvers<ContextType>;
  ColorSwatchData?: ColorSwatchDataResolvers<ContextType>;
  DeletePaymentTokenOutput?: DeletePaymentTokenOutputResolvers<ContextType>;
  CustomerPaymentTokens?: CustomerPaymentTokensResolvers<ContextType>;
  PaymentToken?: PaymentTokenResolvers<ContextType>;
  FixedProductTax?: FixedProductTaxResolvers<ContextType>;
  WishlistOutput?: WishlistOutputResolvers<ContextType>;
  Wishlist?: WishlistResolvers<ContextType>;
  WishlistItemInterface?: WishlistItemInterfaceResolvers<ContextType>;
  WishlistItems?: WishlistItemsResolvers<ContextType>;
  WishlistItem?: WishlistItemResolvers<ContextType>;
  AddWishlistItemsToCartOutput?: AddWishlistItemsToCartOutputResolvers<ContextType>;
  WishlistCartUserInputError?: WishlistCartUserInputErrorResolvers<ContextType>;
  AddProductsToWishlistOutput?: AddProductsToWishlistOutputResolvers<ContextType>;
  RemoveProductsFromWishlistOutput?: RemoveProductsFromWishlistOutputResolvers<ContextType>;
  UpdateProductsInWishlistOutput?: UpdateProductsInWishlistOutputResolvers<ContextType>;
  WishListUserInputError?: WishListUserInputErrorResolvers<ContextType>;
  AmFaqCategoriesSearch?: AmFaqCategoriesSearchResolvers<ContextType>;
  AmFaqQuestionsSearch?: AmFaqQuestionsSearchResolvers<ContextType>;
  AmFaqSettings?: AmFaqSettingsResolvers<ContextType>;
  AmFaqSocialButton?: AmFaqSocialButtonResolvers<ContextType>;
  AmFaqQuestion?: AmFaqQuestionResolvers<ContextType>;
  AmFaqCategory?: AmFaqCategoryResolvers<ContextType>;
  AmFaqCommonOutput?: AmFaqCommonOutputResolvers<ContextType>;
  AmMostviewedBundlePacks?: AmMostviewedBundlePacksResolvers<ContextType>;
  AmMostviewedBundlePack?: AmMostviewedBundlePackResolvers<ContextType>;
  AmMostviewedBundleItem?: AmMostviewedBundleItemResolvers<ContextType>;
  AmMostviewedRelated?: AmMostviewedRelatedResolvers<ContextType>;
  AmMostviewedRelatedRules?: AmMostviewedRelatedRulesResolvers<ContextType>;
  AmProductAttachmentSettings?: AmProductAttachmentSettingsResolvers<ContextType>;
  AmFile?: AmFileResolvers<ContextType>;
  AmSocialLoginButton?: AmSocialLoginButtonResolvers<ContextType>;
  AmLinkedSocialAccounts?: AmLinkedSocialAccountsResolvers<ContextType>;
  AmUnlinkData?: AmUnlinkDataResolvers<ContextType>;
  SortingOrder?: SortingOrderResolvers<ContextType>;
  ProductData?: ProductDataResolvers<ContextType>;
  RevokeSubUserTokenOutput?: RevokeSubUserTokenOutputResolvers<ContextType>;
  SubUserToken?: SubUserTokenResolvers<ContextType>;
  SalesRepUser?: SalesRepUserResolvers<ContextType>;
  SubUser?: SubUserResolvers<ContextType>;
  SubRole?: SubRoleResolvers<ContextType>;
  SmtpBestsellersOutput?: SmtpBestsellersOutputResolvers<ContextType>;
  BestsellersProductOutput?: BestsellersProductOutputResolvers<ContextType>;
  ArtworkInterface?: ArtworkInterfaceResolvers<ContextType>;
  GenericError?: GenericErrorResolvers<ContextType>;
  AttachArtworkOutput?: AttachArtworkOutputResolvers<ContextType>;
  DetachArtworkOutput?: DetachArtworkOutputResolvers<ContextType>;
  Source?: SourceResolvers<ContextType>;
  PriceBreak?: PriceBreakResolvers<ContextType>;
  Color?: ColorResolvers<ContextType>;
  AttachProjectDataOutput?: AttachProjectDataOutputResolvers<ContextType>;
  ProofInterface?: ProofInterfaceResolvers<ContextType>;
  GenericProofOutput?: GenericProofOutputResolvers<ContextType>;
  CartItemsBySource?: CartItemsBySourceResolvers<ContextType>;
  SignedCommandUrlOutput?: SignedCommandUrlOutputResolvers<ContextType>;
  FourOverItemQuantity?: FourOverItemQuantityResolvers<ContextType>;
  Update4OverItemQuantityOutput?: Update4OverItemQuantityOutputResolvers<ContextType>;
  ArtworkRequirement?: ArtworkRequirementResolvers<ContextType>;
  ArtworkPreflightResponse?: ArtworkPreflightResponseResolvers<ContextType>;
  ArtworkPreflightFile?: ArtworkPreflightFileResolvers<ContextType>;
  ArtworkPreflightFileMessage?: ArtworkPreflightFileMessageResolvers<ContextType>;
  OptionFourOverData?: OptionFourOverDataResolvers<ContextType>;
  OptionFourOverDataConditions?: OptionFourOverDataConditionsResolvers<ContextType>;
  FourOverCustomOptionModifier?: FourOverCustomOptionModifierResolvers<ContextType>;
  DeliveryDateRange?: DeliveryDateRangeResolvers<ContextType>;
  GenerateCustomerTokenBySecretOutput?: GenerateCustomerTokenBySecretOutputResolvers<ContextType>;
  ReorderItemOutput?: ReorderItemOutputResolvers<ContextType>;
  ReorderFailedItem?: ReorderFailedItemResolvers<ContextType>;
  SetupFee?: SetupFeeResolvers<ContextType>;
  Aggregate?: AggregateResolvers<ContextType>;
  Asset?: AssetResolvers<ContextType>;
  AssetUpload?: AssetUploadResolvers<ContextType>;
  AssetUploadError?: AssetUploadErrorResolvers<ContextType>;
  AssetUploadRequestPostData?: AssetUploadRequestPostDataResolvers<ContextType>;
  Banner?: BannerResolvers<ContextType>;
  Brand?: BrandResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Entity?: EntityResolvers<ContextType>;
  Footer?: FooterResolvers<ContextType>;
  FooterConnection?: FooterConnectionResolvers<ContextType>;
  FooterEdge?: FooterEdgeResolvers<ContextType>;
  FooterImageLink?: FooterImageLinkResolvers<ContextType>;
  FooterLink?: FooterLinkResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  Json?: GraphQLScalarType;
  LabelAndContent?: LabelAndContentResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  OrderStep?: OrderStepResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageConnection?: PageConnectionResolvers<ContextType>;
  PageContent?: PageContentResolvers<ContextType>;
  PageEdge?: PageEdgeResolvers<ContextType>;
  PageFooter?: PageFooterResolvers<ContextType>;
  PageFooterConnection?: PageFooterConnectionResolvers<ContextType>;
  PageFooterEdge?: PageFooterEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PageLink?: PageLinkResolvers<ContextType>;
  PageLinkConnection?: PageLinkConnectionResolvers<ContextType>;
  PageLinkEdge?: PageLinkEdgeResolvers<ContextType>;
  ProductCategory?: ProductCategoryResolvers<ContextType>;
  ProductSideInfo?: ProductSideInfoResolvers<ContextType>;
  ProductSideInfoConnection?: ProductSideInfoConnectionResolvers<ContextType>;
  ProductSideInfoEdge?: ProductSideInfoEdgeResolvers<ContextType>;
  ProductThingsToKnow?: ProductThingsToKnowResolvers<ContextType>;
  ProductThingsToKnowConnection?: ProductThingsToKnowConnectionResolvers<ContextType>;
  ProductThingsToKnowEdge?: ProductThingsToKnowEdgeResolvers<ContextType>;
  ReviewItem?: ReviewItemResolvers<ContextType>;
  RichText?: RichTextResolvers<ContextType>;
  RichTextAST?: GraphQLScalarType;
  RowBlogContent?: RowBlogContentResolvers<ContextType>;
  RowBlogContentConnection?: RowBlogContentConnectionResolvers<ContextType>;
  RowBlogContentEdge?: RowBlogContentEdgeResolvers<ContextType>;
  RowBrandsBanner?: RowBrandsBannerResolvers<ContextType>;
  RowBrandsBannerConnection?: RowBrandsBannerConnectionResolvers<ContextType>;
  RowBrandsBannerEdge?: RowBrandsBannerEdgeResolvers<ContextType>;
  RowFeaturedCategory?: RowFeaturedCategoryResolvers<ContextType>;
  RowFeaturedCategoryConnection?: RowFeaturedCategoryConnectionResolvers<ContextType>;
  RowFeaturedCategoryEdge?: RowFeaturedCategoryEdgeResolvers<ContextType>;
  RowHeroBanner?: RowHeroBannerResolvers<ContextType>;
  RowHeroBannerConnection?: RowHeroBannerConnectionResolvers<ContextType>;
  RowHeroBannerEdge?: RowHeroBannerEdgeResolvers<ContextType>;
  RowLinks?: RowLinksResolvers<ContextType>;
  RowLinksConnection?: RowLinksConnectionResolvers<ContextType>;
  RowLinksEdge?: RowLinksEdgeResolvers<ContextType>;
  RowOrderProcess?: RowOrderProcessResolvers<ContextType>;
  RowOrderProcessConnection?: RowOrderProcessConnectionResolvers<ContextType>;
  RowOrderProcessEdge?: RowOrderProcessEdgeResolvers<ContextType>;
  RowParagraph?: RowParagraphResolvers<ContextType>;
  RowParagraphConnection?: RowParagraphConnectionResolvers<ContextType>;
  RowParagraphEdge?: RowParagraphEdgeResolvers<ContextType>;
  RowProduct?: RowProductResolvers<ContextType>;
  RowProductConnection?: RowProductConnectionResolvers<ContextType>;
  RowProductEdge?: RowProductEdgeResolvers<ContextType>;
  RowProductHighlight?: RowProductHighlightResolvers<ContextType>;
  RowProductHighlightConnection?: RowProductHighlightConnectionResolvers<ContextType>;
  RowProductHighlightEdge?: RowProductHighlightEdgeResolvers<ContextType>;
  RowReviewHighlight?: RowReviewHighlightResolvers<ContextType>;
  RowReviewHighlightConnection?: RowReviewHighlightConnectionResolvers<ContextType>;
  RowReviewHighlightEdge?: RowReviewHighlightEdgeResolvers<ContextType>;
  RowServiceOptions?: RowServiceOptionsResolvers<ContextType>;
  RowServiceOptionsConnection?: RowServiceOptionsConnectionResolvers<ContextType>;
  RowServiceOptionsEdge?: RowServiceOptionsEdgeResolvers<ContextType>;
  RowServicePageContent?: RowServicePageContentResolvers<ContextType>;
  RowServicePageContentConnection?: RowServicePageContentConnectionResolvers<ContextType>;
  RowServicePageContentEdge?: RowServicePageContentEdgeResolvers<ContextType>;
  ScheduledOperation?: ScheduledOperationResolvers<ContextType>;
  ScheduledOperationAffectedDocument?: ScheduledOperationAffectedDocumentResolvers<ContextType>;
  ScheduledRelease?: ScheduledReleaseResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  Usps?: UspsResolvers<ContextType>;
  UspsConnection?: UspsConnectionResolvers<ContextType>;
  UspsEdge?: UspsEdgeResolvers<ContextType>;
  CurrentCartId?: CurrentCartIdResolvers<ContextType>;
  CurrentCompareUid?: CurrentCompareUidResolvers<ContextType>;
  GuestWishlist?: GuestWishlistResolvers<ContextType>;
  GuestWishlistItem?: GuestWishlistItemResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = MeshContext> = ResolversObject<{
  env?: envDirectiveResolver<any, any, ContextType>;
  injectable?: injectableDirectiveResolver<any, any, ContextType>;
  inject?: injectDirectiveResolver<any, any, ContextType>;
}>;

export type MeshContext = M2Types.Context & HygraphTypes.Context & BaseMeshContext;


const baseDir = pathModule.join(typeof __dirname === 'string' ? __dirname : '/', '..');

const importFn: ImportFn = <T>(moduleId: string) => {
  const relativeModuleId = (pathModule.isAbsolute(moduleId) ? pathModule.relative(baseDir, moduleId) : moduleId).split('\\').join('/').replace(baseDir + '/', '');
  switch(relativeModuleId) {
    case ".mesh/sources/m2/introspectionSchema":
      return Promise.resolve(importedModule$0) as T;
    
    case ".mesh/sources/hygraph/introspectionSchema":
      return Promise.resolve(importedModule$1) as T;
    
    default:
      return Promise.reject(new Error(`Cannot find module '${relativeModuleId}'.`));
  }
};

const rootStore = new MeshStore('.mesh', new FsStoreStorageAdapter({
  cwd: baseDir,
  importFn,
  fileType: "ts",
}), {
  readonly: true,
  validate: false
});

export const rawServeConfig: YamlConfig.Config['serve'] = {"playground":true,"endpoint":"/api/graphql","playgroundTitle":"GraphCommerce® Mesh"} as any
export async function getMeshOptions(): Promise<GetMeshOptions> {
const pubsub = new PubSub();
const sourcesStore = rootStore.child('sources');
const logger = new DefaultLogger("🕸️  Mesh");
const cache = new (MeshCache as any)({
      ...({} as any),
      importFn,
      store: rootStore.child('cache'),
      pubsub,
      logger,
    } as any)

const sources: MeshResolvedSource[] = [];
const transforms: MeshTransform[] = [];
const additionalEnvelopPlugins: MeshPlugin<any>[] = [];
const hygraphTransforms = [];
const m2Transforms = [];
const hygraphHandler = new GraphqlHandler({
              name: "hygraph",
              config: {"useGETForQueries":true,"endpoint":"https://api-us-east-1-shared-usea1-02.hygraph.com/v2/clp04isdg107t01uoa55v8dy3/master","operationHeaders":{"gcms-locales":"{context.headers['gcms-locales']}"}},
              baseDir,
              cache,
              pubsub,
              store: sourcesStore.child("hygraph"),
              logger: logger.child("hygraph"),
              importFn,
            });
const m2Handler = new GraphqlHandler({
              name: "m2",
              config: {"endpoint":"https://ef6265d64c.nxcli.io/graphql","useGETForQueries":true,"batch":false,"operationHeaders":{"Store":"{context.headers.store}","Authorization":"{context.headers.authorization}","X-ReCaptcha":"{context.headers['x-recaptcha']}","Preview-Version":"{context.headers['preview-version']}","Content-Currency":"{context.headers['content-currency']}"}},
              baseDir,
              cache,
              pubsub,
              store: sourcesStore.child("m2"),
              logger: logger.child("m2"),
              importFn,
            });
sources[1] = {
          name: 'm2',
          handler: m2Handler,
          transforms: m2Transforms
        }
additionalEnvelopPlugins[0] = await UseHttpDetailsExtensions({
          ...({
  "if": "env.NODE_ENV === 'development'"
}),
          logger: logger.child("httpDetailsExtensions"),
          cache,
          pubsub,
          baseDir,
          importFn,
        })
hygraphTransforms[0] = new FilterSchemaTransform({
                  apiName: "hygraph",
                  config: {"filters":["Mutation.!*","Query.!{node,asset*,scheduled*,*Version,user*}","*.*.!{after,before,last,forceParentLocale,locales}","*.!{localizations,scheduledIn,documentInStages*,createdAt*,updatedAt*,publishedAt*,createdBy,updatedBy,publishedBy,history,scheduledIn*}"]},
                  baseDir,
                  cache,
                  pubsub,
                  importFn,
                  logger,
                });
hygraphTransforms[1] = new PruneTransform({
                  apiName: "hygraph",
                  config: {"skipPruning":[]},
                  baseDir,
                  cache,
                  pubsub,
                  importFn,
                  logger,
                });
sources[0] = {
          name: 'hygraph',
          handler: hygraphHandler,
          transforms: hygraphTransforms
        }
const additionalTypeDefs = [parse("extend input GraphCommerceStorefrontConfig {\n  hotjarId: String\n  hotjarVersion: String\n}\n\nextend input GraphCommerceConfig {\n  hotjarId: String\n  hotjarVersion: String\n  fbPixelId: String\n  klaviyoPublicKey: String\n  googleMapsApiKey: String\n  gorgiasId: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Enables some demo specific code that is probably not useful for a project:\n  \n  - Adds the \"BY GC\" to the product list items.\n  - Adds \"dominant_color\" attribute swatches to the product list items.\n  - Creates a big list items in the product list.\n  \"\"\"\n  demoMode: Boolean = true\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Enables some demo specific code that is probably not useful for a project:\n  \n  - Adds the \"BY GC\" to the product list items.\n  - Adds \"dominant_color\" attribute swatches to the product list items.\n  - Creates a big list items in the product list.\n  \"\"\"\n  demoMode: Boolean = true\n}"),,parse("extend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Configure different Google Analytics IDs for different locales.\n  \n  To disable for a specific locale, set the value to null.\n  \"\"\"\n  googleAnalyticsId: String\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"\n  See https://support.google.com/analytics/answer/9539598?hl=en\n  \n  Provide a value to enable Google Analytics for your store.\n  \n  To override the value for a specific locale, configure in i18n config.\n  \"\"\"\n  googleAnalyticsId: String\n}"),,parse("extend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Configure different Google Analytics IDs for different locales.\n  \n  To disable for a specific locale, set the value to null.\n  \"\"\"\n  googleAnalyticsId: String\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"\n  See https://support.google.com/analytics/answer/9539598?hl=en\n  \n  Provide a value to enable Google Analytics for your store.\n  \n  To override the value for a specific locale, configure in i18n config.\n  \"\"\"\n  googleAnalyticsId: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Google reCAPTCHA site key.\n  When using reCAPTCHA, this value is required, even if you are configuring different values for each locale.\n  \n  Get a site key and a secret key from https://developers.google.com/recaptcha/docs/v3\n  \n  The secret key should be added in the Magento admin panel (Stores > Configuration > Security > Google ReCAPTCHA Storefront > reCAPTCHA v3 Invisible)\n  ReCAPTCHA can then be enabled/disabled for the different forms, separately (Stores > Configuration > Security > Google ReCAPTCHA Storefront > Storefront)\n  \"\"\"\n  googleRecaptchaKey: String\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"Locale specific google reCAPTCHA key.\"\"\"\n  googleRecaptchaKey: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Google reCAPTCHA site key.\n  When using reCAPTCHA, this value is required, even if you are configuring different values for each locale.\n  \n  Get a site key and a secret key from https://developers.google.com/recaptcha/docs/v3\n  \n  The secret key should be added in the Magento admin panel (Stores > Configuration > Security > Google ReCAPTCHA Storefront > reCAPTCHA v3 Invisible)\n  ReCAPTCHA can then be enabled/disabled for the different forms, separately (Stores > Configuration > Security > Google ReCAPTCHA Storefront > Storefront)\n  \"\"\"\n  googleRecaptchaKey: String\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"Locale specific google reCAPTCHA key.\"\"\"\n  googleRecaptchaKey: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  The Google Tagmanager ID to be used on the site.\n  \n  This value is required even if you are configuring different values for each locale.\n  \"\"\"\n  googleTagmanagerId: String\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"The Google Tagmanager ID to be used per locale.\"\"\"\n  googleTagmanagerId: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  The Google Tagmanager ID to be used on the site.\n  \n  This value is required even if you are configuring different values for each locale.\n  \"\"\"\n  googleTagmanagerId: String\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"The Google Tagmanager ID to be used per locale.\"\"\"\n  googleTagmanagerId: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  The HyGraph endpoint.\n  \n  > Read-only endpoint that allows low latency and high read-throughput content delivery.\n  \n  Project settings -> API Access -> High Performance Read-only Content API\n  \"\"\"\n  hygraphEndpoint: String!\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Add a gcms-locales header to make sure queries return in a certain language, can be an array to define fallbacks.\n  \"\"\"\n  hygraphLocales: [String!]\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  The HyGraph endpoint.\n  \n  > Read-only endpoint that allows low latency and high read-throughput content delivery.\n  \n  Project settings -> API Access -> High Performance Read-only Content API\n  \"\"\"\n  hygraphEndpoint: String!\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Add a gcms-locales header to make sure queries return in a certain language, can be an array to define fallbacks.\n  \"\"\"\n  hygraphLocales: [String!]\n}"),,parse("\"\"\"\nOnly include this fragment in the output when the environment variable is set.\n\"\"\"\ndirective @env(if: String!) on FRAGMENT_DEFINITION"),,parse("\"\"\"\nOnly include this fragment in the output when the environment variable is set.\n\"\"\"\ndirective @env(if: String!) on FRAGMENT_DEFINITION"),,parse("\"\"\"\nDefines wheter a Fragment can be injected\n\n```graphql\nfragment MyInjectableFragment on Model @injectable {\n  id\n}\n```\n\"\"\"\ndirective @injectable on FRAGMENT_DEFINITION\n\n\"\"\"\nDefines whether a Fragment injects into an @injectable\n\n```graphql\nfragment MyFragment on Model @inject(into [\"MyInjectableFragment\"]) {\n  field\n}\n```\n\"\"\"\ndirective @inject(into: [String!]!) on FRAGMENT_DEFINITION"),,parse("\"\"\"\nDefines wheter a Fragment can be injected\n\n```graphql\nfragment MyInjectableFragment on Model @injectable {\n  id\n}\n```\n\"\"\"\ndirective @injectable on FRAGMENT_DEFINITION\n\n\"\"\"\nDefines whether a Fragment injects into an @injectable\n\n```graphql\nfragment MyFragment on Model @inject(into [\"MyInjectableFragment\"]) {\n  field\n}\n```\n\"\"\"\ndirective @inject(into: [String!]!) on FRAGMENT_DEFINITION"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Content API. **Only used for migrations.**\n  \n  > Regular read & write endpoint that allows querying and mutating data in your project.\n  \n  Project settings -> API Access -> Content API\n  \"\"\"\n  hygraphWriteAccessEndpoint: String\n  \"\"\"\n  Hygraph Management SDK Authorization Token. **Only used for migrations.**\n  \n  Project settings -> API Access -> Permanent Auth Tokens\n  \n  1. Click  'Add token' and give it a name, something like 'GraphCommerce Write Access Token' and keep stage on 'Published'.\n  2. Under 'Management API', click 'Yes, Initialize defaults'\n  3. Click 'Edit Permissions' and enable: 'Update' and 'Delete' permissions for 'models', 'enumerations', 'fields', 'components' and 'sources'\n    - Update existing models\n    - Delete existing models\n    - Update existing fields\n    - Delete existing fields\n    - Update existing enumerations\n    - Delete existing enumerations\n    - Update existing components\n    - Delete existing components\n    - Update remote sources\n    - Delete remote sources\n  \n  ```\n  GC_HYGRAPH_WRITE_ACCESS_ENDPOINT=\"https://...hygraph.com/v2/...\"\n  GC_HYGRAPH_WRITE_ACCESS_TOKEN=\"AccessTokenFromHygraph\"\n  yarn graphcommerce hygraph-migrate\n  ```\n  \"\"\"\n  hygraphWriteAccessToken: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Content API. **Only used for migrations.**\n  \n  > Regular read & write endpoint that allows querying and mutating data in your project.\n  \n  Project settings -> API Access -> Content API\n  \"\"\"\n  hygraphWriteAccessEndpoint: String\n  \"\"\"\n  Hygraph Management SDK Authorization Token. **Only used for migrations.**\n  \n  Project settings -> API Access -> Permanent Auth Tokens\n  \n  1. Click  'Add token' and give it a name, something like 'GraphCommerce Write Access Token' and keep stage on 'Published'.\n  2. Under 'Management API', click 'Yes, Initialize defaults'\n  3. Click 'Edit Permissions' and enable: 'Update' and 'Delete' permissions for 'models', 'enumerations', 'fields', 'components' and 'sources'\n    - Update existing models\n    - Delete existing models\n    - Update existing fields\n    - Delete existing fields\n    - Update existing enumerations\n    - Delete existing enumerations\n    - Update existing components\n    - Delete existing components\n    - Update remote sources\n    - Delete remote sources\n  \n  ```\n  GC_HYGRAPH_WRITE_ACCESS_ENDPOINT=\"https://...hygraph.com/v2/...\"\n  GC_HYGRAPH_WRITE_ACCESS_TOKEN=\"AccessTokenFromHygraph\"\n  yarn graphcommerce hygraph-migrate\n  ```\n  \"\"\"\n  hygraphWriteAccessToken: String\n}"),,parse("extend input GraphCommerceStorefrontConfig {\n  \"\"\"Specify a custom locale for to load translations.\"\"\"\n  linguiLocale: String\n}"),,parse("extend input GraphCommerceStorefrontConfig {\n  \"\"\"Specify a custom locale for to load translations.\"\"\"\n  linguiLocale: String\n}"),,parse("extend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Due to a limitation of the GraphQL API it is not possible to determine if a cart should be displayed including or excluding tax.\n  \"\"\"\n  cartDisplayPricesInclTax: Boolean\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"\n  Due to a limitation of the GraphQL API it is not possible to determine if a cart should be displayed including or excluding tax.\n  \n  When Magento's StoreConfig adds this value, this can be replaced.\n  \"\"\"\n  cartDisplayPricesInclTax: Boolean\n}"),,parse("extend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Due to a limitation of the GraphQL API it is not possible to determine if a cart should be displayed including or excluding tax.\n  \"\"\"\n  cartDisplayPricesInclTax: Boolean\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"\n  Due to a limitation of the GraphQL API it is not possible to determine if a cart should be displayed including or excluding tax.\n  \n  When Magento's StoreConfig adds this value, this can be replaced.\n  \"\"\"\n  cartDisplayPricesInclTax: Boolean\n}"),,parse("extend type Query {\n  currentCartId: CurrentCartId\n}\n\ntype CurrentCartId {\n  id: String\n}\n\ninput RegisterCartIdInput {\n  cart_id: String!\n}"),,parse("extend type Query {\n  currentCartId: CurrentCartId\n}\n\ntype CurrentCartId {\n  id: String\n}\n\ninput RegisterCartIdInput {\n  cart_id: String!\n}"),,parse("enum CompareVariant {\n  ICON\n  CHECKBOX\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"Use compare functionality\"\"\"\n  compare: Boolean\n  \"\"\"\n  By default the compare feature is denoted with a 'compare ICON' (2 arrows facing one another).\n  This may be fine for experienced users, but for more clarity it's also possible to present the compare feature as a CHECKBOX accompanied by the 'Compare' label\n  \"\"\"\n  compareVariant: CompareVariant = ICON\n}"),,parse("enum CompareVariant {\n  ICON\n  CHECKBOX\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"Use compare functionality\"\"\"\n  compare: Boolean\n  \"\"\"\n  By default the compare feature is denoted with a 'compare ICON' (2 arrows facing one another).\n  This may be fine for experienced users, but for more clarity it's also possible to present the compare feature as a CHECKBOX accompanied by the 'Compare' label\n  \"\"\"\n  compareVariant: CompareVariant = ICON\n}"),,parse("extend type Query {\n  currentCompareUid: CurrentCompareUid\n}\n\ntype CurrentCompareUid {\n  uid: String\n}"),,parse("extend type Query {\n  currentCompareUid: CurrentCompareUid\n}\n\ntype CurrentCompareUid {\n  uid: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Due to a limitation in the GraphQL API of Magento 2, we need to know if the\n  customer requires email confirmation.\n  \n  This value should match Magento 2's configuration value for\n  `customer/create_account/confirm` and should be removed once we can query\n  \"\"\"\n  customerRequireEmailConfirmation: Boolean\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  Due to a limitation in the GraphQL API of Magento 2, we need to know if the\n  customer requires email confirmation.\n  \n  This value should match Magento 2's configuration value for\n  `customer/create_account/confirm` and should be removed once we can query\n  \"\"\"\n  customerRequireEmailConfirmation: Boolean\n}"),,parse("extend type Query {\n  customerToken: CustomerToken\n}\n\nextend type CustomerToken {\n  createdAt: String\n  valid: Boolean\n}"),,parse("extend type Query {\n  customerToken: CustomerToken\n}\n\nextend type CustomerToken {\n  createdAt: String\n  valid: Boolean\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  GraphQL Magento endpoint.\n  \n  Examples:\n  - https://magento2.test/graphql\n  \"\"\"\n  magentoEndpoint: String!\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Magento store code.\n  \n  Stores => All Stores => [Store View] => Store View Code\n  \n  Examples:\n  - default\n  - en-us\n  - b2b-us\n  \"\"\"\n  magentoStoreCode: String!\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  GraphQL Magento endpoint.\n  \n  Examples:\n  - https://magento2.test/graphql\n  \"\"\"\n  magentoEndpoint: String!\n}\n\nextend input GraphCommerceStorefrontConfig {\n  \"\"\"\n  Magento store code.\n  \n  Stores => All Stores => [Store View] => Store View Code\n  \n  Examples:\n  - default\n  - en-us\n  - b2b-us\n  \"\"\"\n  magentoStoreCode: String!\n}"),,parse("interface CartItemInterface {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype BundleCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype ConfigurableCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype DownloadableCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype SimpleCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype VirtualCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype CartItemError {\n  \"An error code that describes the error encountered\"\n  code: CartItemErrorType!\n  \"A localized error message\"\n  message: String!\n}\n\nenum CartItemErrorType {\n  UNDEFINED\n  ITEM_QTY\n  ITEM_INCREMENTS\n}"),,parse("interface CartItemInterface {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype BundleCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype ConfigurableCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype DownloadableCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype SimpleCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype VirtualCartItem {\n  \"An array of errors encountered while loading the cart item\"\n  errors: [CartItemError]\n}\n\ntype CartItemError {\n  \"An error code that describes the error encountered\"\n  code: CartItemErrorType!\n  \"A localized error message\"\n  message: String!\n}\n\nenum CartItemErrorType {\n  UNDEFINED\n  ITEM_QTY\n  ITEM_INCREMENTS\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  If a simple product is part of a Configurable product page, should the simple product be\n  rendered as a configured option of the configurable product page?\n  \n  How does this work:\n  \n  When the `products(filters: { url_key: { eq: 'simple-product' } }) { ... }` query is ran,\n  Magento also returns the Simple product and the Configurable product the simple belongs to.\n  \n  If that is the case we render the configurable product page instead of the simple product page but\n  the options to select the simple product are pre-selected.\n  \"\"\"\n  configurableVariantForSimple: Boolean = false\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"\n  If a simple product is part of a Configurable product page, should the simple product be\n  rendered as a configured option of the configurable product page?\n  \n  How does this work:\n  \n  When the `products(filters: { url_key: { eq: 'simple-product' } }) { ... }` query is ran,\n  Magento also returns the Simple product and the Configurable product the simple belongs to.\n  \n  If that is the case we render the configurable product page instead of the simple product page but\n  the options to select the simple product are pre-selected.\n  \"\"\"\n  configurableVariantForSimple: Boolean = false\n}"),,parse("enum ProductFiltersLayout {\n  DEFAULT\n  SIDEBAR\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"\n  On older versions of GraphCommerce products would use a product type specific route.\n  \n  This should only be set to true if you use the /product/[url] AND /product/configurable/[url] routes.\n  \n  @deprecated Will be removed in a future version. [migration](../upgrading/graphcommerce-5-to-6.md#product-routing-changes)\n  \"\"\"\n  legacyProductRoute: Boolean\n  \"\"\"\n  Product filters with better UI for mobile and desktop.\n  \n  @experimental This is an experimental feature and may change in the future.\n  \"\"\"\n  productFiltersPro: Boolean\n  \"\"\"\n  Layout how the filters are rendered.\n  DEFAULT: Will be rendered as horzontal chips on desktop and mobile\n  SIDEBAR: Will be rendered as a sidebar on desktop and horizontal chips on mobile\n  \"\"\"\n  productFiltersLayout: ProductFiltersLayout = DEFAULT\n  \"\"\"\n  By default we route products to /p/[url] but you can change this to /product/[url] if you wish.\n  \n  Default: '/p/'\n  Example: '/product/'\n  \"\"\"\n  productRoute: String\n}"),,parse("enum ProductFiltersLayout {\n  DEFAULT\n  SIDEBAR\n}\n\nextend input GraphCommerceConfig {\n  \"\"\"\n  On older versions of GraphCommerce products would use a product type specific route.\n  \n  This should only be set to true if you use the /product/[url] AND /product/configurable/[url] routes.\n  \n  @deprecated Will be removed in a future version. [migration](../upgrading/graphcommerce-5-to-6.md#product-routing-changes)\n  \"\"\"\n  legacyProductRoute: Boolean\n  \"\"\"\n  Product filters with better UI for mobile and desktop.\n  \n  @experimental This is an experimental feature and may change in the future.\n  \"\"\"\n  productFiltersPro: Boolean\n  \"\"\"\n  Layout how the filters are rendered.\n  DEFAULT: Will be rendered as horzontal chips on desktop and mobile\n  SIDEBAR: Will be rendered as a sidebar on desktop and horizontal chips on mobile\n  \"\"\"\n  productFiltersLayout: ProductFiltersLayout = DEFAULT\n  \"\"\"\n  By default we route products to /p/[url] but you can change this to /product/[url] if you wish.\n  \n  Default: '/p/'\n  Example: '/product/'\n  \"\"\"\n  productRoute: String\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"Hide the wishlist functionality for guests.\"\"\"\n  wishlistHideForGuests: Boolean\n  \"\"\"\n  Ignores whether a product is already in the wishlist, makes the toggle an add only.\n  \"\"\"\n  wishlistIgnoreProductWishlistStatus: Boolean\n  \"\"\"Show a message when the product is added to the wishlist.\"\"\"\n  wishlistShowFeedbackMessage: Boolean\n}"),,parse("extend input GraphCommerceConfig {\n  \"\"\"Hide the wishlist functionality for guests.\"\"\"\n  wishlistHideForGuests: Boolean\n  \"\"\"\n  Ignores whether a product is already in the wishlist, makes the toggle an add only.\n  \"\"\"\n  wishlistIgnoreProductWishlistStatus: Boolean\n  \"\"\"Show a message when the product is added to the wishlist.\"\"\"\n  wishlistShowFeedbackMessage: Boolean\n}"),,parse("extend type Query {\n  guestWishlist: GuestWishlist\n}\n\ntype GuestWishlist {\n  items: [GuestWishlistItem!]!\n}\n\ntype GuestWishlistItem {\n  sku: String!\n  url_key: String!\n  selected_options: [ID]\n  quantity: Float!\n}"),,parse("extend type Query {\n  guestWishlist: GuestWishlist\n}\n\ntype GuestWishlist {\n  items: [GuestWishlistItem!]!\n}\n\ntype GuestWishlistItem {\n  sku: String!\n  url_key: String!\n  selected_options: [ID]\n  quantity: Float!\n}"),,parse("\"\"\"\n# GraphCommerce configuration system\n\nGlobal GraphCommerce configuration can be configured in your `graphcommerce.config.js` file\nin the root of your project and are automatically validated on startup.\n\n## Configuring with the configuration file.\n\nThe configuration file is a javascript file that exports a `GraphCommerceConfig` object. See graphcommerce.config.js.example for an example.\n\n## Using configuration\n\nConfiguration can be accessed in your project with the `import.meta.graphCommerce` object.\n\n```tsx\nimport { storefrontAll, storefrontConfig, storefrontConfigDefault, useStorefrontConfig } from '@graphcommerce/next-ui'\n\n// Accessing a global value\nconst globalConf = import.meta.graphCommerce.cartDisplayPricesInclTax\n\nfunction MyComponent() {\n  // Configuration configured per storefront locale.\n  const scopedConfig = useStorefrontConfig().cartDisplayPricesInclTax\n\n  // Creating a fallback system\n  const scopedConfigWithFallback = scopedConfig ?? globalConf\n\n  // Or as single line\n  const scopedConfigWithFallback2 =\n    useStorefrontConfig().cartDisplayPricesInclTax ?? import.meta.graphCommerce.cartDisplayPricesInclTax\n\n  return <div>{googleRecaptchaKey}</div>\n}\n```\n\nYou can also use the configuration in your `.meshrc.yml` by accessing\n`{graphCommerce.myField}`\n\n```yml\nendpoint: '{graphCommerce.magentoEndpoint}'\n```\n\n## Environment variables to override configuration\n\nConfiguration values can be overwriten by environment variables, with the following rules:\n- Convert from camelCase to `SCREAMING_SNAKE_CASE`\n- Prefix with `GC_`\n- Arrays can be indexed with `_0`, `_1`, `_2`, etc.\n- Objects can be accessed with `_<key>`.\n\nExamples:\n- `limitSsg` -> `GC_LIMIT_SSG=\"1\"`\n- `storefront[0].locale` -> `GC_STOREFRONT_0_LOCALE=\"en\"`\n- `debug.pluginStatus` -> `GC_DEBUG_PLUGIN_STATUS=\"1\"`\n\n\n## Exporting current configuration to environment variables\n\nYou can export configuration by running `yarn graphcommerce export-config`\n\n## Extending the configuration in your  project\n\nCreate a graphql/Config.graphqls file in your project and extend the GraphCommerceConfig, GraphCommerceStorefrontConfig inputs to add configuration.\n\n```graphql\nextend input GraphCommerceConfig {\n  myConfig: String # or Boolean, or Int, or Float, make required with `!`\n}\nextend input GraphCommerceStorefrontConfig {\n  myField: Boolean\n}\n```\n\n## All configuration values\n\nBelow is a list of all possible configurations that can be set by GraphCommerce.\n\"\"\"\ninput GraphCommerceConfig {\n  \"\"\"All storefront configuration for the project\"\"\"\n  storefront: [GraphCommerceStorefrontConfig!]!\n  \"\"\"Limit the static generation of SSG when building\"\"\"\n  limitSsg: Boolean\n  \"\"\"\n  Allow the site to be indexed by search engines.\n  If false, the robots.txt file will be set to disallow all.\n  \"\"\"\n  robotsAllow: Boolean\n  \"\"\"\n  The canonical base URL is used for SEO purposes.\n  \n  Examples:\n  - https://example.com\n  - https://example.com/en\n  - https://example.com/en-US\n  \"\"\"\n  canonicalBaseUrl: String!\n  \"\"\"\n  To enable next.js' preview mode, configure the secret you'd like to use.\n  \"\"\"\n  previewSecret: String\n  \"\"\"Debug configuration for GraphCommerce\"\"\"\n  debug: GraphCommerceDebugConfig\n}\n\n\"\"\"All storefront configuration for the project\"\"\"\ninput GraphCommerceStorefrontConfig {\n  \"\"\"\n  There can only be one entry with defaultLocale set to true.\n  - If there are more, the first one is used.\n  - If there is none, the first entry is used.\n  \"\"\"\n  defaultLocale: Boolean\n  \"\"\"\n  Domain configuration, must be a domain https://tools.ietf.org/html/rfc3986\n  \"\"\"\n  domain: String\n  \"\"\"\n  Must be a locale string https://www.unicode.org/reports/tr35/tr35-59/tr35.html#Identifiers\n  \"\"\"\n  locale: String!\n  \"\"\"\n  The canonical base URL is used for SEO purposes.\n  \n  Examples:\n  - https://example.com\n  - https://example.com/en\n  - https://example.com/en-US\n  \"\"\"\n  canonicalBaseUrl: String\n}\n\n\"\"\"Debug configuration for GraphCommerce\"\"\"\ninput GraphCommerceDebugConfig {\n  \"\"\"\n  When updating packages it can happen that the same package is included with different versions in the same project.\n  \n  Issues that this can cause are:\n  - The same package is included multiple times in the bundle, increasing the bundle size.\n  - The Typescript types of the package are not compatible with each other, causing Typescript errors.\n  \"\"\"\n  webpackDuplicatesPlugin: Boolean\n  \"\"\"\n  Cyclic dependencies can cause memory issues and other strange bugs.\n  This plugin will warn you when it detects a cyclic dependency.\n  \n  When running into memory issues, it can be useful to enable this plugin.\n  \"\"\"\n  webpackCircularDependencyPlugin: Boolean\n  \"\"\"Reports which plugins are enabled or disabled.\"\"\"\n  pluginStatus: Boolean\n}"),,parse("\"\"\"\n# GraphCommerce configuration system\n\nGlobal GraphCommerce configuration can be configured in your `graphcommerce.config.js` file\nin the root of your project and are automatically validated on startup.\n\n## Configuring with the configuration file.\n\nThe configuration file is a javascript file that exports a `GraphCommerceConfig` object. See graphcommerce.config.js.example for an example.\n\n## Using configuration\n\nConfiguration can be accessed in your project with the `import.meta.graphCommerce` object.\n\n```tsx\nimport { storefrontAll, storefrontConfig, storefrontConfigDefault, useStorefrontConfig } from '@graphcommerce/next-ui'\n\n// Accessing a global value\nconst globalConf = import.meta.graphCommerce.cartDisplayPricesInclTax\n\nfunction MyComponent() {\n  // Configuration configured per storefront locale.\n  const scopedConfig = useStorefrontConfig().cartDisplayPricesInclTax\n\n  // Creating a fallback system\n  const scopedConfigWithFallback = scopedConfig ?? globalConf\n\n  // Or as single line\n  const scopedConfigWithFallback2 =\n    useStorefrontConfig().cartDisplayPricesInclTax ?? import.meta.graphCommerce.cartDisplayPricesInclTax\n\n  return <div>{googleRecaptchaKey}</div>\n}\n```\n\nYou can also use the configuration in your `.meshrc.yml` by accessing\n`{graphCommerce.myField}`\n\n```yml\nendpoint: '{graphCommerce.magentoEndpoint}'\n```\n\n## Environment variables to override configuration\n\nConfiguration values can be overwriten by environment variables, with the following rules:\n- Convert from camelCase to `SCREAMING_SNAKE_CASE`\n- Prefix with `GC_`\n- Arrays can be indexed with `_0`, `_1`, `_2`, etc.\n- Objects can be accessed with `_<key>`.\n\nExamples:\n- `limitSsg` -> `GC_LIMIT_SSG=\"1\"`\n- `storefront[0].locale` -> `GC_STOREFRONT_0_LOCALE=\"en\"`\n- `debug.pluginStatus` -> `GC_DEBUG_PLUGIN_STATUS=\"1\"`\n\n\n## Exporting current configuration to environment variables\n\nYou can export configuration by running `yarn graphcommerce export-config`\n\n## Extending the configuration in your  project\n\nCreate a graphql/Config.graphqls file in your project and extend the GraphCommerceConfig, GraphCommerceStorefrontConfig inputs to add configuration.\n\n```graphql\nextend input GraphCommerceConfig {\n  myConfig: String # or Boolean, or Int, or Float, make required with `!`\n}\nextend input GraphCommerceStorefrontConfig {\n  myField: Boolean\n}\n```\n\n## All configuration values\n\nBelow is a list of all possible configurations that can be set by GraphCommerce.\n\"\"\"\ninput GraphCommerceConfig {\n  \"\"\"All storefront configuration for the project\"\"\"\n  storefront: [GraphCommerceStorefrontConfig!]!\n  \"\"\"Limit the static generation of SSG when building\"\"\"\n  limitSsg: Boolean\n  \"\"\"\n  Allow the site to be indexed by search engines.\n  If false, the robots.txt file will be set to disallow all.\n  \"\"\"\n  robotsAllow: Boolean\n  \"\"\"\n  The canonical base URL is used for SEO purposes.\n  \n  Examples:\n  - https://example.com\n  - https://example.com/en\n  - https://example.com/en-US\n  \"\"\"\n  canonicalBaseUrl: String!\n  \"\"\"\n  To enable next.js' preview mode, configure the secret you'd like to use.\n  \"\"\"\n  previewSecret: String\n  \"\"\"Debug configuration for GraphCommerce\"\"\"\n  debug: GraphCommerceDebugConfig\n}\n\n\"\"\"All storefront configuration for the project\"\"\"\ninput GraphCommerceStorefrontConfig {\n  \"\"\"\n  There can only be one entry with defaultLocale set to true.\n  - If there are more, the first one is used.\n  - If there is none, the first entry is used.\n  \"\"\"\n  defaultLocale: Boolean\n  \"\"\"\n  Domain configuration, must be a domain https://tools.ietf.org/html/rfc3986\n  \"\"\"\n  domain: String\n  \"\"\"\n  Must be a locale string https://www.unicode.org/reports/tr35/tr35-59/tr35.html#Identifiers\n  \"\"\"\n  locale: String!\n  \"\"\"\n  The canonical base URL is used for SEO purposes.\n  \n  Examples:\n  - https://example.com\n  - https://example.com/en\n  - https://example.com/en-US\n  \"\"\"\n  canonicalBaseUrl: String\n}\n\n\"\"\"Debug configuration for GraphCommerce\"\"\"\ninput GraphCommerceDebugConfig {\n  \"\"\"\n  When updating packages it can happen that the same package is included with different versions in the same project.\n  \n  Issues that this can cause are:\n  - The same package is included multiple times in the bundle, increasing the bundle size.\n  - The Typescript types of the package are not compatible with each other, causing Typescript errors.\n  \"\"\"\n  webpackDuplicatesPlugin: Boolean\n  \"\"\"\n  Cyclic dependencies can cause memory issues and other strange bugs.\n  This plugin will warn you when it detects a cyclic dependency.\n  \n  When running into memory issues, it can be useful to enable this plugin.\n  \"\"\"\n  webpackCircularDependencyPlugin: Boolean\n  \"\"\"Reports which plugins are enabled or disabled.\"\"\"\n  pluginStatus: Boolean\n}"),] as any[];
const additionalResolvers = [] as any[]
const merger = new(StitchingMerger as any)({
        cache,
        pubsub,
        logger: logger.child('stitchingMerger'),
        store: rootStore.child('stitchingMerger')
      })

  return {
    sources,
    transforms,
    additionalTypeDefs,
    additionalResolvers,
    cache,
    pubsub,
    merger,
    logger,
    additionalEnvelopPlugins,
    get documents() {
      return [
      
    ];
    },
    fetchFn,
  };
}

export function createBuiltMeshHTTPHandler<TServerContext = {}>(): MeshHTTPHandler<TServerContext> {
  return createMeshHTTPHandler<TServerContext>({
    baseDir,
    getBuiltMesh: getBuiltMesh,
    rawServeConfig: {"playground":true,"endpoint":"/api/graphql","playgroundTitle":"GraphCommerce® Mesh"},
  })
}


let meshInstance$: Promise<MeshInstance> | undefined;

export function getBuiltMesh(): Promise<MeshInstance> {
  if (meshInstance$ == null) {
    meshInstance$ = getMeshOptions().then(meshOptions => getMesh(meshOptions)).then(mesh => {
      const id = mesh.pubsub.subscribe('destroy', () => {
        meshInstance$ = undefined;
        mesh.pubsub.unsubscribe(id);
      });
      return mesh;
    });
  }
  return meshInstance$;
}

export const execute: ExecuteMeshFn = (...args) => getBuiltMesh().then(({ execute }) => execute(...args));

export const subscribe: SubscribeMeshFn = (...args) => getBuiltMesh().then(({ subscribe }) => subscribe(...args));